import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"ssr":false} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date */
  Date: { input: string; output: string; }
  /** Date Time */
  DateTime: { input: string; output: string; }
};

/** Add To Cart Input */
export type AddToCartInput = {
  /** Group Id */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Item Id */
  itemId: ItemIdInput;
  /** Order Line Options */
  options?: InputMaybe<OrderLineOptionsInput>;
  /** If quote should have customer specific price */
  quoteCustomerSpecificPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Log ID for estimated ship date lineage/tracking */
  shipDateLogId?: InputMaybe<Scalars['String']['input']>;
  /** Line-source tracking for the add to cart item */
  tracking: TrackingSourceInput;
};

/** Add to cart type that checks showcase settings for add to cart functionality */
export enum AddToCartType {
  /** Hidden */
  Hidden = 'HIDDEN',
  /** iFrame post messages */
  IframePostMessage = 'IFRAME_POST_MESSAGE',
  /** One click quotes */
  OneClick = 'ONE_CLICK',
  /** Quote Id */
  QuoteId = 'QUOTE_ID',
  /** Standard */
  Standard = 'STANDARD'
}

/** Add to favorites input */
export type AddToFavoritesInput = {
  /** Favorite list name */
  favoriteListName: Scalars['String']['input'];
  /** Item id */
  itemId: ItemIdInput;
  /** Options */
  options: OrderLineOptionsInput;
};

/** Add To Signet Cart Input */
export type AddToSignetCartInput = {
  /** Cad Cam ID */
  cadCamId: Scalars['ID']['input'];
  /** Product type */
  productType: Scalars['String']['input'];
};

/** Order Line Bag and Tag Options */
export type BagAndTagOptionsInput = {
  /** Determines how many items will be in each bag */
  quantityPerBag?: InputMaybe<Scalars['Int']['input']>;
  /** Determines if each bag will be tagged */
  tagBags?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Credit/Debit Card Type */
export enum CardType {
  /** American Express */
  AmericanExpress = 'AMERICAN_EXPRESS',
  /** Discover */
  Discover = 'DISCOVER',
  /** Mastercard */
  Mastercard = 'MASTERCARD',
  /** Other */
  Other = 'OTHER',
  /** Visa */
  Visa = 'VISA'
}

/** Cart in stock status code */
export enum CartLineInStockStatusCode {
  /** Item has availability */
  Availability = 'AVAILABILITY',
  /** Item is currently not available */
  CurrentlyNotAvailable = 'CURRENTLY_NOT_AVAILABLE',
  /** Item is customized at time of order */
  CustomOrder = 'CUSTOM_ORDER',
  /** Item is in stock */
  InStock = 'IN_STOCK',
  /** Item is mde to order */
  MadeToOrder = 'MADE_TO_ORDER',
  /** Item is out of stock */
  OutOfStock = 'OUT_OF_STOCK',
  /** Item is partially available */
  PartiallyAvailable = 'PARTIALLY_AVAILABLE',
  /** Item can be pre-ordered */
  PreOrder = 'PRE_ORDER',
  /** Item can be special ordered */
  SpecialOrder = 'SPECIAL_ORDER',
  /** Item can be ordered while supplies last */
  WhileSuppliesLast = 'WHILE_SUPPLIES_LAST'
}

/** Cart Service Charge Price Type */
export enum CartServiceChargePriceType {
  /** Flat */
  Flat = 'FLAT',
  /** Per Unit */
  PerUnit = 'PER_UNIT'
}

/** Cart Service Charge Type */
export enum CartServiceChargeType {
  /** Digital Imprinting */
  DigitalImprinting = 'DIGITAL_IMPRINTING',
  /** Hot Stamping */
  HotStamping = 'HOT_STAMPING'
}

/** CMS Options */
export type CmsOptionsInput = {
  /** Current category id of page */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether or not the content should be enveloped in a div + clear, The envelope is required for cms inspecting */
  doNotWrapInDiv?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current group id of page */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Specific display template to use (overrides default) */
  overrideDisplayTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Schedule preview options */
  previewSchedules?: InputMaybe<Array<CmsSchedulePreviewOptionsInput>>;
  /** Preview options */
  previewSpecificVersions?: InputMaybe<Array<CmsPreviewOptionsInput>>;
  /** Current product id of page */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Current URL of page */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** CMS Preview Options */
export type CmsPreviewOptionsInput = {
  /** Container id related to the content id */
  contentContainerId: Scalars['ID']['input'];
  /** Id of the specific version of content that should be previewed */
  contentId: Scalars['ID']['input'];
  /** Content type of the content id */
  contentType: Scalars['String']['input'];
  /** Use the latest version for any related content */
  useLatestForRelated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** CMS Schedule Preview Options */
export type CmsSchedulePreviewOptionsInput = {
  /** Content container id related to the schedule */
  contentContainerId: Scalars['ID']['input'];
  /** Schedule id to be previewed */
  scheduledId: Scalars['ID']['input'];
};

/** Different types of communication lines */
export enum CommunicationPreferenceChannel {
  /** Email */
  Email = 'EMAIL',
  /** Notification on stuller.com */
  Messagecenter = 'MESSAGECENTER',
  /** SMS */
  Sms = 'SMS'
}

/** Configuration Service Charge Input */
export type ConfigurationServiceChargeInput = {
  /** Configuration Id */
  configurationId: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Float']['input'];
};

/** Configuration Service Charge Price Type */
export enum ConfigurationServiceChargePriceType {
  /** Flat price type */
  Flat = 'FLAT',
  /** Price per unit type */
  PerUnit = 'PER_UNIT'
}

/** Configuration Service Charge Type */
export enum ConfigurationServiceChargeType {
  /** Digital Imprinting Type */
  DigitalImprinting = 'DIGITAL_IMPRINTING',
  /** Hot Stamping Type */
  HotStamping = 'HOT_STAMPING'
}

/** User Contact Mode */
export enum ContactMode {
  /** Multi */
  Multi = 'MULTI',
  /** Single */
  Single = 'SINGLE'
}

/** A configuration to be copied/cloned */
export type CopyConfigurationInput = {
  /** The id of the configurations */
  configurationIds: Array<Scalars['ID']['input']>;
  /** The user who will own the newly created configuration */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input to create a Contact */
export type CreateContactInput = {
  /** Direct phone number */
  directPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Extension for direct phone number */
  directPhoneNumberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Email Address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile phone number */
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Ship to account number */
  shipToAccountNumber: Scalars['String']['input'];
  /** Suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** Required data for creating a new credit/debit card */
export type CreateCreditCardInput = {
  /** Card type (Visa / Mastercard / etc.) */
  cardType: CardType | `${CardType}`;
  /** Cardholder Name */
  cardholderName: Scalars['String']['input'];
  /** Card verification value */
  cvv: Scalars['String']['input'];
  /** Expiration month */
  expirationMonth: Scalars['Int']['input'];
  /** Expiration year */
  expirationYear: Scalars['Int']['input'];
  /** The tokenized card number */
  tokenizedCardNumber: Scalars['String']['input'];
  /** Set default payment method (optional) */
  updateDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zip Code */
  zip: Scalars['String']['input'];
};

/** Favorite List Input */
export type CreateFavoriteListInput = {
  /** Optional FavoriteList description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Required FavoriteList name */
  name: Scalars['String']['input'];
};

/** Create Locate A Jeweler Listing Input */
export type CreateLocateAJewelerListingInput = {
  /** Address */
  address: LocateAJewelerAddressInput;
  /** Doing business as */
  doingBusinessAs: Scalars['String']['input'];
  /** Email id */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Hours */
  hours?: InputMaybe<LocateAJewelerHoursInput>;
  /** Jeweler showcase url */
  jewelerShowcaseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Keywords */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Location description */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Owner */
  owner?: InputMaybe<LocateAJewelerOwnerInput>;
  /** Phone number */
  phoneNumber: Scalars['String']['input'];
  /** Products */
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sales features */
  salesFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Services */
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Shiptoaccount number */
  shipToAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Shop featues */
  shopFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Socials */
  socials?: InputMaybe<LocateAJewelerSocialsInput>;
  /** User agreement terms */
  userAgreesToTerms: Scalars['Boolean']['input'];
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Input for createNotification mutation */
export type CreateNotificationInput = {
  /** Notification App */
  app: NotificationApp | `${NotificationApp}`;
  /** Number of Days notification expires in */
  expiresIn: Scalars['Int']['input'];
  /** Notification Important */
  important: Scalars['Boolean']['input'];
  /** Notification Metadata */
  metadata: NotificationMetadataInput;
  /** Notification Status */
  status: NotificationStatus | `${NotificationStatus}`;
  /** Notification Type */
  type: NotificationType | `${NotificationType}`;
  /** Optional uniquekey to prevent duplicates */
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  /** User Id */
  userId: Scalars['ID']['input'];
};

/** Paging Cursor Input */
export type CursorPagingInput = {
  /** Cursor */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Page Size */
  limit: Scalars['Int']['input'];
};

/** Custom Showcase Setting Detail Type */
export enum CustomShowcaseSettingDetailType {
  /** Add to quote */
  AddToQuote = 'AddToQuote',
  /** Allow iframe host API */
  AllowIframeHostApi = 'AllowIframeHostApi',
  /** Allow iframe host API domains csv list */
  AllowIframeHostApiDomainsCsvList = 'AllowIframeHostApiDomainsCsvList',
  /** Allow memo in showcase */
  AllowMemoInShowcase = 'AllowMemoInShowcase',
  /** Allow memo in showcase diamonds with grading report only */
  AllowMemoInShowcaseDiamondsWithGradingReportOnly = 'AllowMemoInShowcaseDiamondsWithGradingReportOnly',
  /** Can Show Quote ID */
  CanShowQuoteId = 'CanShowQuoteId',
  /** Category embed ID */
  CategoryEmbedId = 'CategoryEmbedId',
  /** Category replacement */
  CategoryReplacement = 'CategoryReplacement',
  /** Change color of custom order status display */
  ChangeColorOfStatusDisplayCustomOrder = 'ChangeColorOfStatusDisplayCustomOrder',
  /** Customization Exclusion */
  CustomizationExclusion = 'CustomizationExclusion',
  /** Disable favorites */
  DisableFavorites = 'DisableFavorites',
  /** Hide add to cart */
  HideAddToCart = 'HideAddToCart',
  /** Hide contact links in header */
  HideContactLinksInHeader = 'HideContactLinksInHeader',
  /** Hide nav bar for showcase */
  HideNavBarForShowcase = 'HideNavBarForShowcase',
  /** Hide per CT price */
  HidePerCtPrice = 'HidePerCtPrice',
  /** Hide search bar */
  HideSearchBar = 'HideSearchBar',
  /** Indicates to redirect the diamond landing page to diamonds with grading report search page */
  RedirectDiamondLandingPageToDiamondsWithGradingReportSearch = 'RedirectDiamondLandingPageToDiamondsWithGradingReportSearch',
  /** Replaces status disclaimer of non returnable */
  ReplaceStatusDisplaimerOfNonReturnable = 'ReplaceStatusDisplaimerOfNonReturnable',
  /** Replaces status display of custom order */
  ReplaceStatusDisplayOfCustomOrder = 'ReplaceStatusDisplayOfCustomOrder',
  /** Replaces status display of non customorder */
  ReplaceStatusDisplayOfNonCustomOrder = 'ReplaceStatusDisplayOfNonCustomOrder',
  /** Show custom shipment message */
  ShowCustomShipmentMessage = 'ShowCustomShipmentMessage',
  /** Show estimated ship date */
  ShowEstimatedShipDate = 'ShowEstimatedShipDate',
  /** Use contract pricing */
  UseContractPricing = 'UseContractPricing'
}

/** Input to deactivate a Contact */
export type DeactivateContactInput = {
  /** Contact id */
  id: Scalars['ID']['input'];
  /** Ship to account number */
  shipToAccountNumber: Scalars['String']['input'];
};

/** Delete All Cart Lines Input */
export type DeleteAllCartLinesInput = {
  /** Cart Id */
  cartId: Scalars['ID']['input'];
};

/** Delete cart line input */
export type DeleteCartLineInput = {
  /** Cart line id */
  id: Scalars['ID']['input'];
};

/** Delete Credit Card Input */
export type DeleteCreditCardInput = {
  /** Credit Card ID */
  creditCardId: Scalars['ID']['input'];
};

/** Delete Locate A Jeweler Listing Input */
export type DeleteLocateAJewelerListingInput = {
  /** Locate A Jeweler Listing Id */
  locateAJewelerListingId: Scalars['ID']['input'];
};

/** Input for deleteNotification mutation */
export type DeleteNotificationInput = {
  /** Notification App */
  app: NotificationApp | `${NotificationApp}`;
  /** Notification Id */
  id: Scalars['ID']['input'];
  /** Optionaly user id, default is to use the current user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Delete saved cart line input */
export type DeleteSavedCartLineInput = {
  /** Saved cart line id */
  savedCartLineId: Scalars['ID']['input'];
};

/** Input for GlobalUnsubscribeContact mutation */
export type GlobalUnsubscribeContactInput = {
  /** Contact Id */
  contactId: Scalars['ID']['input'];
  /** Ship-to account number */
  shipToAccountNumber: Scalars['String']['input'];
  /** Unsubscribe email from all preferences */
  unsubscribeEmailAddress: Scalars['Boolean']['input'];
  /** Unsubscribe mobile phone from all preferences */
  unsubscribeMobilePhoneNumber: Scalars['Boolean']['input'];
};

/** Input for GlobalUnsubscribeEmail mutation */
export type GlobalUnsubscribeEmailInput = {
  /** Email Address */
  emailAddress: Scalars['String']['input'];
  /** Salesforce Contact Id */
  salesforceContactId: Scalars['ID']['input'];
};

/** Input to update the hideUsdPrices */
export type HideUsdCurrencyInput = {
  /** HideUsdPrice */
  hideUsdPrices: Scalars['Boolean']['input'];
};

/** Item Id */
export type ItemIdInput = {
  /** Id */
  id: Scalars['ID']['input'];
  /** Type */
  type: ItemType | `${ItemType}`;
};

/** Options for Bag and Tag */
export type ItemLineBagAndTagOptionsInput = {
  /** How many items per bag? */
  quantityPerBag: Scalars['Int']['input'];
  /** Should the bags get tagged? */
  tagBags: Scalars['Boolean']['input'];
};

/** Item line options */
export type ItemLineOptionsInput = {
  /** Bag and Tag Options */
  bagAndTagOptions?: InputMaybe<ItemLineBagAndTagOptionsInput>;
  /** Is annealed */
  isAnnealed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is for consignment */
  isForConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is matched */
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length */
  length?: InputMaybe<LengthValueInput>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Reserved amounts(quantity, length, width) of an item in a scheduled order */
  reservedAmounts?: InputMaybe<ReservedAmountsInput>;
  /** Log ID for estimated ship date lineage/tracking */
  shipDateLogId?: InputMaybe<Scalars['ID']['input']>;
  /** Special instructions */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Width */
  width?: InputMaybe<LengthValueInput>;
};

/** Item Type */
export enum ItemType {
  /** Configuration Type */
  Configuration = 'CONFIGURATION',
  /** Product Type */
  Product = 'PRODUCT',
  /** Serialized Product Type */
  SerializedProduct = 'SERIALIZED_PRODUCT'
}

/** Items input per ship to account */
export type ItemsInput = {
  /** Items to retrieve */
  items: Array<ItemsItemInput>;
  /** Ship to account id */
  shipToAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Showcase Price Behavior */
  showcasePriceBehavior?: InputMaybe<ShowcasePriceBehavior | `${ShowcasePriceBehavior}`>;
};

/** Single item for items input */
export type ItemsItemInput = {
  /** Item id */
  id: ItemIdInput;
  /** Order line options */
  options?: InputMaybe<ItemLineOptionsInput>;
};

/** Create Jeweler Showcase Callback Request */
export type JewelerShowcaseCallbackRequestInput = {
  /** Email Address */
  emailAddress: Scalars['String']['input'];
  /** First Name */
  firstName: Scalars['String']['input'];
  /** Last Name */
  lastName: Scalars['String']['input'];
  /** Message to Jeweler */
  messageToJeweler?: InputMaybe<Scalars['String']['input']>;
  /** Phone Number */
  phoneNumber: Scalars['String']['input'];
  /** Recaptcha Response Token */
  recaptchaResponseToken: Scalars['String']['input'];
};

/** Length Value (for use as an input) */
export type LengthValueInput = {
  /** Unit of Measure */
  uom: LengthValueUom | `${LengthValueUom}`;
  /** Value */
  value: Scalars['Float']['input'];
};

/** Length UOMs */
export enum LengthValueUom {
  /** Measured in inches */
  Inch = 'INCH',
  /** Measured in millimeters */
  Millimeter = 'MILLIMETER'
}

/** Locate A Jeweler Address Input */
export type LocateAJewelerAddressInput = {
  /** Address Line 1 */
  addressLine1: Scalars['String']['input'];
  /** Address Line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country Code */
  country: Scalars['String']['input'];
  /** StateOrProvince */
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zip: Scalars['String']['input'];
};

/** Locate A Jeweler Hours Input */
export type LocateAJewelerHoursInput = {
  /** Friday */
  friday: LocateAJewelerHoursSettingsInput;
  /** Monday */
  monday: LocateAJewelerHoursSettingsInput;
  /** Saturday */
  saturday: LocateAJewelerHoursSettingsInput;
  /** Sunday */
  sunday: LocateAJewelerHoursSettingsInput;
  /** Thursday */
  thursday: LocateAJewelerHoursSettingsInput;
  /** tuesday */
  tuesday: LocateAJewelerHoursSettingsInput;
  /** Wednesday */
  wednesday: LocateAJewelerHoursSettingsInput;
};

/** Locate A Jeweler Hours Settings Input */
export type LocateAJewelerHoursSettingsInput = {
  /** Close time */
  closeTime?: InputMaybe<Scalars['String']['input']>;
  /** Open time */
  openTime?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type: LocateAJewelerHoursSettingsType | `${LocateAJewelerHoursSettingsType}`;
};

/** Jeweler Hours Settings Type */
export enum LocateAJewelerHoursSettingsType {
  /** Appointment Only */
  AppointmentOnly = 'APPOINTMENT_ONLY',
  /** Closed */
  Closed = 'CLOSED',
  /** Open */
  Open = 'OPEN'
}

/** Locate A Jeweler Owner Input */
export type LocateAJewelerOwnerInput = {
  /** First Name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Salutation */
  salutation?: InputMaybe<Scalars['String']['input']>;
  /** Suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** Locate A Jeweler Socials Input */
export type LocateAJewelerSocialsInput = {
  /** Facebook */
  facebook?: InputMaybe<Scalars['String']['input']>;
  /** Instagram */
  instagram?: InputMaybe<Scalars['String']['input']>;
  /** Pinterest */
  pinterest?: InputMaybe<Scalars['String']['input']>;
  /** Twitter */
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** Youtube */
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** Move All Lines To Cart Input */
export type MoveAllLinesToCartInput = {
  /** Id of the source cart to remove lines */
  sourceCartId: Scalars['ID']['input'];
  /** Optional id of the destination cart. If none specified the user's current cart will be used */
  targetCartId?: InputMaybe<Scalars['ID']['input']>;
};

/** Move Single Line To Cart Input */
export type MoveCartLineToCartInput = {
  /** Id of the cart line to be moved */
  cartLineId: Scalars['ID']['input'];
  /** Optional id of the destination cart. If none specified the user's current cart will be used */
  targetCartId?: InputMaybe<Scalars['ID']['input']>;
};

/** Move favorites input */
export type MoveFavoritesInput = {
  /** Favorite Ids */
  favoriteIds: Array<Scalars['ID']['input']>;
  /** Target FavoriteList Id */
  targetFavoriteListId: Scalars['ID']['input'];
};

/** Move saved cart line to cart input */
export type MoveSavedCartLineToCartInput = {
  /** Saved cart line id */
  savedCartLineId: Scalars['ID']['input'];
};

/** Notification app */
export enum NotificationApp {
  /** EverAndEver */
  Everandever = 'EVERANDEVER',
  /** StullerCom */
  Stullercom = 'STULLERCOM',
  /** 302 */
  Threeohtwo = 'THREEOHTWO'
}

/** Notification Metadata Input */
export type NotificationMetadataInput = {
  /** Description body */
  body: Scalars['String']['input'];
  /** Text title */
  title: Scalars['String']['input'];
  /** Url to link to */
  url: Scalars['String']['input'];
};

/** Notification status */
export enum NotificationStatus {
  /** Read Notification */
  Read = 'READ',
  /** Unread Notification */
  Unread = 'UNREAD'
}

/** Notification type */
export enum NotificationType {
  /** Account Update */
  AccountUpdate = 'ACCOUNT_UPDATE',
  /** Blue Check */
  BlueCheck = 'BLUE_CHECK',
  /** Blue Hourglass */
  BlueHourglass = 'BLUE_HOURGLASS',
  /** Blue Info */
  BlueInfo = 'BLUE_INFO',
  /** New Feature */
  FeatureNew = 'FEATURE_NEW',
  /** Green Check */
  GreenCheck = 'GREEN_CHECK',
  /** Membership Update */
  MembershipUpdate = 'MEMBERSHIP_UPDATE',
  /** New Message */
  MessageNew = 'MESSAGE_NEW',
  /** New Green Calendar */
  NewGreenCalendar = 'NEW_GREEN_CALENDAR',
  /** New Green Info */
  NewGreenInfo = 'NEW_GREEN_INFO',
  /** New Green Sparkles */
  NewGreenSparkles = 'NEW_GREEN_SPARKLES',
  /** New Green Tag */
  NewGreenTag = 'NEW_GREEN_TAG',
  /** Project Update */
  ProjectUpdate = 'PROJECT_UPDATE',
  /** Red Exclamation */
  RedExclamation = 'RED_EXCLAMATION',
  /** Return Update */
  ReturnUpdate = 'RETURN_UPDATE',
  /** Shipment Green Check */
  ShipmentGreenCheck = 'SHIPMENT_GREEN_CHECK',
  /** Shipment Green Truck */
  ShipmentGreenTruck = 'SHIPMENT_GREEN_TRUCK',
  /** New Shipment */
  ShipmentNew = 'SHIPMENT_NEW',
  /** Shipment Summary */
  ShipmentSummary = 'SHIPMENT_SUMMARY',
  /** Shipment Update */
  ShipmentUpdate = 'SHIPMENT_UPDATE',
  /** Shipment Yellow Exclamation */
  ShipmentYellowExclamation = 'SHIPMENT_YELLOW_EXCLAMATION',
  /** New Statement */
  StatementNew = 'STATEMENT_NEW',
  /** Yellow Exclamation */
  YellowExclamation = 'YELLOW_EXCLAMATION'
}

/** Order Line Options (for use as an input) */
export type OrderLineOptionsInput = {
  /** Bag and tag options (for Consultant/DOT users) */
  bagAndTagOptions?: InputMaybe<BagAndTagOptionsInput>;
  /** Discount Percent (for Consultant/DOT users) */
  consultantDiscount?: InputMaybe<Scalars['Float']['input']>;
  /** Customer notes */
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  /** Is annealed */
  isAnnealed: Scalars['Boolean']['input'];
  /** Is for consignment */
  isForConsignment: Scalars['Boolean']['input'];
  /** Is matched */
  isMatched: Scalars['Boolean']['input'];
  /** Length */
  length?: InputMaybe<LengthValueInput>;
  /** Matching Code (for Consultant/DOT users) */
  matchingCode?: InputMaybe<Scalars['String']['input']>;
  /** Quantity */
  quantity: Scalars['Float']['input'];
  /** Sales Type (for Consultant/DOT users) */
  salesType?: InputMaybe<SalesType | `${SalesType}`>;
  /** Special instructions */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Width */
  width?: InputMaybe<LengthValueInput>;
};

/** Paging Input */
export type PagingInput = {
  /** Limit */
  limit: Scalars['Int']['input'];
  /** Page */
  page: Scalars['Int']['input'];
};

/** Payment Method Context */
export enum PaymentMethodContext {
  /** Checkout */
  Checkout = 'CHECKOUT'
}

/** Product in stock status code */
export enum ProductInStockStatusCode {
  /** Item has availability */
  Availability = 'AVAILABILITY',
  /** Item is currently not available */
  CurrentlyNotAvailable = 'CURRENTLY_NOT_AVAILABLE',
  /** Item is customized at time of order */
  CustomOrder = 'CUSTOM_ORDER',
  /** Item is in stock */
  InStock = 'IN_STOCK',
  /** Item is mde to order */
  MadeToOrder = 'MADE_TO_ORDER',
  /** Item is out of stock */
  OutOfStock = 'OUT_OF_STOCK',
  /** Item is partially available */
  PartiallyAvailable = 'PARTIALLY_AVAILABLE',
  /** Item can be pre-ordered */
  PreOrder = 'PRE_ORDER',
  /** Item can be special ordered */
  SpecialOrder = 'SPECIAL_ORDER',
  /** Item can be ordered while supplies last */
  WhileSuppliesLast = 'WHILE_SUPPLIES_LAST'
}

/** Product Share Email Input */
export type ProductShareEmailInput = {
  /** Item Id */
  itemId: ItemIdInput;
  /** Message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Recaptcha Response Token */
  recaptchaResponseToken: Scalars['String']['input'];
  /** Recipient Email */
  recipientEmail: Scalars['String']['input'];
  /** Recipient Name */
  recipientName: Scalars['String']['input'];
  /** Sender Email */
  senderEmail: Scalars['String']['input'];
  /** Sender Name */
  senderName: Scalars['String']['input'];
};

/** Reactivate Cad Cam Request by Id Input */
export type ReactivateCadCamRequestByIdInput = {
  /** CAD CAM ID */
  id: Scalars['ID']['input'];
};

/** Amounts reserved in a scheduled order */
export type ReservedAmountsInput = {
  /** Length */
  length?: InputMaybe<LengthValueInput>;
  /** Quantity */
  quantity: Scalars['Float']['input'];
  /** Width */
  width?: InputMaybe<LengthValueInput>;
};

/** Add to Cart Consultant Sales Type */
export enum SalesType {
  /** Cross Sell */
  CrossSell = 'CROSS_SELL',
  /** Substitute */
  Substitute = 'SUBSTITUTE',
  /** Upsell */
  Upsell = 'UPSELL'
}

/** Cart/Order Line Consultant Sales Type (for use as an input) */
export enum SalesTypeInput {
  /** Cross Sell */
  CrossSell = 'CROSS_SELL',
  /** Substitute */
  Substitute = 'SUBSTITUTE',
  /** Upsell */
  Upsell = 'UPSELL'
}

/** Credit/Debit Card Type */
export enum ScheduledOrderCardType {
  /** American Express */
  AmericanExpress = 'AMERICAN_EXPRESS',
  /** Discover */
  Discover = 'DISCOVER',
  /** Mastercard */
  Mastercard = 'MASTERCARD',
  /** Other */
  Other = 'OTHER',
  /** Visa */
  Visa = 'VISA'
}

/** Input for setting the primary contact on a user */
export type SetPrimaryContactInput = {
  /** Contact ID */
  contactId: Scalars['ID']['input'];
  /** Ship to Account to check for other contact admins */
  shipToAccountNumber: Scalars['String']['input'];
};

/** Ship complete method enum */
export enum ShipCompleteMethod {
  /** Individual */
  Individual = 'INDIVIDUAL',
  /** Line level */
  LineLevel = 'LINE_LEVEL',
  /** Partial ship complete */
  PartialShipComplete = 'PARTIAL_SHIP_COMPLETE',
  /** Ship complete */
  ShipComplete = 'SHIP_COMPLETE'
}

/** Shipping countdown type */
export enum ShippingCountdownKind {
  /** No Order */
  NoOrder = 'NO_ORDER',
  /** Previous Order */
  PreviousOrder = 'PREVIOUS_ORDER',
  /** Scheduled Order */
  ScheduledOrder = 'SCHEDULED_ORDER'
}

/** Showcase Price Behavior */
export enum ShowcasePriceBehavior {
  /** Applies showcase markups if the user is in showcase mode or the site mode indicates jeweler showcase */
  Contextual = 'CONTEXTUAL',
  /** Showcase markups do not apply */
  Off = 'OFF'
}

/** Input for querying for if a user is allowed to view Stone Rebates */
export enum StoneRebateType {
  /** Diamond */
  Diamond = 'DIAMOND',
  /** Gemstone */
  Gemstone = 'GEMSTONE'
}

/** Task Identifier Input */
export type TaskIdentifierInput = {
  /** Task domain */
  domain: Scalars['String']['input'];
  /** Invoked from */
  invokedFrom: Scalars['String']['input'];
  /** Task key */
  taskKey: Scalars['String']['input'];
};

/** All line-source tracking data */
export type TrackingSourceInput = {
  /** Index */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** The source that the item was purchased from */
  source: Scalars['String']['input'];
  /** Source Id */
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  /** Type of tracking */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Update cart line options input */
export type UpdateCartLineInput = {
  /** ID */
  cartLineId: Scalars['ID']['input'];
  /** List of existing line options that should be replaced with the new options value(s) */
  fieldsToUpdate: Array<UpdateOrderLineOptionsFieldsInput | `${UpdateOrderLineOptionsFieldsInput}`>;
  /** Order line options values to update */
  options: UpdateOrderLineOptionsInput;
};

/** Update cart line quantity input */
export type UpdateCartLineQuantityInput = {
  /** ID */
  id: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Float']['input'];
};

/** Input to update a Contact */
export type UpdateContactInput = {
  /** Direct phone number */
  directPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Extension for direct phone number */
  directPhoneNumberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Email Address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Contact id */
  id: Scalars['ID']['input'];
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Mobile phone number */
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Ship to account number */
  shipToAccountNumber: Scalars['String']['input'];
  /** Suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** Required data for updating an existing user credit/debit card */
export type UpdateCreditCardInput = {
  /** The card id */
  cardId: Scalars['ID']['input'];
  /** Cardholder Name */
  cardholderName: Scalars['String']['input'];
  /** Expiration month */
  expirationMonth: Scalars['Int']['input'];
  /** Expiration year */
  expirationYear: Scalars['Int']['input'];
  /** Set default payment method (optional) */
  updateDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for CurrencyUpdate mutation */
export type UpdateCurrencyDisplayInput = {
  /** Currency culture */
  currencyDisplay: Scalars['String']['input'];
};

/** Input for UpdateDefaultPaymentMethod mutation */
export type UpdateDefaultPaymentMethodInput = {
  /** Payment Method ID */
  id: Scalars['ID']['input'];
  /** Payment Method Type */
  paymentMethodType: Scalars['String']['input'];
};

/** Update Favorite List Method Input */
export type UpdateFavoriteListInput = {
  /** FavoriteList description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['ID']['input'];
  /** Is Default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Pinned */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** FavoriteList name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update Favorites Input */
export type UpdateFavoritesInput = {
  /** ID of favorite to update */
  favoriteId: Scalars['ID']['input'];
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Sort Order */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for setting Hold Shipment Date on a account number */
export type UpdateHoldShipmentsDateInput = {
  /** Hold Shipments Date */
  holdShipmentsDate?: InputMaybe<Scalars['Date']['input']>;
  /** Ship to Account number to check for user account */
  shipToAccountNumber: Scalars['String']['input'];
};

/** Update Locate A Jeweler Listing Input */
export type UpdateLocateAJewelerListingInput = {
  /** Address */
  address: LocateAJewelerAddressInput;
  /** Doing business as */
  doingBusinessAs: Scalars['String']['input'];
  /** Email id */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Hours */
  hours?: InputMaybe<LocateAJewelerHoursInput>;
  /** Jeweler showcase url */
  jewelerShowcaseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Keywords */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Locate A Jeweler Listing Id */
  locateAJewelerListingId: Scalars['ID']['input'];
  /** Location description */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Owner */
  owner?: InputMaybe<LocateAJewelerOwnerInput>;
  /** Phone number */
  phoneNumber: Scalars['String']['input'];
  /** Products */
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sales features */
  salesFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Services */
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Shiptoaccount number */
  shipToAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Shop featues */
  shopFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Socials */
  socials?: InputMaybe<LocateAJewelerSocialsInput>;
  /** User agreement terms */
  userAgreesToTerms: Scalars['Boolean']['input'];
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updateNotificationStatus mutation */
export type UpdateNotificationStatusInput = {
  /** Notification App */
  app: NotificationApp | `${NotificationApp}`;
  /** Notification Id */
  id: Scalars['ID']['input'];
  /** Notification Status */
  status: NotificationStatus | `${NotificationStatus}`;
  /** Optionaly user id, default is to use the current user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updateNotificationFeedRead mutation */
export type UpdateNotificationsFeedReadInput = {
  /** Notification App */
  app: NotificationApp | `${NotificationApp}`;
  /** Optionaly user id, default is to use the current user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** List of order line options fields */
export enum UpdateOrderLineOptionsFieldsInput {
  /** Discount Percent */
  ConsultantDiscount = 'CONSULTANT_DISCOUNT',
  /** Customer notes */
  CustomerNotes = 'CUSTOMER_NOTES',
  /** Is annealed */
  IsAnnealed = 'IS_ANNEALED',
  /** Is for consignment */
  IsForConsignment = 'IS_FOR_CONSIGNMENT',
  /** Is matched */
  IsMatched = 'IS_MATCHED',
  /** Length */
  Length = 'LENGTH',
  /** Matching Code */
  MatchingCode = 'MATCHING_CODE',
  /** Quantity */
  Quantity = 'QUANTITY',
  /** Sales Type */
  SalesType = 'SALES_TYPE',
  /** Ship set code */
  ShipSetCode = 'SHIP_SET_CODE',
  /** Special instructions */
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  /** Width */
  Width = 'WIDTH'
}

/** Order Line Options with all properties optional (used when updating a cart line) */
export type UpdateOrderLineOptionsInput = {
  /** Discount Percent (for Consultant/DOT users) */
  consultantDiscount?: InputMaybe<Scalars['Float']['input']>;
  /** Customer notes */
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  /** Is annealed */
  isAnnealed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is for consignment */
  isForConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is matched */
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length */
  length?: InputMaybe<LengthValueInput>;
  /** Matching Code (for Consultant/DOT users) */
  matchingCode?: InputMaybe<Scalars['String']['input']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Sales Type (for Consultant/DOT users) */
  salesType?: InputMaybe<SalesType | `${SalesType}`>;
  /** Ship set code */
  shipSetCode?: InputMaybe<Scalars['String']['input']>;
  /** Special instructions */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Width */
  width?: InputMaybe<LengthValueInput>;
};

/** An update to an existing saved cart line */
export type UpdateSavedCartLineInput = {
  /** New saved cartline properties which need to be updated */
  fieldsToUpdate: Array<UpdateSavedOrderLineOptionsFields | `${UpdateSavedOrderLineOptionsFields}`>;
  /** New saved cartline options values */
  options: UpdateSavedOrderLineOptionsInput;
  /** Saved cart line id */
  savedCartLineId: Scalars['ID']['input'];
};

/** List of saved cart line options fields to be updated */
export enum UpdateSavedOrderLineOptionsFields {
  /** Customer notes */
  CustomerNotes = 'CUSTOMER_NOTES',
  /** Is annealed */
  IsAnnealed = 'IS_ANNEALED',
  /** Is for consignment */
  IsForConsignment = 'IS_FOR_CONSIGNMENT',
  /** Is matched */
  IsMatched = 'IS_MATCHED',
  /** Length */
  Length = 'LENGTH',
  /** Quantity */
  Quantity = 'QUANTITY',
  /** Special instructions */
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  /** Width */
  Width = 'WIDTH'
}

/** Saved cart line options with all properties optional (used when updating a saved cart line) */
export type UpdateSavedOrderLineOptionsInput = {
  /** Customer notes */
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  /** Is annealed */
  isAnnealed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is for consignment */
  isForConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is matched */
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length */
  length?: InputMaybe<LengthValueInput>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Special instructions */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Width */
  width?: InputMaybe<LengthValueInput>;
};

/** Update Scheduled Cart Shipping Method Input */
export type UpdateScheduledCartShippingMethodInput = {
  /** Is Saturday Delivery */
  isSaturdayDelivery: Scalars['Boolean']['input'];
  /** Ship Set Code */
  shipSetCode: Scalars['String']['input'];
  /** Shipping Method Id */
  shippingMethodId: Scalars['ID']['input'];
};

/** Update Scheduled Order Input */
export type UpdateScheduledOrderInput = {
  /** Ship complete method */
  shipCompleteMethod: ShipCompleteMethod | `${ShipCompleteMethod}`;
};

/** Input for updating a contact's communication preference */
export type UpsertCommunicationPreferenceInput = {
  /** Create the preference if there is no preference id */
  communicationPreferenceCreationToken: Scalars['ID']['input'];
  /** Preference Id */
  communicationPreferenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Contact Id */
  contactId: Scalars['ID']['input'];
  /** Whether the contact should be subscribed to the preference */
  isSubscribed: Scalars['Boolean']['input'];
  /** Ship to account number */
  shipToAccountNumber: Scalars['String']['input'];
};

/** Input type for upserting customer store information */
export type UpsertCustomerStoreInformationInput = {
  /** Ags */
  ags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Agta */
  agta?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business Established Year */
  businessEstablishedYear?: InputMaybe<Scalars['Int']['input']>;
  /** Business Location Community */
  businessLocationCommunity?: InputMaybe<Scalars['String']['input']>;
  /** Buyers International Group */
  buyersInternationalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Canadian Buying Group */
  canadianBuyingGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Continental Buying Group */
  continentalBuyingGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Creation Date */
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Di Gem */
  diGem?: InputMaybe<Scalars['Boolean']['input']>;
  /** Employee Count */
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  /** Gemalta Cooperative */
  gemaltaCooperative?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Independent Jewelers Organization */
  independentJewelersOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ja */
  ja?: InputMaybe<Scalars['Boolean']['input']>;
  /** Jic */
  jic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Jvc */
  jvc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Leading Jewelers */
  leadingJewelers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Location Of Sales */
  locationOfSales?: InputMaybe<Scalars['String']['input']>;
  /** Mjsa */
  mjsa?: InputMaybe<Scalars['Boolean']['input']>;
  /** Modification Date */
  modificationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** National Pawnbrokers Association */
  nationalPawnbrokersAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number Of Employees */
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  /** Other Organizations */
  otherOrganizations?: InputMaybe<Scalars['String']['input']>;
  /** Primary Location Description */
  primaryLocationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Retail Jewelers Organization */
  retailJewelersOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ship To Account Number */
  shipToAccountNumber: Scalars['String']['input'];
  /** Site Has Shopping Cart */
  siteHasShoppingCart?: InputMaybe<Scalars['String']['input']>;
  /** User Id */
  userId: Scalars['String']['input'];
};

export type GetAccountSettingsLayoutContactInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountSettingsLayoutContactInfoQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, fullName?: string | null, contactMode: ContactMode, defaultActiveShipToAccount?: { __typename?: 'ShipToAccount', id: string, billToAccount: { __typename?: 'BillToAccount', id: string, accountNumber: string, accountType?: string | null, companyName: string } } | null } | null };

export type GetAccountSettingsLayoutPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountSettingsLayoutPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canApproveOrders?: boolean | null, canAutoReorder: boolean, canCreateLocateAJewelerListings: boolean, canCreateUsers: boolean, canManageLogos: boolean, canManageMarketplaceSolutions: boolean, canManagePaymentMethods: boolean, canManagePreferences: boolean, canManageProductDataFeeds: boolean, canManageStullerFirstEnrollments: boolean, canPayBill?: boolean | null, canSetup302Showcase: boolean, canSetupEverAndEverShowcase: boolean, canSetupShowcase: boolean, canSignupForProductDataFeeds: boolean, canUpdateHoldShipments?: boolean | null, canUpgradeAccount: boolean, canUseCreditCards: boolean, canViewInvoices?: boolean | null, canViewJewelerShowcaseRequests: boolean, canViewMarketingAssets: boolean, canViewOrders?: boolean | null, canViewStatements?: boolean | null } };

export type AddToCartMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type AddToCartInStockStatusInfoFragment = { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } };

export type AddToCartPriceValuesInfoFragment = { __typename?: 'CurrencyValue', value: number, valueInUsd: number };

export type AddToCartPriceValuesWithCurrencyInfoFragment = { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } };

export type AddToCartItemPriceInfoFragment = { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } };

type AddToCartSectionInfo_Configuration_Fragment = { __typename?: 'Configuration', id: string, title: string, image?: string | null, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null };

type AddToCartSectionInfo_Product_Fragment = { __typename?: 'Product', id: string, title: string, image?: string | null, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null };

type AddToCartSectionInfo_SerializedProduct_Fragment = { __typename?: 'SerializedProduct', serialNumber: string, percentOffRapaport?: number | null, isOnConsignment?: boolean | null, isActive: boolean, isDiamond: boolean, isGemstone: boolean, isLabGrown: boolean, id: string, title: string, image?: string | null, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null };

export type AddToCartSectionInfoFragment = AddToCartSectionInfo_Configuration_Fragment | AddToCartSectionInfo_Product_Fragment | AddToCartSectionInfo_SerializedProduct_Fragment;

export type GetAddToCartProductDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<ItemLineOptionsInput>;
  nonConsignmentOptions?: InputMaybe<ItemLineOptionsInput>;
}>;


export type GetAddToCartProductDetailsQuery = { __typename?: 'Query', productById?: { __typename?: 'Product', id: string, title: string, image?: string | null, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, product: { __typename?: 'Product', itemNumber: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null } | null };

export type GetAddToCartSerializedDetailsQueryVariables = Exact<{
  serialNumber: Scalars['ID']['input'];
  options?: InputMaybe<ItemLineOptionsInput>;
  nonConsignmentOptions?: InputMaybe<ItemLineOptionsInput>;
}>;


export type GetAddToCartSerializedDetailsQuery = { __typename?: 'Query', serializedProductBySerialNumber?: { __typename?: 'SerializedProduct', id: string, serialNumber: string, percentOffRapaport?: number | null, isOnConsignment?: boolean | null, isActive: boolean, isDiamond: boolean, isGemstone: boolean, isLabGrown: boolean, title: string, image?: string | null, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, product: { __typename?: 'Product', itemNumber: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null } | null };

export type GetAddToCartConfigurationDetailsQueryVariables = Exact<{
  configId: Scalars['ID']['input'];
  options?: InputMaybe<ItemLineOptionsInput>;
  nonConsignmentOptions?: InputMaybe<ItemLineOptionsInput>;
}>;


export type GetAddToCartConfigurationDetailsQuery = { __typename?: 'Query', configurationById?: { __typename?: 'Configuration', id: string, title: string, image?: string | null, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, product: { __typename?: 'Product', itemNumber: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null } | null };

export type GetAddToCartShowcasePriceSummaryQueryVariables = Exact<{
  input: ItemsInput;
}>;


export type GetAddToCartShowcasePriceSummaryQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Configuration', title: string, image?: string | null, showcasePriceSummary?: { __typename?: 'ShowcasePriceSummary', baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, sections?: Array<{ __typename?: 'ShowcasePriceSummarySection', title?: string | null, item?: { __typename?: 'Configuration', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'Product', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'SerializedProduct', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | null, baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, additionalCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, centsOverride?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, components?: Array<{ __typename?: 'ShowcasePriceSummaryComponent', title?: string | null, markupDescription?: string | null, markupMultiplier?: number | null, quantity?: number | null, item?: { __typename?: 'Configuration', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | { __typename?: 'Product', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | { __typename?: 'SerializedProduct', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | null, basePrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, baseStoneSettingCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markupPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, minimumPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, flatPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpStoneSettingCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null }> | null }> | null } | null } | { __typename?: 'Product', title: string, image?: string | null, showcasePriceSummary?: { __typename?: 'ShowcasePriceSummary', baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, sections?: Array<{ __typename?: 'ShowcasePriceSummarySection', title?: string | null, item?: { __typename?: 'Configuration', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'Product', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'SerializedProduct', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | null, baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, additionalCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, centsOverride?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, components?: Array<{ __typename?: 'ShowcasePriceSummaryComponent', title?: string | null, markupDescription?: string | null, markupMultiplier?: number | null, quantity?: number | null, item?: { __typename?: 'Configuration', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | { __typename?: 'Product', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | { __typename?: 'SerializedProduct', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | null, basePrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, baseStoneSettingCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markupPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, minimumPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, flatPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpStoneSettingCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null }> | null }> | null } | null } | { __typename?: 'SerializedProduct', title: string, image?: string | null, showcasePriceSummary?: { __typename?: 'ShowcasePriceSummary', baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, sections?: Array<{ __typename?: 'ShowcasePriceSummarySection', title?: string | null, item?: { __typename?: 'Configuration', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'Product', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'SerializedProduct', image?: string | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | null, baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, additionalCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, centsOverride?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, components?: Array<{ __typename?: 'ShowcasePriceSummaryComponent', title?: string | null, markupDescription?: string | null, markupMultiplier?: number | null, quantity?: number | null, item?: { __typename?: 'Configuration', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | { __typename?: 'Product', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | { __typename?: 'SerializedProduct', itemId: { __typename?: 'ItemId', type: ItemType, id: string } } | null, basePrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, baseStoneSettingCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, baseTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markupPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, minimumPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, flatPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, markedUpStoneSettingCharge?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null }> | null }> | null } | null } | null> };

export type GetAddToCartTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartTypeQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, addToCartType?: AddToCartType | null } };

export type GetAddToCartUserShowcaseSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartUserShowcaseSettingsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, showcaseSettings?: { __typename?: 'ShowcaseSettings', setup: { __typename?: 'ShowcaseSettingsSetup', displayComplete: boolean, markupsComplete: boolean } } | null } | null };

export type GetQuoteDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQuoteDetailsQuery = { __typename?: 'Query', publicQuoteLineById?: { __typename?: 'PublicQuoteLine', date?: string | null, quote?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null };

export type GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartNeedsToAgreeToConsignmentTermsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, needsToAgreeToConsignmentTerms: boolean } | null };

export type GetAddToCartItemsQuantityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartItemsQuantityQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemId: { __typename?: 'ItemId', type: ItemType } } | { __typename?: 'Product', id: string, itemId: { __typename?: 'ItemId', type: ItemType } } | { __typename?: 'SerializedProduct', id: string, itemId: { __typename?: 'ItemId', type: ItemType } } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null }> | null } | null };

export type GetAddToCartDotOptionsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartDotOptionsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canSetOrderLineSalesType?: boolean | null } };

export type GetAddToCartCanAddToFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartCanAddToFavoritesQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canAddToFavorites?: boolean | null } };

export type GetAddToCartCanViewQuantityOnHandQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddToCartCanViewQuantityOnHandQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewQuantityOnHand: boolean } };

export type AddToCartMutationVariables = Exact<{
  inputs: Array<AddToCartInput> | AddToCartInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', addToCart?: { __typename?: 'AddToCartPayload', addedCartLineIds?: Array<string> | null, cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, configurationProduct: { __typename?: 'Product', id: string }, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, isForConsignment: boolean } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null } | null };

export type AddToCartCreateQuoteMutationVariables = Exact<{
  callbackRequest?: InputMaybe<JewelerShowcaseCallbackRequestInput>;
  addToCarts?: InputMaybe<Array<AddToCartInput> | AddToCartInput>;
}>;


export type AddToCartCreateQuoteMutation = { __typename?: 'Mutation', createQuote?: { __typename?: 'CreateQuotePayload', publicQuoteLines?: Array<{ __typename?: 'PublicQuoteLine', id: string }> | null, cart?: { __typename?: 'Cart', id: string, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null, productGroup?: { __typename?: 'ProductGroup', id: string, title: string, code: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null, request?: { __typename?: 'JewelerShowcaseCallbackRequest', emailAddress?: string | null } | null } | null };

export type GetAppAuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppAuthUserQuery = { __typename?: 'Query', authUser?: { __typename?: 'AuthUser', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, roles: Array<string>, impersonatedBy?: string | null, consultantLogin?: string | null, lastRefreshDate: string, user?: { __typename?: 'User', id: string, username: string, memberId: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, preferredShipToAccountId: string, resetPassword: boolean, isStullerFirstEnrolled: boolean, isStullerFirstEligible: boolean, is302Member: boolean, hasGemvisionAccount: boolean, isEverAndEverMember: boolean, ecommerceMerchandisingMode: boolean, currencyDisplay: { __typename?: 'ExchangeRate', culture: string, code: string }, scheduledOrder?: { __typename?: 'ScheduledOrder', id: string } | null, defaultActiveShipToAccount?: { __typename?: 'ShipToAccount', id: string, customerSegment?: string | null, customerValueScore?: number | null, phoneNumber?: string | null, billToAccount: { __typename?: 'BillToAccount', id: string }, timeZone: { __typename?: 'TimeZone', id: string }, priceList: { __typename?: 'PriceList', id: string, type?: string | null }, address: { __typename?: 'Address', country: string } } | null, contact?: { __typename?: 'Contact', id: string, firstName: string, lastName: string, salutation?: string | null, preferredName?: string | null, suffix?: string | null, active: boolean, inactiveReason?: string | null, fullName: string, displayName: string } | null } | null } | null };

export type GetAppShowcaseSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppShowcaseSettingsQuery = { __typename?: 'Query', showcaseSettings?: { __typename?: 'ShowcaseSettings', id: string, title?: string | null, logo?: string | null, phoneNumber?: string | null, jewelerShowcaseSubdomain?: string | null, showMetalMarkets: boolean, requiresAuthentication: boolean, iFrameShowNavigationBar: boolean, aboutUs?: string | null, aboutUsIsChecked: boolean, contactUs?: string | null, contactUsIsChecked: boolean, backgroundColorClass?: string | null, backgroundPatternClass?: string | null, hideUSDPrices: boolean, setup: { __typename?: 'ShowcaseSettingsSetup', markupsComplete: boolean }, customShowcaseSettings?: { __typename?: 'CustomShowcaseSettings', details: Array<{ __typename?: 'CustomShowcaseSettingDetail', id: string, type: CustomShowcaseSettingDetailType, values: Array<string | null> }> } | null } | null };

export type GetAuthExpiredSignatureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthExpiredSignatureQuery = { __typename?: 'Query', authUser?: { __typename?: 'AuthUser', id: string, signature: string } | null };

export type CadCamPageProjectManagerRequestRowInfoFragment = { __typename?: 'CadCamRequest', id: string, source: string, customerReference?: string | null, requestDate: string, estimatedShipDate?: string | null, isCancelled: boolean, cancelledReason?: string | null, canReorder: boolean, canReactivate: boolean, canAddToSignetCart: boolean, brand?: string | null, storeName?: string | null, storeReference?: string | null, customerName?: string | null, image?: { __typename?: 'Image', fullSize?: string | null, thumb225?: string | null } | null, requestStatuses: Array<{ __typename?: 'CadCamRequestStatus', name: string, description: string, startedDate?: string | null, completedDate?: string | null, isCustomerActionRequired: boolean }>, showcasePrice?: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', currencyCode: string, value: number, valueInUsd: number } } | null };

export type GetCadCamPageProjectsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCadCamPageProjectsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewCadCamRequests: boolean } };

export type GetCadCamPageRequestsSearchByDateRangeQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  onlyActionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  onlyReorderable?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCheckedOutByViewer?: InputMaybe<Scalars['Boolean']['input']>;
  shipToAccountNumber?: InputMaybe<Scalars['ID']['input']>;
  paging: PagingInput;
}>;


export type GetCadCamPageRequestsSearchByDateRangeQuery = { __typename?: 'Query', cadCamRequestSearchByDateRange: { __typename?: 'CadCamRequestsSearchByDateRangeResult', count: number, results: Array<{ __typename?: 'CadCamRequest', id: string, source: string, customerReference?: string | null, requestDate: string, estimatedShipDate?: string | null, isCancelled: boolean, cancelledReason?: string | null, canReorder: boolean, canReactivate: boolean, canAddToSignetCart: boolean, brand?: string | null, storeName?: string | null, storeReference?: string | null, customerName?: string | null, image?: { __typename?: 'Image', fullSize?: string | null, thumb225?: string | null } | null, requestStatuses: Array<{ __typename?: 'CadCamRequestStatus', name: string, description: string, startedDate?: string | null, completedDate?: string | null, isCustomerActionRequired: boolean }>, showcasePrice?: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', currencyCode: string, value: number, valueInUsd: number } } | null }> } };

export type GetCadCamRequestSearchByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCadCamRequestSearchByIdQuery = { __typename?: 'Query', cadCamRequestSearchById?: { __typename?: 'CadCamRequest', id: string, source: string, customerReference?: string | null, requestDate: string, estimatedShipDate?: string | null, isCancelled: boolean, cancelledReason?: string | null, canReorder: boolean, canReactivate: boolean, canAddToSignetCart: boolean, brand?: string | null, storeName?: string | null, storeReference?: string | null, customerName?: string | null, image?: { __typename?: 'Image', fullSize?: string | null, thumb225?: string | null } | null, requestStatuses: Array<{ __typename?: 'CadCamRequestStatus', name: string, description: string, startedDate?: string | null, completedDate?: string | null, isCustomerActionRequired: boolean }>, showcasePrice?: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', currencyCode: string, value: number, valueInUsd: number } } | null } | null };

export type GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables = Exact<{
  term: Scalars['String']['input'];
  onlyActionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  onlyReorderable?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCheckedOutByViewer?: InputMaybe<Scalars['Boolean']['input']>;
  shipToAccountNumber?: InputMaybe<Scalars['ID']['input']>;
  paging: PagingInput;
}>;


export type GetCadCamPageRequestsSearchByCustomerReferenceQuery = { __typename?: 'Query', cadCamRequestSearchByCustomerReference: { __typename?: 'CadCamRequestsSearchByCustomerReferenceResult', count: number, results: Array<{ __typename?: 'CadCamRequest', id: string, source: string, customerReference?: string | null, requestDate: string, estimatedShipDate?: string | null, isCancelled: boolean, cancelledReason?: string | null, canReorder: boolean, canReactivate: boolean, canAddToSignetCart: boolean, brand?: string | null, storeName?: string | null, storeReference?: string | null, customerName?: string | null, image?: { __typename?: 'Image', fullSize?: string | null, thumb225?: string | null } | null, requestStatuses: Array<{ __typename?: 'CadCamRequestStatus', name: string, description: string, startedDate?: string | null, completedDate?: string | null, isCustomerActionRequired: boolean }>, showcasePrice?: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', currencyCode: string, value: number, valueInUsd: number } } | null }> } };

export type GetCadCamPageRequestSearchByWipJobNumberQueryVariables = Exact<{
  wipJobNumber: Scalars['String']['input'];
}>;


export type GetCadCamPageRequestSearchByWipJobNumberQuery = { __typename?: 'Query', cadCamRequestSearchByWipJobNumber?: { __typename?: 'CadCamRequest', id: string, source: string, customerReference?: string | null, requestDate: string, estimatedShipDate?: string | null, isCancelled: boolean, cancelledReason?: string | null, canReorder: boolean, canReactivate: boolean, canAddToSignetCart: boolean, brand?: string | null, storeName?: string | null, storeReference?: string | null, customerName?: string | null, image?: { __typename?: 'Image', fullSize?: string | null, thumb225?: string | null } | null, requestStatuses: Array<{ __typename?: 'CadCamRequestStatus', name: string, description: string, startedDate?: string | null, completedDate?: string | null, isCustomerActionRequired: boolean }>, showcasePrice?: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', currencyCode: string, value: number, valueInUsd: number } } | null } | null };

export type CadCamPageReactivateCadCamRequestByIdMutationVariables = Exact<{
  input: ReactivateCadCamRequestByIdInput;
}>;


export type CadCamPageReactivateCadCamRequestByIdMutation = { __typename?: 'Mutation', reactivateCadCamRequestById?: { __typename?: 'ReactivateCadCamRequestByIdPayload', cadCamRequest?: { __typename?: 'CadCamRequest', id: string, source: string, customerReference?: string | null, requestDate: string, estimatedShipDate?: string | null, isCancelled: boolean, cancelledReason?: string | null, canReorder: boolean, canReactivate: boolean, canAddToSignetCart: boolean, brand?: string | null, storeName?: string | null, storeReference?: string | null, customerName?: string | null, image?: { __typename?: 'Image', fullSize?: string | null, thumb225?: string | null } | null, requestStatuses: Array<{ __typename?: 'CadCamRequestStatus', name: string, description: string, startedDate?: string | null, completedDate?: string | null, isCustomerActionRequired: boolean }>, showcasePrice?: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', currencyCode: string, value: number, valueInUsd: number } } | null } | null } | null };

export type CadCamPageAddToSignetCartMutationVariables = Exact<{
  input: AddToSignetCartInput;
}>;


export type CadCamPageAddToSignetCartMutation = { __typename?: 'Mutation', addToSignetCart?: { __typename?: 'AddToSignetCartPayload', redirectUrl?: string | null, message?: string | null } | null };

export type CartPageCartItemMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type CartPageCartItemPriceInfoFragment = { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } };

export type CartPageCartItemPriceDiscountInfoFragment = { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } };

export type CartPageCartItemInStockStatusInfoFragment = { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null };

export type CartPageCartItemOptionsInfoFragment = { __typename?: 'OrderLineOptions', specialInstructions?: string | null, quantity: number, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null };

type CartPageCartItemInfo_CartLine_Fragment = { __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null };

type CartPageCartItemInfo_SavedCartLine_Fragment = { __typename?: 'SavedCartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null };

export type CartPageCartItemInfoFragment = CartPageCartItemInfo_CartLine_Fragment | CartPageCartItemInfo_SavedCartLine_Fragment;

export type GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, needsToAgreeToConsignmentTerms: boolean } | null };

export type GetCartPageCartItemConfigurationSummaryQueryVariables = Exact<{
  configurationByIdId: Scalars['ID']['input'];
}>;


export type GetCartPageCartItemConfigurationSummaryQuery = { __typename?: 'Query', configurationById?: { __typename?: 'Configuration', product: { __typename?: 'Product', type?: string | null, id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean }, details: Array<{ __typename?: 'ChainConfigurationDetail', length: { __typename?: 'LengthValue', value: number, uom: LengthValueUom }, clasp?: { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean } | null } | { __typename?: 'EarringConfigurationDetail', quantity: number, post?: { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean } | null, back?: { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean } | null } | { __typename?: 'EngravingConfigurationDetail', engravings: Array<{ __typename?: 'EngravingLocationConfiguration', locationDescription: string, engraving?: { __typename?: 'CustomerLogoEngravingLocationConfiguration', logo: { __typename?: 'Trademark', name: string, imagePreview?: string | null, id: string } } | { __typename?: 'HandwrittenEngravingLocationConfiguration', color?: { __typename?: 'EngravingColorConfiguration', name: string, hex?: string | null } | null } | { __typename?: 'PatternEngravingLocationConfiguration', patternName: string } | { __typename?: 'StandardEngravingLocationConfiguration', fontName: string, lines: Array<{ __typename?: 'EngravingText', text: string, thumbnailPreviewImage?: string | null }>, color?: { __typename?: 'EngravingColorConfiguration', name: string, hex?: string | null } | null } | null }> } | { __typename?: 'HeadConfigurationDetail', head: { __typename?: 'Configuration', product: { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean }, details: Array<{ __typename?: 'ChainConfigurationDetail' } | { __typename?: 'EarringConfigurationDetail' } | { __typename?: 'EngravingConfigurationDetail' } | { __typename?: 'HeadConfigurationDetail' } | { __typename?: 'ImprintingConfigurationDetail' } | { __typename?: 'KitConfigurationDetail' } | { __typename?: 'MatchingChainConfigurationDetail' } | { __typename?: 'MonogramConfigurationDetail' } | { __typename?: 'RingSizeConfigurationDetail' } | { __typename?: 'SpecialFinishConfigurationDetail' } | { __typename?: 'StoneSettingConfigurationDetail', stoneSettings: Array<{ __typename?: 'StoneSettingLocationConfiguration', locationDescription: string, quantity: number, exactFit?: { __typename?: 'ExactFitConfiguration', length: number, width?: number | null, depth?: number | null } | null, stone?: { __typename?: 'CustomerStone', stoneValue: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean } | { __typename?: 'SerializedProduct', id: string, title: string, image?: string | null, isActive: boolean } | null }> }> } } | { __typename?: 'ImprintingConfigurationDetail', imprintings: Array<{ __typename?: 'CustomerLogoHotStampingLocationConfiguration', locationDescription: string, locationImage?: string | null, logo: { __typename?: 'Trademark', name: string, imagePreview?: string | null }, colors: Array<{ __typename?: 'ImprintingLocationColorConfiguration', name: string, hex?: string | null, instructions?: string | null }> } | { __typename?: 'CustomerLogoImprintingLocationConfiguration', locationDescription: string, locationImage?: string | null, logo: { __typename?: 'Trademark', name: string, imagePreview?: string | null }, colors: Array<{ __typename?: 'ImprintingLocationColorConfiguration', name: string, hex?: string | null, instructions?: string | null }> }> } | { __typename?: 'KitConfigurationDetail', products: Array<{ __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean }> } | { __typename?: 'MatchingChainConfigurationDetail', product: { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean } } | { __typename?: 'MonogramConfigurationDetail', locations: Array<{ __typename?: 'MonogramLocationConfiguration', locationDescription: string, value?: string | null }> } | { __typename?: 'RingSizeConfigurationDetail', ringSize: number } | { __typename?: 'SpecialFinishConfigurationDetail', title: string, finishes: Array<{ __typename?: 'SpecialFinishLocationConfiguration', locationDescription: string, previewImage?: string | null, specialFinishName: string }> } | { __typename?: 'StoneSettingConfigurationDetail', title: string, stoneSettings: Array<{ __typename?: 'StoneSettingLocationConfiguration', locationDescription: string, quantity: number, exactFit?: { __typename?: 'ExactFitConfiguration', length: number, width?: number | null, depth?: number | null } | null, stone?: { __typename?: 'CustomerStone', stoneValue: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | { __typename?: 'Product', id: string, itemNumber: string, title: string, image?: string | null, isWebActive: boolean } | { __typename?: 'SerializedProduct', id: string, title: string, image?: string | null, isActive: boolean, serialNumber: string } | null }> }> } | null };

export type GetCartPageCartItemFavoriteListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartItemFavoriteListsQuery = { __typename?: 'Query', favoriteLists?: Array<{ __typename?: 'FavoriteList', id: string, name?: string | null }> | null };

export type GetCartPageCartItemDotOptionsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartItemDotOptionsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canSetOrderLineConsultantDiscounts?: boolean | null, canSetOrderLineMatching?: boolean | null, canSetOrderLineSalesType?: boolean | null } };

export type GetCartPageCartItemCanAddToFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartItemCanAddToFavoritesQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canAddToFavorites?: boolean | null } };

export type GetCartPageCartItemCanViewQuantityOnHandQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartItemCanViewQuantityOnHandQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewQuantityOnHand: boolean } };

export type CartPageCartItemAcceptConsignmentTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type CartPageCartItemAcceptConsignmentTermsMutation = { __typename?: 'Mutation', acceptConsignmentTerms: { __typename?: 'AcceptConsignmentTermsPayload', user: { __typename?: 'User', id: string, needsToAgreeToConsignmentTerms: boolean } } };

export type CartPageCartItemSaveCartLineForLaterMutationVariables = Exact<{
  cartLineId: Scalars['ID']['input'];
}>;


export type CartPageCartItemSaveCartLineForLaterMutation = { __typename?: 'Mutation', saveCartLineForLater?: { __typename?: 'SaveCartLineForLaterPayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null } | null };

export type CartPageCartItemDeleteCartLineWithShipmentsMutationVariables = Exact<{
  input: DeleteCartLineInput;
}>;


export type CartPageCartItemDeleteCartLineWithShipmentsMutation = { __typename?: 'Mutation', deleteCartLine?: { __typename?: 'DeleteCartLinePayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null } | null };

export type CartPageCartItemDeleteCartLineWithCartListItemMutationVariables = Exact<{
  input: DeleteCartLineInput;
}>;


export type CartPageCartItemDeleteCartLineWithCartListItemMutation = { __typename?: 'Mutation', deleteCartLine?: { __typename?: 'DeleteCartLinePayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null } | null };

export type CartPageCartItemUpdateCartLineWithShipmentsMutationVariables = Exact<{
  input: UpdateCartLineInput;
}>;


export type CartPageCartItemUpdateCartLineWithShipmentsMutation = { __typename?: 'Mutation', updateCartLine?: { __typename?: 'UpdateCartLinePayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null } | null };

export type CartPageCartItemUpdateCartLineWithCartListItemMutationVariables = Exact<{
  input: UpdateCartLineInput;
}>;


export type CartPageCartItemUpdateCartLineWithCartListItemMutation = { __typename?: 'Mutation', updateCartLine?: { __typename?: 'UpdateCartLinePayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null } | null };

export type CartPageCartItemMoveSavedCartLineToCartMutationVariables = Exact<{
  input: MoveSavedCartLineToCartInput;
}>;


export type CartPageCartItemMoveSavedCartLineToCartMutation = { __typename?: 'Mutation', moveSavedCartLineToCart?: { __typename?: 'MoveSavedCartLineToCartPayload', cart?: { __typename?: 'Cart', id: string } | null } | null };

export type CartPageCartItemMoveCartLineToCartMutationVariables = Exact<{
  input: MoveCartLineToCartInput;
}>;


export type CartPageCartItemMoveCartLineToCartMutation = { __typename?: 'Mutation', moveCartLineToCart?: { __typename?: 'MoveCartLineToCartPayload', sourceCart?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null, targetCart?: { __typename?: 'Cart', id: string } | null } | null };

export type CartPageCartItemDeleteSavedCartLineMutationVariables = Exact<{
  input: DeleteSavedCartLineInput;
}>;


export type CartPageCartItemDeleteSavedCartLineMutation = { __typename?: 'Mutation', deleteSavedCartLine?: { __typename?: 'DeleteSavedCartLinePayload', savedCartLineId: string } | null };

export type CartPageCartItemUpdateSavedCartLineMutationVariables = Exact<{
  input: UpdateSavedCartLineInput;
}>;


export type CartPageCartItemUpdateSavedCartLineMutation = { __typename?: 'Mutation', updateSavedCartLine?: { __typename?: 'UpdateSavedCartLinePayload', savedCartLine?: { __typename?: 'SavedCartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null } | null } | null };

export type CartPageCartItemAddToFavoritesMutationVariables = Exact<{
  input: AddToFavoritesInput;
}>;


export type CartPageCartItemAddToFavoritesMutation = { __typename?: 'Mutation', addToFavorites?: { __typename?: 'AddToFavoritesPayload', favorite?: { __typename?: 'Favorite', id: string, notes?: string | null, sortOrder?: number | null, options?: { __typename?: 'OrderLineOptions', customerNotes?: string | null, quantity: number } | null, favoriteList?: { __typename?: 'FavoriteList', id: string, name?: string | null } | null, item?: { __typename?: 'Configuration', id: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'Product', id: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | { __typename?: 'SerializedProduct', id: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType } } | null } | null } | null };

export type CartPageCartListMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type CartPageCartListPriceInfoFragment = { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } };

export type CartPageCartListHeaderInfoFragment = { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null };

export type CartPageCartListHeaderWithEmployeeInfoFragment = { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, lastModifiedByEmployee?: { __typename?: 'Employee', id: string, displayName: string } | null, user?: { __typename?: 'User', id: string } | null };

export type CartPageCartListItemInfoFragment = { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null };

export type GetCartPageCartListShippingEstimatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartListShippingEstimatesQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, estimates?: Array<{ __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null }> | null }> | null } | null };

export type GetCartPageCartListCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type GetCartPageCartListCartQuery = { __typename?: 'Query', cartById?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null };

export type CartPageCartListUpdateScheduledCartShippingMethodMutationVariables = Exact<{
  input: UpdateScheduledCartShippingMethodInput;
}>;


export type CartPageCartListUpdateScheduledCartShippingMethodMutation = { __typename?: 'Mutation', updateScheduledCartShippingMethod?: { __typename?: 'UpdateScheduledCartShippingMethodPayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null } | null };

export type CartPageCartListDeleteAllCartLinesMutationVariables = Exact<{
  input: DeleteAllCartLinesInput;
}>;


export type CartPageCartListDeleteAllCartLinesMutation = { __typename?: 'Mutation', deleteAllCartLines?: { __typename?: 'DeleteAllCartLinesPayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null } | null };

export type CartPageCartListMoveAllLinesToCartMutationVariables = Exact<{
  input: MoveAllLinesToCartInput;
}>;


export type CartPageCartListMoveAllLinesToCartMutation = { __typename?: 'Mutation', moveAllLinesToCart?: { __typename?: 'MoveAllLinesToCartPayload', sourceCart?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null, targetCart?: { __typename?: 'Cart', id: string, itemCount?: number | null } | null } | null };

export type CartPageCartPageMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type CartPageCartPagePriceInfoFragment = { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } };

export type CartPageCartPageShippingEstimateInfoFragment = { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null };

export type CartPageCartPageCartInfoFragment = { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null };

export type CartPageCartPageScheduledOrderInfoFragment = { __typename?: 'ScheduledOrder', id: string, shipCompleteMethod?: ShipCompleteMethod | null, timeZone?: { __typename?: 'TimeZone', cutoff?: string | null } | null, address?: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, province?: string | null, zip?: string | null, country: string } | null, paymentMethod?: { __typename?: 'ScheduledOrderCOD', id: string } | { __typename?: 'ScheduledOrderCreditCard', id: string, lastFourDigits?: string | null, type?: ScheduledOrderCardType | null } | { __typename?: 'ScheduledOrderNormalTerms', id: string } | null, shipToAccount?: { __typename?: 'ShipToAccount', id: string } | null };

export type GetCartPageCartPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewCart?: boolean | null } };

export type GetCartPageCartPageCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartPageCartQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, scheduledOrder?: { __typename?: 'ScheduledOrder', id: string, shipCompleteMethod?: ShipCompleteMethod | null, timeZone?: { __typename?: 'TimeZone', cutoff?: string | null } | null, address?: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, province?: string | null, zip?: string | null, country: string } | null, paymentMethod?: { __typename?: 'ScheduledOrderCOD', id: string } | { __typename?: 'ScheduledOrderCreditCard', id: string, lastFourDigits?: string | null, type?: ScheduledOrderCardType | null } | { __typename?: 'ScheduledOrderNormalTerms', id: string } | null, shipToAccount?: { __typename?: 'ShipToAccount', id: string } | null } | null } | null, cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null };

export type CartPageCartPageDeleteAllCartLinesMutationVariables = Exact<{
  input: DeleteAllCartLinesInput;
}>;


export type CartPageCartPageDeleteAllCartLinesMutation = { __typename?: 'Mutation', deleteAllCartLines?: { __typename?: 'DeleteAllCartLinesPayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null } | null };

export type CartPageCartPageUpdateScheduledOrderMutationVariables = Exact<{
  input: UpdateScheduledOrderInput;
}>;


export type CartPageCartPageUpdateScheduledOrderMutation = { __typename?: 'Mutation', updateScheduledOrder?: { __typename?: 'UpdateScheduledOrderPayload', scheduledOrder?: { __typename?: 'ScheduledOrder', id: string, shipCompleteMethod?: ShipCompleteMethod | null, timeZone?: { __typename?: 'TimeZone', cutoff?: string | null } | null, address?: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, province?: string | null, zip?: string | null, country: string } | null, paymentMethod?: { __typename?: 'ScheduledOrderCOD', id: string } | { __typename?: 'ScheduledOrderCreditCard', id: string, lastFourDigits?: string | null, type?: ScheduledOrderCardType | null } | { __typename?: 'ScheduledOrderNormalTerms', id: string } | null, shipToAccount?: { __typename?: 'ShipToAccount', id: string } | null } | null, cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceChargesTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, shippingTotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, serviceCharges?: Array<{ __typename?: 'CartServiceCharge', type?: CartServiceChargeType | null, title?: string | null, quantity?: number | null, price?: { __typename?: 'CartServiceChargePrice', type?: CartServiceChargePriceType | null, total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, perUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null, items?: Array<{ __typename?: 'CartLine', id: string }> | null, shipments?: Array<{ __typename?: 'Shipment', shipSetCode?: string | null, shipDate?: string | null, isValid?: boolean | null, validationErrors?: Array<string> | null, lines?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, shippingMethodSelection?: { __typename?: 'ShippingEstimate', isSaturdayDelivery?: boolean | null, delivery?: string | null, method?: { __typename?: 'ShippingMethod', id: string, description?: string | null, carrier?: string | null } | null, freight?: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null }> | null } | null } | null };

export type CartPageCartSearchPageMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type GetCartPageCartSearchPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartSearchPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewConsultantCarts?: boolean | null } };

export type GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartSearchPageCustomersWithCartsCountQuery = { __typename?: 'Query', customersWithCart?: Array<{ __typename?: 'User', id: string }> | null };

export type GetCartPageCartSearchPageCartQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetCartPageCartSearchPageCartQuery = { __typename?: 'Query', cartByUserId?: { __typename?: 'Cart', id: string, itemCount?: number | null, createdOn?: string | null, user?: { __typename?: 'User', id: string } | null, items?: Array<{ __typename?: 'CartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, quotedPrice?: { __typename?: 'CartPrice', salesTaxV2?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, subtotal?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null } | null } | null };

export type GetCartPageCartSearchPageCustomersWithCartsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartSearchPageCustomersWithCartsQuery = { __typename?: 'Query', customersWithCart?: Array<{ __typename?: 'User', id: string, cartItemCount?: number | null, scheduledOrder?: { __typename?: 'ScheduledOrder', id: string } | null }> | null };

export type GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canSubmitOrderForApprovalBypassCheckout?: boolean | null } };

export type GetCartPageCartSummaryCanCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageCartSummaryCanCheckoutQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canCheckout?: boolean | null } };

export type CartPageCartSummaryCancelScheduledOrderMutationVariables = Exact<{ [key: string]: never; }>;


export type CartPageCartSummaryCancelScheduledOrderMutation = { __typename?: 'Mutation', cancelScheduledOrder?: { __typename?: 'CancelScheduledOrderPayload', id: string } | null };

export type GetCartPageDotCartsPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageDotCartsPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewConsultantCarts?: boolean | null } };

export type GetCartPageDotCartsPageConsultantCartsQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetCartPageDotCartsPageConsultantCartsQuery = { __typename?: 'Query', consultantCarts?: { __typename?: 'ConsultantCartsResult', cartsCount?: number | null, cartHeaders?: Array<{ __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, lastModifiedByEmployee?: { __typename?: 'Employee', id: string, displayName: string } | null, user?: { __typename?: 'User', id: string } | null }> | null } | null };

export type CartPageJewelerShowcaseCartsPageCallbackRequestInfoFragment = { __typename?: 'JewelerShowcaseCallbackRequest', id: string, emailAddress?: string | null, creationDate?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, messageToJeweler?: string | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string, showcaseSettings?: { __typename?: 'ShowcaseSettings', id: string, jewelerShowcaseSubdomain?: string | null } | null } | null } | null };

export type GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageJewelerShowcaseCartsPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewJewelerShowcaseRequests: boolean } };

export type GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery = { __typename?: 'Query', pendingJewelerShowcaseCallbackRequests?: { __typename?: 'JewelerShowcaseCallbackRequestsResult', count?: number | null, results?: Array<{ __typename?: 'JewelerShowcaseCallbackRequest', id: string, emailAddress?: string | null, creationDate?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, messageToJeweler?: string | null, cartHeader?: { __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string, showcaseSettings?: { __typename?: 'ShowcaseSettings', id: string, jewelerShowcaseSubdomain?: string | null } | null } | null } | null }> | null } | null };

export type GetCartPageSavedItemsPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageSavedItemsPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canSaveCartItems?: boolean | null } };

export type GetCartPageSavedItemsPageCartLinesQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetCartPageSavedItemsPageCartLinesQuery = { __typename?: 'Query', savedCartLines?: { __typename?: 'SavedCartLinesResult', count?: number | null, results?: Array<{ __typename?: 'SavedCartLine', id: string, canEditItem?: boolean | null, creationDate?: string | null, shipDate?: string | null, consultantDescription?: string | null, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, configurationProduct: { __typename?: 'Product', id: string }, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, isTool: boolean, image?: string | null, canAnneal: boolean, canMatch: boolean, canOrderOnConsignment: boolean, canAddSpecialInstructions: boolean, canAddCustomerNotes: boolean, soldByDescription: string, isReturnable: boolean, isLimitedAvailability: boolean, series: string, brand?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, specialInstructions?: string | null, isAnnealed: boolean, customerNotes?: string | null, isMatched: boolean, isForConsignment: boolean, salesType?: SalesType | null, matchingCode?: string | null, consultantDiscount?: number | null, width?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, length?: { __typename?: 'LengthValue', uom: LengthValueUom, value: number } | null, bagAndTagOptions?: { __typename?: 'OrderLineBagAndTagOptions', tagBags?: boolean | null, quantityPerBag?: number | null } | null } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } | null, quotedPrice?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, inStockStatus?: { __typename?: 'CartLineInStockStatus', statusCode?: CartLineInStockStatusCode | null, status?: string | null, quantityOnHand?: number | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null };

export type CartPageCartMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type GetCartPageNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageNavigationQuery = { __typename?: 'Query', cartItemCount?: number | null, viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canAddToFavorites?: boolean | null, canSaveCartItems?: boolean | null, canViewConsultantCarts?: boolean | null, canViewJewelerShowcaseRequests: boolean, canViewShowcaseOnlyUsers?: boolean | null, canViewCart?: boolean | null }, savedCartLines?: { __typename?: 'SavedCartLinesResult', count?: number | null } | null, showcaseOnlyCarts?: { __typename?: 'ShowcaseOnlyCartsResult', count?: number | null } | null, consultantCarts?: { __typename?: 'ConsultantCartsResult', cartLineCount?: number | null } | null, pendingJewelerShowcaseCallbackRequests?: { __typename?: 'JewelerShowcaseCallbackRequestsResult', count?: number | null } | null, viewer?: { __typename?: 'User', id: string, scheduledOrder?: { __typename?: 'ScheduledOrder', id: string } | null } | null, customersWithCart?: Array<{ __typename?: 'User', id: string }> | null };

export type GetCartPageSubCartsPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartPageSubCartsPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewShowcaseOnlyUsers?: boolean | null } };

export type GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetCartPageSubCartsPageShowcaseOnlyCartsQuery = { __typename?: 'Query', showcaseOnlyCarts?: { __typename?: 'ShowcaseOnlyCartsResult', count?: number | null, cartHeaders?: Array<{ __typename?: 'CartHeader', id: string, createdOn?: string | null, itemCount?: number | null, topImages?: Array<string | null> | null, user?: { __typename?: 'User', id: string } | null }> | null } | null };

export type GetCategoryPageActiveCategoryBySanitizedPathQueryVariables = Exact<{
  sanitizedPath: Scalars['String']['input'];
}>;


export type GetCategoryPageActiveCategoryBySanitizedPathQuery = { __typename?: 'Query', activeCategoryBySanitizedPath?: { __typename?: 'Category', id: string, pageTitle?: string | null, pageHeader?: string | null, pageMetaDescription?: string | null, overrideUrl?: string | null, displayTemplate?: string | null, contentId?: number | null, showProducts: boolean, hideSideNav?: string | null, ancestors: Array<{ __typename?: 'Category', id: string, name: string }> } | null };

export type CmsContentContentInfoFragment = { __typename?: 'CmsContent', content: string, splitTestVersionsKey?: string | null };

export type GetCmsContentContentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<CmsOptionsInput>;
}>;


export type GetCmsContentContentByIdQuery = { __typename?: 'Query', cmsContentById?: { __typename?: 'CmsContent', content: string, splitTestVersionsKey?: string | null } | null };

export type GetCmsContentContentByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  options?: InputMaybe<CmsOptionsInput>;
}>;


export type GetCmsContentContentByNameQuery = { __typename?: 'Query', cmsContentByName?: { __typename?: 'CmsContent', content: string, splitTestVersionsKey?: string | null } | null };

export type GetConsultantModeNavInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsultantModeNavInfoQuery = { __typename?: 'Query', authUser?: { __typename?: 'AuthUser', id: string, consultantInfo?: { __typename?: 'ConsultantInfo', employee: { __typename?: 'Employee', id: string, displayName: string } } | null } | null };

export type GetConsultantModeNavDotQuickLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsultantModeNavDotQuickLinksQuery = { __typename?: 'Query', cmsLookupsByType: Array<{ __typename?: 'CmsLookup', id: string, url: string, title: string }> };

export type GetContactFormsAccountSignupPrimaryRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactFormsAccountSignupPrimaryRolesQuery = { __typename?: 'Query', cmsLookupsByType: Array<{ __typename?: 'CmsLookup', id: string, name: string, title: string }> };

export type GetContactFormsCanDeactivateContactQueryVariables = Exact<{
  shipToAccountNumber: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;


export type GetContactFormsCanDeactivateContactQuery = { __typename?: 'Query', canDeactivateContact: boolean };

export type GetContactFormsCanSetPrimaryContactQueryVariables = Exact<{
  shipToAccountNumber: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetContactFormsCanSetPrimaryContactQuery = { __typename?: 'Query', canSetPrimaryContact: boolean };

export type ContactFormsCreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type ContactFormsCreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'CreateContactPayload', contact: { __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null } } | null };

export type ContactFormsDeactivateContactMutationVariables = Exact<{
  input: DeactivateContactInput;
}>;


export type ContactFormsDeactivateContactMutation = { __typename?: 'Mutation', deactivateContact?: { __typename?: 'DeactivateContactPayload', contact?: { __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null } | null } | null };

export type ContactFormsSetPrimaryContactMutationVariables = Exact<{
  input: SetPrimaryContactInput;
}>;


export type ContactFormsSetPrimaryContactMutation = { __typename?: 'Mutation', setPrimaryContact?: { __typename?: 'SetPrimaryContactPayload', user: { __typename?: 'User', id: string, fullName?: string | null, contact?: { __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null } | null } } | null };

export type ContactFormsUpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type ContactFormsUpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'UpdateContactPayload', contact?: { __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null } | null } | null };

export type GetContactSelectorContactSearchQueryVariables = Exact<{
  shipToAccountNumber: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  paging: PagingInput;
}>;


export type GetContactSelectorContactSearchQuery = { __typename?: 'Query', contactSearch: { __typename?: 'ContactSearchResult', count: number, results: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null }> } };

export type GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables = Exact<{
  input: ItemsInput;
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery = { __typename?: 'Query', activeItems: Array<{ __typename?: 'Configuration', id: string, title: string, series: string, image?: string | null, brand?: string | null, itemNumber: string, isInStock: boolean, options?: { __typename?: 'ItemLineOptions', quantity: number } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, discount?: { __typename?: 'PriceDiscount', percent: number, value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null } | { __typename?: 'Product', id: string, title: string, series: string, image?: string | null, brand?: string | null, itemNumber: string, isInStock: boolean, options?: { __typename?: 'ItemLineOptions', quantity: number } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, discount?: { __typename?: 'PriceDiscount', percent: number, value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null } | { __typename?: 'SerializedProduct', id: string, title: string, series: string, image?: string | null, brand?: string | null, itemNumber: string, isInStock: boolean, options?: { __typename?: 'ItemLineOptions', quantity: number } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, discount?: { __typename?: 'PriceDiscount', percent: number, value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null } | null>, activeProductGroupsByIds: Array<{ __typename?: 'ProductGroup', id: string, title: string, code: string, image?: string | null, minPriceProduct?: { __typename?: 'Product', id: string, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } } | null } | null, maxPriceProduct?: { __typename?: 'Product', id: string, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } } | null } | null, maxDiscountProduct?: { __typename?: 'Product', id: string, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null } | null }> };

export type GetContentstackTargetingActiveCategoriesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetContentstackTargetingActiveCategoriesByIdsQuery = { __typename?: 'Query', activeCategoriesByIds: Array<{ __typename?: 'Category', id: string }> };

export type CurrencyCultureExchangeRateInfoFragment = { __typename?: 'ExchangeRate', code: string, culture: string, name: string, exchangeRateToUsd: number };

export type GetCurrencyCultureDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyCultureDataQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canSetupShowcase: boolean, canUpdateCurrency?: boolean | null }, viewer?: { __typename?: 'User', currencyDisplay: { __typename?: 'ExchangeRate', code: string, culture: string, name: string, exchangeRateToUsd: number }, showcaseSettings?: { __typename?: 'ShowcaseSettings', hideUSDPrices: boolean } | null } | null, exchangeRates?: Array<{ __typename?: 'ExchangeRate', code: string, culture: string, name: string, exchangeRateToUsd: number }> | null };

export type CurrencyCultureUpdateCurrencyMutationVariables = Exact<{
  input: UpdateCurrencyDisplayInput;
}>;


export type CurrencyCultureUpdateCurrencyMutation = { __typename?: 'Mutation', updateCurrency?: { __typename?: 'UpdateCurrencyDisplayPayload', user: { __typename?: 'User', currencyDisplay: { __typename?: 'ExchangeRate', code: string }, showcaseSettings?: { __typename?: 'ShowcaseSettings', hideUSDPrices: boolean } | null } } | null };

export type CurrencyCultureUpdateHideUsdPriceMutationVariables = Exact<{
  input: HideUsdCurrencyInput;
}>;


export type CurrencyCultureUpdateHideUsdPriceMutation = { __typename?: 'Mutation', updateHideUsdPrice?: { __typename?: 'UpdateHideUsdPricePayload', showcaseSettings: { __typename?: 'ShowcaseSettings', hideUSDPrices: boolean } } | null };

export type GetFooterShowcaseFooterMarketRatesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetFooterShowcaseFooterMarketRatesQuery = { __typename?: 'Query', marketRates: Array<{ __typename?: 'MarketRate', id: string, date: string, url: string, gold: number, palladium: number, platinum: number, silver: number }> };

export type GetFormstackContactsQueryVariables = Exact<{
  shipToAccountNumber: Scalars['String']['input'];
}>;


export type GetFormstackContactsQuery = { __typename?: 'Query', contactSearch: { __typename?: 'ContactSearchResult', count: number, results: Array<{ __typename?: 'Contact', id: string, fullName: string, firstName: string, lastName: string, emailAddress?: string | null, salesforceContactId?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null } | null }> } };

type GoogleTagManagerItemInfo_Configuration_Fragment = { __typename?: 'Configuration', id: string, title: string, series: string, image?: string | null, brand?: string | null, itemNumber: string, options?: { __typename?: 'ItemLineOptions', quantity: number } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null };

type GoogleTagManagerItemInfo_Product_Fragment = { __typename?: 'Product', id: string, title: string, series: string, image?: string | null, brand?: string | null, itemNumber: string, options?: { __typename?: 'ItemLineOptions', quantity: number } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null };

type GoogleTagManagerItemInfo_SerializedProduct_Fragment = { __typename?: 'SerializedProduct', id: string, title: string, series: string, image?: string | null, brand?: string | null, itemNumber: string, options?: { __typename?: 'ItemLineOptions', quantity: number } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null };

export type GoogleTagManagerItemInfoFragment = GoogleTagManagerItemInfo_Configuration_Fragment | GoogleTagManagerItemInfo_Product_Fragment | GoogleTagManagerItemInfo_SerializedProduct_Fragment;

export type GoogleTagManagerProductGroupInfoFragment = { __typename?: 'ProductGroup', id: string, title: string, code: string };

type GoogleTagManagerCartLineInfo_CartLine_Fragment = { __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null, productGroup?: { __typename?: 'ProductGroup', id: string, title: string, code: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null };

type GoogleTagManagerCartLineInfo_SavedCartLine_Fragment = { __typename?: 'SavedCartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null, productGroup?: { __typename?: 'ProductGroup', id: string, title: string, code: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null };

export type GoogleTagManagerCartLineInfoFragment = GoogleTagManagerCartLineInfo_CartLine_Fragment | GoogleTagManagerCartLineInfo_SavedCartLine_Fragment;

export type GoogleTagManagerCartInfoFragment = { __typename?: 'Cart', id: string, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null, productGroup?: { __typename?: 'ProductGroup', id: string, title: string, code: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null };

export type GoogleTagManagerCartWithShipmentsInfoFragment = { __typename?: 'Cart', id: string, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, shipments?: Array<{ __typename?: 'Shipment', lines?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null, productGroup?: { __typename?: 'ProductGroup', id: string, title: string, code: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null }> | null };

export type GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, hasUnreadSpecialOrderMessages?: boolean | null } | null };

export type GetHeaderMainNavCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderMainNavCategoriesQuery = { __typename?: 'Query', mainNavCategories: Array<{ __typename?: 'Category', id: string, mainNavDisplayName: string, url: string, mainNavContentContainerId?: string | null, mainNavIsFeatured: boolean, mainNavSortOrder?: number | null }> };

export type GetHeaderSearchNavSearchSuggestionsQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type GetHeaderSearchNavSearchSuggestionsQuery = { __typename?: 'Query', searchSuggestions: Array<{ __typename?: 'SearchSuggestion', id: string, description: string, imageUrl?: string | null, groupId?: string | null, clickLoggingUrl?: string | null }> };

export type GetHeaderUtilityNavMenuAccountMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuAccountMembershipsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, isCadCamServicesMember?: boolean | null } | null };

export type GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery = { __typename?: 'Query', locateAJewelerListingSearch?: { __typename?: 'LocateAJewelerListingSearchResult', count?: number | null } | null };

export type HeaderUtilityNavMenuCartMessageInfoFragment = { __typename?: 'CartMessage', code?: string | null, message?: string | null };

export type HeaderUtilityNavMenuCartPriceInfoFragment = { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } };

export type HeaderUtilityNavMenuCartInfoFragment = { __typename?: 'Cart', id: string, itemCount?: number | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, configurationProduct: { __typename?: 'Product', id: string }, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, isForConsignment: boolean } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null };

export type GetHeaderUtilityNavMenuCartItemCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuCartItemCountQuery = { __typename?: 'Query', cartItemCount?: number | null, viewer?: { __typename?: 'User', id: string, scheduledOrder?: { __typename?: 'ScheduledOrder', id: string } | null } | null };

export type GetHeaderUtilityNavMenuCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuCartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, configurationProduct: { __typename?: 'Product', id: string }, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, isForConsignment: boolean } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null };

export type GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuCartCanCheckoutQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canCheckout?: boolean | null } };

export type HeaderUtilityNavMenuCartSaveCartLineForLaterMutationVariables = Exact<{
  cartLineId: Scalars['ID']['input'];
}>;


export type HeaderUtilityNavMenuCartSaveCartLineForLaterMutation = { __typename?: 'Mutation', saveCartLineForLater?: { __typename?: 'SaveCartLineForLaterPayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, configurationProduct: { __typename?: 'Product', id: string }, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, isForConsignment: boolean } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null } | null };

export type HeaderUtilityNavMenuCartDeleteCartLineMutationVariables = Exact<{
  input: DeleteCartLineInput;
}>;


export type HeaderUtilityNavMenuCartDeleteCartLineMutation = { __typename?: 'Mutation', deleteCartLine?: { __typename?: 'DeleteCartLinePayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, configurationProduct: { __typename?: 'Product', id: string }, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, isForConsignment: boolean } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null } | null };

export type HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationVariables = Exact<{
  input: UpdateCartLineQuantityInput;
}>;


export type HeaderUtilityNavMenuCartUpdateCartLineQuantityMutation = { __typename?: 'Mutation', updateCartLineQuantity?: { __typename?: 'UpdateCartLineQuantityPayload', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, shippingCountdown?: { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, configurationProduct: { __typename?: 'Product', id: string }, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, title: string, itemNumber: string, image?: string | null, minimumQuantity?: number | null, maximumQuantity?: number | null, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, notes?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, options?: { __typename?: 'OrderLineOptions', quantity: number, isForConsignment: boolean } | null, productGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number, value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null } | null };

export type HeaderUtilityNavMenuCartCancelScheduledOrderMutationVariables = Exact<{ [key: string]: never; }>;


export type HeaderUtilityNavMenuCartCancelScheduledOrderMutation = { __typename?: 'Mutation', cancelScheduledOrder?: { __typename?: 'CancelScheduledOrderPayload', id: string } | null };

export type GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables = Exact<{
  app: NotificationApp;
}>;


export type GetHeaderUtilityNavMenuMessagesUnreadCountQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, notificationsUnreadCount: { __typename?: 'NotificationsUnreadCount', total: number, important: number } } | null };

export type GetHeaderUtilityNavMenuMessagesFeedQueryVariables = Exact<{
  app: NotificationApp;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<NotificationStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHeaderUtilityNavMenuMessagesFeedQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, notificationsFeed: { __typename?: 'NotificationsFeed', cursor?: string | null, notifications: Array<{ __typename?: 'Notification', id: string, createdDate: string, status: NotificationStatus, type: NotificationType, important: boolean, metadata: { __typename?: 'NotificationMetadata', title: string, body: string, url: string } }> } } | null };

export type HeaderUtilityNavMenuMessagesUpdateFeedReadMutationVariables = Exact<{
  input: UpdateNotificationsFeedReadInput;
}>;


export type HeaderUtilityNavMenuMessagesUpdateFeedReadMutation = { __typename?: 'Mutation', updateNotificationsFeedRead: { __typename?: 'UpdateNotificationsFeedReadPayload', count: number } };

export type HeaderUtilityNavMenuMessagesUpdateStatusMutationVariables = Exact<{
  input: UpdateNotificationStatusInput;
}>;


export type HeaderUtilityNavMenuMessagesUpdateStatusMutation = { __typename?: 'Mutation', updateNotificationStatus?: { __typename?: 'UpdateNotificationStatusPayload', notification?: { __typename?: 'Notification', id: string, status: NotificationStatus } | null } | null };

export type GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, showcaseSettings?: { __typename?: 'ShowcaseSettings', setup: { __typename?: 'ShowcaseSettingsSetup', displayComplete: boolean, markupsComplete: boolean } } | null } | null };

export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery = { __typename?: 'Query', pendingJewelerShowcaseCallbackRequests?: { __typename?: 'JewelerShowcaseCallbackRequestsResult', count?: number | null } | null };

export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery = { __typename?: 'Query', pendingJewelerShowcaseCallbackRequests?: { __typename?: 'JewelerShowcaseCallbackRequestsResult', count?: number | null, results?: Array<{ __typename?: 'JewelerShowcaseCallbackRequest', id: string, emailAddress?: string | null, creationDate?: string | null }> | null } | null };

export type GetHeaderUtilityNavPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHeaderUtilityNavPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewCart?: boolean | null } };

export type HoldShipmentsShipToAccountInfoFragment = { __typename?: 'ShipToAccount', id: string, accountNumber: string, holdShipmentsDate?: string | null, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string, type: string, province?: string | null, isInternational: boolean } };

export type GetHoldShipmentsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHoldShipmentsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canUpdateHoldShipments?: boolean | null } };

export type GetHoldShipmentsShipToAccountByAccountNumberQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type GetHoldShipmentsShipToAccountByAccountNumberQuery = { __typename?: 'Query', shipToAccountByAccountNumber?: { __typename?: 'ShipToAccount', id: string, accountNumber: string, holdShipmentsDate?: string | null, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string, type: string, province?: string | null, isInternational: boolean } } | null };

export type GetHoldShipmentsShipToAccountSearchQueryVariables = Exact<{
  onlyWebActive?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  onlyLocateAJewelerListingUnlisted?: InputMaybe<Scalars['Boolean']['input']>;
  consultantSearchAcrossAllBillToAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  paging: PagingInput;
}>;


export type GetHoldShipmentsShipToAccountSearchQuery = { __typename?: 'Query', shipToAccountSearch: { __typename?: 'ShipToAccountSearchResult', count: number, results: Array<{ __typename?: 'ShipToAccount', id: string, accountNumber: string, holdShipmentsDate?: string | null, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string, type: string, province?: string | null, isInternational: boolean } }> } };

export type HoldShipmentsUpdateHoldShipmentsDateMutationVariables = Exact<{
  input: UpdateHoldShipmentsDateInput;
}>;


export type HoldShipmentsUpdateHoldShipmentsDateMutation = { __typename?: 'Mutation', updateHoldShipmentsDate: { __typename?: 'UpdateHoldShipmentsDatePayload', shipToAccount: { __typename?: 'ShipToAccount', id: string, accountNumber: string, holdShipmentsDate?: string | null } } };

export type GetInactiveGroupProductGroupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInactiveGroupProductGroupByIdQuery = { __typename?: 'Query', productGroupById?: { __typename?: 'ProductGroup', id: string, code: string, title: string, image?: string | null, description?: string | null, active: boolean, discontinued: boolean, replacementGroups: Array<{ __typename?: 'ProductGroup', id: string, code: string, title: string, image?: string | null, active: boolean }> } | null };

export type GetLiveChatEmbeddedChatSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveChatEmbeddedChatSettingsQuery = { __typename?: 'Query', embeddedChatSettings?: { __typename?: 'EmbeddedChatSettingsResult', salesforceSettingName?: string | null, embeddedChatSettings: Array<{ __typename?: 'EmbeddedChatSetting', orgId?: string | null, orgName?: string | null, messagingChannel?: string | null, experienceSiteUrl?: string | null, telephonyUrl?: string | null, srcAttribute?: string | null, chatEnabled?: boolean | null }>, primaryEmbeddedChatSettings?: { __typename?: 'EmbeddedChatSetting', orgId?: string | null, orgName?: string | null, messagingChannel?: string | null, experienceSiteUrl?: string | null, telephonyUrl?: string | null, srcAttribute?: string | null, chatEnabled?: boolean | null } | null } | null };

export type LocateAJewelerListingsListingInfoFragment = { __typename?: 'LocateAJewelerListing', id: string, doingBusinessAs?: string | null, locationDescription?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, jewelerShowcase?: string | null, products?: Array<string> | null, services?: Array<string> | null, salesFeatures?: Array<string> | null, shopFeatures?: Array<string> | null, owner?: { __typename?: 'LocateAJewelerOwner', salutation?: string | null, firstName?: string | null, lastName?: string | null, suffix?: string | null } | null, shipToAccount?: { __typename?: 'ShipToAccount', accountNumber: string } | null, address?: { __typename?: 'LocateAJewelerAddress', addressLine1: string, addressLine2?: string | null, city: string, stateOrProvince?: string | null, zip: string, country: string } | null, socials?: { __typename?: 'LocateAJewelerSocials', facebook?: string | null, twitter?: string | null, instagram?: string | null, pinterest?: string | null, youtube?: string | null } | null, hours?: { __typename?: 'LocateAJewelerHours', monday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, tuesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, wednesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, thursday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, friday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, saturday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, sunday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null } | null };

export type LocateAJewelerListingsCustomerStoreInfoFragment = { __typename?: 'CustomerStoreInformation', id: string, creationDate?: string | null, modificationDate?: string | null, businessEstablishedYear?: number | null, siteHasShoppingCart?: string | null, businessLocationCommunity?: string | null, locationOfSales?: string | null, primaryLocationDescription?: string | null, numberOfEmployees?: string | null, agta?: boolean | null, ags?: boolean | null, mjsa?: boolean | null, ja?: boolean | null, jvc?: boolean | null, jic?: boolean | null, otherOrganizations?: string | null, retailJewelersOrganization?: boolean | null, gemaltaCooperative?: boolean | null, canadianBuyingGroup?: boolean | null, independentJewelersOrganization?: boolean | null, diGem?: boolean | null, leadingJewelers?: boolean | null, continentalBuyingGroup?: boolean | null, buyersInternationalGroup?: boolean | null, employeeCount?: number | null, nationalPawnbrokersAssociation?: boolean | null, shipToAccount: { __typename?: 'ShipToAccount', id: string, accountNumber: string }, user?: { __typename?: 'User', id: string } | null };

export type LocateAJewelerListingsShipToAccountInfoFragment = { __typename?: 'ShipToAccount', id: string, accountNumber: string, phoneNumber?: string | null, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string } };

export type GetLocateAJewelerListingsShowcaseUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocateAJewelerListingsShowcaseUrlQuery = { __typename?: 'Query', jewelerShowcasesList?: Array<{ __typename?: 'ShowcaseSettings', jewelerShowcaseUrl?: string | null, jewelerShowcaseSubdomain?: string | null }> | null };

export type GetLocateAJewelerListingsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocateAJewelerListingsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canCreateLocateAJewelerListings: boolean, canCreateLocateAJewelerListingsWithoutShipToAccount?: boolean | null } };

export type GetLocateAJewelerListingsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocateAJewelerListingsByIdQuery = { __typename?: 'Query', locateAJewelerListingById?: { __typename?: 'LocateAJewelerListing', id: string, doingBusinessAs?: string | null, locationDescription?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, jewelerShowcase?: string | null, products?: Array<string> | null, services?: Array<string> | null, salesFeatures?: Array<string> | null, shopFeatures?: Array<string> | null, owner?: { __typename?: 'LocateAJewelerOwner', salutation?: string | null, firstName?: string | null, lastName?: string | null, suffix?: string | null } | null, shipToAccount?: { __typename?: 'ShipToAccount', accountNumber: string } | null, address?: { __typename?: 'LocateAJewelerAddress', addressLine1: string, addressLine2?: string | null, city: string, stateOrProvince?: string | null, zip: string, country: string } | null, socials?: { __typename?: 'LocateAJewelerSocials', facebook?: string | null, twitter?: string | null, instagram?: string | null, pinterest?: string | null, youtube?: string | null } | null, hours?: { __typename?: 'LocateAJewelerHours', monday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, tuesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, wednesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, thursday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, friday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, saturday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, sunday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null } | null } | null };

export type GetLocateAJewelerListingsListQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetLocateAJewelerListingsListQuery = { __typename?: 'Query', locateAJewelerListingSearch?: { __typename?: 'LocateAJewelerListingSearchResult', count?: number | null, results?: Array<{ __typename?: 'LocateAJewelerListing', id: string, doingBusinessAs?: string | null, locationDescription?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, jewelerShowcase?: string | null, products?: Array<string> | null, services?: Array<string> | null, salesFeatures?: Array<string> | null, shopFeatures?: Array<string> | null, owner?: { __typename?: 'LocateAJewelerOwner', salutation?: string | null, firstName?: string | null, lastName?: string | null, suffix?: string | null } | null, shipToAccount?: { __typename?: 'ShipToAccount', accountNumber: string } | null, address?: { __typename?: 'LocateAJewelerAddress', addressLine1: string, addressLine2?: string | null, city: string, stateOrProvince?: string | null, zip: string, country: string } | null, socials?: { __typename?: 'LocateAJewelerSocials', facebook?: string | null, twitter?: string | null, instagram?: string | null, pinterest?: string | null, youtube?: string | null } | null, hours?: { __typename?: 'LocateAJewelerHours', monday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, tuesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, wednesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, thursday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, friday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, saturday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, sunday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null } | null } | null> | null } | null };

export type GetLocateAJewelerListingsUnlistedStoresQueryVariables = Exact<{
  paging: PagingInput;
}>;


export type GetLocateAJewelerListingsUnlistedStoresQuery = { __typename?: 'Query', shipToAccountSearch: { __typename?: 'ShipToAccountSearchResult', count: number, results: Array<{ __typename?: 'ShipToAccount', id: string, accountNumber: string, phoneNumber?: string | null, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string } }> } };

export type GetLocateAJewelerListingsStateOrProvincesQueryVariables = Exact<{
  countryCode: Scalars['ID']['input'];
}>;


export type GetLocateAJewelerListingsStateOrProvincesQuery = { __typename?: 'Query', stateOrProvinces?: Array<{ __typename?: 'StateOrProvince', code: string, name?: string | null }> | null };

export type GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables = Exact<{
  shipToAccountNumber: Scalars['String']['input'];
}>;


export type GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery = { __typename?: 'Query', customerStoreInformationByShipTo?: { __typename?: 'CustomerStoreInformation', id: string, creationDate?: string | null, modificationDate?: string | null, businessEstablishedYear?: number | null, siteHasShoppingCart?: string | null, businessLocationCommunity?: string | null, locationOfSales?: string | null, primaryLocationDescription?: string | null, numberOfEmployees?: string | null, agta?: boolean | null, ags?: boolean | null, mjsa?: boolean | null, ja?: boolean | null, jvc?: boolean | null, jic?: boolean | null, otherOrganizations?: string | null, retailJewelersOrganization?: boolean | null, gemaltaCooperative?: boolean | null, canadianBuyingGroup?: boolean | null, independentJewelersOrganization?: boolean | null, diGem?: boolean | null, leadingJewelers?: boolean | null, continentalBuyingGroup?: boolean | null, buyersInternationalGroup?: boolean | null, employeeCount?: number | null, nationalPawnbrokersAssociation?: boolean | null, shipToAccount: { __typename?: 'ShipToAccount', id: string, accountNumber: string }, user?: { __typename?: 'User', id: string } | null } | null };

export type GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables = Exact<{
  shipToAccountNumber: Scalars['String']['input'];
}>;


export type GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery = { __typename?: 'Query', customerStoreInformationByShipTo?: { __typename?: 'CustomerStoreInformation', id: string } | null };

export type LocateAJewelerListingsDeleteListingMutationVariables = Exact<{
  input?: InputMaybe<DeleteLocateAJewelerListingInput>;
}>;


export type LocateAJewelerListingsDeleteListingMutation = { __typename?: 'Mutation', deleteLocateAJewelerListing?: { __typename?: 'DeleteLocateAJewelerListingPayload', locateAJewelerListingId?: string | null } | null };

export type LocateAJewelerListingsUpsertCustomerStoreInformationMutationVariables = Exact<{
  input: UpsertCustomerStoreInformationInput;
}>;


export type LocateAJewelerListingsUpsertCustomerStoreInformationMutation = { __typename?: 'Mutation', upsertCustomerStoreInformation: { __typename?: 'UpsertCustomerStoreInformationPayload', customerStoreInformation: { __typename?: 'CustomerStoreInformation', id: string, creationDate?: string | null, modificationDate?: string | null, businessEstablishedYear?: number | null, siteHasShoppingCart?: string | null, businessLocationCommunity?: string | null, locationOfSales?: string | null, primaryLocationDescription?: string | null, numberOfEmployees?: string | null, agta?: boolean | null, ags?: boolean | null, mjsa?: boolean | null, ja?: boolean | null, jvc?: boolean | null, jic?: boolean | null, otherOrganizations?: string | null, retailJewelersOrganization?: boolean | null, gemaltaCooperative?: boolean | null, canadianBuyingGroup?: boolean | null, independentJewelersOrganization?: boolean | null, diGem?: boolean | null, leadingJewelers?: boolean | null, continentalBuyingGroup?: boolean | null, buyersInternationalGroup?: boolean | null, employeeCount?: number | null, nationalPawnbrokersAssociation?: boolean | null, shipToAccount: { __typename?: 'ShipToAccount', id: string, accountNumber: string }, user?: { __typename?: 'User', id: string } | null } } };

export type LocateAJewelerListingsUpdateListingMutationVariables = Exact<{
  input?: InputMaybe<UpdateLocateAJewelerListingInput>;
}>;


export type LocateAJewelerListingsUpdateListingMutation = { __typename?: 'Mutation', updateLocateAJewelerListing?: { __typename?: 'UpdateLocateAJewelerListingPayload', locateAJewelerListing?: { __typename?: 'LocateAJewelerListing', id: string, doingBusinessAs?: string | null, locationDescription?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, jewelerShowcase?: string | null, products?: Array<string> | null, services?: Array<string> | null, salesFeatures?: Array<string> | null, shopFeatures?: Array<string> | null, owner?: { __typename?: 'LocateAJewelerOwner', salutation?: string | null, firstName?: string | null, lastName?: string | null, suffix?: string | null } | null, shipToAccount?: { __typename?: 'ShipToAccount', accountNumber: string } | null, address?: { __typename?: 'LocateAJewelerAddress', addressLine1: string, addressLine2?: string | null, city: string, stateOrProvince?: string | null, zip: string, country: string } | null, socials?: { __typename?: 'LocateAJewelerSocials', facebook?: string | null, twitter?: string | null, instagram?: string | null, pinterest?: string | null, youtube?: string | null } | null, hours?: { __typename?: 'LocateAJewelerHours', monday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, tuesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, wednesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, thursday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, friday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, saturday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, sunday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null } | null } | null } | null };

export type LocateAJewelerListingsCreateListingMutationVariables = Exact<{
  input?: InputMaybe<CreateLocateAJewelerListingInput>;
}>;


export type LocateAJewelerListingsCreateListingMutation = { __typename?: 'Mutation', createLocateAJewelerListing?: { __typename?: 'CreateLocateAJewelerListingPayload', locateAJewelerListing: { __typename?: 'LocateAJewelerListing', id: string, doingBusinessAs?: string | null, locationDescription?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, jewelerShowcase?: string | null, products?: Array<string> | null, services?: Array<string> | null, salesFeatures?: Array<string> | null, shopFeatures?: Array<string> | null, owner?: { __typename?: 'LocateAJewelerOwner', salutation?: string | null, firstName?: string | null, lastName?: string | null, suffix?: string | null } | null, shipToAccount?: { __typename?: 'ShipToAccount', accountNumber: string } | null, address?: { __typename?: 'LocateAJewelerAddress', addressLine1: string, addressLine2?: string | null, city: string, stateOrProvince?: string | null, zip: string, country: string } | null, socials?: { __typename?: 'LocateAJewelerSocials', facebook?: string | null, twitter?: string | null, instagram?: string | null, pinterest?: string | null, youtube?: string | null } | null, hours?: { __typename?: 'LocateAJewelerHours', monday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, tuesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, wednesday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, thursday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, friday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, saturday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null, sunday?: { __typename?: 'LocateAJewelerHoursSettings', type?: LocateAJewelerHoursSettingsType | null, openTime?: string | null, closeTime?: string | null } | null } | null } } | null };

export type GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetLocateAJewelerListingsMultiCheckBoxOptionsQuery = { __typename?: 'Query', cmsLookupsByType: Array<{ __typename?: 'CmsLookup', id: string, name: string }> };

export type GetLocateAJewelerListingsCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocateAJewelerListingsCountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', code: string, name: string }> | null };

export type GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type GetLocateAJewelerListingsShipToAccountByAccountNumberQuery = { __typename?: 'Query', shipToAccountByAccountNumber?: { __typename?: 'ShipToAccount', id: string, accountNumber: string, phoneNumber?: string | null, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string } } | null };

export type LocateAJewelerSearchPageHoursSettingsInfoFragment = { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null };

export type GetLocateAJewelerSearchPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocateAJewelerSearchPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canCreateLocateAJewelerListings: boolean } };

export type GetLocateAJewelerSearchPageDistanceSearchQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  rangeInMiles: Scalars['Int']['input'];
  services?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  paging: PagingInput;
}>;


export type GetLocateAJewelerSearchPageDistanceSearchQuery = { __typename?: 'Query', locateAJewelerListingsDistanceSearch?: { __typename?: 'LocateAJewelerListingsSearchResult', count: number, results: Array<{ __typename?: 'LocateAJewelerListingsSearchResultItem', distanceInMiles?: number | null, locateAJewelerListing?: { __typename?: 'LocateAJewelerListing', doingBusinessAs?: string | null, email?: string | null, id: string, jewelerShowcase?: string | null, longitude?: number | null, latitude?: number | null, phoneNumber?: string | null, services?: Array<string> | null, website?: string | null, address?: { __typename?: 'LocateAJewelerAddress', addressLine1: string, addressLine2?: string | null, city: string, country: string, stateOrProvince?: string | null, zip: string } | null, hours?: { __typename?: 'LocateAJewelerHours', sunday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null, monday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null, tuesday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null, wednesday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null, thursday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null, friday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null, saturday?: { __typename?: 'LocateAJewelerHoursSettings', closeTime?: string | null, openTime?: string | null, type?: LocateAJewelerHoursSettingsType | null } | null } | null, socials?: { __typename?: 'LocateAJewelerSocials', facebook?: string | null, instagram?: string | null, pinterest?: string | null, twitter?: string | null, youtube?: string | null } | null } | null }> } | null };

export type GetLocateAJewelerSearchPageServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocateAJewelerSearchPageServicesQuery = { __typename?: 'Query', cmsLookupsByType: Array<{ __typename?: 'CmsLookup', id: string, order?: number | null, name: string }> };

export type LocationSelectorShipToAccountInfoFragment = { __typename?: 'ShipToAccount', id: string, accountNumber: string, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string, type: string, province?: string | null, isInternational: boolean } };

export type GetLocationSelectorShipToAccountSearchQueryVariables = Exact<{
  onlyWebActive?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  onlyLocateAJewelerListingUnlisted?: InputMaybe<Scalars['Boolean']['input']>;
  consultantSearchAcrossAllBillToAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  paging: PagingInput;
}>;


export type GetLocationSelectorShipToAccountSearchQuery = { __typename?: 'Query', shipToAccountSearch: { __typename?: 'ShipToAccountSearchResult', count: number, results: Array<{ __typename?: 'ShipToAccount', id: string, accountNumber: string, address: { __typename?: 'Address', addressLines: Array<string>, city: string, state?: string | null, zip?: string | null, country: string, type: string, province?: string | null, isInternational: boolean } }> } };

export type GetMarketRatesFooterMarketRatesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetMarketRatesFooterMarketRatesQuery = { __typename?: 'Query', marketRates: Array<{ __typename?: 'MarketRate', id: string, date: string, url: string, gold: number, palladium: number, platinum: number, silver: number }> };

export type GetPaymentMethodsPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canUseCreditCards: boolean } };

export type PaymentMethodsLoyaltyProgramAutorenewalInfoFragment = { __typename?: 'LoyaltyProgramAutorenewal', id: string, autorenewalDate: string, shipToAccount: { __typename?: 'ShipToAccount', id: string }, loyaltyProgram: { __typename?: 'LoyaltyProgram', id: string, displayName: string, isStullerFirst: boolean } };

export type PaymentMethodsCreditCardInfoFragment = { __typename?: 'CreditCard', id: string, type: CardType, cardholderName: string, isDebitCard: boolean, zip?: string | null, expirationMonth: number, expirationYear: number, isExpired: boolean, tokenizedCardNumber: string, lastFourDigits: string, activeAutorenewals: Array<{ __typename?: 'LoyaltyProgramAutorenewal', id: string, autorenewalDate: string, shipToAccount: { __typename?: 'ShipToAccount', id: string }, loyaltyProgram: { __typename?: 'LoyaltyProgram', id: string, displayName: string, isStullerFirst: boolean } }> };

export type GetPaymentMethodsPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canManagePaymentMethods: boolean } };

export type GetPaymentMethodsMethodsQueryVariables = Exact<{
  context: PaymentMethodContext;
}>;


export type GetPaymentMethodsMethodsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', paymentMethods: Array<{ __typename?: 'COD', id: string } | { __typename?: 'CreditCard', id: string, type: CardType, cardholderName: string, isDebitCard: boolean, zip?: string | null, expirationMonth: number, expirationYear: number, isExpired: boolean, tokenizedCardNumber: string, lastFourDigits: string, activeAutorenewals: Array<{ __typename?: 'LoyaltyProgramAutorenewal', id: string, autorenewalDate: string, shipToAccount: { __typename?: 'ShipToAccount', id: string }, loyaltyProgram: { __typename?: 'LoyaltyProgram', id: string, displayName: string, isStullerFirst: boolean } }> } | { __typename?: 'NormalTerms', id: string }>, defaultPaymentMethod?: { __typename?: 'COD', id: string } | { __typename?: 'CreditCard', id: string } | { __typename?: 'NormalTerms', id: string } | null } | null };

export type PaymentMethodsCreateCreditCardMutationVariables = Exact<{
  input: CreateCreditCardInput;
}>;


export type PaymentMethodsCreateCreditCardMutation = { __typename?: 'Mutation', createCreditCard: { __typename?: 'CreateCreditCardPayload', creditCard: { __typename?: 'CreditCard', id: string, cardholderName: string, expirationMonth: number, expirationYear: number, isDebitCard: boolean, isExpired: boolean, lastFourDigits: string, tokenizedCardNumber: string, type: CardType, zip?: string | null } } };

export type PaymentMethodsUpdateDefaultPaymentMethodMutationVariables = Exact<{
  input: UpdateDefaultPaymentMethodInput;
}>;


export type PaymentMethodsUpdateDefaultPaymentMethodMutation = { __typename?: 'Mutation', updateDefaultPaymentMethod: { __typename?: 'UpdateDefaultPaymentMethodPayload', defaultPaymentMethod: { __typename?: 'COD', id: string } | { __typename?: 'CreditCard', id: string, type: CardType, cardholderName: string, isDebitCard: boolean, zip?: string | null, expirationMonth: number, expirationYear: number, isExpired: boolean, tokenizedCardNumber: string, lastFourDigits: string } | { __typename?: 'NormalTerms', id: string } } };

export type PaymentMethodsDeleteCreditCardMutationVariables = Exact<{
  input: DeleteCreditCardInput;
}>;


export type PaymentMethodsDeleteCreditCardMutation = { __typename?: 'Mutation', deleteCreditCard: { __typename?: 'DeleteCreditCardPayload', creditCardId: string } };

export type PaymentMethodsUpdateCreditCardMutationVariables = Exact<{
  input: UpdateCreditCardInput;
}>;


export type PaymentMethodsUpdateCreditCardMutation = { __typename?: 'Mutation', updateCreditCard: { __typename?: 'UpdateCreditCardPayload', creditCard: { __typename?: 'CreditCard', id: string, cardholderName: string, expirationMonth: number, expirationYear: number, isDebitCard: boolean, isExpired: boolean, lastFourDigits: string, tokenizedCardNumber: string, type: CardType, zip?: string | null } } };

type PdpImageCarouselMediaInfo_MeteorImage_Fragment = { __typename?: 'MeteorImage', id: string };

type PdpImageCarouselMediaInfo_Video360_Fragment = { __typename?: 'Video360', id: string, sources?: Array<{ __typename?: 'Video', height?: number | null, width?: number | null, type?: string | null, url?: string | null }> | null };

export type PdpImageCarouselMediaInfoFragment = PdpImageCarouselMediaInfo_MeteorImage_Fragment | PdpImageCarouselMediaInfo_Video360_Fragment;

export type PdpImageCarouselVideo360InfoFragment = { __typename?: 'Video360', id: string, sources?: Array<{ __typename?: 'Video', height?: number | null, width?: number | null, type?: string | null, url?: string | null }> | null };

type PdpImageCarouselInfo_Configuration_Fragment = { __typename?: 'Configuration', id: string };

type PdpImageCarouselInfo_Product_Fragment = { __typename?: 'Product', id: string };

type PdpImageCarouselInfo_SerializedProduct_Fragment = { __typename?: 'SerializedProduct', isLabGrown: boolean, isGemstone: boolean, id: string, media?: Array<{ __typename?: 'MeteorImage', id: string } | { __typename?: 'Video360', id: string, sources?: Array<{ __typename?: 'Video', height?: number | null, width?: number | null, type?: string | null, url?: string | null }> | null }> | null };

export type PdpImageCarouselInfoFragment = PdpImageCarouselInfo_Configuration_Fragment | PdpImageCarouselInfo_Product_Fragment | PdpImageCarouselInfo_SerializedProduct_Fragment;

export type PreferenceContactInfoFragment = { __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null };

export type PreferenceCenterPageCommunicationPreferenceInfoFragment = { __typename?: 'CommunicationPreference', id?: string | null, preferenceCreationToken: string, channel: CommunicationPreferenceChannel, groupName: string, name: string, description?: string | null, isSubscribed: boolean, optInRequired: boolean };

export type GetPreferenceCenterPageUnavailableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferenceCenterPageUnavailableQuery = { __typename?: 'Query', cmsLookupByTypeAndCode?: { __typename?: 'CmsLookup', id: string, unavailable: string } | null };

export type GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;


export type GetPreferenceCenterPageShipToAccountByAccountNumberQuery = { __typename?: 'Query', shipToAccountByAccountNumber?: { __typename?: 'ShipToAccount', id: string, accountNumber: string, address: { __typename?: 'Address', isInternational: boolean } } | null };

export type GetPreferenceCenterPageContactsByPhoneNumberQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  shipToAccountNumber: Scalars['String']['input'];
  paging: PagingInput;
}>;


export type GetPreferenceCenterPageContactsByPhoneNumberQuery = { __typename?: 'Query', contactsByPhoneNumber: { __typename?: 'ContactsByPhoneNumberResult', count: number, results: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null }> } };

export type GetPreferenceCenterPageContactsByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  shipToAccountNumber: Scalars['String']['input'];
  paging: PagingInput;
}>;


export type GetPreferenceCenterPageContactsByEmailQuery = { __typename?: 'Query', contactsByEmail: { __typename?: 'ContactsByEmailResult', count: number, results: Array<{ __typename?: 'Contact', id: string, firstName: string, lastName: string, suffix?: string | null, jobTitle?: string | null, emailAddress?: string | null, mobilePhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null, directPhoneNumber?: { __typename?: 'Phone', phoneNumber?: string | null, sanitizedPhoneNumber?: string | null, extension?: string | null } | null }> } };

export type GetPreferenceCenterPageContactPreferencesQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
  shipToAccountNumber: Scalars['ID']['input'];
}>;


export type GetPreferenceCenterPageContactPreferencesQuery = { __typename?: 'Query', contactPreferencesByContactId: Array<{ __typename?: 'CommunicationPreference', id?: string | null, preferenceCreationToken: string, channel: CommunicationPreferenceChannel, groupName: string, name: string, description?: string | null, isSubscribed: boolean, optInRequired: boolean }> };

export type GetPreferenceCenterPageContactPreferencesResponseQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
  shipToAccountNumber: Scalars['ID']['input'];
}>;


export type GetPreferenceCenterPageContactPreferencesResponseQuery = { __typename?: 'Query', contactPreferencesResponseByContactId?: { __typename?: 'ContactPreferencesResponseByContactIdResult', optedOutEngagementChannels: Array<string>, communicationPreferences: Array<{ __typename?: 'CommunicationPreference', id?: string | null, preferenceCreationToken: string, channel: CommunicationPreferenceChannel, groupName: string, name: string, description?: string | null, isSubscribed: boolean, optInRequired: boolean }>, communicationChannelGlobalSubscriptions: Array<{ __typename?: 'CommunicationChannelGlobalSubscription', engagementChannelType: string, sfdcContactId?: string | null, status: string, optedOut: boolean }> } | null };

export type GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables = Exact<{
  shipToAccountNumber: Scalars['ID']['input'];
}>;


export type GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canAdminContacts: boolean } };

export type GetPreferenceCenterPageCanManagePreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferenceCenterPageCanManagePreferencesQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canManagePreferences: boolean } };

export type GetPreferenceCenterPageCanSetPrimaryContactQueryVariables = Exact<{
  shipToAccountNumber: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPreferenceCenterPageCanSetPrimaryContactQuery = { __typename?: 'Query', canSetPrimaryContact: boolean };

export type PreferenceCenterPageUpsertCommunicationPreferenceMutationVariables = Exact<{
  input: UpsertCommunicationPreferenceInput;
}>;


export type PreferenceCenterPageUpsertCommunicationPreferenceMutation = { __typename?: 'Mutation', upsertCommunicationPreference?: { __typename?: 'UpsertCommunicationPreferencePayload', optedOutEngagementChannels: Array<string>, communicationPreference: { __typename?: 'CommunicationPreference', id?: string | null, preferenceCreationToken: string, channel: CommunicationPreferenceChannel, groupName: string, name: string, description?: string | null, isSubscribed: boolean, optInRequired: boolean } } | null };

export type PreferenceCenterPageGlobalUnsubscribeContactMutationVariables = Exact<{
  input: GlobalUnsubscribeContactInput;
}>;


export type PreferenceCenterPageGlobalUnsubscribeContactMutation = { __typename?: 'Mutation', globalUnsubscribeContact?: { __typename?: 'GlobalUnsubscribeContactPayload', communicationPreferences: Array<{ __typename?: 'CommunicationPreference', id?: string | null, preferenceCreationToken: string, channel: CommunicationPreferenceChannel, groupName: string, name: string, description?: string | null, isSubscribed: boolean, optInRequired: boolean }>, communicationPreferencesResponse?: { __typename?: 'CommunicationPreferencesResponse', optedOutEngagementChannels: Array<string>, communicationPreferences: Array<{ __typename?: 'CommunicationPreference', id?: string | null, preferenceCreationToken: string, channel: CommunicationPreferenceChannel, groupName: string, name: string, description?: string | null, isSubscribed: boolean, optInRequired: boolean }>, communicationChannelGlobalSubscriptions: Array<{ __typename?: 'CommunicationChannelGlobalSubscription', engagementChannelType: string, sfdcContactId?: string | null, status: string, optedOut: boolean }> } | null } | null };

export type GetRecommendationsProductGroupsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetRecommendationsProductGroupsByIdsQuery = { __typename?: 'Query', productGroupsByIds: Array<{ __typename?: 'ProductGroup', id: string, title: string, code: string }> };

export type GetRequestItemsPagePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestItemsPagePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canSubmitQuote?: boolean | null } };

export type GetRequestItemsPageCartCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestItemsPageCartCountQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', id: string, itemCount?: number | null } | null };

export type RequestItemsPageCreateQuoteMutationVariables = Exact<{
  callbackRequest?: InputMaybe<JewelerShowcaseCallbackRequestInput>;
  addToCarts?: InputMaybe<Array<AddToCartInput> | AddToCartInput>;
}>;


export type RequestItemsPageCreateQuoteMutation = { __typename?: 'Mutation', createQuote?: { __typename?: 'CreateQuotePayload', publicQuoteLines?: Array<{ __typename?: 'PublicQuoteLine', id: string }> | null, cart?: { __typename?: 'Cart', id: string, errors?: Array<{ __typename?: 'CartMessage', code?: string | null, message?: string | null }> | null, price?: { __typename?: 'CartPrice', subtotal?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, items?: Array<{ __typename?: 'CartLine', id: string, item?: { __typename?: 'Configuration', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'Product', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | { __typename?: 'SerializedProduct', id: string, itemNumber: string, title: string, brand?: string | null, series: string, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string } | null } | null, options?: { __typename?: 'OrderLineOptions', quantity: number } | null, productGroup?: { __typename?: 'ProductGroup', id: string, title: string, code: string } | null, price?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null } | null, pricePerUnit?: { __typename?: 'CartItemPrice', total?: { __typename?: 'CurrencyValue', valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number }, value: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } | null, trackingSource?: { __typename?: 'TrackingSource', index?: number | null, source: string } | null }> | null } | null, request?: { __typename?: 'JewelerShowcaseCallbackRequest', emailAddress?: string | null } | null } | null };

export type GetSerializedPdpPagesStoneRebateStatusQueryVariables = Exact<{
  type: StoneRebateType;
}>;


export type GetSerializedPdpPagesStoneRebateStatusQuery = { __typename?: 'Query', stoneRebateStatus?: { __typename?: 'StoneRebateByBillToAccountResult', stonesPurchased?: number | null, tiers?: Array<{ __typename?: 'StoneRebateRange', minimumQuantity?: number | null, maximumQuantity?: number | null, rebatePercent?: number | null }> | null } | null };

export type GetSerializedPdpPagesDiamondDetailsQueryVariables = Exact<{
  serialNumber: Scalars['ID']['input'];
  options?: InputMaybe<ItemLineOptionsInput>;
  nonConsignmentOptions?: InputMaybe<ItemLineOptionsInput>;
}>;


export type GetSerializedPdpPagesDiamondDetailsQuery = { __typename?: 'Query', serializedProductBySerialNumber?: { __typename?: 'SerializedProduct', id: string, image?: string | null, agtaDescription?: string | null, calibratedSize?: string | null, color?: string | null, clarity?: string | null, culet?: string | null, depthPercent?: string | null, isDiamond: boolean, fluorescence?: string | null, girdle?: string | null, girdle2?: string | null, isCanadaMark?: boolean | null, isGCal8x: boolean, length?: number | null, lengthToWidthRatio?: number | null, makeLookup?: string | null, maxDiameter?: number | null, minDiameter?: number | null, notes?: string | null, polishLookup?: string | null, serialNumber: string, shape?: string | null, stoneFamily?: string | null, stoneOrigin?: string | null, symmetryLookup?: string | null, tablePercent?: string | null, weight?: number | null, width?: number | null, percentOffRapaport?: number | null, isOnConsignment?: boolean | null, isActive: boolean, isGemstone: boolean, isLabGrown: boolean, title: string, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, report?: { __typename?: 'SerializedProductReport', provider?: string | null, url?: string | null } | null, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, media?: Array<{ __typename?: 'MeteorImage', id: string } | { __typename?: 'Video360', id: string, sources?: Array<{ __typename?: 'Video', height?: number | null, width?: number | null, type?: string | null, url?: string | null }> | null }> | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null } | null };

export type GetSerializedPdpPagesDiamondPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSerializedPdpPagesDiamondPermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewDiamondRebates?: boolean | null } };

export type GetSerializedPdpPagesGemstoneDetailsQueryVariables = Exact<{
  serialNumber: Scalars['ID']['input'];
  options?: InputMaybe<ItemLineOptionsInput>;
  nonConsignmentOptions?: InputMaybe<ItemLineOptionsInput>;
}>;


export type GetSerializedPdpPagesGemstoneDetailsQuery = { __typename?: 'Query', serializedProductBySerialNumber?: { __typename?: 'SerializedProduct', id: string, image?: string | null, serialNumber: string, stoneFamily?: string | null, stoneOrigin?: string | null, isDiamond: boolean, geographicalOrigin?: string | null, percentOffRapaport?: number | null, isOnConsignment?: boolean | null, isActive: boolean, isGemstone: boolean, isLabGrown: boolean, title: string, canAddToCart?: boolean | null, canMatch: boolean, canOrderOnConsignment: boolean, maximumQuantity?: number | null, isLimitedAvailability: boolean, isReturnable: boolean, soldByDescription: string, itemStatus?: string | null, planningCode?: string | null, planningGroup?: string | null, hasCadFile?: boolean | null, series: string, brand?: string | null, itemNumber: string, itemId: { __typename?: 'ItemId', id: string, type: ItemType }, defaultProductGroup?: { __typename?: 'ProductGroup', id: string, code: string, title: string } | null, options?: { __typename?: 'ItemLineOptions', quantity: number, isMatched: boolean, isAnnealed: boolean, isForConsignment: boolean, specialInstructions?: string | null, length?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null, width?: { __typename?: 'LengthValue', value: number, uom: LengthValueUom } | null } | null, nonConsignmentPrice?: { __typename?: 'ItemPrice', roundedPricePerPackUnit?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, priceBreaks?: Array<{ __typename?: 'PriceBreak', minQuantity?: number | null, maxQuantity?: number | null, price?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } | null, discount?: { __typename?: 'PriceDiscount', percent: number } | null }> | null, rounded: { __typename?: 'Price', components: Array<{ __typename?: 'ComponentPrice', key: string, parentKey: string, title: string, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } }>, caratPrice?: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } | null, discount?: { __typename?: 'PriceDiscount', percent: number, source?: string | null, originalPrice: { __typename?: 'CurrencyValue', value: number, valueInUsd: number }, value: { __typename?: 'CurrencyValue', value: number, valueInUsd: number } } | null, total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, stullerFirstDiscount?: { __typename?: 'PriceDiscount', percent: number } | null }, extended: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, valueInUsd: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } }, roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number } } } | null, inStockStatus: { __typename?: 'ProductInStockStatus', status?: string | null, statusCode: ProductInStockStatusCode, backOrderInfo: { __typename?: 'BackOrderInfo', canBackOrder: boolean, quantityOnHand: number } }, shipDate?: { __typename?: 'EstimatedShipDate', date: string, logId?: string | null } | null, shippingCountdown?: { __typename?: 'ShippingCountdown', cutoffDate?: string | null, countdownKind?: ShippingCountdownKind | null } | null, media?: Array<{ __typename?: 'MeteorImage', id: string } | { __typename?: 'Video360', id: string, sources?: Array<{ __typename?: 'Video', height?: number | null, width?: number | null, type?: string | null, url?: string | null }> | null }> | null, merchandiseHierarchy?: { __typename?: 'MerchandiseHierarchy', segment2?: string | null, segment3?: string | null, segment4?: string | null, segment5?: string | null, segment6?: string | null } | null, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', valueInUsd: number }, discount?: { __typename?: 'PriceDiscount', value: { __typename?: 'CurrencyValue', valueInUsd: number }, originalPrice: { __typename?: 'CurrencyValue', valueInUsd: number } } | null } } | null } | null };

export type GetSerializedPdpPagesGemstonePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSerializedPdpPagesGemstonePermissionsQuery = { __typename?: 'Query', viewerPermissions: { __typename?: 'ViewerPermissions', id: string, canViewGemstoneRebates?: boolean | null } };

export type GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables = Exact<{
  serialNumber: Scalars['ID']['input'];
}>;


export type GetSerializedPdpPagesRedirectSerialNumberOr404Query = { __typename?: 'Query', serializedProductBySerialNumber?: { __typename?: 'SerializedProduct', id: string, isDiamond: boolean, serialNumber: string } | null };

export type SerializedPdpPagesSendProductShareEmailMutationVariables = Exact<{
  input: ProductShareEmailInput;
}>;


export type SerializedPdpPagesSendProductShareEmailMutation = { __typename?: 'Mutation', sendProductShareEmail?: { __typename?: 'ProductShareEmailPayload', success: boolean } | null };

export type GetServerAdminTaskDefinitionsByDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type GetServerAdminTaskDefinitionsByDomainQuery = { __typename?: 'Query', taskDefinitionsByDomain?: Array<{ __typename?: 'TaskDefinition', domain: string, nextRunTime?: string | null, status?: string | null, taskName: string, currentRun?: { __typename?: 'TaskRun', beginTime?: string | null, completeTime?: string | null, duration?: number | null, runId: string, status?: string | null, traceId?: string | null } | null, previousRun?: { __typename?: 'TaskRun', beginTime?: string | null, completeTime?: string | null, duration?: number | null, runId: string, status?: string | null, traceId?: string | null } | null }> | null };

export type GetServerAdminTaskRunsQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  taskKey: Scalars['String']['input'];
  paging?: InputMaybe<CursorPagingInput>;
}>;


export type GetServerAdminTaskRunsQuery = { __typename?: 'Query', taskRuns?: { __typename?: 'TaskRunsSearchResult', nextToken?: string | null, taskRuns?: Array<{ __typename?: 'TaskRun', beginTime?: string | null, completeTime?: string | null, duration?: number | null, runId: string, status?: string | null, traceId?: string | null, taskSource?: string | null, details?: { __typename?: 'TaskResultSummary', errorMessages?: Array<string> | null, messages?: Array<string> | null, operations?: { __typename?: 'TaskRunOperations', deletes: { __typename?: 'TaskOperationDetail', count?: number | null, values?: Array<string> | null }, reads: { __typename?: 'TaskOperationDetail', count?: number | null, values?: Array<string> | null }, writes: { __typename?: 'TaskOperationDetail', count?: number | null, values?: Array<string> | null } } | null } | null }> | null } | null };

export type ServerAdminAbortTaskMutationVariables = Exact<{
  input: TaskIdentifierInput;
}>;


export type ServerAdminAbortTaskMutation = { __typename?: 'Mutation', abortTask?: boolean | null };

export type ServerAdminRunTaskMutationVariables = Exact<{
  input: TaskIdentifierInput;
}>;


export type ServerAdminRunTaskMutation = { __typename?: 'Mutation', runTask?: boolean | null };

export type ShippingCountdownInfoFragment = { __typename?: 'ShippingCountdown', countdownKind?: ShippingCountdownKind | null, cutoffDate?: string | null };

export type GetAvailableStatementsQueryVariables = Exact<{
  custAccountId: Scalars['Int']['input'];
}>;


export type GetAvailableStatementsQuery = { __typename?: 'Query', availableStatements?: { __typename?: 'AvailableStatements', currentStatementDates?: Array<string | null> | null, historicalStatementDates?: Array<string | null> | null, showPaperlessEnrollment?: boolean | null } | null };

export type GetTrainingDetailPageEventSessionsQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetTrainingDetailPageEventSessionsQuery = { __typename?: 'Query', eventSessions?: Array<{ __typename?: 'EventSession', id: string, title: string, startDate: string, endDate: string, timeZone: string, location: string }> | null };

export type UiProductCardPriceInfoFragment = { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } };

export type UiProductCardDiscountPriceInfoFragment = { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } };

type UiProductCardItemInfo_Configuration_Fragment = { __typename?: 'Configuration', id: string, title: string, image?: string | null, isInStock: boolean, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null };

type UiProductCardItemInfo_Product_Fragment = { __typename?: 'Product', id: string, title: string, image?: string | null, isInStock: boolean, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null };

type UiProductCardItemInfo_SerializedProduct_Fragment = { __typename?: 'SerializedProduct', id: string, title: string, image?: string | null, isInStock: boolean, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } }, discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null };

export type UiProductCardItemInfoFragment = UiProductCardItemInfo_Configuration_Fragment | UiProductCardItemInfo_Product_Fragment | UiProductCardItemInfo_SerializedProduct_Fragment;

export type UiProductCardGroupInfoFragment = { __typename?: 'ProductGroup', id: string, title: string, image?: string | null, minPriceProduct?: { __typename?: 'Product', id: string, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } } | null } | null, maxPriceProduct?: { __typename?: 'Product', id: string, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', total: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } } | null } | null, maxDiscountProduct?: { __typename?: 'Product', id: string, price?: { __typename?: 'ItemPrice', roundedPerUnit: { __typename?: 'Price', discount?: { __typename?: 'PriceDiscount', percent: number, originalPrice: { __typename?: 'CurrencyValue', value: number, exchangeRate: { __typename?: 'ExchangeRate', code: string, culture: string } } } | null } } | null } | null };

export type UnsubscribeAllPageGlobalUnsubscribeEmailMutationVariables = Exact<{
  input: GlobalUnsubscribeEmailInput;
}>;


export type UnsubscribeAllPageGlobalUnsubscribeEmailMutation = { __typename?: 'Mutation', globalUnsubscribeEmail?: { __typename?: 'GlobalUnsubscribeEmailPayload', salesforceContactId: string } | null };

export type GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnsupportedBannerMinimumSupportedBrowsersQuery = { __typename?: 'Query', cmsLookupsByType: Array<{ __typename?: 'CmsLookup', id: string, name: string, majorVersion: string, minorVersion?: string | null, message?: string | null }> };

export const AddToCartMessageInfoFragmentDoc = gql`
    fragment AddToCartMessageInfo on CartMessage {
  code
  message
}
    `;
export const GoogleTagManagerItemInfoFragmentDoc = gql`
    fragment GoogleTagManagerItemInfo on Item {
  id
  title
  series
  image
  brand
  itemNumber
  options {
    quantity
  }
  defaultProductGroup {
    id
    code
  }
  merchandiseHierarchy {
    segment2
    segment3
    segment4
    segment5
    segment6
  }
  price {
    roundedPerUnit {
      total {
        valueInUsd
      }
      discount {
        value {
          valueInUsd
        }
        originalPrice {
          valueInUsd
        }
      }
    }
  }
}
    `;
export const GoogleTagManagerProductGroupInfoFragmentDoc = gql`
    fragment GoogleTagManagerProductGroupInfo on ProductGroup {
  id
  title
  code
}
    `;
export const AddToCartPriceValuesWithCurrencyInfoFragmentDoc = gql`
    fragment AddToCartPriceValuesWithCurrencyInfo on CurrencyValue {
  value
  valueInUsd
  exchangeRate {
    code
    culture
  }
}
    `;
export const AddToCartPriceValuesInfoFragmentDoc = gql`
    fragment AddToCartPriceValuesInfo on CurrencyValue {
  value
  valueInUsd
}
    `;
export const AddToCartItemPriceInfoFragmentDoc = gql`
    fragment AddToCartItemPriceInfo on ItemPrice {
  roundedPricePerPackUnit {
    ...AddToCartPriceValuesWithCurrencyInfo
  }
  priceBreaks {
    minQuantity
    maxQuantity
    price {
      ...AddToCartPriceValuesInfo
    }
    caratPrice {
      ...AddToCartPriceValuesInfo
    }
    discount {
      percent
    }
  }
  rounded {
    components {
      key
      parentKey
      title
      total {
        ...AddToCartPriceValuesInfo
      }
    }
    caratPrice {
      ...AddToCartPriceValuesWithCurrencyInfo
    }
    discount {
      originalPrice {
        ...AddToCartPriceValuesInfo
      }
      percent
      value {
        ...AddToCartPriceValuesInfo
      }
      source
    }
    total {
      ...AddToCartPriceValuesWithCurrencyInfo
    }
    stullerFirstDiscount {
      percent
    }
  }
  extended {
    total {
      ...AddToCartPriceValuesWithCurrencyInfo
    }
  }
  roundedPerUnit {
    total {
      valueInUsd
    }
  }
}
    ${AddToCartPriceValuesWithCurrencyInfoFragmentDoc}
${AddToCartPriceValuesInfoFragmentDoc}`;
export const AddToCartInStockStatusInfoFragmentDoc = gql`
    fragment AddToCartInStockStatusInfo on ProductInStockStatus {
  status
  statusCode
  backOrderInfo {
    canBackOrder
    quantityOnHand
  }
}
    `;
export const AddToCartSectionInfoFragmentDoc = gql`
    fragment AddToCartSectionInfo on Item {
  ...GoogleTagManagerItemInfo
  id
  itemId {
    id
    type
  }
  title
  image
  defaultProductGroup {
    ...GoogleTagManagerProductGroupInfo
  }
  options {
    quantity
    isMatched
    isAnnealed
    isForConsignment
    specialInstructions
    length {
      value
      uom
    }
    width {
      value
      uom
    }
  }
  nonConsignmentPrice: price(options: $nonConsignmentOptions) {
    ...AddToCartItemPriceInfo
  }
  canAddToCart
  canMatch
  canOrderOnConsignment
  maximumQuantity
  isLimitedAvailability
  isReturnable
  soldByDescription
  itemStatus
  planningCode
  planningGroup
  hasCadFile
  inStockStatus {
    ...AddToCartInStockStatusInfo
  }
  shipDate {
    date
    logId
  }
  shippingCountdown {
    cutoffDate
    countdownKind
  }
  ... on SerializedProduct {
    serialNumber
    percentOffRapaport
    isOnConsignment
    isActive
    isDiamond
    isGemstone
    isLabGrown
  }
}
    ${GoogleTagManagerItemInfoFragmentDoc}
${GoogleTagManagerProductGroupInfoFragmentDoc}
${AddToCartItemPriceInfoFragmentDoc}
${AddToCartInStockStatusInfoFragmentDoc}`;
export const CadCamPageProjectManagerRequestRowInfoFragmentDoc = gql`
    fragment CadCamPageProjectManagerRequestRowInfo on CadCamRequest {
  id
  image {
    fullSize
    thumb225
  }
  source
  customerReference
  requestDate
  estimatedShipDate
  requestStatuses {
    name
    description
    startedDate
    completedDate
    isCustomerActionRequired
  }
  isCancelled
  cancelledReason
  canReorder
  canReactivate
  canAddToSignetCart
  showcasePrice {
    total {
      currencyCode
      value
      valueInUsd
    }
  }
  brand
  storeName
  storeReference
  customerName
}
    `;
export const CartPageCartListHeaderInfoFragmentDoc = gql`
    fragment CartPageCartListHeaderInfo on CartHeader {
  id
  createdOn
  itemCount
  topImages
  user {
    id
  }
}
    `;
export const CartPageCartListHeaderWithEmployeeInfoFragmentDoc = gql`
    fragment CartPageCartListHeaderWithEmployeeInfo on CartHeader {
  ...CartPageCartListHeaderInfo
  lastModifiedByEmployee {
    id
    displayName
  }
}
    ${CartPageCartListHeaderInfoFragmentDoc}`;
export const GoogleTagManagerCartLineInfoFragmentDoc = gql`
    fragment GoogleTagManagerCartLineInfo on ICartLine {
  id
  item {
    id
    itemNumber
    title
    brand
    series
    merchandiseHierarchy {
      segment2
      segment3
      segment4
      segment5
      segment6
    }
    defaultProductGroup {
      id
      code
    }
  }
  options {
    quantity
  }
  productGroup {
    id
    title
    code
  }
  price {
    total {
      valueInUsd
    }
  }
  pricePerUnit {
    total {
      valueInUsd
    }
    discount {
      originalPrice {
        valueInUsd
      }
      value {
        valueInUsd
      }
    }
  }
  trackingSource {
    index
    source
  }
}
    `;
export const GoogleTagManagerCartInfoFragmentDoc = gql`
    fragment GoogleTagManagerCartInfo on Cart {
  id
  price {
    subtotal {
      valueInUsd
    }
  }
  items {
    ...GoogleTagManagerCartLineInfo
  }
}
    ${GoogleTagManagerCartLineInfoFragmentDoc}`;
export const CartPageCartItemMessageInfoFragmentDoc = gql`
    fragment CartPageCartItemMessageInfo on CartMessage {
  code
  message
}
    `;
export const CartPageCartItemOptionsInfoFragmentDoc = gql`
    fragment CartPageCartItemOptionsInfo on OrderLineOptions {
  width {
    uom
    value
  }
  length {
    uom
    value
  }
  specialInstructions
  quantity
  isAnnealed
  customerNotes
  isMatched
  isForConsignment
  bagAndTagOptions {
    tagBags
    quantityPerBag
  }
  salesType
  matchingCode
  consultantDiscount
}
    `;
export const CartPageCartItemPriceInfoFragmentDoc = gql`
    fragment CartPageCartItemPriceInfo on CurrencyValue {
  value
  valueInUsd
  exchangeRate {
    code
    culture
  }
}
    `;
export const CartPageCartItemPriceDiscountInfoFragmentDoc = gql`
    fragment CartPageCartItemPriceDiscountInfo on PriceDiscount {
  originalPrice {
    value
    valueInUsd
    exchangeRate {
      code
      culture
    }
  }
  percent
  value {
    ...CartPageCartItemPriceInfo
  }
}
    ${CartPageCartItemPriceInfoFragmentDoc}`;
export const CartPageCartItemInStockStatusInfoFragmentDoc = gql`
    fragment CartPageCartItemInStockStatusInfo on CartLineInStockStatus {
  statusCode
  status
  quantityOnHand
}
    `;
export const CartPageCartItemInfoFragmentDoc = gql`
    fragment CartPageCartItemInfo on ICartLine {
  ...GoogleTagManagerCartLineInfo
  id
  canEditItem
  creationDate
  item {
    id
    title
    itemNumber
    itemId {
      id
      type
    }
    isTool
    image
    canAnneal
    canMatch
    canOrderOnConsignment
    canAddSpecialInstructions
    canAddCustomerNotes
    soldByDescription
    isReturnable
    isLimitedAvailability
    series
    brand
    defaultProductGroup {
      id
      code
    }
    merchandiseHierarchy {
      segment2
      segment3
      segment4
      segment5
      segment6
    }
    minimumQuantity
    maximumQuantity
    ... on Configuration {
      configurationProduct: product {
        id
      }
    }
    ... on SerializedProduct {
      report {
        provider
        url
      }
    }
  }
  notes {
    ...CartPageCartItemMessageInfo
  }
  errors {
    ...CartPageCartItemMessageInfo
  }
  options {
    ...CartPageCartItemOptionsInfo
  }
  productGroup {
    id
    title
    code
  }
  price {
    total {
      ...CartPageCartItemPriceInfo
    }
    discount {
      ...CartPageCartItemPriceDiscountInfo
    }
  }
  pricePerUnit {
    total {
      ...CartPageCartItemPriceInfo
    }
    discount {
      ...CartPageCartItemPriceDiscountInfo
    }
  }
  quotedPrice {
    total {
      ...CartPageCartItemPriceInfo
    }
  }
  inStockStatus {
    ...CartPageCartItemInStockStatusInfo
  }
  shipDate
  consultantDescription
}
    ${GoogleTagManagerCartLineInfoFragmentDoc}
${CartPageCartItemMessageInfoFragmentDoc}
${CartPageCartItemOptionsInfoFragmentDoc}
${CartPageCartItemPriceInfoFragmentDoc}
${CartPageCartItemPriceDiscountInfoFragmentDoc}
${CartPageCartItemInStockStatusInfoFragmentDoc}`;
export const CartPageCartListMessageInfoFragmentDoc = gql`
    fragment CartPageCartListMessageInfo on CartMessage {
  code
  message
}
    `;
export const CartPageCartListPriceInfoFragmentDoc = gql`
    fragment CartPageCartListPriceInfo on CurrencyValue {
  value
  valueInUsd
  exchangeRate {
    code
    culture
  }
}
    `;
export const CartPageCartListItemInfoFragmentDoc = gql`
    fragment CartPageCartListItemInfo on Cart {
  ...GoogleTagManagerCartInfo
  user {
    id
  }
  id
  itemCount
  items {
    ...CartPageCartItemInfo
  }
  notes {
    ...CartPageCartListMessageInfo
  }
  errors {
    ...CartPageCartListMessageInfo
  }
  createdOn
  price {
    salesTaxV2 {
      ...CartPageCartListPriceInfo
    }
    subtotal {
      ...CartPageCartListPriceInfo
    }
  }
  quotedPrice {
    salesTaxV2 {
      ...CartPageCartListPriceInfo
    }
    subtotal {
      ...CartPageCartListPriceInfo
    }
  }
  cartHeader {
    ...CartPageCartListHeaderInfo
  }
}
    ${GoogleTagManagerCartInfoFragmentDoc}
${CartPageCartItemInfoFragmentDoc}
${CartPageCartListMessageInfoFragmentDoc}
${CartPageCartListPriceInfoFragmentDoc}
${CartPageCartListHeaderInfoFragmentDoc}`;
export const CartPageCartPageMessageInfoFragmentDoc = gql`
    fragment CartPageCartPageMessageInfo on CartMessage {
  code
  message
}
    `;
export const GoogleTagManagerCartWithShipmentsInfoFragmentDoc = gql`
    fragment GoogleTagManagerCartWithShipmentsInfo on Cart {
  id
  price {
    subtotal {
      valueInUsd
    }
  }
  shipments {
    lines {
      ...GoogleTagManagerCartLineInfo
    }
  }
}
    ${GoogleTagManagerCartLineInfoFragmentDoc}`;
export const CartPageCartMessageInfoFragmentDoc = gql`
    fragment CartPageCartMessageInfo on CartMessage {
  code
  message
}
    `;
export const ShippingCountdownInfoFragmentDoc = gql`
    fragment ShippingCountdownInfo on ShippingCountdown {
  countdownKind
  cutoffDate
}
    `;
export const CartPageCartPagePriceInfoFragmentDoc = gql`
    fragment CartPageCartPagePriceInfo on CurrencyValue {
  value
  valueInUsd
  exchangeRate {
    code
    culture
  }
}
    `;
export const CartPageCartPageShippingEstimateInfoFragmentDoc = gql`
    fragment CartPageCartPageShippingEstimateInfo on ShippingEstimate {
  isSaturdayDelivery
  delivery
  method {
    id
    description
    carrier
  }
  freight {
    value
    exchangeRate {
      code
      culture
    }
  }
}
    `;
export const CartPageCartPageCartInfoFragmentDoc = gql`
    fragment CartPageCartPageCartInfo on Cart {
  ...GoogleTagManagerCartWithShipmentsInfo
  id
  itemCount
  errors {
    ...CartPageCartMessageInfo
  }
  notes {
    ...CartPageCartMessageInfo
  }
  shippingCountdown {
    ...ShippingCountdownInfo
  }
  price {
    subtotal {
      ...CartPageCartPagePriceInfo
    }
    serviceChargesTotal {
      ...CartPageCartPagePriceInfo
    }
    shippingTotal {
      ...CartPageCartPagePriceInfo
    }
    salesTaxV2 {
      ...CartPageCartPagePriceInfo
    }
    total {
      ...CartPageCartPagePriceInfo
    }
    serviceCharges {
      type
      title
      quantity
      price {
        type
        total {
          ...CartPageCartPagePriceInfo
        }
        perUnit {
          ...CartPageCartPagePriceInfo
        }
      }
    }
  }
  items {
    id
  }
  shipments {
    shipSetCode
    shipDate
    isValid
    validationErrors
    lines {
      ...CartPageCartItemInfo
    }
    shippingMethodSelection {
      ...CartPageCartPageShippingEstimateInfo
    }
  }
}
    ${GoogleTagManagerCartWithShipmentsInfoFragmentDoc}
${CartPageCartMessageInfoFragmentDoc}
${ShippingCountdownInfoFragmentDoc}
${CartPageCartPagePriceInfoFragmentDoc}
${CartPageCartItemInfoFragmentDoc}
${CartPageCartPageShippingEstimateInfoFragmentDoc}`;
export const CartPageCartPageScheduledOrderInfoFragmentDoc = gql`
    fragment CartPageCartPageScheduledOrderInfo on ScheduledOrder {
  id
  shipCompleteMethod
  timeZone {
    cutoff
  }
  address {
    addressLines
    city
    state
    province
    zip
    country
  }
  paymentMethod {
    ... on ScheduledOrderCreditCard {
      id
      lastFourDigits
      type
    }
    ... on ScheduledOrderNormalTerms {
      id
    }
    ... on ScheduledOrderCOD {
      id
    }
  }
  shipToAccount {
    id
  }
}
    `;
export const CartPageCartSearchPageMessageInfoFragmentDoc = gql`
    fragment CartPageCartSearchPageMessageInfo on CartMessage {
  code
  message
}
    `;
export const CartPageJewelerShowcaseCartsPageCallbackRequestInfoFragmentDoc = gql`
    fragment CartPageJewelerShowcaseCartsPageCallbackRequestInfo on JewelerShowcaseCallbackRequest {
  id
  emailAddress
  creationDate
  firstName
  lastName
  phoneNumber
  messageToJeweler
  cartHeader {
    ...CartPageCartListHeaderInfo
    user {
      showcaseSettings {
        id
        jewelerShowcaseSubdomain
      }
    }
  }
}
    ${CartPageCartListHeaderInfoFragmentDoc}`;
export const CmsContentContentInfoFragmentDoc = gql`
    fragment CmsContentContentInfo on CmsContent {
  content
  splitTestVersionsKey
}
    `;
export const CurrencyCultureExchangeRateInfoFragmentDoc = gql`
    fragment CurrencyCultureExchangeRateInfo on ExchangeRate {
  code
  culture
  name
  exchangeRateToUsd
}
    `;
export const HeaderUtilityNavMenuCartPriceInfoFragmentDoc = gql`
    fragment HeaderUtilityNavMenuCartPriceInfo on CurrencyValue {
  value
  valueInUsd
  exchangeRate {
    code
    culture
  }
}
    `;
export const HeaderUtilityNavMenuCartMessageInfoFragmentDoc = gql`
    fragment HeaderUtilityNavMenuCartMessageInfo on CartMessage {
  code
  message
}
    `;
export const HeaderUtilityNavMenuCartInfoFragmentDoc = gql`
    fragment HeaderUtilityNavMenuCartInfo on Cart {
  ...GoogleTagManagerCartInfo
  id
  itemCount
  price {
    subtotal {
      ...HeaderUtilityNavMenuCartPriceInfo
    }
  }
  errors {
    ...HeaderUtilityNavMenuCartMessageInfo
  }
  shippingCountdown {
    ...ShippingCountdownInfo
  }
  items {
    id
    item {
      id
      title
      itemNumber
      image
      minimumQuantity
      maximumQuantity
      ... on Configuration {
        configurationProduct: product {
          id
        }
      }
    }
    notes {
      ...HeaderUtilityNavMenuCartMessageInfo
    }
    errors {
      ...HeaderUtilityNavMenuCartMessageInfo
    }
    options {
      quantity
      isForConsignment
    }
    productGroup {
      id
    }
    price {
      total {
        ...HeaderUtilityNavMenuCartPriceInfo
      }
    }
  }
}
    ${GoogleTagManagerCartInfoFragmentDoc}
${HeaderUtilityNavMenuCartPriceInfoFragmentDoc}
${HeaderUtilityNavMenuCartMessageInfoFragmentDoc}
${ShippingCountdownInfoFragmentDoc}`;
export const HoldShipmentsShipToAccountInfoFragmentDoc = gql`
    fragment HoldShipmentsShipToAccountInfo on ShipToAccount {
  id
  accountNumber
  holdShipmentsDate
  address {
    addressLines
    city
    state
    zip
    country
    type
    province
    isInternational
  }
}
    `;
export const LocateAJewelerListingsListingInfoFragmentDoc = gql`
    fragment LocateAJewelerListingsListingInfo on LocateAJewelerListing {
  id
  owner {
    salutation
    firstName
    lastName
    suffix
  }
  shipToAccount {
    accountNumber
  }
  doingBusinessAs
  locationDescription
  address {
    addressLine1
    addressLine2
    city
    stateOrProvince
    zip
    country
  }
  phoneNumber
  email
  website
  jewelerShowcase
  socials {
    facebook
    twitter
    instagram
    pinterest
    youtube
  }
  hours {
    monday {
      type
      openTime
      closeTime
    }
    tuesday {
      type
      openTime
      closeTime
    }
    wednesday {
      type
      openTime
      closeTime
    }
    thursday {
      type
      openTime
      closeTime
    }
    friday {
      type
      openTime
      closeTime
    }
    saturday {
      type
      openTime
      closeTime
    }
    sunday {
      type
      openTime
      closeTime
    }
  }
  products
  services
  salesFeatures
  shopFeatures
}
    `;
export const LocateAJewelerListingsCustomerStoreInfoFragmentDoc = gql`
    fragment LocateAJewelerListingsCustomerStoreInfo on CustomerStoreInformation {
  id
  shipToAccount {
    id
    accountNumber
  }
  user {
    id
  }
  creationDate
  modificationDate
  businessEstablishedYear
  siteHasShoppingCart
  businessLocationCommunity
  locationOfSales
  primaryLocationDescription
  numberOfEmployees
  agta
  ags
  mjsa
  ja
  jvc
  jic
  otherOrganizations
  retailJewelersOrganization
  gemaltaCooperative
  canadianBuyingGroup
  independentJewelersOrganization
  diGem
  leadingJewelers
  continentalBuyingGroup
  buyersInternationalGroup
  employeeCount
  nationalPawnbrokersAssociation
}
    `;
export const LocateAJewelerListingsShipToAccountInfoFragmentDoc = gql`
    fragment LocateAJewelerListingsShipToAccountInfo on ShipToAccount {
  id
  accountNumber
  phoneNumber
  address {
    addressLines
    city
    state
    zip
    country
  }
}
    `;
export const LocateAJewelerSearchPageHoursSettingsInfoFragmentDoc = gql`
    fragment LocateAJewelerSearchPageHoursSettingsInfo on LocateAJewelerHoursSettings {
  closeTime
  openTime
  type
}
    `;
export const LocationSelectorShipToAccountInfoFragmentDoc = gql`
    fragment LocationSelectorShipToAccountInfo on ShipToAccount {
  id
  accountNumber
  address {
    addressLines
    city
    state
    zip
    country
    type
    province
    isInternational
  }
}
    `;
export const PaymentMethodsLoyaltyProgramAutorenewalInfoFragmentDoc = gql`
    fragment PaymentMethodsLoyaltyProgramAutorenewalInfo on LoyaltyProgramAutorenewal {
  id
  autorenewalDate
  shipToAccount {
    id
  }
  loyaltyProgram {
    id
    displayName
    isStullerFirst
  }
}
    `;
export const PaymentMethodsCreditCardInfoFragmentDoc = gql`
    fragment PaymentMethodsCreditCardInfo on CreditCard {
  id
  type
  cardholderName
  isDebitCard
  zip
  expirationMonth
  expirationYear
  isExpired
  tokenizedCardNumber
  lastFourDigits
  activeAutorenewals {
    ...PaymentMethodsLoyaltyProgramAutorenewalInfo
  }
}
    ${PaymentMethodsLoyaltyProgramAutorenewalInfoFragmentDoc}`;
export const PdpImageCarouselVideo360InfoFragmentDoc = gql`
    fragment PdpImageCarouselVideo360Info on Video360 {
  id
  sources {
    height
    width
    type
    url
  }
}
    `;
export const PdpImageCarouselMediaInfoFragmentDoc = gql`
    fragment PdpImageCarouselMediaInfo on Media {
  id
  ... on Video360 {
    ...PdpImageCarouselVideo360Info
  }
}
    ${PdpImageCarouselVideo360InfoFragmentDoc}`;
export const PdpImageCarouselInfoFragmentDoc = gql`
    fragment PdpImageCarouselInfo on Item {
  id
  ... on SerializedProduct {
    isLabGrown
    isGemstone
    media {
      ...PdpImageCarouselMediaInfo
    }
  }
}
    ${PdpImageCarouselMediaInfoFragmentDoc}`;
export const PreferenceContactInfoFragmentDoc = gql`
    fragment PreferenceContactInfo on Contact {
  id
  firstName
  lastName
  suffix
  jobTitle
  emailAddress
  mobilePhoneNumber {
    phoneNumber
    sanitizedPhoneNumber
    extension
  }
  directPhoneNumber {
    phoneNumber
    sanitizedPhoneNumber
    extension
  }
}
    `;
export const PreferenceCenterPageCommunicationPreferenceInfoFragmentDoc = gql`
    fragment PreferenceCenterPageCommunicationPreferenceInfo on CommunicationPreference {
  id
  preferenceCreationToken
  channel
  groupName
  name
  description
  isSubscribed
  optInRequired
}
    `;
export const UiProductCardPriceInfoFragmentDoc = gql`
    fragment UiProductCardPriceInfo on CurrencyValue {
  value
  exchangeRate {
    code
    culture
  }
}
    `;
export const UiProductCardDiscountPriceInfoFragmentDoc = gql`
    fragment UiProductCardDiscountPriceInfo on PriceDiscount {
  originalPrice {
    ...UiProductCardPriceInfo
  }
  percent
}
    ${UiProductCardPriceInfoFragmentDoc}`;
export const UiProductCardItemInfoFragmentDoc = gql`
    fragment UiProductCardItemInfo on Item {
  id
  title
  image
  isInStock
  price {
    roundedPerUnit {
      total {
        ...UiProductCardPriceInfo
      }
      discount {
        ...UiProductCardDiscountPriceInfo
      }
    }
  }
}
    ${UiProductCardPriceInfoFragmentDoc}
${UiProductCardDiscountPriceInfoFragmentDoc}`;
export const UiProductCardGroupInfoFragmentDoc = gql`
    fragment UiProductCardGroupInfo on ProductGroup {
  id
  title
  image
  minPriceProduct {
    id
    price {
      roundedPerUnit {
        total {
          ...UiProductCardPriceInfo
        }
      }
    }
  }
  maxPriceProduct {
    id
    price {
      roundedPerUnit {
        total {
          ...UiProductCardPriceInfo
        }
      }
    }
  }
  maxDiscountProduct {
    id
    price {
      roundedPerUnit {
        discount {
          ...UiProductCardDiscountPriceInfo
        }
      }
    }
  }
}
    ${UiProductCardPriceInfoFragmentDoc}
${UiProductCardDiscountPriceInfoFragmentDoc}`;
export const GetAccountSettingsLayoutContactInfoDocument = gql`
    query GetAccountSettingsLayoutContactInfo {
  viewer {
    id
    fullName
    contactMode
    defaultActiveShipToAccount {
      id
      billToAccount {
        id
        accountNumber
        accountType
        companyName
      }
    }
  }
}
    `;

/**
 * __useGetAccountSettingsLayoutContactInfoQuery__
 *
 * To run a query within a React component, call `useGetAccountSettingsLayoutContactInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSettingsLayoutContactInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSettingsLayoutContactInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountSettingsLayoutContactInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>(GetAccountSettingsLayoutContactInfoDocument, options);
      }
export function useGetAccountSettingsLayoutContactInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>(GetAccountSettingsLayoutContactInfoDocument, options);
        }
export function useGetAccountSettingsLayoutContactInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>(GetAccountSettingsLayoutContactInfoDocument, options);
        }
export type GetAccountSettingsLayoutContactInfoQueryHookResult = ReturnType<typeof useGetAccountSettingsLayoutContactInfoQuery>;
export type GetAccountSettingsLayoutContactInfoLazyQueryHookResult = ReturnType<typeof useGetAccountSettingsLayoutContactInfoLazyQuery>;
export type GetAccountSettingsLayoutContactInfoSuspenseQueryHookResult = ReturnType<typeof useGetAccountSettingsLayoutContactInfoSuspenseQuery>;
export type GetAccountSettingsLayoutContactInfoQueryResult = Apollo.QueryResult<GetAccountSettingsLayoutContactInfoQuery, GetAccountSettingsLayoutContactInfoQueryVariables>;
export const GetAccountSettingsLayoutPermissionsDocument = gql`
    query GetAccountSettingsLayoutPermissions {
  viewerPermissions {
    id
    canApproveOrders
    canAutoReorder
    canCreateLocateAJewelerListings
    canCreateUsers
    canManageLogos
    canManageMarketplaceSolutions
    canManagePaymentMethods
    canManagePreferences
    canManageProductDataFeeds
    canManageStullerFirstEnrollments
    canPayBill
    canSetup302Showcase
    canSetupEverAndEverShowcase
    canSetupShowcase
    canSignupForProductDataFeeds
    canUpdateHoldShipments
    canUpgradeAccount
    canUseCreditCards
    canViewInvoices
    canViewJewelerShowcaseRequests
    canViewMarketingAssets
    canViewOrders
    canViewStatements
  }
}
    `;

/**
 * __useGetAccountSettingsLayoutPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAccountSettingsLayoutPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSettingsLayoutPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSettingsLayoutPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountSettingsLayoutPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>(GetAccountSettingsLayoutPermissionsDocument, options);
      }
export function useGetAccountSettingsLayoutPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>(GetAccountSettingsLayoutPermissionsDocument, options);
        }
export function useGetAccountSettingsLayoutPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>(GetAccountSettingsLayoutPermissionsDocument, options);
        }
export type GetAccountSettingsLayoutPermissionsQueryHookResult = ReturnType<typeof useGetAccountSettingsLayoutPermissionsQuery>;
export type GetAccountSettingsLayoutPermissionsLazyQueryHookResult = ReturnType<typeof useGetAccountSettingsLayoutPermissionsLazyQuery>;
export type GetAccountSettingsLayoutPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAccountSettingsLayoutPermissionsSuspenseQuery>;
export type GetAccountSettingsLayoutPermissionsQueryResult = Apollo.QueryResult<GetAccountSettingsLayoutPermissionsQuery, GetAccountSettingsLayoutPermissionsQueryVariables>;
export const GetAddToCartProductDetailsDocument = gql`
    query GetAddToCartProductDetails($id: ID!, $options: ItemLineOptionsInput, $nonConsignmentOptions: ItemLineOptionsInput = {isForConsignment: false}) {
  productById(id: $id, options: $options) {
    ...AddToCartSectionInfo
    id
    product {
      itemNumber
    }
  }
}
    ${AddToCartSectionInfoFragmentDoc}`;

/**
 * __useGetAddToCartProductDetailsQuery__
 *
 * To run a query within a React component, call `useGetAddToCartProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *      nonConsignmentOptions: // value for 'nonConsignmentOptions'
 *   },
 * });
 */
export function useGetAddToCartProductDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables> & ({ variables: GetAddToCartProductDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables>(GetAddToCartProductDetailsDocument, options);
      }
export function useGetAddToCartProductDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables>(GetAddToCartProductDetailsDocument, options);
        }
export function useGetAddToCartProductDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables>(GetAddToCartProductDetailsDocument, options);
        }
export type GetAddToCartProductDetailsQueryHookResult = ReturnType<typeof useGetAddToCartProductDetailsQuery>;
export type GetAddToCartProductDetailsLazyQueryHookResult = ReturnType<typeof useGetAddToCartProductDetailsLazyQuery>;
export type GetAddToCartProductDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartProductDetailsSuspenseQuery>;
export type GetAddToCartProductDetailsQueryResult = Apollo.QueryResult<GetAddToCartProductDetailsQuery, GetAddToCartProductDetailsQueryVariables>;
export const GetAddToCartSerializedDetailsDocument = gql`
    query GetAddToCartSerializedDetails($serialNumber: ID!, $options: ItemLineOptionsInput, $nonConsignmentOptions: ItemLineOptionsInput = {isForConsignment: false}) {
  serializedProductBySerialNumber(serialNumber: $serialNumber, options: $options) {
    ...AddToCartSectionInfo
    id
    serialNumber
    product {
      itemNumber
    }
  }
}
    ${AddToCartSectionInfoFragmentDoc}`;

/**
 * __useGetAddToCartSerializedDetailsQuery__
 *
 * To run a query within a React component, call `useGetAddToCartSerializedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartSerializedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartSerializedDetailsQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *      options: // value for 'options'
 *      nonConsignmentOptions: // value for 'nonConsignmentOptions'
 *   },
 * });
 */
export function useGetAddToCartSerializedDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables> & ({ variables: GetAddToCartSerializedDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables>(GetAddToCartSerializedDetailsDocument, options);
      }
export function useGetAddToCartSerializedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables>(GetAddToCartSerializedDetailsDocument, options);
        }
export function useGetAddToCartSerializedDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables>(GetAddToCartSerializedDetailsDocument, options);
        }
export type GetAddToCartSerializedDetailsQueryHookResult = ReturnType<typeof useGetAddToCartSerializedDetailsQuery>;
export type GetAddToCartSerializedDetailsLazyQueryHookResult = ReturnType<typeof useGetAddToCartSerializedDetailsLazyQuery>;
export type GetAddToCartSerializedDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartSerializedDetailsSuspenseQuery>;
export type GetAddToCartSerializedDetailsQueryResult = Apollo.QueryResult<GetAddToCartSerializedDetailsQuery, GetAddToCartSerializedDetailsQueryVariables>;
export const GetAddToCartConfigurationDetailsDocument = gql`
    query GetAddToCartConfigurationDetails($configId: ID!, $options: ItemLineOptionsInput, $nonConsignmentOptions: ItemLineOptionsInput = {isForConsignment: false}) {
  configurationById(id: $configId, options: $options) {
    ...AddToCartSectionInfo
    id
    product {
      itemNumber
    }
  }
}
    ${AddToCartSectionInfoFragmentDoc}`;

/**
 * __useGetAddToCartConfigurationDetailsQuery__
 *
 * To run a query within a React component, call `useGetAddToCartConfigurationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartConfigurationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartConfigurationDetailsQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      options: // value for 'options'
 *      nonConsignmentOptions: // value for 'nonConsignmentOptions'
 *   },
 * });
 */
export function useGetAddToCartConfigurationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables> & ({ variables: GetAddToCartConfigurationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables>(GetAddToCartConfigurationDetailsDocument, options);
      }
export function useGetAddToCartConfigurationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables>(GetAddToCartConfigurationDetailsDocument, options);
        }
export function useGetAddToCartConfigurationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables>(GetAddToCartConfigurationDetailsDocument, options);
        }
export type GetAddToCartConfigurationDetailsQueryHookResult = ReturnType<typeof useGetAddToCartConfigurationDetailsQuery>;
export type GetAddToCartConfigurationDetailsLazyQueryHookResult = ReturnType<typeof useGetAddToCartConfigurationDetailsLazyQuery>;
export type GetAddToCartConfigurationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartConfigurationDetailsSuspenseQuery>;
export type GetAddToCartConfigurationDetailsQueryResult = Apollo.QueryResult<GetAddToCartConfigurationDetailsQuery, GetAddToCartConfigurationDetailsQueryVariables>;
export const GetAddToCartShowcasePriceSummaryDocument = gql`
    query GetAddToCartShowcasePriceSummary($input: ItemsInput!) {
  items(input: $input) {
    title
    image
    showcasePriceSummary {
      baseTotal {
        ...AddToCartPriceValuesWithCurrencyInfo
      }
      markedUpTotal {
        ...AddToCartPriceValuesWithCurrencyInfo
      }
      sections {
        title
        item {
          image
          itemId {
            id
            type
          }
        }
        baseTotal {
          ...AddToCartPriceValuesWithCurrencyInfo
        }
        markedUpTotal {
          ...AddToCartPriceValuesWithCurrencyInfo
        }
        additionalCharge {
          ...AddToCartPriceValuesWithCurrencyInfo
        }
        centsOverride {
          ...AddToCartPriceValuesWithCurrencyInfo
        }
        components {
          title
          item {
            itemId {
              type
              id
            }
          }
          markupDescription
          markupMultiplier
          quantity
          basePrice {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          baseStoneSettingCharge {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          baseTotal {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          markupPrice {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          minimumPrice {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          flatPrice {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          markedUpTotal {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
          markedUpStoneSettingCharge {
            ...AddToCartPriceValuesWithCurrencyInfo
          }
        }
      }
    }
  }
}
    ${AddToCartPriceValuesWithCurrencyInfoFragmentDoc}`;

/**
 * __useGetAddToCartShowcasePriceSummaryQuery__
 *
 * To run a query within a React component, call `useGetAddToCartShowcasePriceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartShowcasePriceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartShowcasePriceSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAddToCartShowcasePriceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables> & ({ variables: GetAddToCartShowcasePriceSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables>(GetAddToCartShowcasePriceSummaryDocument, options);
      }
export function useGetAddToCartShowcasePriceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables>(GetAddToCartShowcasePriceSummaryDocument, options);
        }
export function useGetAddToCartShowcasePriceSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables>(GetAddToCartShowcasePriceSummaryDocument, options);
        }
export type GetAddToCartShowcasePriceSummaryQueryHookResult = ReturnType<typeof useGetAddToCartShowcasePriceSummaryQuery>;
export type GetAddToCartShowcasePriceSummaryLazyQueryHookResult = ReturnType<typeof useGetAddToCartShowcasePriceSummaryLazyQuery>;
export type GetAddToCartShowcasePriceSummarySuspenseQueryHookResult = ReturnType<typeof useGetAddToCartShowcasePriceSummarySuspenseQuery>;
export type GetAddToCartShowcasePriceSummaryQueryResult = Apollo.QueryResult<GetAddToCartShowcasePriceSummaryQuery, GetAddToCartShowcasePriceSummaryQueryVariables>;
export const GetAddToCartTypeDocument = gql`
    query GetAddToCartType {
  viewerPermissions {
    id
    addToCartType
  }
}
    `;

/**
 * __useGetAddToCartTypeQuery__
 *
 * To run a query within a React component, call `useGetAddToCartTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>(GetAddToCartTypeDocument, options);
      }
export function useGetAddToCartTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>(GetAddToCartTypeDocument, options);
        }
export function useGetAddToCartTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>(GetAddToCartTypeDocument, options);
        }
export type GetAddToCartTypeQueryHookResult = ReturnType<typeof useGetAddToCartTypeQuery>;
export type GetAddToCartTypeLazyQueryHookResult = ReturnType<typeof useGetAddToCartTypeLazyQuery>;
export type GetAddToCartTypeSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartTypeSuspenseQuery>;
export type GetAddToCartTypeQueryResult = Apollo.QueryResult<GetAddToCartTypeQuery, GetAddToCartTypeQueryVariables>;
export const GetAddToCartUserShowcaseSettingsDocument = gql`
    query GetAddToCartUserShowcaseSettings {
  viewer {
    id
    showcaseSettings {
      setup {
        displayComplete
        markupsComplete
      }
    }
  }
}
    `;

/**
 * __useGetAddToCartUserShowcaseSettingsQuery__
 *
 * To run a query within a React component, call `useGetAddToCartUserShowcaseSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartUserShowcaseSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartUserShowcaseSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartUserShowcaseSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>(GetAddToCartUserShowcaseSettingsDocument, options);
      }
export function useGetAddToCartUserShowcaseSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>(GetAddToCartUserShowcaseSettingsDocument, options);
        }
export function useGetAddToCartUserShowcaseSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>(GetAddToCartUserShowcaseSettingsDocument, options);
        }
export type GetAddToCartUserShowcaseSettingsQueryHookResult = ReturnType<typeof useGetAddToCartUserShowcaseSettingsQuery>;
export type GetAddToCartUserShowcaseSettingsLazyQueryHookResult = ReturnType<typeof useGetAddToCartUserShowcaseSettingsLazyQuery>;
export type GetAddToCartUserShowcaseSettingsSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartUserShowcaseSettingsSuspenseQuery>;
export type GetAddToCartUserShowcaseSettingsQueryResult = Apollo.QueryResult<GetAddToCartUserShowcaseSettingsQuery, GetAddToCartUserShowcaseSettingsQueryVariables>;
export const GetQuoteDetailsDocument = gql`
    query GetQuoteDetails($id: ID!) {
  publicQuoteLineById(quoteLineId: $id) {
    date
    quote {
      ...AddToCartPriceValuesWithCurrencyInfo
    }
  }
}
    ${AddToCartPriceValuesWithCurrencyInfoFragmentDoc}`;

/**
 * __useGetQuoteDetailsQuery__
 *
 * To run a query within a React component, call `useGetQuoteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables> & ({ variables: GetQuoteDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables>(GetQuoteDetailsDocument, options);
      }
export function useGetQuoteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables>(GetQuoteDetailsDocument, options);
        }
export function useGetQuoteDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables>(GetQuoteDetailsDocument, options);
        }
export type GetQuoteDetailsQueryHookResult = ReturnType<typeof useGetQuoteDetailsQuery>;
export type GetQuoteDetailsLazyQueryHookResult = ReturnType<typeof useGetQuoteDetailsLazyQuery>;
export type GetQuoteDetailsSuspenseQueryHookResult = ReturnType<typeof useGetQuoteDetailsSuspenseQuery>;
export type GetQuoteDetailsQueryResult = Apollo.QueryResult<GetQuoteDetailsQuery, GetQuoteDetailsQueryVariables>;
export const GetAddToCartNeedsToAgreeToConsignmentTermsDocument = gql`
    query GetAddToCartNeedsToAgreeToConsignmentTerms {
  viewer {
    id
    needsToAgreeToConsignmentTerms
  }
}
    `;

/**
 * __useGetAddToCartNeedsToAgreeToConsignmentTermsQuery__
 *
 * To run a query within a React component, call `useGetAddToCartNeedsToAgreeToConsignmentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartNeedsToAgreeToConsignmentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartNeedsToAgreeToConsignmentTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartNeedsToAgreeToConsignmentTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>(GetAddToCartNeedsToAgreeToConsignmentTermsDocument, options);
      }
export function useGetAddToCartNeedsToAgreeToConsignmentTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>(GetAddToCartNeedsToAgreeToConsignmentTermsDocument, options);
        }
export function useGetAddToCartNeedsToAgreeToConsignmentTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>(GetAddToCartNeedsToAgreeToConsignmentTermsDocument, options);
        }
export type GetAddToCartNeedsToAgreeToConsignmentTermsQueryHookResult = ReturnType<typeof useGetAddToCartNeedsToAgreeToConsignmentTermsQuery>;
export type GetAddToCartNeedsToAgreeToConsignmentTermsLazyQueryHookResult = ReturnType<typeof useGetAddToCartNeedsToAgreeToConsignmentTermsLazyQuery>;
export type GetAddToCartNeedsToAgreeToConsignmentTermsSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartNeedsToAgreeToConsignmentTermsSuspenseQuery>;
export type GetAddToCartNeedsToAgreeToConsignmentTermsQueryResult = Apollo.QueryResult<GetAddToCartNeedsToAgreeToConsignmentTermsQuery, GetAddToCartNeedsToAgreeToConsignmentTermsQueryVariables>;
export const GetAddToCartItemsQuantityDocument = gql`
    query GetAddToCartItemsQuantity {
  cart {
    id
    items {
      id
      item {
        id
        itemId {
          type
        }
      }
      options {
        quantity
      }
    }
  }
}
    `;

/**
 * __useGetAddToCartItemsQuantityQuery__
 *
 * To run a query within a React component, call `useGetAddToCartItemsQuantityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartItemsQuantityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartItemsQuantityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartItemsQuantityQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>(GetAddToCartItemsQuantityDocument, options);
      }
export function useGetAddToCartItemsQuantityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>(GetAddToCartItemsQuantityDocument, options);
        }
export function useGetAddToCartItemsQuantitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>(GetAddToCartItemsQuantityDocument, options);
        }
export type GetAddToCartItemsQuantityQueryHookResult = ReturnType<typeof useGetAddToCartItemsQuantityQuery>;
export type GetAddToCartItemsQuantityLazyQueryHookResult = ReturnType<typeof useGetAddToCartItemsQuantityLazyQuery>;
export type GetAddToCartItemsQuantitySuspenseQueryHookResult = ReturnType<typeof useGetAddToCartItemsQuantitySuspenseQuery>;
export type GetAddToCartItemsQuantityQueryResult = Apollo.QueryResult<GetAddToCartItemsQuantityQuery, GetAddToCartItemsQuantityQueryVariables>;
export const GetAddToCartDotOptionsPermissionsDocument = gql`
    query GetAddToCartDotOptionsPermissions {
  viewerPermissions {
    id
    canSetOrderLineSalesType
  }
}
    `;

/**
 * __useGetAddToCartDotOptionsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAddToCartDotOptionsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartDotOptionsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartDotOptionsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartDotOptionsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>(GetAddToCartDotOptionsPermissionsDocument, options);
      }
export function useGetAddToCartDotOptionsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>(GetAddToCartDotOptionsPermissionsDocument, options);
        }
export function useGetAddToCartDotOptionsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>(GetAddToCartDotOptionsPermissionsDocument, options);
        }
export type GetAddToCartDotOptionsPermissionsQueryHookResult = ReturnType<typeof useGetAddToCartDotOptionsPermissionsQuery>;
export type GetAddToCartDotOptionsPermissionsLazyQueryHookResult = ReturnType<typeof useGetAddToCartDotOptionsPermissionsLazyQuery>;
export type GetAddToCartDotOptionsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartDotOptionsPermissionsSuspenseQuery>;
export type GetAddToCartDotOptionsPermissionsQueryResult = Apollo.QueryResult<GetAddToCartDotOptionsPermissionsQuery, GetAddToCartDotOptionsPermissionsQueryVariables>;
export const GetAddToCartCanAddToFavoritesDocument = gql`
    query GetAddToCartCanAddToFavorites {
  viewerPermissions {
    id
    canAddToFavorites
  }
}
    `;

/**
 * __useGetAddToCartCanAddToFavoritesQuery__
 *
 * To run a query within a React component, call `useGetAddToCartCanAddToFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartCanAddToFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartCanAddToFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartCanAddToFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>(GetAddToCartCanAddToFavoritesDocument, options);
      }
export function useGetAddToCartCanAddToFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>(GetAddToCartCanAddToFavoritesDocument, options);
        }
export function useGetAddToCartCanAddToFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>(GetAddToCartCanAddToFavoritesDocument, options);
        }
export type GetAddToCartCanAddToFavoritesQueryHookResult = ReturnType<typeof useGetAddToCartCanAddToFavoritesQuery>;
export type GetAddToCartCanAddToFavoritesLazyQueryHookResult = ReturnType<typeof useGetAddToCartCanAddToFavoritesLazyQuery>;
export type GetAddToCartCanAddToFavoritesSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartCanAddToFavoritesSuspenseQuery>;
export type GetAddToCartCanAddToFavoritesQueryResult = Apollo.QueryResult<GetAddToCartCanAddToFavoritesQuery, GetAddToCartCanAddToFavoritesQueryVariables>;
export const GetAddToCartCanViewQuantityOnHandDocument = gql`
    query GetAddToCartCanViewQuantityOnHand {
  viewerPermissions {
    id
    canViewQuantityOnHand
  }
}
    `;

/**
 * __useGetAddToCartCanViewQuantityOnHandQuery__
 *
 * To run a query within a React component, call `useGetAddToCartCanViewQuantityOnHandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddToCartCanViewQuantityOnHandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddToCartCanViewQuantityOnHandQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddToCartCanViewQuantityOnHandQuery(baseOptions?: Apollo.QueryHookOptions<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>(GetAddToCartCanViewQuantityOnHandDocument, options);
      }
export function useGetAddToCartCanViewQuantityOnHandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>(GetAddToCartCanViewQuantityOnHandDocument, options);
        }
export function useGetAddToCartCanViewQuantityOnHandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>(GetAddToCartCanViewQuantityOnHandDocument, options);
        }
export type GetAddToCartCanViewQuantityOnHandQueryHookResult = ReturnType<typeof useGetAddToCartCanViewQuantityOnHandQuery>;
export type GetAddToCartCanViewQuantityOnHandLazyQueryHookResult = ReturnType<typeof useGetAddToCartCanViewQuantityOnHandLazyQuery>;
export type GetAddToCartCanViewQuantityOnHandSuspenseQueryHookResult = ReturnType<typeof useGetAddToCartCanViewQuantityOnHandSuspenseQuery>;
export type GetAddToCartCanViewQuantityOnHandQueryResult = Apollo.QueryResult<GetAddToCartCanViewQuantityOnHandQuery, GetAddToCartCanViewQuantityOnHandQueryVariables>;
export const AddToCartDocument = gql`
    mutation AddToCart($inputs: [AddToCartInput!]!) {
  addToCart(inputs: $inputs) {
    cart {
      ...HeaderUtilityNavMenuCartInfo
    }
    addedCartLineIds
  }
}
    ${HeaderUtilityNavMenuCartInfoFragmentDoc}`;
export type AddToCartMutationFn = Apollo.MutationFunction<AddToCartMutation, AddToCartMutationVariables>;

/**
 * __useAddToCartMutation__
 *
 * To run a mutation, you first call `useAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToCartMutation, { data, loading, error }] = useAddToCartMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAddToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddToCartMutation, AddToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToCartMutation, AddToCartMutationVariables>(AddToCartDocument, options);
      }
export type AddToCartMutationHookResult = ReturnType<typeof useAddToCartMutation>;
export type AddToCartMutationResult = Apollo.MutationResult<AddToCartMutation>;
export type AddToCartMutationOptions = Apollo.BaseMutationOptions<AddToCartMutation, AddToCartMutationVariables>;
export const AddToCartCreateQuoteDocument = gql`
    mutation AddToCartCreateQuote($callbackRequest: JewelerShowcaseCallbackRequestInput, $addToCarts: [AddToCartInput!]) {
  createQuote(callbackRequest: $callbackRequest, addToCarts: $addToCarts) {
    publicQuoteLines {
      id
    }
    cart {
      ...GoogleTagManagerCartInfo
      errors {
        ...AddToCartMessageInfo
      }
    }
    request {
      emailAddress
    }
  }
}
    ${GoogleTagManagerCartInfoFragmentDoc}
${AddToCartMessageInfoFragmentDoc}`;
export type AddToCartCreateQuoteMutationFn = Apollo.MutationFunction<AddToCartCreateQuoteMutation, AddToCartCreateQuoteMutationVariables>;

/**
 * __useAddToCartCreateQuoteMutation__
 *
 * To run a mutation, you first call `useAddToCartCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToCartCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToCartCreateQuoteMutation, { data, loading, error }] = useAddToCartCreateQuoteMutation({
 *   variables: {
 *      callbackRequest: // value for 'callbackRequest'
 *      addToCarts: // value for 'addToCarts'
 *   },
 * });
 */
export function useAddToCartCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<AddToCartCreateQuoteMutation, AddToCartCreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToCartCreateQuoteMutation, AddToCartCreateQuoteMutationVariables>(AddToCartCreateQuoteDocument, options);
      }
export type AddToCartCreateQuoteMutationHookResult = ReturnType<typeof useAddToCartCreateQuoteMutation>;
export type AddToCartCreateQuoteMutationResult = Apollo.MutationResult<AddToCartCreateQuoteMutation>;
export type AddToCartCreateQuoteMutationOptions = Apollo.BaseMutationOptions<AddToCartCreateQuoteMutation, AddToCartCreateQuoteMutationVariables>;
export const GetAppAuthUserDocument = gql`
    query GetAppAuthUser {
  authUser {
    id
    username
    firstName
    lastName
    email
    roles
    impersonatedBy
    consultantLogin
    lastRefreshDate
    user {
      id
      username
      memberId
      firstName
      lastName
      fullName
      preferredShipToAccountId
      resetPassword
      isStullerFirstEnrolled
      isStullerFirstEligible
      is302Member
      hasGemvisionAccount
      isEverAndEverMember
      ecommerceMerchandisingMode
      currencyDisplay {
        culture
        code
      }
      scheduledOrder {
        id
      }
      defaultActiveShipToAccount {
        id
        customerSegment
        customerValueScore
        phoneNumber
        billToAccount {
          id
        }
        timeZone {
          id
        }
        priceList {
          id
          type
        }
        address {
          country
        }
      }
      contact {
        id
        firstName
        lastName
        salutation
        preferredName
        suffix
        active
        inactiveReason
        fullName
        displayName
      }
    }
  }
}
    `;

/**
 * __useGetAppAuthUserQuery__
 *
 * To run a query within a React component, call `useGetAppAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppAuthUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppAuthUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>(GetAppAuthUserDocument, options);
      }
export function useGetAppAuthUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>(GetAppAuthUserDocument, options);
        }
export function useGetAppAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>(GetAppAuthUserDocument, options);
        }
export type GetAppAuthUserQueryHookResult = ReturnType<typeof useGetAppAuthUserQuery>;
export type GetAppAuthUserLazyQueryHookResult = ReturnType<typeof useGetAppAuthUserLazyQuery>;
export type GetAppAuthUserSuspenseQueryHookResult = ReturnType<typeof useGetAppAuthUserSuspenseQuery>;
export type GetAppAuthUserQueryResult = Apollo.QueryResult<GetAppAuthUserQuery, GetAppAuthUserQueryVariables>;
export const GetAppShowcaseSettingsDocument = gql`
    query GetAppShowcaseSettings {
  showcaseSettings {
    id
    title
    logo
    phoneNumber
    jewelerShowcaseSubdomain
    showMetalMarkets
    requiresAuthentication
    iFrameShowNavigationBar
    aboutUs
    aboutUsIsChecked
    contactUs
    contactUsIsChecked
    backgroundColorClass
    backgroundPatternClass
    hideUSDPrices
    setup {
      markupsComplete
    }
    customShowcaseSettings {
      details(
        detailTypes: [AddToQuote, AllowIframeHostApi, ChangeColorOfStatusDisplayCustomOrder, DisableFavorites, HideAddToCart, HideContactLinksInHeader, HideNavBarForShowcase, HideSearchBar, ReplaceStatusDisplaimerOfNonReturnable, RedirectDiamondLandingPageToDiamondsWithGradingReportSearch, ShowCustomShipmentMessage, AllowIframeHostApi, AllowIframeHostApiDomainsCsvList]
      ) {
        id
        type
        values
      }
    }
  }
}
    `;

/**
 * __useGetAppShowcaseSettingsQuery__
 *
 * To run a query within a React component, call `useGetAppShowcaseSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppShowcaseSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppShowcaseSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppShowcaseSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>(GetAppShowcaseSettingsDocument, options);
      }
export function useGetAppShowcaseSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>(GetAppShowcaseSettingsDocument, options);
        }
export function useGetAppShowcaseSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>(GetAppShowcaseSettingsDocument, options);
        }
export type GetAppShowcaseSettingsQueryHookResult = ReturnType<typeof useGetAppShowcaseSettingsQuery>;
export type GetAppShowcaseSettingsLazyQueryHookResult = ReturnType<typeof useGetAppShowcaseSettingsLazyQuery>;
export type GetAppShowcaseSettingsSuspenseQueryHookResult = ReturnType<typeof useGetAppShowcaseSettingsSuspenseQuery>;
export type GetAppShowcaseSettingsQueryResult = Apollo.QueryResult<GetAppShowcaseSettingsQuery, GetAppShowcaseSettingsQueryVariables>;
export const GetAuthExpiredSignatureDocument = gql`
    query GetAuthExpiredSignature {
  authUser {
    id
    signature
  }
}
    `;

/**
 * __useGetAuthExpiredSignatureQuery__
 *
 * To run a query within a React component, call `useGetAuthExpiredSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthExpiredSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthExpiredSignatureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthExpiredSignatureQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>(GetAuthExpiredSignatureDocument, options);
      }
export function useGetAuthExpiredSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>(GetAuthExpiredSignatureDocument, options);
        }
export function useGetAuthExpiredSignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>(GetAuthExpiredSignatureDocument, options);
        }
export type GetAuthExpiredSignatureQueryHookResult = ReturnType<typeof useGetAuthExpiredSignatureQuery>;
export type GetAuthExpiredSignatureLazyQueryHookResult = ReturnType<typeof useGetAuthExpiredSignatureLazyQuery>;
export type GetAuthExpiredSignatureSuspenseQueryHookResult = ReturnType<typeof useGetAuthExpiredSignatureSuspenseQuery>;
export type GetAuthExpiredSignatureQueryResult = Apollo.QueryResult<GetAuthExpiredSignatureQuery, GetAuthExpiredSignatureQueryVariables>;
export const GetCadCamPageProjectsPermissionsDocument = gql`
    query GetCadCamPageProjectsPermissions {
  viewerPermissions {
    id
    canViewCadCamRequests
  }
}
    `;

/**
 * __useGetCadCamPageProjectsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCadCamPageProjectsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCadCamPageProjectsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCadCamPageProjectsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCadCamPageProjectsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>(GetCadCamPageProjectsPermissionsDocument, options);
      }
export function useGetCadCamPageProjectsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>(GetCadCamPageProjectsPermissionsDocument, options);
        }
export function useGetCadCamPageProjectsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>(GetCadCamPageProjectsPermissionsDocument, options);
        }
export type GetCadCamPageProjectsPermissionsQueryHookResult = ReturnType<typeof useGetCadCamPageProjectsPermissionsQuery>;
export type GetCadCamPageProjectsPermissionsLazyQueryHookResult = ReturnType<typeof useGetCadCamPageProjectsPermissionsLazyQuery>;
export type GetCadCamPageProjectsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCadCamPageProjectsPermissionsSuspenseQuery>;
export type GetCadCamPageProjectsPermissionsQueryResult = Apollo.QueryResult<GetCadCamPageProjectsPermissionsQuery, GetCadCamPageProjectsPermissionsQueryVariables>;
export const GetCadCamPageRequestsSearchByDateRangeDocument = gql`
    query GetCadCamPageRequestsSearchByDateRange($startDate: Date!, $endDate: Date!, $onlyActionRequired: Boolean, $onlyReorderable: Boolean, $onlyCheckedOutByViewer: Boolean, $shipToAccountNumber: ID, $paging: PagingInput!) {
  cadCamRequestSearchByDateRange(
    startDate: $startDate
    endDate: $endDate
    onlyActionRequired: $onlyActionRequired
    onlyReorderable: $onlyReorderable
    onlyCheckedOutByViewer: $onlyCheckedOutByViewer
    shipToAccountNumber: $shipToAccountNumber
  ) {
    count
    results(paging: $paging) {
      ...CadCamPageProjectManagerRequestRowInfo
    }
  }
}
    ${CadCamPageProjectManagerRequestRowInfoFragmentDoc}`;

/**
 * __useGetCadCamPageRequestsSearchByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetCadCamPageRequestsSearchByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCadCamPageRequestsSearchByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCadCamPageRequestsSearchByDateRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      onlyActionRequired: // value for 'onlyActionRequired'
 *      onlyReorderable: // value for 'onlyReorderable'
 *      onlyCheckedOutByViewer: // value for 'onlyCheckedOutByViewer'
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCadCamPageRequestsSearchByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables> & ({ variables: GetCadCamPageRequestsSearchByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables>(GetCadCamPageRequestsSearchByDateRangeDocument, options);
      }
export function useGetCadCamPageRequestsSearchByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables>(GetCadCamPageRequestsSearchByDateRangeDocument, options);
        }
export function useGetCadCamPageRequestsSearchByDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables>(GetCadCamPageRequestsSearchByDateRangeDocument, options);
        }
export type GetCadCamPageRequestsSearchByDateRangeQueryHookResult = ReturnType<typeof useGetCadCamPageRequestsSearchByDateRangeQuery>;
export type GetCadCamPageRequestsSearchByDateRangeLazyQueryHookResult = ReturnType<typeof useGetCadCamPageRequestsSearchByDateRangeLazyQuery>;
export type GetCadCamPageRequestsSearchByDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetCadCamPageRequestsSearchByDateRangeSuspenseQuery>;
export type GetCadCamPageRequestsSearchByDateRangeQueryResult = Apollo.QueryResult<GetCadCamPageRequestsSearchByDateRangeQuery, GetCadCamPageRequestsSearchByDateRangeQueryVariables>;
export const GetCadCamRequestSearchByIdDocument = gql`
    query GetCadCamRequestSearchById($id: ID!) {
  cadCamRequestSearchById(id: $id) {
    ...CadCamPageProjectManagerRequestRowInfo
  }
}
    ${CadCamPageProjectManagerRequestRowInfoFragmentDoc}`;

/**
 * __useGetCadCamRequestSearchByIdQuery__
 *
 * To run a query within a React component, call `useGetCadCamRequestSearchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCadCamRequestSearchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCadCamRequestSearchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCadCamRequestSearchByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables> & ({ variables: GetCadCamRequestSearchByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables>(GetCadCamRequestSearchByIdDocument, options);
      }
export function useGetCadCamRequestSearchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables>(GetCadCamRequestSearchByIdDocument, options);
        }
export function useGetCadCamRequestSearchByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables>(GetCadCamRequestSearchByIdDocument, options);
        }
export type GetCadCamRequestSearchByIdQueryHookResult = ReturnType<typeof useGetCadCamRequestSearchByIdQuery>;
export type GetCadCamRequestSearchByIdLazyQueryHookResult = ReturnType<typeof useGetCadCamRequestSearchByIdLazyQuery>;
export type GetCadCamRequestSearchByIdSuspenseQueryHookResult = ReturnType<typeof useGetCadCamRequestSearchByIdSuspenseQuery>;
export type GetCadCamRequestSearchByIdQueryResult = Apollo.QueryResult<GetCadCamRequestSearchByIdQuery, GetCadCamRequestSearchByIdQueryVariables>;
export const GetCadCamPageRequestsSearchByCustomerReferenceDocument = gql`
    query GetCadCamPageRequestsSearchByCustomerReference($term: String!, $onlyActionRequired: Boolean, $onlyReorderable: Boolean, $onlyCheckedOutByViewer: Boolean, $shipToAccountNumber: ID, $paging: PagingInput!) {
  cadCamRequestSearchByCustomerReference(
    term: $term
    onlyActionRequired: $onlyActionRequired
    onlyReorderable: $onlyReorderable
    onlyCheckedOutByViewer: $onlyCheckedOutByViewer
    shipToAccountNumber: $shipToAccountNumber
  ) {
    count
    results(paging: $paging) {
      ...CadCamPageProjectManagerRequestRowInfo
    }
  }
}
    ${CadCamPageProjectManagerRequestRowInfoFragmentDoc}`;

/**
 * __useGetCadCamPageRequestsSearchByCustomerReferenceQuery__
 *
 * To run a query within a React component, call `useGetCadCamPageRequestsSearchByCustomerReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCadCamPageRequestsSearchByCustomerReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCadCamPageRequestsSearchByCustomerReferenceQuery({
 *   variables: {
 *      term: // value for 'term'
 *      onlyActionRequired: // value for 'onlyActionRequired'
 *      onlyReorderable: // value for 'onlyReorderable'
 *      onlyCheckedOutByViewer: // value for 'onlyCheckedOutByViewer'
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCadCamPageRequestsSearchByCustomerReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables> & ({ variables: GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables>(GetCadCamPageRequestsSearchByCustomerReferenceDocument, options);
      }
export function useGetCadCamPageRequestsSearchByCustomerReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables>(GetCadCamPageRequestsSearchByCustomerReferenceDocument, options);
        }
export function useGetCadCamPageRequestsSearchByCustomerReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables>(GetCadCamPageRequestsSearchByCustomerReferenceDocument, options);
        }
export type GetCadCamPageRequestsSearchByCustomerReferenceQueryHookResult = ReturnType<typeof useGetCadCamPageRequestsSearchByCustomerReferenceQuery>;
export type GetCadCamPageRequestsSearchByCustomerReferenceLazyQueryHookResult = ReturnType<typeof useGetCadCamPageRequestsSearchByCustomerReferenceLazyQuery>;
export type GetCadCamPageRequestsSearchByCustomerReferenceSuspenseQueryHookResult = ReturnType<typeof useGetCadCamPageRequestsSearchByCustomerReferenceSuspenseQuery>;
export type GetCadCamPageRequestsSearchByCustomerReferenceQueryResult = Apollo.QueryResult<GetCadCamPageRequestsSearchByCustomerReferenceQuery, GetCadCamPageRequestsSearchByCustomerReferenceQueryVariables>;
export const GetCadCamPageRequestSearchByWipJobNumberDocument = gql`
    query GetCadCamPageRequestSearchByWipJobNumber($wipJobNumber: String!) {
  cadCamRequestSearchByWipJobNumber(wipJobNumber: $wipJobNumber) {
    ...CadCamPageProjectManagerRequestRowInfo
  }
}
    ${CadCamPageProjectManagerRequestRowInfoFragmentDoc}`;

/**
 * __useGetCadCamPageRequestSearchByWipJobNumberQuery__
 *
 * To run a query within a React component, call `useGetCadCamPageRequestSearchByWipJobNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCadCamPageRequestSearchByWipJobNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCadCamPageRequestSearchByWipJobNumberQuery({
 *   variables: {
 *      wipJobNumber: // value for 'wipJobNumber'
 *   },
 * });
 */
export function useGetCadCamPageRequestSearchByWipJobNumberQuery(baseOptions: Apollo.QueryHookOptions<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables> & ({ variables: GetCadCamPageRequestSearchByWipJobNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables>(GetCadCamPageRequestSearchByWipJobNumberDocument, options);
      }
export function useGetCadCamPageRequestSearchByWipJobNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables>(GetCadCamPageRequestSearchByWipJobNumberDocument, options);
        }
export function useGetCadCamPageRequestSearchByWipJobNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables>(GetCadCamPageRequestSearchByWipJobNumberDocument, options);
        }
export type GetCadCamPageRequestSearchByWipJobNumberQueryHookResult = ReturnType<typeof useGetCadCamPageRequestSearchByWipJobNumberQuery>;
export type GetCadCamPageRequestSearchByWipJobNumberLazyQueryHookResult = ReturnType<typeof useGetCadCamPageRequestSearchByWipJobNumberLazyQuery>;
export type GetCadCamPageRequestSearchByWipJobNumberSuspenseQueryHookResult = ReturnType<typeof useGetCadCamPageRequestSearchByWipJobNumberSuspenseQuery>;
export type GetCadCamPageRequestSearchByWipJobNumberQueryResult = Apollo.QueryResult<GetCadCamPageRequestSearchByWipJobNumberQuery, GetCadCamPageRequestSearchByWipJobNumberQueryVariables>;
export const CadCamPageReactivateCadCamRequestByIdDocument = gql`
    mutation CadCamPageReactivateCadCamRequestById($input: ReactivateCadCamRequestByIdInput!) {
  reactivateCadCamRequestById(input: $input) {
    cadCamRequest {
      ...CadCamPageProjectManagerRequestRowInfo
    }
  }
}
    ${CadCamPageProjectManagerRequestRowInfoFragmentDoc}`;
export type CadCamPageReactivateCadCamRequestByIdMutationFn = Apollo.MutationFunction<CadCamPageReactivateCadCamRequestByIdMutation, CadCamPageReactivateCadCamRequestByIdMutationVariables>;

/**
 * __useCadCamPageReactivateCadCamRequestByIdMutation__
 *
 * To run a mutation, you first call `useCadCamPageReactivateCadCamRequestByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCadCamPageReactivateCadCamRequestByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cadCamPageReactivateCadCamRequestByIdMutation, { data, loading, error }] = useCadCamPageReactivateCadCamRequestByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCadCamPageReactivateCadCamRequestByIdMutation(baseOptions?: Apollo.MutationHookOptions<CadCamPageReactivateCadCamRequestByIdMutation, CadCamPageReactivateCadCamRequestByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CadCamPageReactivateCadCamRequestByIdMutation, CadCamPageReactivateCadCamRequestByIdMutationVariables>(CadCamPageReactivateCadCamRequestByIdDocument, options);
      }
export type CadCamPageReactivateCadCamRequestByIdMutationHookResult = ReturnType<typeof useCadCamPageReactivateCadCamRequestByIdMutation>;
export type CadCamPageReactivateCadCamRequestByIdMutationResult = Apollo.MutationResult<CadCamPageReactivateCadCamRequestByIdMutation>;
export type CadCamPageReactivateCadCamRequestByIdMutationOptions = Apollo.BaseMutationOptions<CadCamPageReactivateCadCamRequestByIdMutation, CadCamPageReactivateCadCamRequestByIdMutationVariables>;
export const CadCamPageAddToSignetCartDocument = gql`
    mutation CadCamPageAddToSignetCart($input: AddToSignetCartInput!) {
  addToSignetCart(input: $input) {
    redirectUrl
    message
  }
}
    `;
export type CadCamPageAddToSignetCartMutationFn = Apollo.MutationFunction<CadCamPageAddToSignetCartMutation, CadCamPageAddToSignetCartMutationVariables>;

/**
 * __useCadCamPageAddToSignetCartMutation__
 *
 * To run a mutation, you first call `useCadCamPageAddToSignetCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCadCamPageAddToSignetCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cadCamPageAddToSignetCartMutation, { data, loading, error }] = useCadCamPageAddToSignetCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCadCamPageAddToSignetCartMutation(baseOptions?: Apollo.MutationHookOptions<CadCamPageAddToSignetCartMutation, CadCamPageAddToSignetCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CadCamPageAddToSignetCartMutation, CadCamPageAddToSignetCartMutationVariables>(CadCamPageAddToSignetCartDocument, options);
      }
export type CadCamPageAddToSignetCartMutationHookResult = ReturnType<typeof useCadCamPageAddToSignetCartMutation>;
export type CadCamPageAddToSignetCartMutationResult = Apollo.MutationResult<CadCamPageAddToSignetCartMutation>;
export type CadCamPageAddToSignetCartMutationOptions = Apollo.BaseMutationOptions<CadCamPageAddToSignetCartMutation, CadCamPageAddToSignetCartMutationVariables>;
export const GetCartPageCartItemNeedsToAgreeToConsignmentTermsDocument = gql`
    query GetCartPageCartItemNeedsToAgreeToConsignmentTerms {
  viewer {
    id
    needsToAgreeToConsignmentTerms
  }
}
    `;

/**
 * __useGetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>(GetCartPageCartItemNeedsToAgreeToConsignmentTermsDocument, options);
      }
export function useGetCartPageCartItemNeedsToAgreeToConsignmentTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>(GetCartPageCartItemNeedsToAgreeToConsignmentTermsDocument, options);
        }
export function useGetCartPageCartItemNeedsToAgreeToConsignmentTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>(GetCartPageCartItemNeedsToAgreeToConsignmentTermsDocument, options);
        }
export type GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryHookResult = ReturnType<typeof useGetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery>;
export type GetCartPageCartItemNeedsToAgreeToConsignmentTermsLazyQueryHookResult = ReturnType<typeof useGetCartPageCartItemNeedsToAgreeToConsignmentTermsLazyQuery>;
export type GetCartPageCartItemNeedsToAgreeToConsignmentTermsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartItemNeedsToAgreeToConsignmentTermsSuspenseQuery>;
export type GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryResult = Apollo.QueryResult<GetCartPageCartItemNeedsToAgreeToConsignmentTermsQuery, GetCartPageCartItemNeedsToAgreeToConsignmentTermsQueryVariables>;
export const GetCartPageCartItemConfigurationSummaryDocument = gql`
    query GetCartPageCartItemConfigurationSummary($configurationByIdId: ID!) {
  configurationById(id: $configurationByIdId) {
    product {
      type
      id
      itemNumber
      title
      image
      isWebActive
    }
    details {
      ... on RingSizeConfigurationDetail {
        ringSize
      }
      ... on StoneSettingConfigurationDetail {
        title
        stoneSettings {
          locationDescription
          quantity
          exactFit {
            length
            width
            depth
          }
          stone {
            ... on Product {
              id
              itemNumber
              title
              image
              isWebActive
            }
            ... on SerializedProduct {
              id
              title
              image
              isActive
              serialNumber
            }
            ... on CustomerStone {
              stoneValue {
                value
                valueInUsd
              }
            }
          }
        }
      }
      ... on EngravingConfigurationDetail {
        engravings {
          locationDescription
          engraving {
            ... on HandwrittenEngravingLocationConfiguration {
              color {
                name
                hex
              }
            }
            ... on PatternEngravingLocationConfiguration {
              patternName
            }
            ... on StandardEngravingLocationConfiguration {
              fontName
              lines {
                text
                thumbnailPreviewImage
              }
              color {
                name
                hex
              }
            }
            ... on CustomerLogoEngravingLocationConfiguration {
              logo {
                name
                imagePreview
                id
              }
            }
          }
        }
      }
      ... on ImprintingConfigurationDetail {
        imprintings {
          locationDescription
          locationImage
          logo {
            name
            imagePreview
          }
          colors {
            name
            hex
            instructions
          }
        }
      }
      ... on SpecialFinishConfigurationDetail {
        title
        finishes {
          locationDescription
          previewImage
          specialFinishName
        }
      }
      ... on ChainConfigurationDetail {
        length {
          value
          uom
        }
        clasp {
          id
          itemNumber
          title
          image
          isWebActive
        }
      }
      ... on MonogramConfigurationDetail {
        locations {
          locationDescription
          value
        }
      }
      ... on HeadConfigurationDetail {
        head {
          product {
            id
            itemNumber
            title
            image
            isWebActive
          }
          details {
            ... on StoneSettingConfigurationDetail {
              stoneSettings {
                locationDescription
                quantity
                exactFit {
                  length
                  width
                  depth
                }
                stone {
                  ... on Product {
                    id
                    itemNumber
                    title
                    image
                    isWebActive
                  }
                  ... on SerializedProduct {
                    id
                    title
                    image
                    isActive
                  }
                  ... on CustomerStone {
                    stoneValue {
                      value
                      valueInUsd
                    }
                  }
                }
              }
            }
          }
        }
      }
      ... on EarringConfigurationDetail {
        post {
          id
          itemNumber
          title
          image
          isWebActive
        }
        back {
          id
          itemNumber
          title
          image
          isWebActive
        }
        quantity
      }
      ... on MatchingChainConfigurationDetail {
        product {
          id
          itemNumber
          title
          image
          isWebActive
        }
      }
      ... on KitConfigurationDetail {
        products {
          id
          itemNumber
          title
          image
          isWebActive
        }
      }
    }
  }
}
    `;

/**
 * __useGetCartPageCartItemConfigurationSummaryQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartItemConfigurationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartItemConfigurationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartItemConfigurationSummaryQuery({
 *   variables: {
 *      configurationByIdId: // value for 'configurationByIdId'
 *   },
 * });
 */
export function useGetCartPageCartItemConfigurationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables> & ({ variables: GetCartPageCartItemConfigurationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables>(GetCartPageCartItemConfigurationSummaryDocument, options);
      }
export function useGetCartPageCartItemConfigurationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables>(GetCartPageCartItemConfigurationSummaryDocument, options);
        }
export function useGetCartPageCartItemConfigurationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables>(GetCartPageCartItemConfigurationSummaryDocument, options);
        }
export type GetCartPageCartItemConfigurationSummaryQueryHookResult = ReturnType<typeof useGetCartPageCartItemConfigurationSummaryQuery>;
export type GetCartPageCartItemConfigurationSummaryLazyQueryHookResult = ReturnType<typeof useGetCartPageCartItemConfigurationSummaryLazyQuery>;
export type GetCartPageCartItemConfigurationSummarySuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartItemConfigurationSummarySuspenseQuery>;
export type GetCartPageCartItemConfigurationSummaryQueryResult = Apollo.QueryResult<GetCartPageCartItemConfigurationSummaryQuery, GetCartPageCartItemConfigurationSummaryQueryVariables>;
export const GetCartPageCartItemFavoriteListsDocument = gql`
    query GetCartPageCartItemFavoriteLists {
  favoriteLists {
    id
    name
  }
}
    `;

/**
 * __useGetCartPageCartItemFavoriteListsQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartItemFavoriteListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartItemFavoriteListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartItemFavoriteListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartItemFavoriteListsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>(GetCartPageCartItemFavoriteListsDocument, options);
      }
export function useGetCartPageCartItemFavoriteListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>(GetCartPageCartItemFavoriteListsDocument, options);
        }
export function useGetCartPageCartItemFavoriteListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>(GetCartPageCartItemFavoriteListsDocument, options);
        }
export type GetCartPageCartItemFavoriteListsQueryHookResult = ReturnType<typeof useGetCartPageCartItemFavoriteListsQuery>;
export type GetCartPageCartItemFavoriteListsLazyQueryHookResult = ReturnType<typeof useGetCartPageCartItemFavoriteListsLazyQuery>;
export type GetCartPageCartItemFavoriteListsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartItemFavoriteListsSuspenseQuery>;
export type GetCartPageCartItemFavoriteListsQueryResult = Apollo.QueryResult<GetCartPageCartItemFavoriteListsQuery, GetCartPageCartItemFavoriteListsQueryVariables>;
export const GetCartPageCartItemDotOptionsPermissionsDocument = gql`
    query GetCartPageCartItemDotOptionsPermissions {
  viewerPermissions {
    id
    canSetOrderLineConsultantDiscounts
    canSetOrderLineMatching
    canSetOrderLineSalesType
  }
}
    `;

/**
 * __useGetCartPageCartItemDotOptionsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartItemDotOptionsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartItemDotOptionsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartItemDotOptionsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartItemDotOptionsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>(GetCartPageCartItemDotOptionsPermissionsDocument, options);
      }
export function useGetCartPageCartItemDotOptionsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>(GetCartPageCartItemDotOptionsPermissionsDocument, options);
        }
export function useGetCartPageCartItemDotOptionsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>(GetCartPageCartItemDotOptionsPermissionsDocument, options);
        }
export type GetCartPageCartItemDotOptionsPermissionsQueryHookResult = ReturnType<typeof useGetCartPageCartItemDotOptionsPermissionsQuery>;
export type GetCartPageCartItemDotOptionsPermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageCartItemDotOptionsPermissionsLazyQuery>;
export type GetCartPageCartItemDotOptionsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartItemDotOptionsPermissionsSuspenseQuery>;
export type GetCartPageCartItemDotOptionsPermissionsQueryResult = Apollo.QueryResult<GetCartPageCartItemDotOptionsPermissionsQuery, GetCartPageCartItemDotOptionsPermissionsQueryVariables>;
export const GetCartPageCartItemCanAddToFavoritesDocument = gql`
    query GetCartPageCartItemCanAddToFavorites {
  viewerPermissions {
    id
    canAddToFavorites
  }
}
    `;

/**
 * __useGetCartPageCartItemCanAddToFavoritesQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartItemCanAddToFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartItemCanAddToFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartItemCanAddToFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartItemCanAddToFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>(GetCartPageCartItemCanAddToFavoritesDocument, options);
      }
export function useGetCartPageCartItemCanAddToFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>(GetCartPageCartItemCanAddToFavoritesDocument, options);
        }
export function useGetCartPageCartItemCanAddToFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>(GetCartPageCartItemCanAddToFavoritesDocument, options);
        }
export type GetCartPageCartItemCanAddToFavoritesQueryHookResult = ReturnType<typeof useGetCartPageCartItemCanAddToFavoritesQuery>;
export type GetCartPageCartItemCanAddToFavoritesLazyQueryHookResult = ReturnType<typeof useGetCartPageCartItemCanAddToFavoritesLazyQuery>;
export type GetCartPageCartItemCanAddToFavoritesSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartItemCanAddToFavoritesSuspenseQuery>;
export type GetCartPageCartItemCanAddToFavoritesQueryResult = Apollo.QueryResult<GetCartPageCartItemCanAddToFavoritesQuery, GetCartPageCartItemCanAddToFavoritesQueryVariables>;
export const GetCartPageCartItemCanViewQuantityOnHandDocument = gql`
    query GetCartPageCartItemCanViewQuantityOnHand {
  viewerPermissions {
    id
    canViewQuantityOnHand
  }
}
    `;

/**
 * __useGetCartPageCartItemCanViewQuantityOnHandQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartItemCanViewQuantityOnHandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartItemCanViewQuantityOnHandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartItemCanViewQuantityOnHandQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartItemCanViewQuantityOnHandQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>(GetCartPageCartItemCanViewQuantityOnHandDocument, options);
      }
export function useGetCartPageCartItemCanViewQuantityOnHandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>(GetCartPageCartItemCanViewQuantityOnHandDocument, options);
        }
export function useGetCartPageCartItemCanViewQuantityOnHandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>(GetCartPageCartItemCanViewQuantityOnHandDocument, options);
        }
export type GetCartPageCartItemCanViewQuantityOnHandQueryHookResult = ReturnType<typeof useGetCartPageCartItemCanViewQuantityOnHandQuery>;
export type GetCartPageCartItemCanViewQuantityOnHandLazyQueryHookResult = ReturnType<typeof useGetCartPageCartItemCanViewQuantityOnHandLazyQuery>;
export type GetCartPageCartItemCanViewQuantityOnHandSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartItemCanViewQuantityOnHandSuspenseQuery>;
export type GetCartPageCartItemCanViewQuantityOnHandQueryResult = Apollo.QueryResult<GetCartPageCartItemCanViewQuantityOnHandQuery, GetCartPageCartItemCanViewQuantityOnHandQueryVariables>;
export const CartPageCartItemAcceptConsignmentTermsDocument = gql`
    mutation CartPageCartItemAcceptConsignmentTerms {
  acceptConsignmentTerms {
    user {
      id
      needsToAgreeToConsignmentTerms
    }
  }
}
    `;
export type CartPageCartItemAcceptConsignmentTermsMutationFn = Apollo.MutationFunction<CartPageCartItemAcceptConsignmentTermsMutation, CartPageCartItemAcceptConsignmentTermsMutationVariables>;

/**
 * __useCartPageCartItemAcceptConsignmentTermsMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemAcceptConsignmentTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemAcceptConsignmentTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemAcceptConsignmentTermsMutation, { data, loading, error }] = useCartPageCartItemAcceptConsignmentTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCartPageCartItemAcceptConsignmentTermsMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemAcceptConsignmentTermsMutation, CartPageCartItemAcceptConsignmentTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemAcceptConsignmentTermsMutation, CartPageCartItemAcceptConsignmentTermsMutationVariables>(CartPageCartItemAcceptConsignmentTermsDocument, options);
      }
export type CartPageCartItemAcceptConsignmentTermsMutationHookResult = ReturnType<typeof useCartPageCartItemAcceptConsignmentTermsMutation>;
export type CartPageCartItemAcceptConsignmentTermsMutationResult = Apollo.MutationResult<CartPageCartItemAcceptConsignmentTermsMutation>;
export type CartPageCartItemAcceptConsignmentTermsMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemAcceptConsignmentTermsMutation, CartPageCartItemAcceptConsignmentTermsMutationVariables>;
export const CartPageCartItemSaveCartLineForLaterDocument = gql`
    mutation CartPageCartItemSaveCartLineForLater($cartLineId: ID!) {
  saveCartLineForLater(cartLineId: $cartLineId) {
    cart {
      ...CartPageCartPageCartInfo
    }
  }
}
    ${CartPageCartPageCartInfoFragmentDoc}`;
export type CartPageCartItemSaveCartLineForLaterMutationFn = Apollo.MutationFunction<CartPageCartItemSaveCartLineForLaterMutation, CartPageCartItemSaveCartLineForLaterMutationVariables>;

/**
 * __useCartPageCartItemSaveCartLineForLaterMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemSaveCartLineForLaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemSaveCartLineForLaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemSaveCartLineForLaterMutation, { data, loading, error }] = useCartPageCartItemSaveCartLineForLaterMutation({
 *   variables: {
 *      cartLineId: // value for 'cartLineId'
 *   },
 * });
 */
export function useCartPageCartItemSaveCartLineForLaterMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemSaveCartLineForLaterMutation, CartPageCartItemSaveCartLineForLaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemSaveCartLineForLaterMutation, CartPageCartItemSaveCartLineForLaterMutationVariables>(CartPageCartItemSaveCartLineForLaterDocument, options);
      }
export type CartPageCartItemSaveCartLineForLaterMutationHookResult = ReturnType<typeof useCartPageCartItemSaveCartLineForLaterMutation>;
export type CartPageCartItemSaveCartLineForLaterMutationResult = Apollo.MutationResult<CartPageCartItemSaveCartLineForLaterMutation>;
export type CartPageCartItemSaveCartLineForLaterMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemSaveCartLineForLaterMutation, CartPageCartItemSaveCartLineForLaterMutationVariables>;
export const CartPageCartItemDeleteCartLineWithShipmentsDocument = gql`
    mutation CartPageCartItemDeleteCartLineWithShipments($input: DeleteCartLineInput!) {
  deleteCartLine(input: $input) {
    cart {
      ...CartPageCartPageCartInfo
    }
  }
}
    ${CartPageCartPageCartInfoFragmentDoc}`;
export type CartPageCartItemDeleteCartLineWithShipmentsMutationFn = Apollo.MutationFunction<CartPageCartItemDeleteCartLineWithShipmentsMutation, CartPageCartItemDeleteCartLineWithShipmentsMutationVariables>;

/**
 * __useCartPageCartItemDeleteCartLineWithShipmentsMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemDeleteCartLineWithShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemDeleteCartLineWithShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemDeleteCartLineWithShipmentsMutation, { data, loading, error }] = useCartPageCartItemDeleteCartLineWithShipmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemDeleteCartLineWithShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemDeleteCartLineWithShipmentsMutation, CartPageCartItemDeleteCartLineWithShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemDeleteCartLineWithShipmentsMutation, CartPageCartItemDeleteCartLineWithShipmentsMutationVariables>(CartPageCartItemDeleteCartLineWithShipmentsDocument, options);
      }
export type CartPageCartItemDeleteCartLineWithShipmentsMutationHookResult = ReturnType<typeof useCartPageCartItemDeleteCartLineWithShipmentsMutation>;
export type CartPageCartItemDeleteCartLineWithShipmentsMutationResult = Apollo.MutationResult<CartPageCartItemDeleteCartLineWithShipmentsMutation>;
export type CartPageCartItemDeleteCartLineWithShipmentsMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemDeleteCartLineWithShipmentsMutation, CartPageCartItemDeleteCartLineWithShipmentsMutationVariables>;
export const CartPageCartItemDeleteCartLineWithCartListItemDocument = gql`
    mutation CartPageCartItemDeleteCartLineWithCartListItem($input: DeleteCartLineInput!) {
  deleteCartLine(input: $input) {
    cart {
      ...CartPageCartListItemInfo
    }
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;
export type CartPageCartItemDeleteCartLineWithCartListItemMutationFn = Apollo.MutationFunction<CartPageCartItemDeleteCartLineWithCartListItemMutation, CartPageCartItemDeleteCartLineWithCartListItemMutationVariables>;

/**
 * __useCartPageCartItemDeleteCartLineWithCartListItemMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemDeleteCartLineWithCartListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemDeleteCartLineWithCartListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemDeleteCartLineWithCartListItemMutation, { data, loading, error }] = useCartPageCartItemDeleteCartLineWithCartListItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemDeleteCartLineWithCartListItemMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemDeleteCartLineWithCartListItemMutation, CartPageCartItemDeleteCartLineWithCartListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemDeleteCartLineWithCartListItemMutation, CartPageCartItemDeleteCartLineWithCartListItemMutationVariables>(CartPageCartItemDeleteCartLineWithCartListItemDocument, options);
      }
export type CartPageCartItemDeleteCartLineWithCartListItemMutationHookResult = ReturnType<typeof useCartPageCartItemDeleteCartLineWithCartListItemMutation>;
export type CartPageCartItemDeleteCartLineWithCartListItemMutationResult = Apollo.MutationResult<CartPageCartItemDeleteCartLineWithCartListItemMutation>;
export type CartPageCartItemDeleteCartLineWithCartListItemMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemDeleteCartLineWithCartListItemMutation, CartPageCartItemDeleteCartLineWithCartListItemMutationVariables>;
export const CartPageCartItemUpdateCartLineWithShipmentsDocument = gql`
    mutation CartPageCartItemUpdateCartLineWithShipments($input: UpdateCartLineInput!) {
  updateCartLine(input: $input) {
    cart {
      ...CartPageCartPageCartInfo
    }
  }
}
    ${CartPageCartPageCartInfoFragmentDoc}`;
export type CartPageCartItemUpdateCartLineWithShipmentsMutationFn = Apollo.MutationFunction<CartPageCartItemUpdateCartLineWithShipmentsMutation, CartPageCartItemUpdateCartLineWithShipmentsMutationVariables>;

/**
 * __useCartPageCartItemUpdateCartLineWithShipmentsMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemUpdateCartLineWithShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemUpdateCartLineWithShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemUpdateCartLineWithShipmentsMutation, { data, loading, error }] = useCartPageCartItemUpdateCartLineWithShipmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemUpdateCartLineWithShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemUpdateCartLineWithShipmentsMutation, CartPageCartItemUpdateCartLineWithShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemUpdateCartLineWithShipmentsMutation, CartPageCartItemUpdateCartLineWithShipmentsMutationVariables>(CartPageCartItemUpdateCartLineWithShipmentsDocument, options);
      }
export type CartPageCartItemUpdateCartLineWithShipmentsMutationHookResult = ReturnType<typeof useCartPageCartItemUpdateCartLineWithShipmentsMutation>;
export type CartPageCartItemUpdateCartLineWithShipmentsMutationResult = Apollo.MutationResult<CartPageCartItemUpdateCartLineWithShipmentsMutation>;
export type CartPageCartItemUpdateCartLineWithShipmentsMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemUpdateCartLineWithShipmentsMutation, CartPageCartItemUpdateCartLineWithShipmentsMutationVariables>;
export const CartPageCartItemUpdateCartLineWithCartListItemDocument = gql`
    mutation CartPageCartItemUpdateCartLineWithCartListItem($input: UpdateCartLineInput!) {
  updateCartLine(input: $input) {
    cart {
      ...CartPageCartListItemInfo
    }
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;
export type CartPageCartItemUpdateCartLineWithCartListItemMutationFn = Apollo.MutationFunction<CartPageCartItemUpdateCartLineWithCartListItemMutation, CartPageCartItemUpdateCartLineWithCartListItemMutationVariables>;

/**
 * __useCartPageCartItemUpdateCartLineWithCartListItemMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemUpdateCartLineWithCartListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemUpdateCartLineWithCartListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemUpdateCartLineWithCartListItemMutation, { data, loading, error }] = useCartPageCartItemUpdateCartLineWithCartListItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemUpdateCartLineWithCartListItemMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemUpdateCartLineWithCartListItemMutation, CartPageCartItemUpdateCartLineWithCartListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemUpdateCartLineWithCartListItemMutation, CartPageCartItemUpdateCartLineWithCartListItemMutationVariables>(CartPageCartItemUpdateCartLineWithCartListItemDocument, options);
      }
export type CartPageCartItemUpdateCartLineWithCartListItemMutationHookResult = ReturnType<typeof useCartPageCartItemUpdateCartLineWithCartListItemMutation>;
export type CartPageCartItemUpdateCartLineWithCartListItemMutationResult = Apollo.MutationResult<CartPageCartItemUpdateCartLineWithCartListItemMutation>;
export type CartPageCartItemUpdateCartLineWithCartListItemMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemUpdateCartLineWithCartListItemMutation, CartPageCartItemUpdateCartLineWithCartListItemMutationVariables>;
export const CartPageCartItemMoveSavedCartLineToCartDocument = gql`
    mutation CartPageCartItemMoveSavedCartLineToCart($input: MoveSavedCartLineToCartInput!) {
  moveSavedCartLineToCart(input: $input) {
    cart {
      id
    }
  }
}
    `;
export type CartPageCartItemMoveSavedCartLineToCartMutationFn = Apollo.MutationFunction<CartPageCartItemMoveSavedCartLineToCartMutation, CartPageCartItemMoveSavedCartLineToCartMutationVariables>;

/**
 * __useCartPageCartItemMoveSavedCartLineToCartMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemMoveSavedCartLineToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemMoveSavedCartLineToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemMoveSavedCartLineToCartMutation, { data, loading, error }] = useCartPageCartItemMoveSavedCartLineToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemMoveSavedCartLineToCartMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemMoveSavedCartLineToCartMutation, CartPageCartItemMoveSavedCartLineToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemMoveSavedCartLineToCartMutation, CartPageCartItemMoveSavedCartLineToCartMutationVariables>(CartPageCartItemMoveSavedCartLineToCartDocument, options);
      }
export type CartPageCartItemMoveSavedCartLineToCartMutationHookResult = ReturnType<typeof useCartPageCartItemMoveSavedCartLineToCartMutation>;
export type CartPageCartItemMoveSavedCartLineToCartMutationResult = Apollo.MutationResult<CartPageCartItemMoveSavedCartLineToCartMutation>;
export type CartPageCartItemMoveSavedCartLineToCartMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemMoveSavedCartLineToCartMutation, CartPageCartItemMoveSavedCartLineToCartMutationVariables>;
export const CartPageCartItemMoveCartLineToCartDocument = gql`
    mutation CartPageCartItemMoveCartLineToCart($input: MoveCartLineToCartInput!) {
  moveCartLineToCart(input: $input) {
    sourceCart {
      ...CartPageCartListItemInfo
    }
    targetCart {
      id
    }
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;
export type CartPageCartItemMoveCartLineToCartMutationFn = Apollo.MutationFunction<CartPageCartItemMoveCartLineToCartMutation, CartPageCartItemMoveCartLineToCartMutationVariables>;

/**
 * __useCartPageCartItemMoveCartLineToCartMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemMoveCartLineToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemMoveCartLineToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemMoveCartLineToCartMutation, { data, loading, error }] = useCartPageCartItemMoveCartLineToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemMoveCartLineToCartMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemMoveCartLineToCartMutation, CartPageCartItemMoveCartLineToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemMoveCartLineToCartMutation, CartPageCartItemMoveCartLineToCartMutationVariables>(CartPageCartItemMoveCartLineToCartDocument, options);
      }
export type CartPageCartItemMoveCartLineToCartMutationHookResult = ReturnType<typeof useCartPageCartItemMoveCartLineToCartMutation>;
export type CartPageCartItemMoveCartLineToCartMutationResult = Apollo.MutationResult<CartPageCartItemMoveCartLineToCartMutation>;
export type CartPageCartItemMoveCartLineToCartMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemMoveCartLineToCartMutation, CartPageCartItemMoveCartLineToCartMutationVariables>;
export const CartPageCartItemDeleteSavedCartLineDocument = gql`
    mutation CartPageCartItemDeleteSavedCartLine($input: DeleteSavedCartLineInput!) {
  deleteSavedCartLine(input: $input) {
    savedCartLineId
  }
}
    `;
export type CartPageCartItemDeleteSavedCartLineMutationFn = Apollo.MutationFunction<CartPageCartItemDeleteSavedCartLineMutation, CartPageCartItemDeleteSavedCartLineMutationVariables>;

/**
 * __useCartPageCartItemDeleteSavedCartLineMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemDeleteSavedCartLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemDeleteSavedCartLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemDeleteSavedCartLineMutation, { data, loading, error }] = useCartPageCartItemDeleteSavedCartLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemDeleteSavedCartLineMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemDeleteSavedCartLineMutation, CartPageCartItemDeleteSavedCartLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemDeleteSavedCartLineMutation, CartPageCartItemDeleteSavedCartLineMutationVariables>(CartPageCartItemDeleteSavedCartLineDocument, options);
      }
export type CartPageCartItemDeleteSavedCartLineMutationHookResult = ReturnType<typeof useCartPageCartItemDeleteSavedCartLineMutation>;
export type CartPageCartItemDeleteSavedCartLineMutationResult = Apollo.MutationResult<CartPageCartItemDeleteSavedCartLineMutation>;
export type CartPageCartItemDeleteSavedCartLineMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemDeleteSavedCartLineMutation, CartPageCartItemDeleteSavedCartLineMutationVariables>;
export const CartPageCartItemUpdateSavedCartLineDocument = gql`
    mutation CartPageCartItemUpdateSavedCartLine($input: UpdateSavedCartLineInput!) {
  updateSavedCartLine(input: $input) {
    savedCartLine {
      ...CartPageCartItemInfo
    }
  }
}
    ${CartPageCartItemInfoFragmentDoc}`;
export type CartPageCartItemUpdateSavedCartLineMutationFn = Apollo.MutationFunction<CartPageCartItemUpdateSavedCartLineMutation, CartPageCartItemUpdateSavedCartLineMutationVariables>;

/**
 * __useCartPageCartItemUpdateSavedCartLineMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemUpdateSavedCartLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemUpdateSavedCartLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemUpdateSavedCartLineMutation, { data, loading, error }] = useCartPageCartItemUpdateSavedCartLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemUpdateSavedCartLineMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemUpdateSavedCartLineMutation, CartPageCartItemUpdateSavedCartLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemUpdateSavedCartLineMutation, CartPageCartItemUpdateSavedCartLineMutationVariables>(CartPageCartItemUpdateSavedCartLineDocument, options);
      }
export type CartPageCartItemUpdateSavedCartLineMutationHookResult = ReturnType<typeof useCartPageCartItemUpdateSavedCartLineMutation>;
export type CartPageCartItemUpdateSavedCartLineMutationResult = Apollo.MutationResult<CartPageCartItemUpdateSavedCartLineMutation>;
export type CartPageCartItemUpdateSavedCartLineMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemUpdateSavedCartLineMutation, CartPageCartItemUpdateSavedCartLineMutationVariables>;
export const CartPageCartItemAddToFavoritesDocument = gql`
    mutation CartPageCartItemAddToFavorites($input: AddToFavoritesInput!) {
  addToFavorites(input: $input) {
    favorite {
      id
      notes
      sortOrder
      options {
        customerNotes
        quantity
      }
      favoriteList {
        id
        name
      }
      item {
        id
        itemId {
          id
          type
        }
      }
    }
  }
}
    `;
export type CartPageCartItemAddToFavoritesMutationFn = Apollo.MutationFunction<CartPageCartItemAddToFavoritesMutation, CartPageCartItemAddToFavoritesMutationVariables>;

/**
 * __useCartPageCartItemAddToFavoritesMutation__
 *
 * To run a mutation, you first call `useCartPageCartItemAddToFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartItemAddToFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartItemAddToFavoritesMutation, { data, loading, error }] = useCartPageCartItemAddToFavoritesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartItemAddToFavoritesMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartItemAddToFavoritesMutation, CartPageCartItemAddToFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartItemAddToFavoritesMutation, CartPageCartItemAddToFavoritesMutationVariables>(CartPageCartItemAddToFavoritesDocument, options);
      }
export type CartPageCartItemAddToFavoritesMutationHookResult = ReturnType<typeof useCartPageCartItemAddToFavoritesMutation>;
export type CartPageCartItemAddToFavoritesMutationResult = Apollo.MutationResult<CartPageCartItemAddToFavoritesMutation>;
export type CartPageCartItemAddToFavoritesMutationOptions = Apollo.BaseMutationOptions<CartPageCartItemAddToFavoritesMutation, CartPageCartItemAddToFavoritesMutationVariables>;
export const GetCartPageCartListShippingEstimatesDocument = gql`
    query GetCartPageCartListShippingEstimates {
  cart {
    id
    shipments {
      shipSetCode
      shipDate
      isValid
      validationErrors
      estimates {
        ...CartPageCartPageShippingEstimateInfo
      }
    }
  }
}
    ${CartPageCartPageShippingEstimateInfoFragmentDoc}`;

/**
 * __useGetCartPageCartListShippingEstimatesQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartListShippingEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartListShippingEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartListShippingEstimatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartListShippingEstimatesQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>(GetCartPageCartListShippingEstimatesDocument, options);
      }
export function useGetCartPageCartListShippingEstimatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>(GetCartPageCartListShippingEstimatesDocument, options);
        }
export function useGetCartPageCartListShippingEstimatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>(GetCartPageCartListShippingEstimatesDocument, options);
        }
export type GetCartPageCartListShippingEstimatesQueryHookResult = ReturnType<typeof useGetCartPageCartListShippingEstimatesQuery>;
export type GetCartPageCartListShippingEstimatesLazyQueryHookResult = ReturnType<typeof useGetCartPageCartListShippingEstimatesLazyQuery>;
export type GetCartPageCartListShippingEstimatesSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartListShippingEstimatesSuspenseQuery>;
export type GetCartPageCartListShippingEstimatesQueryResult = Apollo.QueryResult<GetCartPageCartListShippingEstimatesQuery, GetCartPageCartListShippingEstimatesQueryVariables>;
export const GetCartPageCartListCartDocument = gql`
    query GetCartPageCartListCart($cartId: ID!) {
  cartById(cartId: $cartId) {
    ...CartPageCartListItemInfo
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;

/**
 * __useGetCartPageCartListCartQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartListCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartListCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartListCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useGetCartPageCartListCartQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables> & ({ variables: GetCartPageCartListCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables>(GetCartPageCartListCartDocument, options);
      }
export function useGetCartPageCartListCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables>(GetCartPageCartListCartDocument, options);
        }
export function useGetCartPageCartListCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables>(GetCartPageCartListCartDocument, options);
        }
export type GetCartPageCartListCartQueryHookResult = ReturnType<typeof useGetCartPageCartListCartQuery>;
export type GetCartPageCartListCartLazyQueryHookResult = ReturnType<typeof useGetCartPageCartListCartLazyQuery>;
export type GetCartPageCartListCartSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartListCartSuspenseQuery>;
export type GetCartPageCartListCartQueryResult = Apollo.QueryResult<GetCartPageCartListCartQuery, GetCartPageCartListCartQueryVariables>;
export const CartPageCartListUpdateScheduledCartShippingMethodDocument = gql`
    mutation CartPageCartListUpdateScheduledCartShippingMethod($input: UpdateScheduledCartShippingMethodInput!) {
  updateScheduledCartShippingMethod(input: $input) {
    cart {
      ...CartPageCartPageCartInfo
    }
  }
}
    ${CartPageCartPageCartInfoFragmentDoc}`;
export type CartPageCartListUpdateScheduledCartShippingMethodMutationFn = Apollo.MutationFunction<CartPageCartListUpdateScheduledCartShippingMethodMutation, CartPageCartListUpdateScheduledCartShippingMethodMutationVariables>;

/**
 * __useCartPageCartListUpdateScheduledCartShippingMethodMutation__
 *
 * To run a mutation, you first call `useCartPageCartListUpdateScheduledCartShippingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartListUpdateScheduledCartShippingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartListUpdateScheduledCartShippingMethodMutation, { data, loading, error }] = useCartPageCartListUpdateScheduledCartShippingMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartListUpdateScheduledCartShippingMethodMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartListUpdateScheduledCartShippingMethodMutation, CartPageCartListUpdateScheduledCartShippingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartListUpdateScheduledCartShippingMethodMutation, CartPageCartListUpdateScheduledCartShippingMethodMutationVariables>(CartPageCartListUpdateScheduledCartShippingMethodDocument, options);
      }
export type CartPageCartListUpdateScheduledCartShippingMethodMutationHookResult = ReturnType<typeof useCartPageCartListUpdateScheduledCartShippingMethodMutation>;
export type CartPageCartListUpdateScheduledCartShippingMethodMutationResult = Apollo.MutationResult<CartPageCartListUpdateScheduledCartShippingMethodMutation>;
export type CartPageCartListUpdateScheduledCartShippingMethodMutationOptions = Apollo.BaseMutationOptions<CartPageCartListUpdateScheduledCartShippingMethodMutation, CartPageCartListUpdateScheduledCartShippingMethodMutationVariables>;
export const CartPageCartListDeleteAllCartLinesDocument = gql`
    mutation CartPageCartListDeleteAllCartLines($input: DeleteAllCartLinesInput!) {
  deleteAllCartLines(input: $input) {
    cart {
      ...CartPageCartListItemInfo
    }
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;
export type CartPageCartListDeleteAllCartLinesMutationFn = Apollo.MutationFunction<CartPageCartListDeleteAllCartLinesMutation, CartPageCartListDeleteAllCartLinesMutationVariables>;

/**
 * __useCartPageCartListDeleteAllCartLinesMutation__
 *
 * To run a mutation, you first call `useCartPageCartListDeleteAllCartLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartListDeleteAllCartLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartListDeleteAllCartLinesMutation, { data, loading, error }] = useCartPageCartListDeleteAllCartLinesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartListDeleteAllCartLinesMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartListDeleteAllCartLinesMutation, CartPageCartListDeleteAllCartLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartListDeleteAllCartLinesMutation, CartPageCartListDeleteAllCartLinesMutationVariables>(CartPageCartListDeleteAllCartLinesDocument, options);
      }
export type CartPageCartListDeleteAllCartLinesMutationHookResult = ReturnType<typeof useCartPageCartListDeleteAllCartLinesMutation>;
export type CartPageCartListDeleteAllCartLinesMutationResult = Apollo.MutationResult<CartPageCartListDeleteAllCartLinesMutation>;
export type CartPageCartListDeleteAllCartLinesMutationOptions = Apollo.BaseMutationOptions<CartPageCartListDeleteAllCartLinesMutation, CartPageCartListDeleteAllCartLinesMutationVariables>;
export const CartPageCartListMoveAllLinesToCartDocument = gql`
    mutation CartPageCartListMoveAllLinesToCart($input: MoveAllLinesToCartInput!) {
  moveAllLinesToCart(input: $input) {
    sourceCart {
      ...CartPageCartListItemInfo
    }
    targetCart {
      id
      itemCount
    }
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;
export type CartPageCartListMoveAllLinesToCartMutationFn = Apollo.MutationFunction<CartPageCartListMoveAllLinesToCartMutation, CartPageCartListMoveAllLinesToCartMutationVariables>;

/**
 * __useCartPageCartListMoveAllLinesToCartMutation__
 *
 * To run a mutation, you first call `useCartPageCartListMoveAllLinesToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartListMoveAllLinesToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartListMoveAllLinesToCartMutation, { data, loading, error }] = useCartPageCartListMoveAllLinesToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartListMoveAllLinesToCartMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartListMoveAllLinesToCartMutation, CartPageCartListMoveAllLinesToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartListMoveAllLinesToCartMutation, CartPageCartListMoveAllLinesToCartMutationVariables>(CartPageCartListMoveAllLinesToCartDocument, options);
      }
export type CartPageCartListMoveAllLinesToCartMutationHookResult = ReturnType<typeof useCartPageCartListMoveAllLinesToCartMutation>;
export type CartPageCartListMoveAllLinesToCartMutationResult = Apollo.MutationResult<CartPageCartListMoveAllLinesToCartMutation>;
export type CartPageCartListMoveAllLinesToCartMutationOptions = Apollo.BaseMutationOptions<CartPageCartListMoveAllLinesToCartMutation, CartPageCartListMoveAllLinesToCartMutationVariables>;
export const GetCartPageCartPagePermissionsDocument = gql`
    query GetCartPageCartPagePermissions {
  viewerPermissions {
    id
    canViewCart
  }
}
    `;

/**
 * __useGetCartPageCartPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>(GetCartPageCartPagePermissionsDocument, options);
      }
export function useGetCartPageCartPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>(GetCartPageCartPagePermissionsDocument, options);
        }
export function useGetCartPageCartPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>(GetCartPageCartPagePermissionsDocument, options);
        }
export type GetCartPageCartPagePermissionsQueryHookResult = ReturnType<typeof useGetCartPageCartPagePermissionsQuery>;
export type GetCartPageCartPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageCartPagePermissionsLazyQuery>;
export type GetCartPageCartPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartPagePermissionsSuspenseQuery>;
export type GetCartPageCartPagePermissionsQueryResult = Apollo.QueryResult<GetCartPageCartPagePermissionsQuery, GetCartPageCartPagePermissionsQueryVariables>;
export const GetCartPageCartPageCartDocument = gql`
    query GetCartPageCartPageCart {
  viewer {
    id
    scheduledOrder {
      ...CartPageCartPageScheduledOrderInfo
    }
  }
  cart {
    ...CartPageCartPageCartInfo
  }
}
    ${CartPageCartPageScheduledOrderInfoFragmentDoc}
${CartPageCartPageCartInfoFragmentDoc}`;

/**
 * __useGetCartPageCartPageCartQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartPageCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartPageCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartPageCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartPageCartQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>(GetCartPageCartPageCartDocument, options);
      }
export function useGetCartPageCartPageCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>(GetCartPageCartPageCartDocument, options);
        }
export function useGetCartPageCartPageCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>(GetCartPageCartPageCartDocument, options);
        }
export type GetCartPageCartPageCartQueryHookResult = ReturnType<typeof useGetCartPageCartPageCartQuery>;
export type GetCartPageCartPageCartLazyQueryHookResult = ReturnType<typeof useGetCartPageCartPageCartLazyQuery>;
export type GetCartPageCartPageCartSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartPageCartSuspenseQuery>;
export type GetCartPageCartPageCartQueryResult = Apollo.QueryResult<GetCartPageCartPageCartQuery, GetCartPageCartPageCartQueryVariables>;
export const CartPageCartPageDeleteAllCartLinesDocument = gql`
    mutation CartPageCartPageDeleteAllCartLines($input: DeleteAllCartLinesInput!) {
  deleteAllCartLines(input: $input) {
    cart {
      ...CartPageCartPageCartInfo
    }
  }
}
    ${CartPageCartPageCartInfoFragmentDoc}`;
export type CartPageCartPageDeleteAllCartLinesMutationFn = Apollo.MutationFunction<CartPageCartPageDeleteAllCartLinesMutation, CartPageCartPageDeleteAllCartLinesMutationVariables>;

/**
 * __useCartPageCartPageDeleteAllCartLinesMutation__
 *
 * To run a mutation, you first call `useCartPageCartPageDeleteAllCartLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartPageDeleteAllCartLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartPageDeleteAllCartLinesMutation, { data, loading, error }] = useCartPageCartPageDeleteAllCartLinesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartPageDeleteAllCartLinesMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartPageDeleteAllCartLinesMutation, CartPageCartPageDeleteAllCartLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartPageDeleteAllCartLinesMutation, CartPageCartPageDeleteAllCartLinesMutationVariables>(CartPageCartPageDeleteAllCartLinesDocument, options);
      }
export type CartPageCartPageDeleteAllCartLinesMutationHookResult = ReturnType<typeof useCartPageCartPageDeleteAllCartLinesMutation>;
export type CartPageCartPageDeleteAllCartLinesMutationResult = Apollo.MutationResult<CartPageCartPageDeleteAllCartLinesMutation>;
export type CartPageCartPageDeleteAllCartLinesMutationOptions = Apollo.BaseMutationOptions<CartPageCartPageDeleteAllCartLinesMutation, CartPageCartPageDeleteAllCartLinesMutationVariables>;
export const CartPageCartPageUpdateScheduledOrderDocument = gql`
    mutation CartPageCartPageUpdateScheduledOrder($input: UpdateScheduledOrderInput!) {
  updateScheduledOrder(input: $input) {
    scheduledOrder {
      ...CartPageCartPageScheduledOrderInfo
    }
    cart {
      ...CartPageCartPageCartInfo
    }
  }
}
    ${CartPageCartPageScheduledOrderInfoFragmentDoc}
${CartPageCartPageCartInfoFragmentDoc}`;
export type CartPageCartPageUpdateScheduledOrderMutationFn = Apollo.MutationFunction<CartPageCartPageUpdateScheduledOrderMutation, CartPageCartPageUpdateScheduledOrderMutationVariables>;

/**
 * __useCartPageCartPageUpdateScheduledOrderMutation__
 *
 * To run a mutation, you first call `useCartPageCartPageUpdateScheduledOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartPageUpdateScheduledOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartPageUpdateScheduledOrderMutation, { data, loading, error }] = useCartPageCartPageUpdateScheduledOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartPageCartPageUpdateScheduledOrderMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartPageUpdateScheduledOrderMutation, CartPageCartPageUpdateScheduledOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartPageUpdateScheduledOrderMutation, CartPageCartPageUpdateScheduledOrderMutationVariables>(CartPageCartPageUpdateScheduledOrderDocument, options);
      }
export type CartPageCartPageUpdateScheduledOrderMutationHookResult = ReturnType<typeof useCartPageCartPageUpdateScheduledOrderMutation>;
export type CartPageCartPageUpdateScheduledOrderMutationResult = Apollo.MutationResult<CartPageCartPageUpdateScheduledOrderMutation>;
export type CartPageCartPageUpdateScheduledOrderMutationOptions = Apollo.BaseMutationOptions<CartPageCartPageUpdateScheduledOrderMutation, CartPageCartPageUpdateScheduledOrderMutationVariables>;
export const GetCartPageCartSearchPagePermissionsDocument = gql`
    query GetCartPageCartSearchPagePermissions {
  viewerPermissions {
    id
    canViewConsultantCarts
  }
}
    `;

/**
 * __useGetCartPageCartSearchPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartSearchPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartSearchPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartSearchPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartSearchPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>(GetCartPageCartSearchPagePermissionsDocument, options);
      }
export function useGetCartPageCartSearchPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>(GetCartPageCartSearchPagePermissionsDocument, options);
        }
export function useGetCartPageCartSearchPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>(GetCartPageCartSearchPagePermissionsDocument, options);
        }
export type GetCartPageCartSearchPagePermissionsQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPagePermissionsQuery>;
export type GetCartPageCartSearchPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPagePermissionsLazyQuery>;
export type GetCartPageCartSearchPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPagePermissionsSuspenseQuery>;
export type GetCartPageCartSearchPagePermissionsQueryResult = Apollo.QueryResult<GetCartPageCartSearchPagePermissionsQuery, GetCartPageCartSearchPagePermissionsQueryVariables>;
export const GetCartPageCartSearchPageCustomersWithCartsCountDocument = gql`
    query GetCartPageCartSearchPageCustomersWithCartsCount {
  customersWithCart {
    id
  }
}
    `;

/**
 * __useGetCartPageCartSearchPageCustomersWithCartsCountQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartSearchPageCustomersWithCartsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartSearchPageCustomersWithCartsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartSearchPageCustomersWithCartsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartSearchPageCustomersWithCartsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>(GetCartPageCartSearchPageCustomersWithCartsCountDocument, options);
      }
export function useGetCartPageCartSearchPageCustomersWithCartsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>(GetCartPageCartSearchPageCustomersWithCartsCountDocument, options);
        }
export function useGetCartPageCartSearchPageCustomersWithCartsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>(GetCartPageCartSearchPageCustomersWithCartsCountDocument, options);
        }
export type GetCartPageCartSearchPageCustomersWithCartsCountQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCustomersWithCartsCountQuery>;
export type GetCartPageCartSearchPageCustomersWithCartsCountLazyQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCustomersWithCartsCountLazyQuery>;
export type GetCartPageCartSearchPageCustomersWithCartsCountSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCustomersWithCartsCountSuspenseQuery>;
export type GetCartPageCartSearchPageCustomersWithCartsCountQueryResult = Apollo.QueryResult<GetCartPageCartSearchPageCustomersWithCartsCountQuery, GetCartPageCartSearchPageCustomersWithCartsCountQueryVariables>;
export const GetCartPageCartSearchPageCartDocument = gql`
    query GetCartPageCartSearchPageCart($userId: ID!) {
  cartByUserId(userId: $userId) {
    ...CartPageCartListItemInfo
  }
}
    ${CartPageCartListItemInfoFragmentDoc}`;

/**
 * __useGetCartPageCartSearchPageCartQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartSearchPageCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartSearchPageCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartSearchPageCartQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCartPageCartSearchPageCartQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables> & ({ variables: GetCartPageCartSearchPageCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables>(GetCartPageCartSearchPageCartDocument, options);
      }
export function useGetCartPageCartSearchPageCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables>(GetCartPageCartSearchPageCartDocument, options);
        }
export function useGetCartPageCartSearchPageCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables>(GetCartPageCartSearchPageCartDocument, options);
        }
export type GetCartPageCartSearchPageCartQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCartQuery>;
export type GetCartPageCartSearchPageCartLazyQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCartLazyQuery>;
export type GetCartPageCartSearchPageCartSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCartSuspenseQuery>;
export type GetCartPageCartSearchPageCartQueryResult = Apollo.QueryResult<GetCartPageCartSearchPageCartQuery, GetCartPageCartSearchPageCartQueryVariables>;
export const GetCartPageCartSearchPageCustomersWithCartsDocument = gql`
    query GetCartPageCartSearchPageCustomersWithCarts {
  customersWithCart {
    id
    cartItemCount
    scheduledOrder {
      id
    }
  }
}
    `;

/**
 * __useGetCartPageCartSearchPageCustomersWithCartsQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartSearchPageCustomersWithCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartSearchPageCustomersWithCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartSearchPageCustomersWithCartsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartSearchPageCustomersWithCartsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>(GetCartPageCartSearchPageCustomersWithCartsDocument, options);
      }
export function useGetCartPageCartSearchPageCustomersWithCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>(GetCartPageCartSearchPageCustomersWithCartsDocument, options);
        }
export function useGetCartPageCartSearchPageCustomersWithCartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>(GetCartPageCartSearchPageCustomersWithCartsDocument, options);
        }
export type GetCartPageCartSearchPageCustomersWithCartsQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCustomersWithCartsQuery>;
export type GetCartPageCartSearchPageCustomersWithCartsLazyQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCustomersWithCartsLazyQuery>;
export type GetCartPageCartSearchPageCustomersWithCartsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartSearchPageCustomersWithCartsSuspenseQuery>;
export type GetCartPageCartSearchPageCustomersWithCartsQueryResult = Apollo.QueryResult<GetCartPageCartSearchPageCustomersWithCartsQuery, GetCartPageCartSearchPageCustomersWithCartsQueryVariables>;
export const GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutDocument = gql`
    query GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckout {
  viewerPermissions {
    id
    canSubmitOrderForApprovalBypassCheckout
  }
}
    `;

/**
 * __useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>(GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutDocument, options);
      }
export function useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>(GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutDocument, options);
        }
export function useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>(GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutDocument, options);
        }
export type GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryHookResult = ReturnType<typeof useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery>;
export type GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutLazyQueryHookResult = ReturnType<typeof useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutLazyQuery>;
export type GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutSuspenseQuery>;
export type GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryResult = Apollo.QueryResult<GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQuery, GetCartPageCartSummaryCanSubmitOrderForApprovalBypassCheckoutQueryVariables>;
export const GetCartPageCartSummaryCanCheckoutDocument = gql`
    query GetCartPageCartSummaryCanCheckout {
  viewerPermissions {
    id
    canCheckout
  }
}
    `;

/**
 * __useGetCartPageCartSummaryCanCheckoutQuery__
 *
 * To run a query within a React component, call `useGetCartPageCartSummaryCanCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageCartSummaryCanCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageCartSummaryCanCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageCartSummaryCanCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>(GetCartPageCartSummaryCanCheckoutDocument, options);
      }
export function useGetCartPageCartSummaryCanCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>(GetCartPageCartSummaryCanCheckoutDocument, options);
        }
export function useGetCartPageCartSummaryCanCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>(GetCartPageCartSummaryCanCheckoutDocument, options);
        }
export type GetCartPageCartSummaryCanCheckoutQueryHookResult = ReturnType<typeof useGetCartPageCartSummaryCanCheckoutQuery>;
export type GetCartPageCartSummaryCanCheckoutLazyQueryHookResult = ReturnType<typeof useGetCartPageCartSummaryCanCheckoutLazyQuery>;
export type GetCartPageCartSummaryCanCheckoutSuspenseQueryHookResult = ReturnType<typeof useGetCartPageCartSummaryCanCheckoutSuspenseQuery>;
export type GetCartPageCartSummaryCanCheckoutQueryResult = Apollo.QueryResult<GetCartPageCartSummaryCanCheckoutQuery, GetCartPageCartSummaryCanCheckoutQueryVariables>;
export const CartPageCartSummaryCancelScheduledOrderDocument = gql`
    mutation CartPageCartSummaryCancelScheduledOrder {
  cancelScheduledOrder {
    id
  }
}
    `;
export type CartPageCartSummaryCancelScheduledOrderMutationFn = Apollo.MutationFunction<CartPageCartSummaryCancelScheduledOrderMutation, CartPageCartSummaryCancelScheduledOrderMutationVariables>;

/**
 * __useCartPageCartSummaryCancelScheduledOrderMutation__
 *
 * To run a mutation, you first call `useCartPageCartSummaryCancelScheduledOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartPageCartSummaryCancelScheduledOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartPageCartSummaryCancelScheduledOrderMutation, { data, loading, error }] = useCartPageCartSummaryCancelScheduledOrderMutation({
 *   variables: {
 *   },
 * });
 */
export function useCartPageCartSummaryCancelScheduledOrderMutation(baseOptions?: Apollo.MutationHookOptions<CartPageCartSummaryCancelScheduledOrderMutation, CartPageCartSummaryCancelScheduledOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartPageCartSummaryCancelScheduledOrderMutation, CartPageCartSummaryCancelScheduledOrderMutationVariables>(CartPageCartSummaryCancelScheduledOrderDocument, options);
      }
export type CartPageCartSummaryCancelScheduledOrderMutationHookResult = ReturnType<typeof useCartPageCartSummaryCancelScheduledOrderMutation>;
export type CartPageCartSummaryCancelScheduledOrderMutationResult = Apollo.MutationResult<CartPageCartSummaryCancelScheduledOrderMutation>;
export type CartPageCartSummaryCancelScheduledOrderMutationOptions = Apollo.BaseMutationOptions<CartPageCartSummaryCancelScheduledOrderMutation, CartPageCartSummaryCancelScheduledOrderMutationVariables>;
export const GetCartPageDotCartsPagePermissionsDocument = gql`
    query GetCartPageDotCartsPagePermissions {
  viewerPermissions {
    id
    canViewConsultantCarts
  }
}
    `;

/**
 * __useGetCartPageDotCartsPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageDotCartsPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageDotCartsPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageDotCartsPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageDotCartsPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>(GetCartPageDotCartsPagePermissionsDocument, options);
      }
export function useGetCartPageDotCartsPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>(GetCartPageDotCartsPagePermissionsDocument, options);
        }
export function useGetCartPageDotCartsPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>(GetCartPageDotCartsPagePermissionsDocument, options);
        }
export type GetCartPageDotCartsPagePermissionsQueryHookResult = ReturnType<typeof useGetCartPageDotCartsPagePermissionsQuery>;
export type GetCartPageDotCartsPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageDotCartsPagePermissionsLazyQuery>;
export type GetCartPageDotCartsPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageDotCartsPagePermissionsSuspenseQuery>;
export type GetCartPageDotCartsPagePermissionsQueryResult = Apollo.QueryResult<GetCartPageDotCartsPagePermissionsQuery, GetCartPageDotCartsPagePermissionsQueryVariables>;
export const GetCartPageDotCartsPageConsultantCartsDocument = gql`
    query GetCartPageDotCartsPageConsultantCarts($paging: PagingInput!) {
  consultantCarts {
    cartsCount
    cartHeaders(paging: $paging) {
      ...CartPageCartListHeaderWithEmployeeInfo
    }
  }
}
    ${CartPageCartListHeaderWithEmployeeInfoFragmentDoc}`;

/**
 * __useGetCartPageDotCartsPageConsultantCartsQuery__
 *
 * To run a query within a React component, call `useGetCartPageDotCartsPageConsultantCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageDotCartsPageConsultantCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageDotCartsPageConsultantCartsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCartPageDotCartsPageConsultantCartsQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables> & ({ variables: GetCartPageDotCartsPageConsultantCartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables>(GetCartPageDotCartsPageConsultantCartsDocument, options);
      }
export function useGetCartPageDotCartsPageConsultantCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables>(GetCartPageDotCartsPageConsultantCartsDocument, options);
        }
export function useGetCartPageDotCartsPageConsultantCartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables>(GetCartPageDotCartsPageConsultantCartsDocument, options);
        }
export type GetCartPageDotCartsPageConsultantCartsQueryHookResult = ReturnType<typeof useGetCartPageDotCartsPageConsultantCartsQuery>;
export type GetCartPageDotCartsPageConsultantCartsLazyQueryHookResult = ReturnType<typeof useGetCartPageDotCartsPageConsultantCartsLazyQuery>;
export type GetCartPageDotCartsPageConsultantCartsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageDotCartsPageConsultantCartsSuspenseQuery>;
export type GetCartPageDotCartsPageConsultantCartsQueryResult = Apollo.QueryResult<GetCartPageDotCartsPageConsultantCartsQuery, GetCartPageDotCartsPageConsultantCartsQueryVariables>;
export const GetCartPageJewelerShowcaseCartsPagePermissionsDocument = gql`
    query GetCartPageJewelerShowcaseCartsPagePermissions {
  viewerPermissions {
    id
    canViewJewelerShowcaseRequests
  }
}
    `;

/**
 * __useGetCartPageJewelerShowcaseCartsPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageJewelerShowcaseCartsPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageJewelerShowcaseCartsPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageJewelerShowcaseCartsPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageJewelerShowcaseCartsPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>(GetCartPageJewelerShowcaseCartsPagePermissionsDocument, options);
      }
export function useGetCartPageJewelerShowcaseCartsPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>(GetCartPageJewelerShowcaseCartsPagePermissionsDocument, options);
        }
export function useGetCartPageJewelerShowcaseCartsPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>(GetCartPageJewelerShowcaseCartsPagePermissionsDocument, options);
        }
export type GetCartPageJewelerShowcaseCartsPagePermissionsQueryHookResult = ReturnType<typeof useGetCartPageJewelerShowcaseCartsPagePermissionsQuery>;
export type GetCartPageJewelerShowcaseCartsPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageJewelerShowcaseCartsPagePermissionsLazyQuery>;
export type GetCartPageJewelerShowcaseCartsPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageJewelerShowcaseCartsPagePermissionsSuspenseQuery>;
export type GetCartPageJewelerShowcaseCartsPagePermissionsQueryResult = Apollo.QueryResult<GetCartPageJewelerShowcaseCartsPagePermissionsQuery, GetCartPageJewelerShowcaseCartsPagePermissionsQueryVariables>;
export const GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsDocument = gql`
    query GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequests($paging: PagingInput!) {
  pendingJewelerShowcaseCallbackRequests(onlyRecent: false) {
    results(paging: $paging) {
      ...CartPageJewelerShowcaseCartsPageCallbackRequestInfo
    }
    count
  }
}
    ${CartPageJewelerShowcaseCartsPageCallbackRequestInfoFragmentDoc}`;

/**
 * __useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery__
 *
 * To run a query within a React component, call `useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables> & ({ variables: GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables>(GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsDocument, options);
      }
export function useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables>(GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsDocument, options);
        }
export function useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables>(GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsDocument, options);
        }
export type GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryHookResult = ReturnType<typeof useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery>;
export type GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsLazyQueryHookResult = ReturnType<typeof useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsLazyQuery>;
export type GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsSuspenseQuery>;
export type GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryResult = Apollo.QueryResult<GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQuery, GetCartPageJewelerShowcaseCartsPagePendingJewelerShowcaseRequestsQueryVariables>;
export const GetCartPageSavedItemsPagePermissionsDocument = gql`
    query GetCartPageSavedItemsPagePermissions {
  viewerPermissions {
    id
    canSaveCartItems
  }
}
    `;

/**
 * __useGetCartPageSavedItemsPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageSavedItemsPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageSavedItemsPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageSavedItemsPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageSavedItemsPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>(GetCartPageSavedItemsPagePermissionsDocument, options);
      }
export function useGetCartPageSavedItemsPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>(GetCartPageSavedItemsPagePermissionsDocument, options);
        }
export function useGetCartPageSavedItemsPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>(GetCartPageSavedItemsPagePermissionsDocument, options);
        }
export type GetCartPageSavedItemsPagePermissionsQueryHookResult = ReturnType<typeof useGetCartPageSavedItemsPagePermissionsQuery>;
export type GetCartPageSavedItemsPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageSavedItemsPagePermissionsLazyQuery>;
export type GetCartPageSavedItemsPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageSavedItemsPagePermissionsSuspenseQuery>;
export type GetCartPageSavedItemsPagePermissionsQueryResult = Apollo.QueryResult<GetCartPageSavedItemsPagePermissionsQuery, GetCartPageSavedItemsPagePermissionsQueryVariables>;
export const GetCartPageSavedItemsPageCartLinesDocument = gql`
    query GetCartPageSavedItemsPageCartLines($paging: PagingInput!) {
  savedCartLines {
    count
    results(paging: $paging) {
      ...CartPageCartItemInfo
    }
  }
}
    ${CartPageCartItemInfoFragmentDoc}`;

/**
 * __useGetCartPageSavedItemsPageCartLinesQuery__
 *
 * To run a query within a React component, call `useGetCartPageSavedItemsPageCartLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageSavedItemsPageCartLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageSavedItemsPageCartLinesQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCartPageSavedItemsPageCartLinesQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables> & ({ variables: GetCartPageSavedItemsPageCartLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables>(GetCartPageSavedItemsPageCartLinesDocument, options);
      }
export function useGetCartPageSavedItemsPageCartLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables>(GetCartPageSavedItemsPageCartLinesDocument, options);
        }
export function useGetCartPageSavedItemsPageCartLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables>(GetCartPageSavedItemsPageCartLinesDocument, options);
        }
export type GetCartPageSavedItemsPageCartLinesQueryHookResult = ReturnType<typeof useGetCartPageSavedItemsPageCartLinesQuery>;
export type GetCartPageSavedItemsPageCartLinesLazyQueryHookResult = ReturnType<typeof useGetCartPageSavedItemsPageCartLinesLazyQuery>;
export type GetCartPageSavedItemsPageCartLinesSuspenseQueryHookResult = ReturnType<typeof useGetCartPageSavedItemsPageCartLinesSuspenseQuery>;
export type GetCartPageSavedItemsPageCartLinesQueryResult = Apollo.QueryResult<GetCartPageSavedItemsPageCartLinesQuery, GetCartPageSavedItemsPageCartLinesQueryVariables>;
export const GetCartPageNavigationDocument = gql`
    query GetCartPageNavigation {
  viewerPermissions {
    id
    canAddToFavorites
    canSaveCartItems
    canViewConsultantCarts
    canViewJewelerShowcaseRequests
    canViewShowcaseOnlyUsers
    canViewCart
  }
  cartItemCount
  savedCartLines {
    count
  }
  showcaseOnlyCarts {
    count
  }
  consultantCarts {
    cartLineCount
  }
  pendingJewelerShowcaseCallbackRequests(onlyRecent: false) {
    count
  }
  viewer {
    id
    scheduledOrder {
      id
    }
  }
  customersWithCart {
    id
  }
}
    `;

/**
 * __useGetCartPageNavigationQuery__
 *
 * To run a query within a React component, call `useGetCartPageNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageNavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageNavigationQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>(GetCartPageNavigationDocument, options);
      }
export function useGetCartPageNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>(GetCartPageNavigationDocument, options);
        }
export function useGetCartPageNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>(GetCartPageNavigationDocument, options);
        }
export type GetCartPageNavigationQueryHookResult = ReturnType<typeof useGetCartPageNavigationQuery>;
export type GetCartPageNavigationLazyQueryHookResult = ReturnType<typeof useGetCartPageNavigationLazyQuery>;
export type GetCartPageNavigationSuspenseQueryHookResult = ReturnType<typeof useGetCartPageNavigationSuspenseQuery>;
export type GetCartPageNavigationQueryResult = Apollo.QueryResult<GetCartPageNavigationQuery, GetCartPageNavigationQueryVariables>;
export const GetCartPageSubCartsPagePermissionsDocument = gql`
    query GetCartPageSubCartsPagePermissions {
  viewerPermissions {
    id
    canViewShowcaseOnlyUsers
  }
}
    `;

/**
 * __useGetCartPageSubCartsPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetCartPageSubCartsPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageSubCartsPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageSubCartsPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCartPageSubCartsPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>(GetCartPageSubCartsPagePermissionsDocument, options);
      }
export function useGetCartPageSubCartsPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>(GetCartPageSubCartsPagePermissionsDocument, options);
        }
export function useGetCartPageSubCartsPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>(GetCartPageSubCartsPagePermissionsDocument, options);
        }
export type GetCartPageSubCartsPagePermissionsQueryHookResult = ReturnType<typeof useGetCartPageSubCartsPagePermissionsQuery>;
export type GetCartPageSubCartsPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetCartPageSubCartsPagePermissionsLazyQuery>;
export type GetCartPageSubCartsPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageSubCartsPagePermissionsSuspenseQuery>;
export type GetCartPageSubCartsPagePermissionsQueryResult = Apollo.QueryResult<GetCartPageSubCartsPagePermissionsQuery, GetCartPageSubCartsPagePermissionsQueryVariables>;
export const GetCartPageSubCartsPageShowcaseOnlyCartsDocument = gql`
    query GetCartPageSubCartsPageShowcaseOnlyCarts($paging: PagingInput!) {
  showcaseOnlyCarts {
    count
    cartHeaders(paging: $paging) {
      ...CartPageCartListHeaderInfo
    }
  }
}
    ${CartPageCartListHeaderInfoFragmentDoc}`;

/**
 * __useGetCartPageSubCartsPageShowcaseOnlyCartsQuery__
 *
 * To run a query within a React component, call `useGetCartPageSubCartsPageShowcaseOnlyCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartPageSubCartsPageShowcaseOnlyCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartPageSubCartsPageShowcaseOnlyCartsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetCartPageSubCartsPageShowcaseOnlyCartsQuery(baseOptions: Apollo.QueryHookOptions<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables> & ({ variables: GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables>(GetCartPageSubCartsPageShowcaseOnlyCartsDocument, options);
      }
export function useGetCartPageSubCartsPageShowcaseOnlyCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables>(GetCartPageSubCartsPageShowcaseOnlyCartsDocument, options);
        }
export function useGetCartPageSubCartsPageShowcaseOnlyCartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables>(GetCartPageSubCartsPageShowcaseOnlyCartsDocument, options);
        }
export type GetCartPageSubCartsPageShowcaseOnlyCartsQueryHookResult = ReturnType<typeof useGetCartPageSubCartsPageShowcaseOnlyCartsQuery>;
export type GetCartPageSubCartsPageShowcaseOnlyCartsLazyQueryHookResult = ReturnType<typeof useGetCartPageSubCartsPageShowcaseOnlyCartsLazyQuery>;
export type GetCartPageSubCartsPageShowcaseOnlyCartsSuspenseQueryHookResult = ReturnType<typeof useGetCartPageSubCartsPageShowcaseOnlyCartsSuspenseQuery>;
export type GetCartPageSubCartsPageShowcaseOnlyCartsQueryResult = Apollo.QueryResult<GetCartPageSubCartsPageShowcaseOnlyCartsQuery, GetCartPageSubCartsPageShowcaseOnlyCartsQueryVariables>;
export const GetCategoryPageActiveCategoryBySanitizedPathDocument = gql`
    query GetCategoryPageActiveCategoryBySanitizedPath($sanitizedPath: String!) {
  activeCategoryBySanitizedPath(sanitizedPath: $sanitizedPath) {
    id
    pageTitle
    pageHeader
    pageMetaDescription
    overrideUrl
    ancestors {
      id
      name
    }
    displayTemplate
    contentId
    showProducts
    hideSideNav
  }
}
    `;

/**
 * __useGetCategoryPageActiveCategoryBySanitizedPathQuery__
 *
 * To run a query within a React component, call `useGetCategoryPageActiveCategoryBySanitizedPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryPageActiveCategoryBySanitizedPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryPageActiveCategoryBySanitizedPathQuery({
 *   variables: {
 *      sanitizedPath: // value for 'sanitizedPath'
 *   },
 * });
 */
export function useGetCategoryPageActiveCategoryBySanitizedPathQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables> & ({ variables: GetCategoryPageActiveCategoryBySanitizedPathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables>(GetCategoryPageActiveCategoryBySanitizedPathDocument, options);
      }
export function useGetCategoryPageActiveCategoryBySanitizedPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables>(GetCategoryPageActiveCategoryBySanitizedPathDocument, options);
        }
export function useGetCategoryPageActiveCategoryBySanitizedPathSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables>(GetCategoryPageActiveCategoryBySanitizedPathDocument, options);
        }
export type GetCategoryPageActiveCategoryBySanitizedPathQueryHookResult = ReturnType<typeof useGetCategoryPageActiveCategoryBySanitizedPathQuery>;
export type GetCategoryPageActiveCategoryBySanitizedPathLazyQueryHookResult = ReturnType<typeof useGetCategoryPageActiveCategoryBySanitizedPathLazyQuery>;
export type GetCategoryPageActiveCategoryBySanitizedPathSuspenseQueryHookResult = ReturnType<typeof useGetCategoryPageActiveCategoryBySanitizedPathSuspenseQuery>;
export type GetCategoryPageActiveCategoryBySanitizedPathQueryResult = Apollo.QueryResult<GetCategoryPageActiveCategoryBySanitizedPathQuery, GetCategoryPageActiveCategoryBySanitizedPathQueryVariables>;
export const GetCmsContentContentByIdDocument = gql`
    query GetCmsContentContentById($id: ID!, $options: CmsOptionsInput) {
  cmsContentById(contentContainerId: $id, options: $options) {
    ...CmsContentContentInfo
  }
}
    ${CmsContentContentInfoFragmentDoc}`;

/**
 * __useGetCmsContentContentByIdQuery__
 *
 * To run a query within a React component, call `useGetCmsContentContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsContentContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsContentContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetCmsContentContentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables> & ({ variables: GetCmsContentContentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables>(GetCmsContentContentByIdDocument, options);
      }
export function useGetCmsContentContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables>(GetCmsContentContentByIdDocument, options);
        }
export function useGetCmsContentContentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables>(GetCmsContentContentByIdDocument, options);
        }
export type GetCmsContentContentByIdQueryHookResult = ReturnType<typeof useGetCmsContentContentByIdQuery>;
export type GetCmsContentContentByIdLazyQueryHookResult = ReturnType<typeof useGetCmsContentContentByIdLazyQuery>;
export type GetCmsContentContentByIdSuspenseQueryHookResult = ReturnType<typeof useGetCmsContentContentByIdSuspenseQuery>;
export type GetCmsContentContentByIdQueryResult = Apollo.QueryResult<GetCmsContentContentByIdQuery, GetCmsContentContentByIdQueryVariables>;
export const GetCmsContentContentByNameDocument = gql`
    query GetCmsContentContentByName($name: String!, $options: CmsOptionsInput) {
  cmsContentByName(contentContainerName: $name, options: $options) {
    ...CmsContentContentInfo
  }
}
    ${CmsContentContentInfoFragmentDoc}`;

/**
 * __useGetCmsContentContentByNameQuery__
 *
 * To run a query within a React component, call `useGetCmsContentContentByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsContentContentByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsContentContentByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetCmsContentContentByNameQuery(baseOptions: Apollo.QueryHookOptions<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables> & ({ variables: GetCmsContentContentByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables>(GetCmsContentContentByNameDocument, options);
      }
export function useGetCmsContentContentByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables>(GetCmsContentContentByNameDocument, options);
        }
export function useGetCmsContentContentByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables>(GetCmsContentContentByNameDocument, options);
        }
export type GetCmsContentContentByNameQueryHookResult = ReturnType<typeof useGetCmsContentContentByNameQuery>;
export type GetCmsContentContentByNameLazyQueryHookResult = ReturnType<typeof useGetCmsContentContentByNameLazyQuery>;
export type GetCmsContentContentByNameSuspenseQueryHookResult = ReturnType<typeof useGetCmsContentContentByNameSuspenseQuery>;
export type GetCmsContentContentByNameQueryResult = Apollo.QueryResult<GetCmsContentContentByNameQuery, GetCmsContentContentByNameQueryVariables>;
export const GetConsultantModeNavInfoDocument = gql`
    query GetConsultantModeNavInfo {
  authUser {
    id
    consultantInfo {
      employee {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useGetConsultantModeNavInfoQuery__
 *
 * To run a query within a React component, call `useGetConsultantModeNavInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantModeNavInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantModeNavInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConsultantModeNavInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>(GetConsultantModeNavInfoDocument, options);
      }
export function useGetConsultantModeNavInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>(GetConsultantModeNavInfoDocument, options);
        }
export function useGetConsultantModeNavInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>(GetConsultantModeNavInfoDocument, options);
        }
export type GetConsultantModeNavInfoQueryHookResult = ReturnType<typeof useGetConsultantModeNavInfoQuery>;
export type GetConsultantModeNavInfoLazyQueryHookResult = ReturnType<typeof useGetConsultantModeNavInfoLazyQuery>;
export type GetConsultantModeNavInfoSuspenseQueryHookResult = ReturnType<typeof useGetConsultantModeNavInfoSuspenseQuery>;
export type GetConsultantModeNavInfoQueryResult = Apollo.QueryResult<GetConsultantModeNavInfoQuery, GetConsultantModeNavInfoQueryVariables>;
export const GetConsultantModeNavDotQuickLinksDocument = gql`
    query GetConsultantModeNavDotQuickLinks {
  cmsLookupsByType(type: "DOTQuickLinks") {
    id
    url: code
    title: value
  }
}
    `;

/**
 * __useGetConsultantModeNavDotQuickLinksQuery__
 *
 * To run a query within a React component, call `useGetConsultantModeNavDotQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsultantModeNavDotQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsultantModeNavDotQuickLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConsultantModeNavDotQuickLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>(GetConsultantModeNavDotQuickLinksDocument, options);
      }
export function useGetConsultantModeNavDotQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>(GetConsultantModeNavDotQuickLinksDocument, options);
        }
export function useGetConsultantModeNavDotQuickLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>(GetConsultantModeNavDotQuickLinksDocument, options);
        }
export type GetConsultantModeNavDotQuickLinksQueryHookResult = ReturnType<typeof useGetConsultantModeNavDotQuickLinksQuery>;
export type GetConsultantModeNavDotQuickLinksLazyQueryHookResult = ReturnType<typeof useGetConsultantModeNavDotQuickLinksLazyQuery>;
export type GetConsultantModeNavDotQuickLinksSuspenseQueryHookResult = ReturnType<typeof useGetConsultantModeNavDotQuickLinksSuspenseQuery>;
export type GetConsultantModeNavDotQuickLinksQueryResult = Apollo.QueryResult<GetConsultantModeNavDotQuickLinksQuery, GetConsultantModeNavDotQuickLinksQueryVariables>;
export const GetContactFormsAccountSignupPrimaryRolesDocument = gql`
    query GetContactFormsAccountSignupPrimaryRoles {
  cmsLookupsByType(type: "Account-Signup-Primary-Roles") {
    id
    name: code
    title: value
  }
}
    `;

/**
 * __useGetContactFormsAccountSignupPrimaryRolesQuery__
 *
 * To run a query within a React component, call `useGetContactFormsAccountSignupPrimaryRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactFormsAccountSignupPrimaryRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactFormsAccountSignupPrimaryRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactFormsAccountSignupPrimaryRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>(GetContactFormsAccountSignupPrimaryRolesDocument, options);
      }
export function useGetContactFormsAccountSignupPrimaryRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>(GetContactFormsAccountSignupPrimaryRolesDocument, options);
        }
export function useGetContactFormsAccountSignupPrimaryRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>(GetContactFormsAccountSignupPrimaryRolesDocument, options);
        }
export type GetContactFormsAccountSignupPrimaryRolesQueryHookResult = ReturnType<typeof useGetContactFormsAccountSignupPrimaryRolesQuery>;
export type GetContactFormsAccountSignupPrimaryRolesLazyQueryHookResult = ReturnType<typeof useGetContactFormsAccountSignupPrimaryRolesLazyQuery>;
export type GetContactFormsAccountSignupPrimaryRolesSuspenseQueryHookResult = ReturnType<typeof useGetContactFormsAccountSignupPrimaryRolesSuspenseQuery>;
export type GetContactFormsAccountSignupPrimaryRolesQueryResult = Apollo.QueryResult<GetContactFormsAccountSignupPrimaryRolesQuery, GetContactFormsAccountSignupPrimaryRolesQueryVariables>;
export const GetContactFormsCanDeactivateContactDocument = gql`
    query GetContactFormsCanDeactivateContact($shipToAccountNumber: ID!, $contactId: ID!) {
  canDeactivateContact(
    shipToAccountNumber: $shipToAccountNumber
    contactId: $contactId
  )
}
    `;

/**
 * __useGetContactFormsCanDeactivateContactQuery__
 *
 * To run a query within a React component, call `useGetContactFormsCanDeactivateContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactFormsCanDeactivateContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactFormsCanDeactivateContactQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactFormsCanDeactivateContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables> & ({ variables: GetContactFormsCanDeactivateContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables>(GetContactFormsCanDeactivateContactDocument, options);
      }
export function useGetContactFormsCanDeactivateContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables>(GetContactFormsCanDeactivateContactDocument, options);
        }
export function useGetContactFormsCanDeactivateContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables>(GetContactFormsCanDeactivateContactDocument, options);
        }
export type GetContactFormsCanDeactivateContactQueryHookResult = ReturnType<typeof useGetContactFormsCanDeactivateContactQuery>;
export type GetContactFormsCanDeactivateContactLazyQueryHookResult = ReturnType<typeof useGetContactFormsCanDeactivateContactLazyQuery>;
export type GetContactFormsCanDeactivateContactSuspenseQueryHookResult = ReturnType<typeof useGetContactFormsCanDeactivateContactSuspenseQuery>;
export type GetContactFormsCanDeactivateContactQueryResult = Apollo.QueryResult<GetContactFormsCanDeactivateContactQuery, GetContactFormsCanDeactivateContactQueryVariables>;
export const GetContactFormsCanSetPrimaryContactDocument = gql`
    query GetContactFormsCanSetPrimaryContact($shipToAccountNumber: ID!, $contactId: ID) {
  canSetPrimaryContact(
    shipToAccountNumber: $shipToAccountNumber
    contactId: $contactId
  )
}
    `;

/**
 * __useGetContactFormsCanSetPrimaryContactQuery__
 *
 * To run a query within a React component, call `useGetContactFormsCanSetPrimaryContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactFormsCanSetPrimaryContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactFormsCanSetPrimaryContactQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactFormsCanSetPrimaryContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables> & ({ variables: GetContactFormsCanSetPrimaryContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables>(GetContactFormsCanSetPrimaryContactDocument, options);
      }
export function useGetContactFormsCanSetPrimaryContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables>(GetContactFormsCanSetPrimaryContactDocument, options);
        }
export function useGetContactFormsCanSetPrimaryContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables>(GetContactFormsCanSetPrimaryContactDocument, options);
        }
export type GetContactFormsCanSetPrimaryContactQueryHookResult = ReturnType<typeof useGetContactFormsCanSetPrimaryContactQuery>;
export type GetContactFormsCanSetPrimaryContactLazyQueryHookResult = ReturnType<typeof useGetContactFormsCanSetPrimaryContactLazyQuery>;
export type GetContactFormsCanSetPrimaryContactSuspenseQueryHookResult = ReturnType<typeof useGetContactFormsCanSetPrimaryContactSuspenseQuery>;
export type GetContactFormsCanSetPrimaryContactQueryResult = Apollo.QueryResult<GetContactFormsCanSetPrimaryContactQuery, GetContactFormsCanSetPrimaryContactQueryVariables>;
export const ContactFormsCreateContactDocument = gql`
    mutation ContactFormsCreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    contact {
      ...PreferenceContactInfo
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;
export type ContactFormsCreateContactMutationFn = Apollo.MutationFunction<ContactFormsCreateContactMutation, ContactFormsCreateContactMutationVariables>;

/**
 * __useContactFormsCreateContactMutation__
 *
 * To run a mutation, you first call `useContactFormsCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactFormsCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactFormsCreateContactMutation, { data, loading, error }] = useContactFormsCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactFormsCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<ContactFormsCreateContactMutation, ContactFormsCreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactFormsCreateContactMutation, ContactFormsCreateContactMutationVariables>(ContactFormsCreateContactDocument, options);
      }
export type ContactFormsCreateContactMutationHookResult = ReturnType<typeof useContactFormsCreateContactMutation>;
export type ContactFormsCreateContactMutationResult = Apollo.MutationResult<ContactFormsCreateContactMutation>;
export type ContactFormsCreateContactMutationOptions = Apollo.BaseMutationOptions<ContactFormsCreateContactMutation, ContactFormsCreateContactMutationVariables>;
export const ContactFormsDeactivateContactDocument = gql`
    mutation ContactFormsDeactivateContact($input: DeactivateContactInput!) {
  deactivateContact(input: $input) {
    contact {
      ...PreferenceContactInfo
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;
export type ContactFormsDeactivateContactMutationFn = Apollo.MutationFunction<ContactFormsDeactivateContactMutation, ContactFormsDeactivateContactMutationVariables>;

/**
 * __useContactFormsDeactivateContactMutation__
 *
 * To run a mutation, you first call `useContactFormsDeactivateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactFormsDeactivateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactFormsDeactivateContactMutation, { data, loading, error }] = useContactFormsDeactivateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactFormsDeactivateContactMutation(baseOptions?: Apollo.MutationHookOptions<ContactFormsDeactivateContactMutation, ContactFormsDeactivateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactFormsDeactivateContactMutation, ContactFormsDeactivateContactMutationVariables>(ContactFormsDeactivateContactDocument, options);
      }
export type ContactFormsDeactivateContactMutationHookResult = ReturnType<typeof useContactFormsDeactivateContactMutation>;
export type ContactFormsDeactivateContactMutationResult = Apollo.MutationResult<ContactFormsDeactivateContactMutation>;
export type ContactFormsDeactivateContactMutationOptions = Apollo.BaseMutationOptions<ContactFormsDeactivateContactMutation, ContactFormsDeactivateContactMutationVariables>;
export const ContactFormsSetPrimaryContactDocument = gql`
    mutation ContactFormsSetPrimaryContact($input: SetPrimaryContactInput!) {
  setPrimaryContact(input: $input) {
    user {
      id
      fullName
      contact {
        ...PreferenceContactInfo
      }
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;
export type ContactFormsSetPrimaryContactMutationFn = Apollo.MutationFunction<ContactFormsSetPrimaryContactMutation, ContactFormsSetPrimaryContactMutationVariables>;

/**
 * __useContactFormsSetPrimaryContactMutation__
 *
 * To run a mutation, you first call `useContactFormsSetPrimaryContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactFormsSetPrimaryContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactFormsSetPrimaryContactMutation, { data, loading, error }] = useContactFormsSetPrimaryContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactFormsSetPrimaryContactMutation(baseOptions?: Apollo.MutationHookOptions<ContactFormsSetPrimaryContactMutation, ContactFormsSetPrimaryContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactFormsSetPrimaryContactMutation, ContactFormsSetPrimaryContactMutationVariables>(ContactFormsSetPrimaryContactDocument, options);
      }
export type ContactFormsSetPrimaryContactMutationHookResult = ReturnType<typeof useContactFormsSetPrimaryContactMutation>;
export type ContactFormsSetPrimaryContactMutationResult = Apollo.MutationResult<ContactFormsSetPrimaryContactMutation>;
export type ContactFormsSetPrimaryContactMutationOptions = Apollo.BaseMutationOptions<ContactFormsSetPrimaryContactMutation, ContactFormsSetPrimaryContactMutationVariables>;
export const ContactFormsUpdateContactDocument = gql`
    mutation ContactFormsUpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    contact {
      ...PreferenceContactInfo
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;
export type ContactFormsUpdateContactMutationFn = Apollo.MutationFunction<ContactFormsUpdateContactMutation, ContactFormsUpdateContactMutationVariables>;

/**
 * __useContactFormsUpdateContactMutation__
 *
 * To run a mutation, you first call `useContactFormsUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactFormsUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactFormsUpdateContactMutation, { data, loading, error }] = useContactFormsUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactFormsUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<ContactFormsUpdateContactMutation, ContactFormsUpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactFormsUpdateContactMutation, ContactFormsUpdateContactMutationVariables>(ContactFormsUpdateContactDocument, options);
      }
export type ContactFormsUpdateContactMutationHookResult = ReturnType<typeof useContactFormsUpdateContactMutation>;
export type ContactFormsUpdateContactMutationResult = Apollo.MutationResult<ContactFormsUpdateContactMutation>;
export type ContactFormsUpdateContactMutationOptions = Apollo.BaseMutationOptions<ContactFormsUpdateContactMutation, ContactFormsUpdateContactMutationVariables>;
export const GetContactSelectorContactSearchDocument = gql`
    query GetContactSelectorContactSearch($shipToAccountNumber: String!, $term: String, $paging: PagingInput!) {
  contactSearch(shipToAccountNumber: $shipToAccountNumber, term: $term) {
    count
    results(paging: $paging) {
      ...PreferenceContactInfo
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;

/**
 * __useGetContactSelectorContactSearchQuery__
 *
 * To run a query within a React component, call `useGetContactSelectorContactSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactSelectorContactSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactSelectorContactSearchQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      term: // value for 'term'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetContactSelectorContactSearchQuery(baseOptions: Apollo.QueryHookOptions<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables> & ({ variables: GetContactSelectorContactSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables>(GetContactSelectorContactSearchDocument, options);
      }
export function useGetContactSelectorContactSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables>(GetContactSelectorContactSearchDocument, options);
        }
export function useGetContactSelectorContactSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables>(GetContactSelectorContactSearchDocument, options);
        }
export type GetContactSelectorContactSearchQueryHookResult = ReturnType<typeof useGetContactSelectorContactSearchQuery>;
export type GetContactSelectorContactSearchLazyQueryHookResult = ReturnType<typeof useGetContactSelectorContactSearchLazyQuery>;
export type GetContactSelectorContactSearchSuspenseQueryHookResult = ReturnType<typeof useGetContactSelectorContactSearchSuspenseQuery>;
export type GetContactSelectorContactSearchQueryResult = Apollo.QueryResult<GetContactSelectorContactSearchQuery, GetContactSelectorContactSearchQueryVariables>;
export const GetContentstackSharedContentstackRelatedItemsProductsGroupsDocument = gql`
    query GetContentstackSharedContentstackRelatedItemsProductsGroups($input: ItemsInput!, $ids: [ID!]!) {
  activeItems(input: $input) {
    ...GoogleTagManagerItemInfo
    ...UiProductCardItemInfo
  }
  activeProductGroupsByIds(ids: $ids) {
    ...GoogleTagManagerProductGroupInfo
    ...UiProductCardGroupInfo
  }
}
    ${GoogleTagManagerItemInfoFragmentDoc}
${UiProductCardItemInfoFragmentDoc}
${GoogleTagManagerProductGroupInfoFragmentDoc}
${UiProductCardGroupInfoFragmentDoc}`;

/**
 * __useGetContentstackSharedContentstackRelatedItemsProductsGroupsQuery__
 *
 * To run a query within a React component, call `useGetContentstackSharedContentstackRelatedItemsProductsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentstackSharedContentstackRelatedItemsProductsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentstackSharedContentstackRelatedItemsProductsGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetContentstackSharedContentstackRelatedItemsProductsGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables> & ({ variables: GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables>(GetContentstackSharedContentstackRelatedItemsProductsGroupsDocument, options);
      }
export function useGetContentstackSharedContentstackRelatedItemsProductsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables>(GetContentstackSharedContentstackRelatedItemsProductsGroupsDocument, options);
        }
export function useGetContentstackSharedContentstackRelatedItemsProductsGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables>(GetContentstackSharedContentstackRelatedItemsProductsGroupsDocument, options);
        }
export type GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryHookResult = ReturnType<typeof useGetContentstackSharedContentstackRelatedItemsProductsGroupsQuery>;
export type GetContentstackSharedContentstackRelatedItemsProductsGroupsLazyQueryHookResult = ReturnType<typeof useGetContentstackSharedContentstackRelatedItemsProductsGroupsLazyQuery>;
export type GetContentstackSharedContentstackRelatedItemsProductsGroupsSuspenseQueryHookResult = ReturnType<typeof useGetContentstackSharedContentstackRelatedItemsProductsGroupsSuspenseQuery>;
export type GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryResult = Apollo.QueryResult<GetContentstackSharedContentstackRelatedItemsProductsGroupsQuery, GetContentstackSharedContentstackRelatedItemsProductsGroupsQueryVariables>;
export const GetContentstackTargetingActiveCategoriesByIdsDocument = gql`
    query GetContentstackTargetingActiveCategoriesByIds($ids: [ID!]!) {
  activeCategoriesByIds(ids: $ids) {
    id
  }
}
    `;

/**
 * __useGetContentstackTargetingActiveCategoriesByIdsQuery__
 *
 * To run a query within a React component, call `useGetContentstackTargetingActiveCategoriesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentstackTargetingActiveCategoriesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentstackTargetingActiveCategoriesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetContentstackTargetingActiveCategoriesByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables> & ({ variables: GetContentstackTargetingActiveCategoriesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables>(GetContentstackTargetingActiveCategoriesByIdsDocument, options);
      }
export function useGetContentstackTargetingActiveCategoriesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables>(GetContentstackTargetingActiveCategoriesByIdsDocument, options);
        }
export function useGetContentstackTargetingActiveCategoriesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables>(GetContentstackTargetingActiveCategoriesByIdsDocument, options);
        }
export type GetContentstackTargetingActiveCategoriesByIdsQueryHookResult = ReturnType<typeof useGetContentstackTargetingActiveCategoriesByIdsQuery>;
export type GetContentstackTargetingActiveCategoriesByIdsLazyQueryHookResult = ReturnType<typeof useGetContentstackTargetingActiveCategoriesByIdsLazyQuery>;
export type GetContentstackTargetingActiveCategoriesByIdsSuspenseQueryHookResult = ReturnType<typeof useGetContentstackTargetingActiveCategoriesByIdsSuspenseQuery>;
export type GetContentstackTargetingActiveCategoriesByIdsQueryResult = Apollo.QueryResult<GetContentstackTargetingActiveCategoriesByIdsQuery, GetContentstackTargetingActiveCategoriesByIdsQueryVariables>;
export const GetCurrencyCultureDataDocument = gql`
    query GetCurrencyCultureData {
  viewerPermissions {
    id
    canSetupShowcase
    canUpdateCurrency
  }
  viewer {
    currencyDisplay {
      ...CurrencyCultureExchangeRateInfo
    }
    showcaseSettings {
      hideUSDPrices
    }
  }
  exchangeRates {
    ...CurrencyCultureExchangeRateInfo
  }
}
    ${CurrencyCultureExchangeRateInfoFragmentDoc}`;

/**
 * __useGetCurrencyCultureDataQuery__
 *
 * To run a query within a React component, call `useGetCurrencyCultureDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyCultureDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyCultureDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyCultureDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>(GetCurrencyCultureDataDocument, options);
      }
export function useGetCurrencyCultureDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>(GetCurrencyCultureDataDocument, options);
        }
export function useGetCurrencyCultureDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>(GetCurrencyCultureDataDocument, options);
        }
export type GetCurrencyCultureDataQueryHookResult = ReturnType<typeof useGetCurrencyCultureDataQuery>;
export type GetCurrencyCultureDataLazyQueryHookResult = ReturnType<typeof useGetCurrencyCultureDataLazyQuery>;
export type GetCurrencyCultureDataSuspenseQueryHookResult = ReturnType<typeof useGetCurrencyCultureDataSuspenseQuery>;
export type GetCurrencyCultureDataQueryResult = Apollo.QueryResult<GetCurrencyCultureDataQuery, GetCurrencyCultureDataQueryVariables>;
export const CurrencyCultureUpdateCurrencyDocument = gql`
    mutation CurrencyCultureUpdateCurrency($input: UpdateCurrencyDisplayInput!) {
  updateCurrency(input: $input) {
    user {
      currencyDisplay {
        code
      }
      showcaseSettings {
        hideUSDPrices
      }
    }
  }
}
    `;
export type CurrencyCultureUpdateCurrencyMutationFn = Apollo.MutationFunction<CurrencyCultureUpdateCurrencyMutation, CurrencyCultureUpdateCurrencyMutationVariables>;

/**
 * __useCurrencyCultureUpdateCurrencyMutation__
 *
 * To run a mutation, you first call `useCurrencyCultureUpdateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrencyCultureUpdateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currencyCultureUpdateCurrencyMutation, { data, loading, error }] = useCurrencyCultureUpdateCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCurrencyCultureUpdateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<CurrencyCultureUpdateCurrencyMutation, CurrencyCultureUpdateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CurrencyCultureUpdateCurrencyMutation, CurrencyCultureUpdateCurrencyMutationVariables>(CurrencyCultureUpdateCurrencyDocument, options);
      }
export type CurrencyCultureUpdateCurrencyMutationHookResult = ReturnType<typeof useCurrencyCultureUpdateCurrencyMutation>;
export type CurrencyCultureUpdateCurrencyMutationResult = Apollo.MutationResult<CurrencyCultureUpdateCurrencyMutation>;
export type CurrencyCultureUpdateCurrencyMutationOptions = Apollo.BaseMutationOptions<CurrencyCultureUpdateCurrencyMutation, CurrencyCultureUpdateCurrencyMutationVariables>;
export const CurrencyCultureUpdateHideUsdPriceDocument = gql`
    mutation CurrencyCultureUpdateHideUsdPrice($input: HideUsdCurrencyInput!) {
  updateHideUsdPrice(input: $input) {
    showcaseSettings {
      hideUSDPrices
    }
  }
}
    `;
export type CurrencyCultureUpdateHideUsdPriceMutationFn = Apollo.MutationFunction<CurrencyCultureUpdateHideUsdPriceMutation, CurrencyCultureUpdateHideUsdPriceMutationVariables>;

/**
 * __useCurrencyCultureUpdateHideUsdPriceMutation__
 *
 * To run a mutation, you first call `useCurrencyCultureUpdateHideUsdPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrencyCultureUpdateHideUsdPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currencyCultureUpdateHideUsdPriceMutation, { data, loading, error }] = useCurrencyCultureUpdateHideUsdPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCurrencyCultureUpdateHideUsdPriceMutation(baseOptions?: Apollo.MutationHookOptions<CurrencyCultureUpdateHideUsdPriceMutation, CurrencyCultureUpdateHideUsdPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CurrencyCultureUpdateHideUsdPriceMutation, CurrencyCultureUpdateHideUsdPriceMutationVariables>(CurrencyCultureUpdateHideUsdPriceDocument, options);
      }
export type CurrencyCultureUpdateHideUsdPriceMutationHookResult = ReturnType<typeof useCurrencyCultureUpdateHideUsdPriceMutation>;
export type CurrencyCultureUpdateHideUsdPriceMutationResult = Apollo.MutationResult<CurrencyCultureUpdateHideUsdPriceMutation>;
export type CurrencyCultureUpdateHideUsdPriceMutationOptions = Apollo.BaseMutationOptions<CurrencyCultureUpdateHideUsdPriceMutation, CurrencyCultureUpdateHideUsdPriceMutationVariables>;
export const GetFooterShowcaseFooterMarketRatesDocument = gql`
    query GetFooterShowcaseFooterMarketRates($limit: Int!) {
  marketRates(limit: $limit) {
    id
    date
    url
    gold
    palladium
    platinum
    silver
  }
}
    `;

/**
 * __useGetFooterShowcaseFooterMarketRatesQuery__
 *
 * To run a query within a React component, call `useGetFooterShowcaseFooterMarketRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterShowcaseFooterMarketRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterShowcaseFooterMarketRatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFooterShowcaseFooterMarketRatesQuery(baseOptions: Apollo.QueryHookOptions<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables> & ({ variables: GetFooterShowcaseFooterMarketRatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables>(GetFooterShowcaseFooterMarketRatesDocument, options);
      }
export function useGetFooterShowcaseFooterMarketRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables>(GetFooterShowcaseFooterMarketRatesDocument, options);
        }
export function useGetFooterShowcaseFooterMarketRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables>(GetFooterShowcaseFooterMarketRatesDocument, options);
        }
export type GetFooterShowcaseFooterMarketRatesQueryHookResult = ReturnType<typeof useGetFooterShowcaseFooterMarketRatesQuery>;
export type GetFooterShowcaseFooterMarketRatesLazyQueryHookResult = ReturnType<typeof useGetFooterShowcaseFooterMarketRatesLazyQuery>;
export type GetFooterShowcaseFooterMarketRatesSuspenseQueryHookResult = ReturnType<typeof useGetFooterShowcaseFooterMarketRatesSuspenseQuery>;
export type GetFooterShowcaseFooterMarketRatesQueryResult = Apollo.QueryResult<GetFooterShowcaseFooterMarketRatesQuery, GetFooterShowcaseFooterMarketRatesQueryVariables>;
export const GetFormstackContactsDocument = gql`
    query GetFormstackContacts($shipToAccountNumber: String!) {
  contactSearch(shipToAccountNumber: $shipToAccountNumber) {
    count
    results(paging: {limit: 3000, page: 1}) {
      id
      fullName
      firstName
      lastName
      emailAddress
      salesforceContactId
      mobilePhoneNumber {
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __useGetFormstackContactsQuery__
 *
 * To run a query within a React component, call `useGetFormstackContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormstackContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormstackContactsQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *   },
 * });
 */
export function useGetFormstackContactsQuery(baseOptions: Apollo.QueryHookOptions<GetFormstackContactsQuery, GetFormstackContactsQueryVariables> & ({ variables: GetFormstackContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormstackContactsQuery, GetFormstackContactsQueryVariables>(GetFormstackContactsDocument, options);
      }
export function useGetFormstackContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormstackContactsQuery, GetFormstackContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormstackContactsQuery, GetFormstackContactsQueryVariables>(GetFormstackContactsDocument, options);
        }
export function useGetFormstackContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFormstackContactsQuery, GetFormstackContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormstackContactsQuery, GetFormstackContactsQueryVariables>(GetFormstackContactsDocument, options);
        }
export type GetFormstackContactsQueryHookResult = ReturnType<typeof useGetFormstackContactsQuery>;
export type GetFormstackContactsLazyQueryHookResult = ReturnType<typeof useGetFormstackContactsLazyQuery>;
export type GetFormstackContactsSuspenseQueryHookResult = ReturnType<typeof useGetFormstackContactsSuspenseQuery>;
export type GetFormstackContactsQueryResult = Apollo.QueryResult<GetFormstackContactsQuery, GetFormstackContactsQueryVariables>;
export const GetHeaderMainNavSterlingHasSpecialOrderMessagesDocument = gql`
    query GetHeaderMainNavSterlingHasSpecialOrderMessages {
  viewer {
    id
    hasUnreadSpecialOrderMessages
  }
}
    `;

/**
 * __useGetHeaderMainNavSterlingHasSpecialOrderMessagesQuery__
 *
 * To run a query within a React component, call `useGetHeaderMainNavSterlingHasSpecialOrderMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderMainNavSterlingHasSpecialOrderMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderMainNavSterlingHasSpecialOrderMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderMainNavSterlingHasSpecialOrderMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>(GetHeaderMainNavSterlingHasSpecialOrderMessagesDocument, options);
      }
export function useGetHeaderMainNavSterlingHasSpecialOrderMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>(GetHeaderMainNavSterlingHasSpecialOrderMessagesDocument, options);
        }
export function useGetHeaderMainNavSterlingHasSpecialOrderMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>(GetHeaderMainNavSterlingHasSpecialOrderMessagesDocument, options);
        }
export type GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryHookResult = ReturnType<typeof useGetHeaderMainNavSterlingHasSpecialOrderMessagesQuery>;
export type GetHeaderMainNavSterlingHasSpecialOrderMessagesLazyQueryHookResult = ReturnType<typeof useGetHeaderMainNavSterlingHasSpecialOrderMessagesLazyQuery>;
export type GetHeaderMainNavSterlingHasSpecialOrderMessagesSuspenseQueryHookResult = ReturnType<typeof useGetHeaderMainNavSterlingHasSpecialOrderMessagesSuspenseQuery>;
export type GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryResult = Apollo.QueryResult<GetHeaderMainNavSterlingHasSpecialOrderMessagesQuery, GetHeaderMainNavSterlingHasSpecialOrderMessagesQueryVariables>;
export const GetHeaderMainNavCategoriesDocument = gql`
    query GetHeaderMainNavCategories {
  mainNavCategories {
    id
    mainNavDisplayName
    url
    mainNavContentContainerId
    mainNavIsFeatured
    mainNavSortOrder
  }
}
    `;

/**
 * __useGetHeaderMainNavCategoriesQuery__
 *
 * To run a query within a React component, call `useGetHeaderMainNavCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderMainNavCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderMainNavCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderMainNavCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>(GetHeaderMainNavCategoriesDocument, options);
      }
export function useGetHeaderMainNavCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>(GetHeaderMainNavCategoriesDocument, options);
        }
export function useGetHeaderMainNavCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>(GetHeaderMainNavCategoriesDocument, options);
        }
export type GetHeaderMainNavCategoriesQueryHookResult = ReturnType<typeof useGetHeaderMainNavCategoriesQuery>;
export type GetHeaderMainNavCategoriesLazyQueryHookResult = ReturnType<typeof useGetHeaderMainNavCategoriesLazyQuery>;
export type GetHeaderMainNavCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetHeaderMainNavCategoriesSuspenseQuery>;
export type GetHeaderMainNavCategoriesQueryResult = Apollo.QueryResult<GetHeaderMainNavCategoriesQuery, GetHeaderMainNavCategoriesQueryVariables>;
export const GetHeaderSearchNavSearchSuggestionsDocument = gql`
    query GetHeaderSearchNavSearchSuggestions($term: String!) {
  searchSuggestions(term: $term) {
    id
    description
    imageUrl
    groupId
    clickLoggingUrl
  }
}
    `;

/**
 * __useGetHeaderSearchNavSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetHeaderSearchNavSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderSearchNavSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderSearchNavSearchSuggestionsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetHeaderSearchNavSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables> & ({ variables: GetHeaderSearchNavSearchSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables>(GetHeaderSearchNavSearchSuggestionsDocument, options);
      }
export function useGetHeaderSearchNavSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables>(GetHeaderSearchNavSearchSuggestionsDocument, options);
        }
export function useGetHeaderSearchNavSearchSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables>(GetHeaderSearchNavSearchSuggestionsDocument, options);
        }
export type GetHeaderSearchNavSearchSuggestionsQueryHookResult = ReturnType<typeof useGetHeaderSearchNavSearchSuggestionsQuery>;
export type GetHeaderSearchNavSearchSuggestionsLazyQueryHookResult = ReturnType<typeof useGetHeaderSearchNavSearchSuggestionsLazyQuery>;
export type GetHeaderSearchNavSearchSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetHeaderSearchNavSearchSuggestionsSuspenseQuery>;
export type GetHeaderSearchNavSearchSuggestionsQueryResult = Apollo.QueryResult<GetHeaderSearchNavSearchSuggestionsQuery, GetHeaderSearchNavSearchSuggestionsQueryVariables>;
export const GetHeaderUtilityNavMenuAccountMembershipsDocument = gql`
    query GetHeaderUtilityNavMenuAccountMemberships {
  viewer {
    id
    isCadCamServicesMember
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuAccountMembershipsQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuAccountMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuAccountMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuAccountMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuAccountMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>(GetHeaderUtilityNavMenuAccountMembershipsDocument, options);
      }
export function useGetHeaderUtilityNavMenuAccountMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>(GetHeaderUtilityNavMenuAccountMembershipsDocument, options);
        }
export function useGetHeaderUtilityNavMenuAccountMembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>(GetHeaderUtilityNavMenuAccountMembershipsDocument, options);
        }
export type GetHeaderUtilityNavMenuAccountMembershipsQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuAccountMembershipsQuery>;
export type GetHeaderUtilityNavMenuAccountMembershipsLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuAccountMembershipsLazyQuery>;
export type GetHeaderUtilityNavMenuAccountMembershipsSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuAccountMembershipsSuspenseQuery>;
export type GetHeaderUtilityNavMenuAccountMembershipsQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuAccountMembershipsQuery, GetHeaderUtilityNavMenuAccountMembershipsQueryVariables>;
export const GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountDocument = gql`
    query GetHeaderUtilityNavMenuAccountLocateAJewelerListingCount {
  locateAJewelerListingSearch {
    count
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>(GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountDocument, options);
      }
export function useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>(GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountDocument, options);
        }
export function useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>(GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountDocument, options);
        }
export type GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery>;
export type GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountLazyQuery>;
export type GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuAccountLocateAJewelerListingCountSuspenseQuery>;
export type GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQuery, GetHeaderUtilityNavMenuAccountLocateAJewelerListingCountQueryVariables>;
export const GetHeaderUtilityNavMenuCartItemCountDocument = gql`
    query GetHeaderUtilityNavMenuCartItemCount {
  cartItemCount
  viewer {
    id
    scheduledOrder {
      id
    }
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuCartItemCountQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuCartItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuCartItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuCartItemCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuCartItemCountQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>(GetHeaderUtilityNavMenuCartItemCountDocument, options);
      }
export function useGetHeaderUtilityNavMenuCartItemCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>(GetHeaderUtilityNavMenuCartItemCountDocument, options);
        }
export function useGetHeaderUtilityNavMenuCartItemCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>(GetHeaderUtilityNavMenuCartItemCountDocument, options);
        }
export type GetHeaderUtilityNavMenuCartItemCountQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartItemCountQuery>;
export type GetHeaderUtilityNavMenuCartItemCountLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartItemCountLazyQuery>;
export type GetHeaderUtilityNavMenuCartItemCountSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartItemCountSuspenseQuery>;
export type GetHeaderUtilityNavMenuCartItemCountQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuCartItemCountQuery, GetHeaderUtilityNavMenuCartItemCountQueryVariables>;
export const GetHeaderUtilityNavMenuCartDocument = gql`
    query GetHeaderUtilityNavMenuCart {
  cart {
    ...HeaderUtilityNavMenuCartInfo
  }
}
    ${HeaderUtilityNavMenuCartInfoFragmentDoc}`;

/**
 * __useGetHeaderUtilityNavMenuCartQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuCartQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>(GetHeaderUtilityNavMenuCartDocument, options);
      }
export function useGetHeaderUtilityNavMenuCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>(GetHeaderUtilityNavMenuCartDocument, options);
        }
export function useGetHeaderUtilityNavMenuCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>(GetHeaderUtilityNavMenuCartDocument, options);
        }
export type GetHeaderUtilityNavMenuCartQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartQuery>;
export type GetHeaderUtilityNavMenuCartLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartLazyQuery>;
export type GetHeaderUtilityNavMenuCartSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartSuspenseQuery>;
export type GetHeaderUtilityNavMenuCartQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuCartQuery, GetHeaderUtilityNavMenuCartQueryVariables>;
export const GetHeaderUtilityNavMenuCartCanCheckoutDocument = gql`
    query GetHeaderUtilityNavMenuCartCanCheckout {
  viewerPermissions {
    id
    canCheckout
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuCartCanCheckoutQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuCartCanCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuCartCanCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuCartCanCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuCartCanCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>(GetHeaderUtilityNavMenuCartCanCheckoutDocument, options);
      }
export function useGetHeaderUtilityNavMenuCartCanCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>(GetHeaderUtilityNavMenuCartCanCheckoutDocument, options);
        }
export function useGetHeaderUtilityNavMenuCartCanCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>(GetHeaderUtilityNavMenuCartCanCheckoutDocument, options);
        }
export type GetHeaderUtilityNavMenuCartCanCheckoutQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartCanCheckoutQuery>;
export type GetHeaderUtilityNavMenuCartCanCheckoutLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartCanCheckoutLazyQuery>;
export type GetHeaderUtilityNavMenuCartCanCheckoutSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuCartCanCheckoutSuspenseQuery>;
export type GetHeaderUtilityNavMenuCartCanCheckoutQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuCartCanCheckoutQuery, GetHeaderUtilityNavMenuCartCanCheckoutQueryVariables>;
export const HeaderUtilityNavMenuCartSaveCartLineForLaterDocument = gql`
    mutation HeaderUtilityNavMenuCartSaveCartLineForLater($cartLineId: ID!) {
  saveCartLineForLater(cartLineId: $cartLineId) {
    cart {
      ...HeaderUtilityNavMenuCartInfo
    }
  }
}
    ${HeaderUtilityNavMenuCartInfoFragmentDoc}`;
export type HeaderUtilityNavMenuCartSaveCartLineForLaterMutationFn = Apollo.MutationFunction<HeaderUtilityNavMenuCartSaveCartLineForLaterMutation, HeaderUtilityNavMenuCartSaveCartLineForLaterMutationVariables>;

/**
 * __useHeaderUtilityNavMenuCartSaveCartLineForLaterMutation__
 *
 * To run a mutation, you first call `useHeaderUtilityNavMenuCartSaveCartLineForLaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaderUtilityNavMenuCartSaveCartLineForLaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [headerUtilityNavMenuCartSaveCartLineForLaterMutation, { data, loading, error }] = useHeaderUtilityNavMenuCartSaveCartLineForLaterMutation({
 *   variables: {
 *      cartLineId: // value for 'cartLineId'
 *   },
 * });
 */
export function useHeaderUtilityNavMenuCartSaveCartLineForLaterMutation(baseOptions?: Apollo.MutationHookOptions<HeaderUtilityNavMenuCartSaveCartLineForLaterMutation, HeaderUtilityNavMenuCartSaveCartLineForLaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaderUtilityNavMenuCartSaveCartLineForLaterMutation, HeaderUtilityNavMenuCartSaveCartLineForLaterMutationVariables>(HeaderUtilityNavMenuCartSaveCartLineForLaterDocument, options);
      }
export type HeaderUtilityNavMenuCartSaveCartLineForLaterMutationHookResult = ReturnType<typeof useHeaderUtilityNavMenuCartSaveCartLineForLaterMutation>;
export type HeaderUtilityNavMenuCartSaveCartLineForLaterMutationResult = Apollo.MutationResult<HeaderUtilityNavMenuCartSaveCartLineForLaterMutation>;
export type HeaderUtilityNavMenuCartSaveCartLineForLaterMutationOptions = Apollo.BaseMutationOptions<HeaderUtilityNavMenuCartSaveCartLineForLaterMutation, HeaderUtilityNavMenuCartSaveCartLineForLaterMutationVariables>;
export const HeaderUtilityNavMenuCartDeleteCartLineDocument = gql`
    mutation HeaderUtilityNavMenuCartDeleteCartLine($input: DeleteCartLineInput!) {
  deleteCartLine(input: $input) {
    cart {
      ...HeaderUtilityNavMenuCartInfo
    }
  }
}
    ${HeaderUtilityNavMenuCartInfoFragmentDoc}`;
export type HeaderUtilityNavMenuCartDeleteCartLineMutationFn = Apollo.MutationFunction<HeaderUtilityNavMenuCartDeleteCartLineMutation, HeaderUtilityNavMenuCartDeleteCartLineMutationVariables>;

/**
 * __useHeaderUtilityNavMenuCartDeleteCartLineMutation__
 *
 * To run a mutation, you first call `useHeaderUtilityNavMenuCartDeleteCartLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaderUtilityNavMenuCartDeleteCartLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [headerUtilityNavMenuCartDeleteCartLineMutation, { data, loading, error }] = useHeaderUtilityNavMenuCartDeleteCartLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaderUtilityNavMenuCartDeleteCartLineMutation(baseOptions?: Apollo.MutationHookOptions<HeaderUtilityNavMenuCartDeleteCartLineMutation, HeaderUtilityNavMenuCartDeleteCartLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaderUtilityNavMenuCartDeleteCartLineMutation, HeaderUtilityNavMenuCartDeleteCartLineMutationVariables>(HeaderUtilityNavMenuCartDeleteCartLineDocument, options);
      }
export type HeaderUtilityNavMenuCartDeleteCartLineMutationHookResult = ReturnType<typeof useHeaderUtilityNavMenuCartDeleteCartLineMutation>;
export type HeaderUtilityNavMenuCartDeleteCartLineMutationResult = Apollo.MutationResult<HeaderUtilityNavMenuCartDeleteCartLineMutation>;
export type HeaderUtilityNavMenuCartDeleteCartLineMutationOptions = Apollo.BaseMutationOptions<HeaderUtilityNavMenuCartDeleteCartLineMutation, HeaderUtilityNavMenuCartDeleteCartLineMutationVariables>;
export const HeaderUtilityNavMenuCartUpdateCartLineQuantityDocument = gql`
    mutation HeaderUtilityNavMenuCartUpdateCartLineQuantity($input: UpdateCartLineQuantityInput!) {
  updateCartLineQuantity(input: $input) {
    cart {
      ...HeaderUtilityNavMenuCartInfo
    }
  }
}
    ${HeaderUtilityNavMenuCartInfoFragmentDoc}`;
export type HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationFn = Apollo.MutationFunction<HeaderUtilityNavMenuCartUpdateCartLineQuantityMutation, HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationVariables>;

/**
 * __useHeaderUtilityNavMenuCartUpdateCartLineQuantityMutation__
 *
 * To run a mutation, you first call `useHeaderUtilityNavMenuCartUpdateCartLineQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaderUtilityNavMenuCartUpdateCartLineQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [headerUtilityNavMenuCartUpdateCartLineQuantityMutation, { data, loading, error }] = useHeaderUtilityNavMenuCartUpdateCartLineQuantityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaderUtilityNavMenuCartUpdateCartLineQuantityMutation(baseOptions?: Apollo.MutationHookOptions<HeaderUtilityNavMenuCartUpdateCartLineQuantityMutation, HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaderUtilityNavMenuCartUpdateCartLineQuantityMutation, HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationVariables>(HeaderUtilityNavMenuCartUpdateCartLineQuantityDocument, options);
      }
export type HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationHookResult = ReturnType<typeof useHeaderUtilityNavMenuCartUpdateCartLineQuantityMutation>;
export type HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationResult = Apollo.MutationResult<HeaderUtilityNavMenuCartUpdateCartLineQuantityMutation>;
export type HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationOptions = Apollo.BaseMutationOptions<HeaderUtilityNavMenuCartUpdateCartLineQuantityMutation, HeaderUtilityNavMenuCartUpdateCartLineQuantityMutationVariables>;
export const HeaderUtilityNavMenuCartCancelScheduledOrderDocument = gql`
    mutation HeaderUtilityNavMenuCartCancelScheduledOrder {
  cancelScheduledOrder {
    id
  }
}
    `;
export type HeaderUtilityNavMenuCartCancelScheduledOrderMutationFn = Apollo.MutationFunction<HeaderUtilityNavMenuCartCancelScheduledOrderMutation, HeaderUtilityNavMenuCartCancelScheduledOrderMutationVariables>;

/**
 * __useHeaderUtilityNavMenuCartCancelScheduledOrderMutation__
 *
 * To run a mutation, you first call `useHeaderUtilityNavMenuCartCancelScheduledOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaderUtilityNavMenuCartCancelScheduledOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [headerUtilityNavMenuCartCancelScheduledOrderMutation, { data, loading, error }] = useHeaderUtilityNavMenuCartCancelScheduledOrderMutation({
 *   variables: {
 *   },
 * });
 */
export function useHeaderUtilityNavMenuCartCancelScheduledOrderMutation(baseOptions?: Apollo.MutationHookOptions<HeaderUtilityNavMenuCartCancelScheduledOrderMutation, HeaderUtilityNavMenuCartCancelScheduledOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaderUtilityNavMenuCartCancelScheduledOrderMutation, HeaderUtilityNavMenuCartCancelScheduledOrderMutationVariables>(HeaderUtilityNavMenuCartCancelScheduledOrderDocument, options);
      }
export type HeaderUtilityNavMenuCartCancelScheduledOrderMutationHookResult = ReturnType<typeof useHeaderUtilityNavMenuCartCancelScheduledOrderMutation>;
export type HeaderUtilityNavMenuCartCancelScheduledOrderMutationResult = Apollo.MutationResult<HeaderUtilityNavMenuCartCancelScheduledOrderMutation>;
export type HeaderUtilityNavMenuCartCancelScheduledOrderMutationOptions = Apollo.BaseMutationOptions<HeaderUtilityNavMenuCartCancelScheduledOrderMutation, HeaderUtilityNavMenuCartCancelScheduledOrderMutationVariables>;
export const GetHeaderUtilityNavMenuMessagesUnreadCountDocument = gql`
    query GetHeaderUtilityNavMenuMessagesUnreadCount($app: NotificationApp!) {
  viewer {
    id
    notificationsUnreadCount(app: $app) {
      total
      important
    }
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuMessagesUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuMessagesUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuMessagesUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuMessagesUnreadCountQuery({
 *   variables: {
 *      app: // value for 'app'
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuMessagesUnreadCountQuery(baseOptions: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables> & ({ variables: GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables>(GetHeaderUtilityNavMenuMessagesUnreadCountDocument, options);
      }
export function useGetHeaderUtilityNavMenuMessagesUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables>(GetHeaderUtilityNavMenuMessagesUnreadCountDocument, options);
        }
export function useGetHeaderUtilityNavMenuMessagesUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables>(GetHeaderUtilityNavMenuMessagesUnreadCountDocument, options);
        }
export type GetHeaderUtilityNavMenuMessagesUnreadCountQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuMessagesUnreadCountQuery>;
export type GetHeaderUtilityNavMenuMessagesUnreadCountLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuMessagesUnreadCountLazyQuery>;
export type GetHeaderUtilityNavMenuMessagesUnreadCountSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuMessagesUnreadCountSuspenseQuery>;
export type GetHeaderUtilityNavMenuMessagesUnreadCountQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuMessagesUnreadCountQuery, GetHeaderUtilityNavMenuMessagesUnreadCountQueryVariables>;
export const GetHeaderUtilityNavMenuMessagesFeedDocument = gql`
    query GetHeaderUtilityNavMenuMessagesFeed($app: NotificationApp!, $important: Boolean, $status: NotificationStatus, $limit: Int, $cursor: String) {
  viewer {
    id
    notificationsFeed(
      app: $app
      important: $important
      status: $status
      limit: $limit
      cursor: $cursor
    ) {
      cursor
      notifications {
        id
        createdDate
        status
        type
        important
        metadata {
          title
          body
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuMessagesFeedQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuMessagesFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuMessagesFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuMessagesFeedQuery({
 *   variables: {
 *      app: // value for 'app'
 *      important: // value for 'important'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuMessagesFeedQuery(baseOptions: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables> & ({ variables: GetHeaderUtilityNavMenuMessagesFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables>(GetHeaderUtilityNavMenuMessagesFeedDocument, options);
      }
export function useGetHeaderUtilityNavMenuMessagesFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables>(GetHeaderUtilityNavMenuMessagesFeedDocument, options);
        }
export function useGetHeaderUtilityNavMenuMessagesFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables>(GetHeaderUtilityNavMenuMessagesFeedDocument, options);
        }
export type GetHeaderUtilityNavMenuMessagesFeedQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuMessagesFeedQuery>;
export type GetHeaderUtilityNavMenuMessagesFeedLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuMessagesFeedLazyQuery>;
export type GetHeaderUtilityNavMenuMessagesFeedSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuMessagesFeedSuspenseQuery>;
export type GetHeaderUtilityNavMenuMessagesFeedQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuMessagesFeedQuery, GetHeaderUtilityNavMenuMessagesFeedQueryVariables>;
export const HeaderUtilityNavMenuMessagesUpdateFeedReadDocument = gql`
    mutation HeaderUtilityNavMenuMessagesUpdateFeedRead($input: UpdateNotificationsFeedReadInput!) {
  updateNotificationsFeedRead(input: $input) {
    count
  }
}
    `;
export type HeaderUtilityNavMenuMessagesUpdateFeedReadMutationFn = Apollo.MutationFunction<HeaderUtilityNavMenuMessagesUpdateFeedReadMutation, HeaderUtilityNavMenuMessagesUpdateFeedReadMutationVariables>;

/**
 * __useHeaderUtilityNavMenuMessagesUpdateFeedReadMutation__
 *
 * To run a mutation, you first call `useHeaderUtilityNavMenuMessagesUpdateFeedReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaderUtilityNavMenuMessagesUpdateFeedReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [headerUtilityNavMenuMessagesUpdateFeedReadMutation, { data, loading, error }] = useHeaderUtilityNavMenuMessagesUpdateFeedReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaderUtilityNavMenuMessagesUpdateFeedReadMutation(baseOptions?: Apollo.MutationHookOptions<HeaderUtilityNavMenuMessagesUpdateFeedReadMutation, HeaderUtilityNavMenuMessagesUpdateFeedReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaderUtilityNavMenuMessagesUpdateFeedReadMutation, HeaderUtilityNavMenuMessagesUpdateFeedReadMutationVariables>(HeaderUtilityNavMenuMessagesUpdateFeedReadDocument, options);
      }
export type HeaderUtilityNavMenuMessagesUpdateFeedReadMutationHookResult = ReturnType<typeof useHeaderUtilityNavMenuMessagesUpdateFeedReadMutation>;
export type HeaderUtilityNavMenuMessagesUpdateFeedReadMutationResult = Apollo.MutationResult<HeaderUtilityNavMenuMessagesUpdateFeedReadMutation>;
export type HeaderUtilityNavMenuMessagesUpdateFeedReadMutationOptions = Apollo.BaseMutationOptions<HeaderUtilityNavMenuMessagesUpdateFeedReadMutation, HeaderUtilityNavMenuMessagesUpdateFeedReadMutationVariables>;
export const HeaderUtilityNavMenuMessagesUpdateStatusDocument = gql`
    mutation HeaderUtilityNavMenuMessagesUpdateStatus($input: UpdateNotificationStatusInput!) {
  updateNotificationStatus(input: $input) {
    notification {
      id
      status
    }
  }
}
    `;
export type HeaderUtilityNavMenuMessagesUpdateStatusMutationFn = Apollo.MutationFunction<HeaderUtilityNavMenuMessagesUpdateStatusMutation, HeaderUtilityNavMenuMessagesUpdateStatusMutationVariables>;

/**
 * __useHeaderUtilityNavMenuMessagesUpdateStatusMutation__
 *
 * To run a mutation, you first call `useHeaderUtilityNavMenuMessagesUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaderUtilityNavMenuMessagesUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [headerUtilityNavMenuMessagesUpdateStatusMutation, { data, loading, error }] = useHeaderUtilityNavMenuMessagesUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaderUtilityNavMenuMessagesUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<HeaderUtilityNavMenuMessagesUpdateStatusMutation, HeaderUtilityNavMenuMessagesUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaderUtilityNavMenuMessagesUpdateStatusMutation, HeaderUtilityNavMenuMessagesUpdateStatusMutationVariables>(HeaderUtilityNavMenuMessagesUpdateStatusDocument, options);
      }
export type HeaderUtilityNavMenuMessagesUpdateStatusMutationHookResult = ReturnType<typeof useHeaderUtilityNavMenuMessagesUpdateStatusMutation>;
export type HeaderUtilityNavMenuMessagesUpdateStatusMutationResult = Apollo.MutationResult<HeaderUtilityNavMenuMessagesUpdateStatusMutation>;
export type HeaderUtilityNavMenuMessagesUpdateStatusMutationOptions = Apollo.BaseMutationOptions<HeaderUtilityNavMenuMessagesUpdateStatusMutation, HeaderUtilityNavMenuMessagesUpdateStatusMutationVariables>;
export const GetHeaderUtilityNavMenuShowcaseSettingsSetupDocument = gql`
    query GetHeaderUtilityNavMenuShowcaseSettingsSetup {
  viewer {
    id
    showcaseSettings {
      setup {
        displayComplete
        markupsComplete
      }
    }
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuShowcaseSettingsSetupQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuShowcaseSettingsSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuShowcaseSettingsSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuShowcaseSettingsSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuShowcaseSettingsSetupQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>(GetHeaderUtilityNavMenuShowcaseSettingsSetupDocument, options);
      }
export function useGetHeaderUtilityNavMenuShowcaseSettingsSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>(GetHeaderUtilityNavMenuShowcaseSettingsSetupDocument, options);
        }
export function useGetHeaderUtilityNavMenuShowcaseSettingsSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>(GetHeaderUtilityNavMenuShowcaseSettingsSetupDocument, options);
        }
export type GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseSettingsSetupQuery>;
export type GetHeaderUtilityNavMenuShowcaseSettingsSetupLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseSettingsSetupLazyQuery>;
export type GetHeaderUtilityNavMenuShowcaseSettingsSetupSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseSettingsSetupSuspenseQuery>;
export type GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuShowcaseSettingsSetupQuery, GetHeaderUtilityNavMenuShowcaseSettingsSetupQueryVariables>;
export const GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountDocument = gql`
    query GetHeaderUtilityNavMenuShowcaseCallbackRequestsCount {
  pendingJewelerShowcaseCallbackRequests(onlyRecent: true) {
    count
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>(GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountDocument, options);
      }
export function useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>(GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountDocument, options);
        }
export function useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>(GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountDocument, options);
        }
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery>;
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountLazyQuery>;
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseCallbackRequestsCountSuspenseQuery>;
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsCountQueryVariables>;
export const GetHeaderUtilityNavMenuShowcaseCallbackRequestsDocument = gql`
    query GetHeaderUtilityNavMenuShowcaseCallbackRequests($paging: PagingInput!) {
  pendingJewelerShowcaseCallbackRequests(onlyRecent: true) {
    count
    results(paging: $paging) {
      id
      emailAddress
      creationDate
    }
  }
}
    `;

/**
 * __useGetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables> & ({ variables: GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables>(GetHeaderUtilityNavMenuShowcaseCallbackRequestsDocument, options);
      }
export function useGetHeaderUtilityNavMenuShowcaseCallbackRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables>(GetHeaderUtilityNavMenuShowcaseCallbackRequestsDocument, options);
        }
export function useGetHeaderUtilityNavMenuShowcaseCallbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables>(GetHeaderUtilityNavMenuShowcaseCallbackRequestsDocument, options);
        }
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery>;
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseCallbackRequestsLazyQuery>;
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavMenuShowcaseCallbackRequestsSuspenseQuery>;
export type GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryResult = Apollo.QueryResult<GetHeaderUtilityNavMenuShowcaseCallbackRequestsQuery, GetHeaderUtilityNavMenuShowcaseCallbackRequestsQueryVariables>;
export const GetHeaderUtilityNavPermissionsDocument = gql`
    query GetHeaderUtilityNavPermissions {
  viewerPermissions {
    id
    canViewCart
  }
}
    `;

/**
 * __useGetHeaderUtilityNavPermissionsQuery__
 *
 * To run a query within a React component, call `useGetHeaderUtilityNavPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderUtilityNavPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderUtilityNavPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHeaderUtilityNavPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>(GetHeaderUtilityNavPermissionsDocument, options);
      }
export function useGetHeaderUtilityNavPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>(GetHeaderUtilityNavPermissionsDocument, options);
        }
export function useGetHeaderUtilityNavPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>(GetHeaderUtilityNavPermissionsDocument, options);
        }
export type GetHeaderUtilityNavPermissionsQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavPermissionsQuery>;
export type GetHeaderUtilityNavPermissionsLazyQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavPermissionsLazyQuery>;
export type GetHeaderUtilityNavPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetHeaderUtilityNavPermissionsSuspenseQuery>;
export type GetHeaderUtilityNavPermissionsQueryResult = Apollo.QueryResult<GetHeaderUtilityNavPermissionsQuery, GetHeaderUtilityNavPermissionsQueryVariables>;
export const GetHoldShipmentsPermissionsDocument = gql`
    query GetHoldShipmentsPermissions {
  viewerPermissions {
    id
    canUpdateHoldShipments
  }
}
    `;

/**
 * __useGetHoldShipmentsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetHoldShipmentsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoldShipmentsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoldShipmentsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHoldShipmentsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>(GetHoldShipmentsPermissionsDocument, options);
      }
export function useGetHoldShipmentsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>(GetHoldShipmentsPermissionsDocument, options);
        }
export function useGetHoldShipmentsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>(GetHoldShipmentsPermissionsDocument, options);
        }
export type GetHoldShipmentsPermissionsQueryHookResult = ReturnType<typeof useGetHoldShipmentsPermissionsQuery>;
export type GetHoldShipmentsPermissionsLazyQueryHookResult = ReturnType<typeof useGetHoldShipmentsPermissionsLazyQuery>;
export type GetHoldShipmentsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetHoldShipmentsPermissionsSuspenseQuery>;
export type GetHoldShipmentsPermissionsQueryResult = Apollo.QueryResult<GetHoldShipmentsPermissionsQuery, GetHoldShipmentsPermissionsQueryVariables>;
export const GetHoldShipmentsShipToAccountByAccountNumberDocument = gql`
    query GetHoldShipmentsShipToAccountByAccountNumber($accountNumber: String!) {
  shipToAccountByAccountNumber(accountNumber: $accountNumber) {
    ...HoldShipmentsShipToAccountInfo
  }
}
    ${HoldShipmentsShipToAccountInfoFragmentDoc}`;

/**
 * __useGetHoldShipmentsShipToAccountByAccountNumberQuery__
 *
 * To run a query within a React component, call `useGetHoldShipmentsShipToAccountByAccountNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoldShipmentsShipToAccountByAccountNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoldShipmentsShipToAccountByAccountNumberQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useGetHoldShipmentsShipToAccountByAccountNumberQuery(baseOptions: Apollo.QueryHookOptions<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables> & ({ variables: GetHoldShipmentsShipToAccountByAccountNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables>(GetHoldShipmentsShipToAccountByAccountNumberDocument, options);
      }
export function useGetHoldShipmentsShipToAccountByAccountNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables>(GetHoldShipmentsShipToAccountByAccountNumberDocument, options);
        }
export function useGetHoldShipmentsShipToAccountByAccountNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables>(GetHoldShipmentsShipToAccountByAccountNumberDocument, options);
        }
export type GetHoldShipmentsShipToAccountByAccountNumberQueryHookResult = ReturnType<typeof useGetHoldShipmentsShipToAccountByAccountNumberQuery>;
export type GetHoldShipmentsShipToAccountByAccountNumberLazyQueryHookResult = ReturnType<typeof useGetHoldShipmentsShipToAccountByAccountNumberLazyQuery>;
export type GetHoldShipmentsShipToAccountByAccountNumberSuspenseQueryHookResult = ReturnType<typeof useGetHoldShipmentsShipToAccountByAccountNumberSuspenseQuery>;
export type GetHoldShipmentsShipToAccountByAccountNumberQueryResult = Apollo.QueryResult<GetHoldShipmentsShipToAccountByAccountNumberQuery, GetHoldShipmentsShipToAccountByAccountNumberQueryVariables>;
export const GetHoldShipmentsShipToAccountSearchDocument = gql`
    query GetHoldShipmentsShipToAccountSearch($onlyWebActive: Boolean, $term: String, $onlyLocateAJewelerListingUnlisted: Boolean, $consultantSearchAcrossAllBillToAccounts: Boolean, $paging: PagingInput!) {
  shipToAccountSearch(
    onlyWebActive: $onlyWebActive
    term: $term
    onlyLocateAJewelerListingUnlisted: $onlyLocateAJewelerListingUnlisted
    consultantSearchAcrossAllBillToAccounts: $consultantSearchAcrossAllBillToAccounts
  ) {
    count
    results(paging: $paging) {
      ...HoldShipmentsShipToAccountInfo
    }
  }
}
    ${HoldShipmentsShipToAccountInfoFragmentDoc}`;

/**
 * __useGetHoldShipmentsShipToAccountSearchQuery__
 *
 * To run a query within a React component, call `useGetHoldShipmentsShipToAccountSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoldShipmentsShipToAccountSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoldShipmentsShipToAccountSearchQuery({
 *   variables: {
 *      onlyWebActive: // value for 'onlyWebActive'
 *      term: // value for 'term'
 *      onlyLocateAJewelerListingUnlisted: // value for 'onlyLocateAJewelerListingUnlisted'
 *      consultantSearchAcrossAllBillToAccounts: // value for 'consultantSearchAcrossAllBillToAccounts'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetHoldShipmentsShipToAccountSearchQuery(baseOptions: Apollo.QueryHookOptions<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables> & ({ variables: GetHoldShipmentsShipToAccountSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables>(GetHoldShipmentsShipToAccountSearchDocument, options);
      }
export function useGetHoldShipmentsShipToAccountSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables>(GetHoldShipmentsShipToAccountSearchDocument, options);
        }
export function useGetHoldShipmentsShipToAccountSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables>(GetHoldShipmentsShipToAccountSearchDocument, options);
        }
export type GetHoldShipmentsShipToAccountSearchQueryHookResult = ReturnType<typeof useGetHoldShipmentsShipToAccountSearchQuery>;
export type GetHoldShipmentsShipToAccountSearchLazyQueryHookResult = ReturnType<typeof useGetHoldShipmentsShipToAccountSearchLazyQuery>;
export type GetHoldShipmentsShipToAccountSearchSuspenseQueryHookResult = ReturnType<typeof useGetHoldShipmentsShipToAccountSearchSuspenseQuery>;
export type GetHoldShipmentsShipToAccountSearchQueryResult = Apollo.QueryResult<GetHoldShipmentsShipToAccountSearchQuery, GetHoldShipmentsShipToAccountSearchQueryVariables>;
export const HoldShipmentsUpdateHoldShipmentsDateDocument = gql`
    mutation HoldShipmentsUpdateHoldShipmentsDate($input: UpdateHoldShipmentsDateInput!) {
  updateHoldShipmentsDate(input: $input) {
    shipToAccount {
      id
      accountNumber
      holdShipmentsDate
    }
  }
}
    `;
export type HoldShipmentsUpdateHoldShipmentsDateMutationFn = Apollo.MutationFunction<HoldShipmentsUpdateHoldShipmentsDateMutation, HoldShipmentsUpdateHoldShipmentsDateMutationVariables>;

/**
 * __useHoldShipmentsUpdateHoldShipmentsDateMutation__
 *
 * To run a mutation, you first call `useHoldShipmentsUpdateHoldShipmentsDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldShipmentsUpdateHoldShipmentsDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdShipmentsUpdateHoldShipmentsDateMutation, { data, loading, error }] = useHoldShipmentsUpdateHoldShipmentsDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHoldShipmentsUpdateHoldShipmentsDateMutation(baseOptions?: Apollo.MutationHookOptions<HoldShipmentsUpdateHoldShipmentsDateMutation, HoldShipmentsUpdateHoldShipmentsDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HoldShipmentsUpdateHoldShipmentsDateMutation, HoldShipmentsUpdateHoldShipmentsDateMutationVariables>(HoldShipmentsUpdateHoldShipmentsDateDocument, options);
      }
export type HoldShipmentsUpdateHoldShipmentsDateMutationHookResult = ReturnType<typeof useHoldShipmentsUpdateHoldShipmentsDateMutation>;
export type HoldShipmentsUpdateHoldShipmentsDateMutationResult = Apollo.MutationResult<HoldShipmentsUpdateHoldShipmentsDateMutation>;
export type HoldShipmentsUpdateHoldShipmentsDateMutationOptions = Apollo.BaseMutationOptions<HoldShipmentsUpdateHoldShipmentsDateMutation, HoldShipmentsUpdateHoldShipmentsDateMutationVariables>;
export const GetInactiveGroupProductGroupByIdDocument = gql`
    query GetInactiveGroupProductGroupById($id: ID!) {
  productGroupById(id: $id) {
    id
    code
    title
    image
    description
    active
    discontinued
    replacementGroups {
      id
      code
      title
      image
      active
    }
  }
}
    `;

/**
 * __useGetInactiveGroupProductGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetInactiveGroupProductGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInactiveGroupProductGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInactiveGroupProductGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInactiveGroupProductGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables> & ({ variables: GetInactiveGroupProductGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables>(GetInactiveGroupProductGroupByIdDocument, options);
      }
export function useGetInactiveGroupProductGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables>(GetInactiveGroupProductGroupByIdDocument, options);
        }
export function useGetInactiveGroupProductGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables>(GetInactiveGroupProductGroupByIdDocument, options);
        }
export type GetInactiveGroupProductGroupByIdQueryHookResult = ReturnType<typeof useGetInactiveGroupProductGroupByIdQuery>;
export type GetInactiveGroupProductGroupByIdLazyQueryHookResult = ReturnType<typeof useGetInactiveGroupProductGroupByIdLazyQuery>;
export type GetInactiveGroupProductGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetInactiveGroupProductGroupByIdSuspenseQuery>;
export type GetInactiveGroupProductGroupByIdQueryResult = Apollo.QueryResult<GetInactiveGroupProductGroupByIdQuery, GetInactiveGroupProductGroupByIdQueryVariables>;
export const GetLiveChatEmbeddedChatSettingsDocument = gql`
    query GetLiveChatEmbeddedChatSettings {
  embeddedChatSettings {
    embeddedChatSettings {
      orgId
      orgName
      messagingChannel
      experienceSiteUrl
      telephonyUrl
      srcAttribute
      chatEnabled
    }
    primaryEmbeddedChatSettings {
      orgId
      orgName
      messagingChannel
      experienceSiteUrl
      telephonyUrl
      srcAttribute
      chatEnabled
    }
    salesforceSettingName
  }
}
    `;

/**
 * __useGetLiveChatEmbeddedChatSettingsQuery__
 *
 * To run a query within a React component, call `useGetLiveChatEmbeddedChatSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveChatEmbeddedChatSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveChatEmbeddedChatSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLiveChatEmbeddedChatSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>(GetLiveChatEmbeddedChatSettingsDocument, options);
      }
export function useGetLiveChatEmbeddedChatSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>(GetLiveChatEmbeddedChatSettingsDocument, options);
        }
export function useGetLiveChatEmbeddedChatSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>(GetLiveChatEmbeddedChatSettingsDocument, options);
        }
export type GetLiveChatEmbeddedChatSettingsQueryHookResult = ReturnType<typeof useGetLiveChatEmbeddedChatSettingsQuery>;
export type GetLiveChatEmbeddedChatSettingsLazyQueryHookResult = ReturnType<typeof useGetLiveChatEmbeddedChatSettingsLazyQuery>;
export type GetLiveChatEmbeddedChatSettingsSuspenseQueryHookResult = ReturnType<typeof useGetLiveChatEmbeddedChatSettingsSuspenseQuery>;
export type GetLiveChatEmbeddedChatSettingsQueryResult = Apollo.QueryResult<GetLiveChatEmbeddedChatSettingsQuery, GetLiveChatEmbeddedChatSettingsQueryVariables>;
export const GetLocateAJewelerListingsShowcaseUrlDocument = gql`
    query GetLocateAJewelerListingsShowcaseUrl {
  jewelerShowcasesList {
    jewelerShowcaseUrl
    jewelerShowcaseSubdomain
  }
}
    `;

/**
 * __useGetLocateAJewelerListingsShowcaseUrlQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsShowcaseUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsShowcaseUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsShowcaseUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocateAJewelerListingsShowcaseUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>(GetLocateAJewelerListingsShowcaseUrlDocument, options);
      }
export function useGetLocateAJewelerListingsShowcaseUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>(GetLocateAJewelerListingsShowcaseUrlDocument, options);
        }
export function useGetLocateAJewelerListingsShowcaseUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>(GetLocateAJewelerListingsShowcaseUrlDocument, options);
        }
export type GetLocateAJewelerListingsShowcaseUrlQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsShowcaseUrlQuery>;
export type GetLocateAJewelerListingsShowcaseUrlLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsShowcaseUrlLazyQuery>;
export type GetLocateAJewelerListingsShowcaseUrlSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsShowcaseUrlSuspenseQuery>;
export type GetLocateAJewelerListingsShowcaseUrlQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsShowcaseUrlQuery, GetLocateAJewelerListingsShowcaseUrlQueryVariables>;
export const GetLocateAJewelerListingsPermissionsDocument = gql`
    query GetLocateAJewelerListingsPermissions {
  viewerPermissions {
    id
    canCreateLocateAJewelerListings
    canCreateLocateAJewelerListingsWithoutShipToAccount
  }
}
    `;

/**
 * __useGetLocateAJewelerListingsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocateAJewelerListingsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>(GetLocateAJewelerListingsPermissionsDocument, options);
      }
export function useGetLocateAJewelerListingsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>(GetLocateAJewelerListingsPermissionsDocument, options);
        }
export function useGetLocateAJewelerListingsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>(GetLocateAJewelerListingsPermissionsDocument, options);
        }
export type GetLocateAJewelerListingsPermissionsQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsPermissionsQuery>;
export type GetLocateAJewelerListingsPermissionsLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsPermissionsLazyQuery>;
export type GetLocateAJewelerListingsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsPermissionsSuspenseQuery>;
export type GetLocateAJewelerListingsPermissionsQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsPermissionsQuery, GetLocateAJewelerListingsPermissionsQueryVariables>;
export const GetLocateAJewelerListingsByIdDocument = gql`
    query GetLocateAJewelerListingsById($id: ID!) {
  locateAJewelerListingById(id: $id) {
    ...LocateAJewelerListingsListingInfo
  }
}
    ${LocateAJewelerListingsListingInfoFragmentDoc}`;

/**
 * __useGetLocateAJewelerListingsByIdQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables> & ({ variables: GetLocateAJewelerListingsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables>(GetLocateAJewelerListingsByIdDocument, options);
      }
export function useGetLocateAJewelerListingsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables>(GetLocateAJewelerListingsByIdDocument, options);
        }
export function useGetLocateAJewelerListingsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables>(GetLocateAJewelerListingsByIdDocument, options);
        }
export type GetLocateAJewelerListingsByIdQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsByIdQuery>;
export type GetLocateAJewelerListingsByIdLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsByIdLazyQuery>;
export type GetLocateAJewelerListingsByIdSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsByIdSuspenseQuery>;
export type GetLocateAJewelerListingsByIdQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsByIdQuery, GetLocateAJewelerListingsByIdQueryVariables>;
export const GetLocateAJewelerListingsListDocument = gql`
    query GetLocateAJewelerListingsList($paging: PagingInput!) {
  locateAJewelerListingSearch {
    count
    results(paging: $paging) {
      ...LocateAJewelerListingsListingInfo
    }
  }
}
    ${LocateAJewelerListingsListingInfoFragmentDoc}`;

/**
 * __useGetLocateAJewelerListingsListQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsListQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsListQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables> & ({ variables: GetLocateAJewelerListingsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables>(GetLocateAJewelerListingsListDocument, options);
      }
export function useGetLocateAJewelerListingsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables>(GetLocateAJewelerListingsListDocument, options);
        }
export function useGetLocateAJewelerListingsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables>(GetLocateAJewelerListingsListDocument, options);
        }
export type GetLocateAJewelerListingsListQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsListQuery>;
export type GetLocateAJewelerListingsListLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsListLazyQuery>;
export type GetLocateAJewelerListingsListSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsListSuspenseQuery>;
export type GetLocateAJewelerListingsListQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsListQuery, GetLocateAJewelerListingsListQueryVariables>;
export const GetLocateAJewelerListingsUnlistedStoresDocument = gql`
    query GetLocateAJewelerListingsUnlistedStores($paging: PagingInput!) {
  shipToAccountSearch(
    onlyWebActive: true
    onlyLocateAJewelerListingUnlisted: true
  ) {
    count
    results(paging: $paging) {
      ...LocateAJewelerListingsShipToAccountInfo
    }
  }
}
    ${LocateAJewelerListingsShipToAccountInfoFragmentDoc}`;

/**
 * __useGetLocateAJewelerListingsUnlistedStoresQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsUnlistedStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsUnlistedStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsUnlistedStoresQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsUnlistedStoresQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables> & ({ variables: GetLocateAJewelerListingsUnlistedStoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables>(GetLocateAJewelerListingsUnlistedStoresDocument, options);
      }
export function useGetLocateAJewelerListingsUnlistedStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables>(GetLocateAJewelerListingsUnlistedStoresDocument, options);
        }
export function useGetLocateAJewelerListingsUnlistedStoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables>(GetLocateAJewelerListingsUnlistedStoresDocument, options);
        }
export type GetLocateAJewelerListingsUnlistedStoresQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsUnlistedStoresQuery>;
export type GetLocateAJewelerListingsUnlistedStoresLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsUnlistedStoresLazyQuery>;
export type GetLocateAJewelerListingsUnlistedStoresSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsUnlistedStoresSuspenseQuery>;
export type GetLocateAJewelerListingsUnlistedStoresQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsUnlistedStoresQuery, GetLocateAJewelerListingsUnlistedStoresQueryVariables>;
export const GetLocateAJewelerListingsStateOrProvincesDocument = gql`
    query GetLocateAJewelerListingsStateOrProvinces($countryCode: ID!) {
  stateOrProvinces(countryCode: $countryCode) {
    code
    name
  }
}
    `;

/**
 * __useGetLocateAJewelerListingsStateOrProvincesQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsStateOrProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsStateOrProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsStateOrProvincesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsStateOrProvincesQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables> & ({ variables: GetLocateAJewelerListingsStateOrProvincesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables>(GetLocateAJewelerListingsStateOrProvincesDocument, options);
      }
export function useGetLocateAJewelerListingsStateOrProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables>(GetLocateAJewelerListingsStateOrProvincesDocument, options);
        }
export function useGetLocateAJewelerListingsStateOrProvincesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables>(GetLocateAJewelerListingsStateOrProvincesDocument, options);
        }
export type GetLocateAJewelerListingsStateOrProvincesQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsStateOrProvincesQuery>;
export type GetLocateAJewelerListingsStateOrProvincesLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsStateOrProvincesLazyQuery>;
export type GetLocateAJewelerListingsStateOrProvincesSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsStateOrProvincesSuspenseQuery>;
export type GetLocateAJewelerListingsStateOrProvincesQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsStateOrProvincesQuery, GetLocateAJewelerListingsStateOrProvincesQueryVariables>;
export const GetLocateAJewelerListingsCustomerStoreInformationByShipToDocument = gql`
    query GetLocateAJewelerListingsCustomerStoreInformationByShipTo($shipToAccountNumber: String!) {
  customerStoreInformationByShipTo(shipToAccountNumber: $shipToAccountNumber) {
    ...LocateAJewelerListingsCustomerStoreInfo
  }
}
    ${LocateAJewelerListingsCustomerStoreInfoFragmentDoc}`;

/**
 * __useGetLocateAJewelerListingsCustomerStoreInformationByShipToQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsCustomerStoreInformationByShipToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsCustomerStoreInformationByShipToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsCustomerStoreInformationByShipToQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsCustomerStoreInformationByShipToQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables> & ({ variables: GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables>(GetLocateAJewelerListingsCustomerStoreInformationByShipToDocument, options);
      }
export function useGetLocateAJewelerListingsCustomerStoreInformationByShipToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables>(GetLocateAJewelerListingsCustomerStoreInformationByShipToDocument, options);
        }
export function useGetLocateAJewelerListingsCustomerStoreInformationByShipToSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables>(GetLocateAJewelerListingsCustomerStoreInformationByShipToDocument, options);
        }
export type GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCustomerStoreInformationByShipToQuery>;
export type GetLocateAJewelerListingsCustomerStoreInformationByShipToLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCustomerStoreInformationByShipToLazyQuery>;
export type GetLocateAJewelerListingsCustomerStoreInformationByShipToSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCustomerStoreInformationByShipToSuspenseQuery>;
export type GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsCustomerStoreInformationByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationByShipToQueryVariables>;
export const GetLocateAJewelerListingsCustomerStoreInformationIdByShipToDocument = gql`
    query GetLocateAJewelerListingsCustomerStoreInformationIdByShipTo($shipToAccountNumber: String!) {
  customerStoreInformationByShipTo(shipToAccountNumber: $shipToAccountNumber) {
    id
  }
}
    `;

/**
 * __useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables> & ({ variables: GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables>(GetLocateAJewelerListingsCustomerStoreInformationIdByShipToDocument, options);
      }
export function useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables>(GetLocateAJewelerListingsCustomerStoreInformationIdByShipToDocument, options);
        }
export function useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables>(GetLocateAJewelerListingsCustomerStoreInformationIdByShipToDocument, options);
        }
export type GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery>;
export type GetLocateAJewelerListingsCustomerStoreInformationIdByShipToLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToLazyQuery>;
export type GetLocateAJewelerListingsCustomerStoreInformationIdByShipToSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCustomerStoreInformationIdByShipToSuspenseQuery>;
export type GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQuery, GetLocateAJewelerListingsCustomerStoreInformationIdByShipToQueryVariables>;
export const LocateAJewelerListingsDeleteListingDocument = gql`
    mutation LocateAJewelerListingsDeleteListing($input: DeleteLocateAJewelerListingInput) {
  deleteLocateAJewelerListing(input: $input) {
    locateAJewelerListingId
  }
}
    `;
export type LocateAJewelerListingsDeleteListingMutationFn = Apollo.MutationFunction<LocateAJewelerListingsDeleteListingMutation, LocateAJewelerListingsDeleteListingMutationVariables>;

/**
 * __useLocateAJewelerListingsDeleteListingMutation__
 *
 * To run a mutation, you first call `useLocateAJewelerListingsDeleteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocateAJewelerListingsDeleteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locateAJewelerListingsDeleteListingMutation, { data, loading, error }] = useLocateAJewelerListingsDeleteListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocateAJewelerListingsDeleteListingMutation(baseOptions?: Apollo.MutationHookOptions<LocateAJewelerListingsDeleteListingMutation, LocateAJewelerListingsDeleteListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocateAJewelerListingsDeleteListingMutation, LocateAJewelerListingsDeleteListingMutationVariables>(LocateAJewelerListingsDeleteListingDocument, options);
      }
export type LocateAJewelerListingsDeleteListingMutationHookResult = ReturnType<typeof useLocateAJewelerListingsDeleteListingMutation>;
export type LocateAJewelerListingsDeleteListingMutationResult = Apollo.MutationResult<LocateAJewelerListingsDeleteListingMutation>;
export type LocateAJewelerListingsDeleteListingMutationOptions = Apollo.BaseMutationOptions<LocateAJewelerListingsDeleteListingMutation, LocateAJewelerListingsDeleteListingMutationVariables>;
export const LocateAJewelerListingsUpsertCustomerStoreInformationDocument = gql`
    mutation LocateAJewelerListingsUpsertCustomerStoreInformation($input: UpsertCustomerStoreInformationInput!) {
  upsertCustomerStoreInformation(input: $input) {
    customerStoreInformation {
      ...LocateAJewelerListingsCustomerStoreInfo
    }
  }
}
    ${LocateAJewelerListingsCustomerStoreInfoFragmentDoc}`;
export type LocateAJewelerListingsUpsertCustomerStoreInformationMutationFn = Apollo.MutationFunction<LocateAJewelerListingsUpsertCustomerStoreInformationMutation, LocateAJewelerListingsUpsertCustomerStoreInformationMutationVariables>;

/**
 * __useLocateAJewelerListingsUpsertCustomerStoreInformationMutation__
 *
 * To run a mutation, you first call `useLocateAJewelerListingsUpsertCustomerStoreInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocateAJewelerListingsUpsertCustomerStoreInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locateAJewelerListingsUpsertCustomerStoreInformationMutation, { data, loading, error }] = useLocateAJewelerListingsUpsertCustomerStoreInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocateAJewelerListingsUpsertCustomerStoreInformationMutation(baseOptions?: Apollo.MutationHookOptions<LocateAJewelerListingsUpsertCustomerStoreInformationMutation, LocateAJewelerListingsUpsertCustomerStoreInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocateAJewelerListingsUpsertCustomerStoreInformationMutation, LocateAJewelerListingsUpsertCustomerStoreInformationMutationVariables>(LocateAJewelerListingsUpsertCustomerStoreInformationDocument, options);
      }
export type LocateAJewelerListingsUpsertCustomerStoreInformationMutationHookResult = ReturnType<typeof useLocateAJewelerListingsUpsertCustomerStoreInformationMutation>;
export type LocateAJewelerListingsUpsertCustomerStoreInformationMutationResult = Apollo.MutationResult<LocateAJewelerListingsUpsertCustomerStoreInformationMutation>;
export type LocateAJewelerListingsUpsertCustomerStoreInformationMutationOptions = Apollo.BaseMutationOptions<LocateAJewelerListingsUpsertCustomerStoreInformationMutation, LocateAJewelerListingsUpsertCustomerStoreInformationMutationVariables>;
export const LocateAJewelerListingsUpdateListingDocument = gql`
    mutation LocateAJewelerListingsUpdateListing($input: UpdateLocateAJewelerListingInput) {
  updateLocateAJewelerListing(input: $input) {
    locateAJewelerListing {
      ...LocateAJewelerListingsListingInfo
    }
  }
}
    ${LocateAJewelerListingsListingInfoFragmentDoc}`;
export type LocateAJewelerListingsUpdateListingMutationFn = Apollo.MutationFunction<LocateAJewelerListingsUpdateListingMutation, LocateAJewelerListingsUpdateListingMutationVariables>;

/**
 * __useLocateAJewelerListingsUpdateListingMutation__
 *
 * To run a mutation, you first call `useLocateAJewelerListingsUpdateListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocateAJewelerListingsUpdateListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locateAJewelerListingsUpdateListingMutation, { data, loading, error }] = useLocateAJewelerListingsUpdateListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocateAJewelerListingsUpdateListingMutation(baseOptions?: Apollo.MutationHookOptions<LocateAJewelerListingsUpdateListingMutation, LocateAJewelerListingsUpdateListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocateAJewelerListingsUpdateListingMutation, LocateAJewelerListingsUpdateListingMutationVariables>(LocateAJewelerListingsUpdateListingDocument, options);
      }
export type LocateAJewelerListingsUpdateListingMutationHookResult = ReturnType<typeof useLocateAJewelerListingsUpdateListingMutation>;
export type LocateAJewelerListingsUpdateListingMutationResult = Apollo.MutationResult<LocateAJewelerListingsUpdateListingMutation>;
export type LocateAJewelerListingsUpdateListingMutationOptions = Apollo.BaseMutationOptions<LocateAJewelerListingsUpdateListingMutation, LocateAJewelerListingsUpdateListingMutationVariables>;
export const LocateAJewelerListingsCreateListingDocument = gql`
    mutation LocateAJewelerListingsCreateListing($input: CreateLocateAJewelerListingInput) {
  createLocateAJewelerListing(input: $input) {
    locateAJewelerListing {
      ...LocateAJewelerListingsListingInfo
    }
  }
}
    ${LocateAJewelerListingsListingInfoFragmentDoc}`;
export type LocateAJewelerListingsCreateListingMutationFn = Apollo.MutationFunction<LocateAJewelerListingsCreateListingMutation, LocateAJewelerListingsCreateListingMutationVariables>;

/**
 * __useLocateAJewelerListingsCreateListingMutation__
 *
 * To run a mutation, you first call `useLocateAJewelerListingsCreateListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocateAJewelerListingsCreateListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locateAJewelerListingsCreateListingMutation, { data, loading, error }] = useLocateAJewelerListingsCreateListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocateAJewelerListingsCreateListingMutation(baseOptions?: Apollo.MutationHookOptions<LocateAJewelerListingsCreateListingMutation, LocateAJewelerListingsCreateListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocateAJewelerListingsCreateListingMutation, LocateAJewelerListingsCreateListingMutationVariables>(LocateAJewelerListingsCreateListingDocument, options);
      }
export type LocateAJewelerListingsCreateListingMutationHookResult = ReturnType<typeof useLocateAJewelerListingsCreateListingMutation>;
export type LocateAJewelerListingsCreateListingMutationResult = Apollo.MutationResult<LocateAJewelerListingsCreateListingMutation>;
export type LocateAJewelerListingsCreateListingMutationOptions = Apollo.BaseMutationOptions<LocateAJewelerListingsCreateListingMutation, LocateAJewelerListingsCreateListingMutationVariables>;
export const GetLocateAJewelerListingsMultiCheckBoxOptionsDocument = gql`
    query GetLocateAJewelerListingsMultiCheckBoxOptions($type: String!) {
  cmsLookupsByType(type: $type) {
    id
    name: value
  }
}
    `;

/**
 * __useGetLocateAJewelerListingsMultiCheckBoxOptionsQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsMultiCheckBoxOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsMultiCheckBoxOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsMultiCheckBoxOptionsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsMultiCheckBoxOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables> & ({ variables: GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables>(GetLocateAJewelerListingsMultiCheckBoxOptionsDocument, options);
      }
export function useGetLocateAJewelerListingsMultiCheckBoxOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables>(GetLocateAJewelerListingsMultiCheckBoxOptionsDocument, options);
        }
export function useGetLocateAJewelerListingsMultiCheckBoxOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables>(GetLocateAJewelerListingsMultiCheckBoxOptionsDocument, options);
        }
export type GetLocateAJewelerListingsMultiCheckBoxOptionsQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsMultiCheckBoxOptionsQuery>;
export type GetLocateAJewelerListingsMultiCheckBoxOptionsLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsMultiCheckBoxOptionsLazyQuery>;
export type GetLocateAJewelerListingsMultiCheckBoxOptionsSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsMultiCheckBoxOptionsSuspenseQuery>;
export type GetLocateAJewelerListingsMultiCheckBoxOptionsQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsMultiCheckBoxOptionsQuery, GetLocateAJewelerListingsMultiCheckBoxOptionsQueryVariables>;
export const GetLocateAJewelerListingsCountriesDocument = gql`
    query GetLocateAJewelerListingsCountries {
  countries {
    code
    name
  }
}
    `;

/**
 * __useGetLocateAJewelerListingsCountriesQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocateAJewelerListingsCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>(GetLocateAJewelerListingsCountriesDocument, options);
      }
export function useGetLocateAJewelerListingsCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>(GetLocateAJewelerListingsCountriesDocument, options);
        }
export function useGetLocateAJewelerListingsCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>(GetLocateAJewelerListingsCountriesDocument, options);
        }
export type GetLocateAJewelerListingsCountriesQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCountriesQuery>;
export type GetLocateAJewelerListingsCountriesLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCountriesLazyQuery>;
export type GetLocateAJewelerListingsCountriesSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsCountriesSuspenseQuery>;
export type GetLocateAJewelerListingsCountriesQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsCountriesQuery, GetLocateAJewelerListingsCountriesQueryVariables>;
export const GetLocateAJewelerListingsShipToAccountByAccountNumberDocument = gql`
    query GetLocateAJewelerListingsShipToAccountByAccountNumber($accountNumber: String!) {
  shipToAccountByAccountNumber(accountNumber: $accountNumber) {
    ...LocateAJewelerListingsShipToAccountInfo
  }
}
    ${LocateAJewelerListingsShipToAccountInfoFragmentDoc}`;

/**
 * __useGetLocateAJewelerListingsShipToAccountByAccountNumberQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerListingsShipToAccountByAccountNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerListingsShipToAccountByAccountNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerListingsShipToAccountByAccountNumberQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useGetLocateAJewelerListingsShipToAccountByAccountNumberQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables> & ({ variables: GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables>(GetLocateAJewelerListingsShipToAccountByAccountNumberDocument, options);
      }
export function useGetLocateAJewelerListingsShipToAccountByAccountNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables>(GetLocateAJewelerListingsShipToAccountByAccountNumberDocument, options);
        }
export function useGetLocateAJewelerListingsShipToAccountByAccountNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables>(GetLocateAJewelerListingsShipToAccountByAccountNumberDocument, options);
        }
export type GetLocateAJewelerListingsShipToAccountByAccountNumberQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsShipToAccountByAccountNumberQuery>;
export type GetLocateAJewelerListingsShipToAccountByAccountNumberLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsShipToAccountByAccountNumberLazyQuery>;
export type GetLocateAJewelerListingsShipToAccountByAccountNumberSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerListingsShipToAccountByAccountNumberSuspenseQuery>;
export type GetLocateAJewelerListingsShipToAccountByAccountNumberQueryResult = Apollo.QueryResult<GetLocateAJewelerListingsShipToAccountByAccountNumberQuery, GetLocateAJewelerListingsShipToAccountByAccountNumberQueryVariables>;
export const GetLocateAJewelerSearchPagePermissionsDocument = gql`
    query GetLocateAJewelerSearchPagePermissions {
  viewerPermissions {
    id
    canCreateLocateAJewelerListings
  }
}
    `;

/**
 * __useGetLocateAJewelerSearchPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerSearchPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerSearchPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerSearchPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocateAJewelerSearchPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>(GetLocateAJewelerSearchPagePermissionsDocument, options);
      }
export function useGetLocateAJewelerSearchPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>(GetLocateAJewelerSearchPagePermissionsDocument, options);
        }
export function useGetLocateAJewelerSearchPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>(GetLocateAJewelerSearchPagePermissionsDocument, options);
        }
export type GetLocateAJewelerSearchPagePermissionsQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPagePermissionsQuery>;
export type GetLocateAJewelerSearchPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPagePermissionsLazyQuery>;
export type GetLocateAJewelerSearchPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPagePermissionsSuspenseQuery>;
export type GetLocateAJewelerSearchPagePermissionsQueryResult = Apollo.QueryResult<GetLocateAJewelerSearchPagePermissionsQuery, GetLocateAJewelerSearchPagePermissionsQueryVariables>;
export const GetLocateAJewelerSearchPageDistanceSearchDocument = gql`
    query GetLocateAJewelerSearchPageDistanceSearch($latitude: Float!, $longitude: Float!, $rangeInMiles: Int!, $services: [String!], $paging: PagingInput!) {
  locateAJewelerListingsDistanceSearch(
    latitude: $latitude
    longitude: $longitude
    rangeInMiles: $rangeInMiles
    services: $services
  ) {
    count
    results(paging: $paging) {
      distanceInMiles
      locateAJewelerListing {
        address {
          addressLine1
          addressLine2
          city
          country
          stateOrProvince
          zip
        }
        doingBusinessAs
        email
        hours {
          sunday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
          monday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
          tuesday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
          wednesday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
          thursday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
          friday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
          saturday {
            ...LocateAJewelerSearchPageHoursSettingsInfo
          }
        }
        id
        jewelerShowcase
        longitude
        latitude
        phoneNumber
        services
        socials {
          facebook
          instagram
          pinterest
          twitter
          youtube
        }
        website
      }
    }
  }
}
    ${LocateAJewelerSearchPageHoursSettingsInfoFragmentDoc}`;

/**
 * __useGetLocateAJewelerSearchPageDistanceSearchQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerSearchPageDistanceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerSearchPageDistanceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerSearchPageDistanceSearchQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      rangeInMiles: // value for 'rangeInMiles'
 *      services: // value for 'services'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetLocateAJewelerSearchPageDistanceSearchQuery(baseOptions: Apollo.QueryHookOptions<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables> & ({ variables: GetLocateAJewelerSearchPageDistanceSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables>(GetLocateAJewelerSearchPageDistanceSearchDocument, options);
      }
export function useGetLocateAJewelerSearchPageDistanceSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables>(GetLocateAJewelerSearchPageDistanceSearchDocument, options);
        }
export function useGetLocateAJewelerSearchPageDistanceSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables>(GetLocateAJewelerSearchPageDistanceSearchDocument, options);
        }
export type GetLocateAJewelerSearchPageDistanceSearchQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPageDistanceSearchQuery>;
export type GetLocateAJewelerSearchPageDistanceSearchLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPageDistanceSearchLazyQuery>;
export type GetLocateAJewelerSearchPageDistanceSearchSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPageDistanceSearchSuspenseQuery>;
export type GetLocateAJewelerSearchPageDistanceSearchQueryResult = Apollo.QueryResult<GetLocateAJewelerSearchPageDistanceSearchQuery, GetLocateAJewelerSearchPageDistanceSearchQueryVariables>;
export const GetLocateAJewelerSearchPageServicesDocument = gql`
    query GetLocateAJewelerSearchPageServices {
  cmsLookupsByType(type: "Locate a Jeweler Services") {
    id
    name: value
    order
  }
}
    `;

/**
 * __useGetLocateAJewelerSearchPageServicesQuery__
 *
 * To run a query within a React component, call `useGetLocateAJewelerSearchPageServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocateAJewelerSearchPageServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocateAJewelerSearchPageServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocateAJewelerSearchPageServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>(GetLocateAJewelerSearchPageServicesDocument, options);
      }
export function useGetLocateAJewelerSearchPageServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>(GetLocateAJewelerSearchPageServicesDocument, options);
        }
export function useGetLocateAJewelerSearchPageServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>(GetLocateAJewelerSearchPageServicesDocument, options);
        }
export type GetLocateAJewelerSearchPageServicesQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPageServicesQuery>;
export type GetLocateAJewelerSearchPageServicesLazyQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPageServicesLazyQuery>;
export type GetLocateAJewelerSearchPageServicesSuspenseQueryHookResult = ReturnType<typeof useGetLocateAJewelerSearchPageServicesSuspenseQuery>;
export type GetLocateAJewelerSearchPageServicesQueryResult = Apollo.QueryResult<GetLocateAJewelerSearchPageServicesQuery, GetLocateAJewelerSearchPageServicesQueryVariables>;
export const GetLocationSelectorShipToAccountSearchDocument = gql`
    query GetLocationSelectorShipToAccountSearch($onlyWebActive: Boolean, $term: String, $onlyLocateAJewelerListingUnlisted: Boolean, $consultantSearchAcrossAllBillToAccounts: Boolean, $paging: PagingInput!) {
  shipToAccountSearch(
    onlyWebActive: $onlyWebActive
    term: $term
    onlyLocateAJewelerListingUnlisted: $onlyLocateAJewelerListingUnlisted
    consultantSearchAcrossAllBillToAccounts: $consultantSearchAcrossAllBillToAccounts
  ) {
    count
    results(paging: $paging) {
      ...LocationSelectorShipToAccountInfo
    }
  }
}
    ${LocationSelectorShipToAccountInfoFragmentDoc}`;

/**
 * __useGetLocationSelectorShipToAccountSearchQuery__
 *
 * To run a query within a React component, call `useGetLocationSelectorShipToAccountSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSelectorShipToAccountSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSelectorShipToAccountSearchQuery({
 *   variables: {
 *      onlyWebActive: // value for 'onlyWebActive'
 *      term: // value for 'term'
 *      onlyLocateAJewelerListingUnlisted: // value for 'onlyLocateAJewelerListingUnlisted'
 *      consultantSearchAcrossAllBillToAccounts: // value for 'consultantSearchAcrossAllBillToAccounts'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetLocationSelectorShipToAccountSearchQuery(baseOptions: Apollo.QueryHookOptions<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables> & ({ variables: GetLocationSelectorShipToAccountSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables>(GetLocationSelectorShipToAccountSearchDocument, options);
      }
export function useGetLocationSelectorShipToAccountSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables>(GetLocationSelectorShipToAccountSearchDocument, options);
        }
export function useGetLocationSelectorShipToAccountSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables>(GetLocationSelectorShipToAccountSearchDocument, options);
        }
export type GetLocationSelectorShipToAccountSearchQueryHookResult = ReturnType<typeof useGetLocationSelectorShipToAccountSearchQuery>;
export type GetLocationSelectorShipToAccountSearchLazyQueryHookResult = ReturnType<typeof useGetLocationSelectorShipToAccountSearchLazyQuery>;
export type GetLocationSelectorShipToAccountSearchSuspenseQueryHookResult = ReturnType<typeof useGetLocationSelectorShipToAccountSearchSuspenseQuery>;
export type GetLocationSelectorShipToAccountSearchQueryResult = Apollo.QueryResult<GetLocationSelectorShipToAccountSearchQuery, GetLocationSelectorShipToAccountSearchQueryVariables>;
export const GetMarketRatesFooterMarketRatesDocument = gql`
    query GetMarketRatesFooterMarketRates($limit: Int!) {
  marketRates(limit: $limit) {
    id
    date
    url
    gold
    palladium
    platinum
    silver
  }
}
    `;

/**
 * __useGetMarketRatesFooterMarketRatesQuery__
 *
 * To run a query within a React component, call `useGetMarketRatesFooterMarketRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketRatesFooterMarketRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketRatesFooterMarketRatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMarketRatesFooterMarketRatesQuery(baseOptions: Apollo.QueryHookOptions<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables> & ({ variables: GetMarketRatesFooterMarketRatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables>(GetMarketRatesFooterMarketRatesDocument, options);
      }
export function useGetMarketRatesFooterMarketRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables>(GetMarketRatesFooterMarketRatesDocument, options);
        }
export function useGetMarketRatesFooterMarketRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables>(GetMarketRatesFooterMarketRatesDocument, options);
        }
export type GetMarketRatesFooterMarketRatesQueryHookResult = ReturnType<typeof useGetMarketRatesFooterMarketRatesQuery>;
export type GetMarketRatesFooterMarketRatesLazyQueryHookResult = ReturnType<typeof useGetMarketRatesFooterMarketRatesLazyQuery>;
export type GetMarketRatesFooterMarketRatesSuspenseQueryHookResult = ReturnType<typeof useGetMarketRatesFooterMarketRatesSuspenseQuery>;
export type GetMarketRatesFooterMarketRatesQueryResult = Apollo.QueryResult<GetMarketRatesFooterMarketRatesQuery, GetMarketRatesFooterMarketRatesQueryVariables>;
export const GetPaymentMethodsPagePermissionsDocument = gql`
    query GetPaymentMethodsPagePermissions {
  viewerPermissions {
    id
    canUseCreditCards
  }
}
    `;

/**
 * __useGetPaymentMethodsPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>(GetPaymentMethodsPagePermissionsDocument, options);
      }
export function useGetPaymentMethodsPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>(GetPaymentMethodsPagePermissionsDocument, options);
        }
export function useGetPaymentMethodsPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>(GetPaymentMethodsPagePermissionsDocument, options);
        }
export type GetPaymentMethodsPagePermissionsQueryHookResult = ReturnType<typeof useGetPaymentMethodsPagePermissionsQuery>;
export type GetPaymentMethodsPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsPagePermissionsLazyQuery>;
export type GetPaymentMethodsPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsPagePermissionsSuspenseQuery>;
export type GetPaymentMethodsPagePermissionsQueryResult = Apollo.QueryResult<GetPaymentMethodsPagePermissionsQuery, GetPaymentMethodsPagePermissionsQueryVariables>;
export const GetPaymentMethodsPermissionsDocument = gql`
    query GetPaymentMethodsPermissions {
  viewerPermissions {
    id
    canManagePaymentMethods
  }
}
    `;

/**
 * __useGetPaymentMethodsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>(GetPaymentMethodsPermissionsDocument, options);
      }
export function useGetPaymentMethodsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>(GetPaymentMethodsPermissionsDocument, options);
        }
export function useGetPaymentMethodsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>(GetPaymentMethodsPermissionsDocument, options);
        }
export type GetPaymentMethodsPermissionsQueryHookResult = ReturnType<typeof useGetPaymentMethodsPermissionsQuery>;
export type GetPaymentMethodsPermissionsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsPermissionsLazyQuery>;
export type GetPaymentMethodsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsPermissionsSuspenseQuery>;
export type GetPaymentMethodsPermissionsQueryResult = Apollo.QueryResult<GetPaymentMethodsPermissionsQuery, GetPaymentMethodsPermissionsQueryVariables>;
export const GetPaymentMethodsMethodsDocument = gql`
    query GetPaymentMethodsMethods($context: PaymentMethodContext!) {
  viewer {
    paymentMethods(context: $context) {
      ... on COD {
        id
      }
      ... on NormalTerms {
        id
      }
      ... on CreditCard {
        ...PaymentMethodsCreditCardInfo
      }
    }
    defaultPaymentMethod {
      ... on COD {
        id
      }
      ... on NormalTerms {
        id
      }
      ... on CreditCard {
        id
      }
    }
  }
}
    ${PaymentMethodsCreditCardInfoFragmentDoc}`;

/**
 * __useGetPaymentMethodsMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsMethodsQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetPaymentMethodsMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables> & ({ variables: GetPaymentMethodsMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables>(GetPaymentMethodsMethodsDocument, options);
      }
export function useGetPaymentMethodsMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables>(GetPaymentMethodsMethodsDocument, options);
        }
export function useGetPaymentMethodsMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables>(GetPaymentMethodsMethodsDocument, options);
        }
export type GetPaymentMethodsMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsMethodsQuery>;
export type GetPaymentMethodsMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsMethodsLazyQuery>;
export type GetPaymentMethodsMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsMethodsSuspenseQuery>;
export type GetPaymentMethodsMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsMethodsQuery, GetPaymentMethodsMethodsQueryVariables>;
export const PaymentMethodsCreateCreditCardDocument = gql`
    mutation PaymentMethodsCreateCreditCard($input: CreateCreditCardInput!) {
  createCreditCard(input: $input) {
    creditCard {
      id
      cardholderName
      expirationMonth
      expirationYear
      isDebitCard
      isExpired
      lastFourDigits
      tokenizedCardNumber
      type
      zip
    }
  }
}
    `;
export type PaymentMethodsCreateCreditCardMutationFn = Apollo.MutationFunction<PaymentMethodsCreateCreditCardMutation, PaymentMethodsCreateCreditCardMutationVariables>;

/**
 * __usePaymentMethodsCreateCreditCardMutation__
 *
 * To run a mutation, you first call `usePaymentMethodsCreateCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsCreateCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodsCreateCreditCardMutation, { data, loading, error }] = usePaymentMethodsCreateCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentMethodsCreateCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodsCreateCreditCardMutation, PaymentMethodsCreateCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodsCreateCreditCardMutation, PaymentMethodsCreateCreditCardMutationVariables>(PaymentMethodsCreateCreditCardDocument, options);
      }
export type PaymentMethodsCreateCreditCardMutationHookResult = ReturnType<typeof usePaymentMethodsCreateCreditCardMutation>;
export type PaymentMethodsCreateCreditCardMutationResult = Apollo.MutationResult<PaymentMethodsCreateCreditCardMutation>;
export type PaymentMethodsCreateCreditCardMutationOptions = Apollo.BaseMutationOptions<PaymentMethodsCreateCreditCardMutation, PaymentMethodsCreateCreditCardMutationVariables>;
export const PaymentMethodsUpdateDefaultPaymentMethodDocument = gql`
    mutation PaymentMethodsUpdateDefaultPaymentMethod($input: UpdateDefaultPaymentMethodInput!) {
  updateDefaultPaymentMethod(input: $input) {
    defaultPaymentMethod {
      ... on COD {
        id
      }
      ... on NormalTerms {
        id
      }
      ... on CreditCard {
        id
        type
        cardholderName
        isDebitCard
        zip
        expirationMonth
        expirationYear
        isExpired
        tokenizedCardNumber
        lastFourDigits
      }
    }
  }
}
    `;
export type PaymentMethodsUpdateDefaultPaymentMethodMutationFn = Apollo.MutationFunction<PaymentMethodsUpdateDefaultPaymentMethodMutation, PaymentMethodsUpdateDefaultPaymentMethodMutationVariables>;

/**
 * __usePaymentMethodsUpdateDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `usePaymentMethodsUpdateDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsUpdateDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodsUpdateDefaultPaymentMethodMutation, { data, loading, error }] = usePaymentMethodsUpdateDefaultPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentMethodsUpdateDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodsUpdateDefaultPaymentMethodMutation, PaymentMethodsUpdateDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodsUpdateDefaultPaymentMethodMutation, PaymentMethodsUpdateDefaultPaymentMethodMutationVariables>(PaymentMethodsUpdateDefaultPaymentMethodDocument, options);
      }
export type PaymentMethodsUpdateDefaultPaymentMethodMutationHookResult = ReturnType<typeof usePaymentMethodsUpdateDefaultPaymentMethodMutation>;
export type PaymentMethodsUpdateDefaultPaymentMethodMutationResult = Apollo.MutationResult<PaymentMethodsUpdateDefaultPaymentMethodMutation>;
export type PaymentMethodsUpdateDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<PaymentMethodsUpdateDefaultPaymentMethodMutation, PaymentMethodsUpdateDefaultPaymentMethodMutationVariables>;
export const PaymentMethodsDeleteCreditCardDocument = gql`
    mutation PaymentMethodsDeleteCreditCard($input: DeleteCreditCardInput!) {
  deleteCreditCard(input: $input) {
    creditCardId
  }
}
    `;
export type PaymentMethodsDeleteCreditCardMutationFn = Apollo.MutationFunction<PaymentMethodsDeleteCreditCardMutation, PaymentMethodsDeleteCreditCardMutationVariables>;

/**
 * __usePaymentMethodsDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `usePaymentMethodsDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodsDeleteCreditCardMutation, { data, loading, error }] = usePaymentMethodsDeleteCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentMethodsDeleteCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodsDeleteCreditCardMutation, PaymentMethodsDeleteCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodsDeleteCreditCardMutation, PaymentMethodsDeleteCreditCardMutationVariables>(PaymentMethodsDeleteCreditCardDocument, options);
      }
export type PaymentMethodsDeleteCreditCardMutationHookResult = ReturnType<typeof usePaymentMethodsDeleteCreditCardMutation>;
export type PaymentMethodsDeleteCreditCardMutationResult = Apollo.MutationResult<PaymentMethodsDeleteCreditCardMutation>;
export type PaymentMethodsDeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<PaymentMethodsDeleteCreditCardMutation, PaymentMethodsDeleteCreditCardMutationVariables>;
export const PaymentMethodsUpdateCreditCardDocument = gql`
    mutation PaymentMethodsUpdateCreditCard($input: UpdateCreditCardInput!) {
  updateCreditCard(input: $input) {
    creditCard {
      id
      cardholderName
      expirationMonth
      expirationYear
      isDebitCard
      isExpired
      lastFourDigits
      tokenizedCardNumber
      type
      zip
    }
  }
}
    `;
export type PaymentMethodsUpdateCreditCardMutationFn = Apollo.MutationFunction<PaymentMethodsUpdateCreditCardMutation, PaymentMethodsUpdateCreditCardMutationVariables>;

/**
 * __usePaymentMethodsUpdateCreditCardMutation__
 *
 * To run a mutation, you first call `usePaymentMethodsUpdateCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsUpdateCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodsUpdateCreditCardMutation, { data, loading, error }] = usePaymentMethodsUpdateCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentMethodsUpdateCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodsUpdateCreditCardMutation, PaymentMethodsUpdateCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodsUpdateCreditCardMutation, PaymentMethodsUpdateCreditCardMutationVariables>(PaymentMethodsUpdateCreditCardDocument, options);
      }
export type PaymentMethodsUpdateCreditCardMutationHookResult = ReturnType<typeof usePaymentMethodsUpdateCreditCardMutation>;
export type PaymentMethodsUpdateCreditCardMutationResult = Apollo.MutationResult<PaymentMethodsUpdateCreditCardMutation>;
export type PaymentMethodsUpdateCreditCardMutationOptions = Apollo.BaseMutationOptions<PaymentMethodsUpdateCreditCardMutation, PaymentMethodsUpdateCreditCardMutationVariables>;
export const GetPreferenceCenterPageUnavailableDocument = gql`
    query GetPreferenceCenterPageUnavailable {
  cmsLookupByTypeAndCode(
    type: "system-settings"
    code: "feature-preference-center-unavailable"
  ) {
    id
    unavailable: value
  }
}
    `;

/**
 * __useGetPreferenceCenterPageUnavailableQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageUnavailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageUnavailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageUnavailableQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreferenceCenterPageUnavailableQuery(baseOptions?: Apollo.QueryHookOptions<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>(GetPreferenceCenterPageUnavailableDocument, options);
      }
export function useGetPreferenceCenterPageUnavailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>(GetPreferenceCenterPageUnavailableDocument, options);
        }
export function useGetPreferenceCenterPageUnavailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>(GetPreferenceCenterPageUnavailableDocument, options);
        }
export type GetPreferenceCenterPageUnavailableQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageUnavailableQuery>;
export type GetPreferenceCenterPageUnavailableLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageUnavailableLazyQuery>;
export type GetPreferenceCenterPageUnavailableSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageUnavailableSuspenseQuery>;
export type GetPreferenceCenterPageUnavailableQueryResult = Apollo.QueryResult<GetPreferenceCenterPageUnavailableQuery, GetPreferenceCenterPageUnavailableQueryVariables>;
export const GetPreferenceCenterPageShipToAccountByAccountNumberDocument = gql`
    query GetPreferenceCenterPageShipToAccountByAccountNumber($accountNumber: String!) {
  shipToAccountByAccountNumber(accountNumber: $accountNumber) {
    id
    accountNumber
    address {
      isInternational
    }
  }
}
    `;

/**
 * __useGetPreferenceCenterPageShipToAccountByAccountNumberQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageShipToAccountByAccountNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageShipToAccountByAccountNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageShipToAccountByAccountNumberQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useGetPreferenceCenterPageShipToAccountByAccountNumberQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables> & ({ variables: GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables>(GetPreferenceCenterPageShipToAccountByAccountNumberDocument, options);
      }
export function useGetPreferenceCenterPageShipToAccountByAccountNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables>(GetPreferenceCenterPageShipToAccountByAccountNumberDocument, options);
        }
export function useGetPreferenceCenterPageShipToAccountByAccountNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables>(GetPreferenceCenterPageShipToAccountByAccountNumberDocument, options);
        }
export type GetPreferenceCenterPageShipToAccountByAccountNumberQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageShipToAccountByAccountNumberQuery>;
export type GetPreferenceCenterPageShipToAccountByAccountNumberLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageShipToAccountByAccountNumberLazyQuery>;
export type GetPreferenceCenterPageShipToAccountByAccountNumberSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageShipToAccountByAccountNumberSuspenseQuery>;
export type GetPreferenceCenterPageShipToAccountByAccountNumberQueryResult = Apollo.QueryResult<GetPreferenceCenterPageShipToAccountByAccountNumberQuery, GetPreferenceCenterPageShipToAccountByAccountNumberQueryVariables>;
export const GetPreferenceCenterPageContactsByPhoneNumberDocument = gql`
    query GetPreferenceCenterPageContactsByPhoneNumber($phoneNumber: String!, $shipToAccountNumber: String!, $paging: PagingInput!) {
  contactsByPhoneNumber(
    phoneNumber: $phoneNumber
    shipToAccountNumber: $shipToAccountNumber
  ) {
    count
    results(paging: $paging) {
      ...PreferenceContactInfo
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;

/**
 * __useGetPreferenceCenterPageContactsByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageContactsByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageContactsByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageContactsByPhoneNumberQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetPreferenceCenterPageContactsByPhoneNumberQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables> & ({ variables: GetPreferenceCenterPageContactsByPhoneNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables>(GetPreferenceCenterPageContactsByPhoneNumberDocument, options);
      }
export function useGetPreferenceCenterPageContactsByPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables>(GetPreferenceCenterPageContactsByPhoneNumberDocument, options);
        }
export function useGetPreferenceCenterPageContactsByPhoneNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables>(GetPreferenceCenterPageContactsByPhoneNumberDocument, options);
        }
export type GetPreferenceCenterPageContactsByPhoneNumberQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactsByPhoneNumberQuery>;
export type GetPreferenceCenterPageContactsByPhoneNumberLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactsByPhoneNumberLazyQuery>;
export type GetPreferenceCenterPageContactsByPhoneNumberSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactsByPhoneNumberSuspenseQuery>;
export type GetPreferenceCenterPageContactsByPhoneNumberQueryResult = Apollo.QueryResult<GetPreferenceCenterPageContactsByPhoneNumberQuery, GetPreferenceCenterPageContactsByPhoneNumberQueryVariables>;
export const GetPreferenceCenterPageContactsByEmailDocument = gql`
    query GetPreferenceCenterPageContactsByEmail($email: String!, $shipToAccountNumber: String!, $paging: PagingInput!) {
  contactsByEmail(email: $email, shipToAccountNumber: $shipToAccountNumber) {
    count
    results(paging: $paging) {
      ...PreferenceContactInfo
    }
  }
}
    ${PreferenceContactInfoFragmentDoc}`;

/**
 * __useGetPreferenceCenterPageContactsByEmailQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageContactsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageContactsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageContactsByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetPreferenceCenterPageContactsByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables> & ({ variables: GetPreferenceCenterPageContactsByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables>(GetPreferenceCenterPageContactsByEmailDocument, options);
      }
export function useGetPreferenceCenterPageContactsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables>(GetPreferenceCenterPageContactsByEmailDocument, options);
        }
export function useGetPreferenceCenterPageContactsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables>(GetPreferenceCenterPageContactsByEmailDocument, options);
        }
export type GetPreferenceCenterPageContactsByEmailQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactsByEmailQuery>;
export type GetPreferenceCenterPageContactsByEmailLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactsByEmailLazyQuery>;
export type GetPreferenceCenterPageContactsByEmailSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactsByEmailSuspenseQuery>;
export type GetPreferenceCenterPageContactsByEmailQueryResult = Apollo.QueryResult<GetPreferenceCenterPageContactsByEmailQuery, GetPreferenceCenterPageContactsByEmailQueryVariables>;
export const GetPreferenceCenterPageContactPreferencesDocument = gql`
    query GetPreferenceCenterPageContactPreferences($contactId: ID!, $shipToAccountNumber: ID!) {
  contactPreferencesByContactId(
    contactId: $contactId
    shipToAccountNumber: $shipToAccountNumber
  ) {
    ...PreferenceCenterPageCommunicationPreferenceInfo
  }
}
    ${PreferenceCenterPageCommunicationPreferenceInfoFragmentDoc}`;

/**
 * __useGetPreferenceCenterPageContactPreferencesQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageContactPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageContactPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageContactPreferencesQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *   },
 * });
 */
export function useGetPreferenceCenterPageContactPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables> & ({ variables: GetPreferenceCenterPageContactPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables>(GetPreferenceCenterPageContactPreferencesDocument, options);
      }
export function useGetPreferenceCenterPageContactPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables>(GetPreferenceCenterPageContactPreferencesDocument, options);
        }
export function useGetPreferenceCenterPageContactPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables>(GetPreferenceCenterPageContactPreferencesDocument, options);
        }
export type GetPreferenceCenterPageContactPreferencesQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactPreferencesQuery>;
export type GetPreferenceCenterPageContactPreferencesLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactPreferencesLazyQuery>;
export type GetPreferenceCenterPageContactPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactPreferencesSuspenseQuery>;
export type GetPreferenceCenterPageContactPreferencesQueryResult = Apollo.QueryResult<GetPreferenceCenterPageContactPreferencesQuery, GetPreferenceCenterPageContactPreferencesQueryVariables>;
export const GetPreferenceCenterPageContactPreferencesResponseDocument = gql`
    query GetPreferenceCenterPageContactPreferencesResponse($contactId: ID!, $shipToAccountNumber: ID!) {
  contactPreferencesResponseByContactId(
    contactId: $contactId
    shipToAccountNumber: $shipToAccountNumber
  ) {
    communicationPreferences {
      ...PreferenceCenterPageCommunicationPreferenceInfo
    }
    communicationChannelGlobalSubscriptions {
      engagementChannelType
      sfdcContactId
      status
      optedOut
    }
    optedOutEngagementChannels
  }
}
    ${PreferenceCenterPageCommunicationPreferenceInfoFragmentDoc}`;

/**
 * __useGetPreferenceCenterPageContactPreferencesResponseQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageContactPreferencesResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageContactPreferencesResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageContactPreferencesResponseQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *   },
 * });
 */
export function useGetPreferenceCenterPageContactPreferencesResponseQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables> & ({ variables: GetPreferenceCenterPageContactPreferencesResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables>(GetPreferenceCenterPageContactPreferencesResponseDocument, options);
      }
export function useGetPreferenceCenterPageContactPreferencesResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables>(GetPreferenceCenterPageContactPreferencesResponseDocument, options);
        }
export function useGetPreferenceCenterPageContactPreferencesResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables>(GetPreferenceCenterPageContactPreferencesResponseDocument, options);
        }
export type GetPreferenceCenterPageContactPreferencesResponseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactPreferencesResponseQuery>;
export type GetPreferenceCenterPageContactPreferencesResponseLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactPreferencesResponseLazyQuery>;
export type GetPreferenceCenterPageContactPreferencesResponseSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageContactPreferencesResponseSuspenseQuery>;
export type GetPreferenceCenterPageContactPreferencesResponseQueryResult = Apollo.QueryResult<GetPreferenceCenterPageContactPreferencesResponseQuery, GetPreferenceCenterPageContactPreferencesResponseQueryVariables>;
export const GetPreferenceCenterPageAccountSettingsUserContactsPermissionsDocument = gql`
    query GetPreferenceCenterPageAccountSettingsUserContactsPermissions($shipToAccountNumber: ID!) {
  viewerPermissions {
    id
    canAdminContacts(shipToAccountNumber: $shipToAccountNumber)
  }
}
    `;

/**
 * __useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *   },
 * });
 */
export function useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables> & ({ variables: GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables>(GetPreferenceCenterPageAccountSettingsUserContactsPermissionsDocument, options);
      }
export function useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables>(GetPreferenceCenterPageAccountSettingsUserContactsPermissionsDocument, options);
        }
export function useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables>(GetPreferenceCenterPageAccountSettingsUserContactsPermissionsDocument, options);
        }
export type GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery>;
export type GetPreferenceCenterPageAccountSettingsUserContactsPermissionsLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsLazyQuery>;
export type GetPreferenceCenterPageAccountSettingsUserContactsPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageAccountSettingsUserContactsPermissionsSuspenseQuery>;
export type GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryResult = Apollo.QueryResult<GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQuery, GetPreferenceCenterPageAccountSettingsUserContactsPermissionsQueryVariables>;
export const GetPreferenceCenterPageCanManagePreferencesDocument = gql`
    query GetPreferenceCenterPageCanManagePreferences {
  viewerPermissions {
    id
    canManagePreferences
  }
}
    `;

/**
 * __useGetPreferenceCenterPageCanManagePreferencesQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageCanManagePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageCanManagePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageCanManagePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreferenceCenterPageCanManagePreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>(GetPreferenceCenterPageCanManagePreferencesDocument, options);
      }
export function useGetPreferenceCenterPageCanManagePreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>(GetPreferenceCenterPageCanManagePreferencesDocument, options);
        }
export function useGetPreferenceCenterPageCanManagePreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>(GetPreferenceCenterPageCanManagePreferencesDocument, options);
        }
export type GetPreferenceCenterPageCanManagePreferencesQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageCanManagePreferencesQuery>;
export type GetPreferenceCenterPageCanManagePreferencesLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageCanManagePreferencesLazyQuery>;
export type GetPreferenceCenterPageCanManagePreferencesSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageCanManagePreferencesSuspenseQuery>;
export type GetPreferenceCenterPageCanManagePreferencesQueryResult = Apollo.QueryResult<GetPreferenceCenterPageCanManagePreferencesQuery, GetPreferenceCenterPageCanManagePreferencesQueryVariables>;
export const GetPreferenceCenterPageCanSetPrimaryContactDocument = gql`
    query GetPreferenceCenterPageCanSetPrimaryContact($shipToAccountNumber: ID!, $contactId: ID) {
  canSetPrimaryContact(
    shipToAccountNumber: $shipToAccountNumber
    contactId: $contactId
  )
}
    `;

/**
 * __useGetPreferenceCenterPageCanSetPrimaryContactQuery__
 *
 * To run a query within a React component, call `useGetPreferenceCenterPageCanSetPrimaryContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferenceCenterPageCanSetPrimaryContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferenceCenterPageCanSetPrimaryContactQuery({
 *   variables: {
 *      shipToAccountNumber: // value for 'shipToAccountNumber'
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetPreferenceCenterPageCanSetPrimaryContactQuery(baseOptions: Apollo.QueryHookOptions<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables> & ({ variables: GetPreferenceCenterPageCanSetPrimaryContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables>(GetPreferenceCenterPageCanSetPrimaryContactDocument, options);
      }
export function useGetPreferenceCenterPageCanSetPrimaryContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables>(GetPreferenceCenterPageCanSetPrimaryContactDocument, options);
        }
export function useGetPreferenceCenterPageCanSetPrimaryContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables>(GetPreferenceCenterPageCanSetPrimaryContactDocument, options);
        }
export type GetPreferenceCenterPageCanSetPrimaryContactQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageCanSetPrimaryContactQuery>;
export type GetPreferenceCenterPageCanSetPrimaryContactLazyQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageCanSetPrimaryContactLazyQuery>;
export type GetPreferenceCenterPageCanSetPrimaryContactSuspenseQueryHookResult = ReturnType<typeof useGetPreferenceCenterPageCanSetPrimaryContactSuspenseQuery>;
export type GetPreferenceCenterPageCanSetPrimaryContactQueryResult = Apollo.QueryResult<GetPreferenceCenterPageCanSetPrimaryContactQuery, GetPreferenceCenterPageCanSetPrimaryContactQueryVariables>;
export const PreferenceCenterPageUpsertCommunicationPreferenceDocument = gql`
    mutation PreferenceCenterPageUpsertCommunicationPreference($input: UpsertCommunicationPreferenceInput!) {
  upsertCommunicationPreference(input: $input) {
    communicationPreference {
      ...PreferenceCenterPageCommunicationPreferenceInfo
    }
    optedOutEngagementChannels
  }
}
    ${PreferenceCenterPageCommunicationPreferenceInfoFragmentDoc}`;
export type PreferenceCenterPageUpsertCommunicationPreferenceMutationFn = Apollo.MutationFunction<PreferenceCenterPageUpsertCommunicationPreferenceMutation, PreferenceCenterPageUpsertCommunicationPreferenceMutationVariables>;

/**
 * __usePreferenceCenterPageUpsertCommunicationPreferenceMutation__
 *
 * To run a mutation, you first call `usePreferenceCenterPageUpsertCommunicationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreferenceCenterPageUpsertCommunicationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preferenceCenterPageUpsertCommunicationPreferenceMutation, { data, loading, error }] = usePreferenceCenterPageUpsertCommunicationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreferenceCenterPageUpsertCommunicationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<PreferenceCenterPageUpsertCommunicationPreferenceMutation, PreferenceCenterPageUpsertCommunicationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreferenceCenterPageUpsertCommunicationPreferenceMutation, PreferenceCenterPageUpsertCommunicationPreferenceMutationVariables>(PreferenceCenterPageUpsertCommunicationPreferenceDocument, options);
      }
export type PreferenceCenterPageUpsertCommunicationPreferenceMutationHookResult = ReturnType<typeof usePreferenceCenterPageUpsertCommunicationPreferenceMutation>;
export type PreferenceCenterPageUpsertCommunicationPreferenceMutationResult = Apollo.MutationResult<PreferenceCenterPageUpsertCommunicationPreferenceMutation>;
export type PreferenceCenterPageUpsertCommunicationPreferenceMutationOptions = Apollo.BaseMutationOptions<PreferenceCenterPageUpsertCommunicationPreferenceMutation, PreferenceCenterPageUpsertCommunicationPreferenceMutationVariables>;
export const PreferenceCenterPageGlobalUnsubscribeContactDocument = gql`
    mutation PreferenceCenterPageGlobalUnsubscribeContact($input: GlobalUnsubscribeContactInput!) {
  globalUnsubscribeContact(input: $input) {
    communicationPreferences {
      ...PreferenceCenterPageCommunicationPreferenceInfo
    }
    communicationPreferencesResponse {
      communicationPreferences {
        ...PreferenceCenterPageCommunicationPreferenceInfo
      }
      communicationChannelGlobalSubscriptions {
        engagementChannelType
        sfdcContactId
        status
        optedOut
      }
      optedOutEngagementChannels
    }
  }
}
    ${PreferenceCenterPageCommunicationPreferenceInfoFragmentDoc}`;
export type PreferenceCenterPageGlobalUnsubscribeContactMutationFn = Apollo.MutationFunction<PreferenceCenterPageGlobalUnsubscribeContactMutation, PreferenceCenterPageGlobalUnsubscribeContactMutationVariables>;

/**
 * __usePreferenceCenterPageGlobalUnsubscribeContactMutation__
 *
 * To run a mutation, you first call `usePreferenceCenterPageGlobalUnsubscribeContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreferenceCenterPageGlobalUnsubscribeContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preferenceCenterPageGlobalUnsubscribeContactMutation, { data, loading, error }] = usePreferenceCenterPageGlobalUnsubscribeContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreferenceCenterPageGlobalUnsubscribeContactMutation(baseOptions?: Apollo.MutationHookOptions<PreferenceCenterPageGlobalUnsubscribeContactMutation, PreferenceCenterPageGlobalUnsubscribeContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreferenceCenterPageGlobalUnsubscribeContactMutation, PreferenceCenterPageGlobalUnsubscribeContactMutationVariables>(PreferenceCenterPageGlobalUnsubscribeContactDocument, options);
      }
export type PreferenceCenterPageGlobalUnsubscribeContactMutationHookResult = ReturnType<typeof usePreferenceCenterPageGlobalUnsubscribeContactMutation>;
export type PreferenceCenterPageGlobalUnsubscribeContactMutationResult = Apollo.MutationResult<PreferenceCenterPageGlobalUnsubscribeContactMutation>;
export type PreferenceCenterPageGlobalUnsubscribeContactMutationOptions = Apollo.BaseMutationOptions<PreferenceCenterPageGlobalUnsubscribeContactMutation, PreferenceCenterPageGlobalUnsubscribeContactMutationVariables>;
export const GetRecommendationsProductGroupsByIdsDocument = gql`
    query GetRecommendationsProductGroupsByIds($ids: [ID!]!) {
  productGroupsByIds(ids: $ids) {
    ...GoogleTagManagerProductGroupInfo
  }
}
    ${GoogleTagManagerProductGroupInfoFragmentDoc}`;

/**
 * __useGetRecommendationsProductGroupsByIdsQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsProductGroupsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsProductGroupsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsProductGroupsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetRecommendationsProductGroupsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables> & ({ variables: GetRecommendationsProductGroupsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables>(GetRecommendationsProductGroupsByIdsDocument, options);
      }
export function useGetRecommendationsProductGroupsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables>(GetRecommendationsProductGroupsByIdsDocument, options);
        }
export function useGetRecommendationsProductGroupsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables>(GetRecommendationsProductGroupsByIdsDocument, options);
        }
export type GetRecommendationsProductGroupsByIdsQueryHookResult = ReturnType<typeof useGetRecommendationsProductGroupsByIdsQuery>;
export type GetRecommendationsProductGroupsByIdsLazyQueryHookResult = ReturnType<typeof useGetRecommendationsProductGroupsByIdsLazyQuery>;
export type GetRecommendationsProductGroupsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendationsProductGroupsByIdsSuspenseQuery>;
export type GetRecommendationsProductGroupsByIdsQueryResult = Apollo.QueryResult<GetRecommendationsProductGroupsByIdsQuery, GetRecommendationsProductGroupsByIdsQueryVariables>;
export const GetRequestItemsPagePermissionsDocument = gql`
    query GetRequestItemsPagePermissions {
  viewerPermissions {
    id
    canSubmitQuote
  }
}
    `;

/**
 * __useGetRequestItemsPagePermissionsQuery__
 *
 * To run a query within a React component, call `useGetRequestItemsPagePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestItemsPagePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestItemsPagePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequestItemsPagePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>(GetRequestItemsPagePermissionsDocument, options);
      }
export function useGetRequestItemsPagePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>(GetRequestItemsPagePermissionsDocument, options);
        }
export function useGetRequestItemsPagePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>(GetRequestItemsPagePermissionsDocument, options);
        }
export type GetRequestItemsPagePermissionsQueryHookResult = ReturnType<typeof useGetRequestItemsPagePermissionsQuery>;
export type GetRequestItemsPagePermissionsLazyQueryHookResult = ReturnType<typeof useGetRequestItemsPagePermissionsLazyQuery>;
export type GetRequestItemsPagePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetRequestItemsPagePermissionsSuspenseQuery>;
export type GetRequestItemsPagePermissionsQueryResult = Apollo.QueryResult<GetRequestItemsPagePermissionsQuery, GetRequestItemsPagePermissionsQueryVariables>;
export const GetRequestItemsPageCartCountDocument = gql`
    query GetRequestItemsPageCartCount {
  cart {
    id
    itemCount
  }
}
    `;

/**
 * __useGetRequestItemsPageCartCountQuery__
 *
 * To run a query within a React component, call `useGetRequestItemsPageCartCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestItemsPageCartCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestItemsPageCartCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequestItemsPageCartCountQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>(GetRequestItemsPageCartCountDocument, options);
      }
export function useGetRequestItemsPageCartCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>(GetRequestItemsPageCartCountDocument, options);
        }
export function useGetRequestItemsPageCartCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>(GetRequestItemsPageCartCountDocument, options);
        }
export type GetRequestItemsPageCartCountQueryHookResult = ReturnType<typeof useGetRequestItemsPageCartCountQuery>;
export type GetRequestItemsPageCartCountLazyQueryHookResult = ReturnType<typeof useGetRequestItemsPageCartCountLazyQuery>;
export type GetRequestItemsPageCartCountSuspenseQueryHookResult = ReturnType<typeof useGetRequestItemsPageCartCountSuspenseQuery>;
export type GetRequestItemsPageCartCountQueryResult = Apollo.QueryResult<GetRequestItemsPageCartCountQuery, GetRequestItemsPageCartCountQueryVariables>;
export const RequestItemsPageCreateQuoteDocument = gql`
    mutation RequestItemsPageCreateQuote($callbackRequest: JewelerShowcaseCallbackRequestInput, $addToCarts: [AddToCartInput!]) {
  createQuote(callbackRequest: $callbackRequest, addToCarts: $addToCarts) {
    publicQuoteLines {
      id
    }
    cart {
      ...GoogleTagManagerCartInfo
      errors {
        code
        message
      }
    }
    request {
      emailAddress
    }
  }
}
    ${GoogleTagManagerCartInfoFragmentDoc}`;
export type RequestItemsPageCreateQuoteMutationFn = Apollo.MutationFunction<RequestItemsPageCreateQuoteMutation, RequestItemsPageCreateQuoteMutationVariables>;

/**
 * __useRequestItemsPageCreateQuoteMutation__
 *
 * To run a mutation, you first call `useRequestItemsPageCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestItemsPageCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestItemsPageCreateQuoteMutation, { data, loading, error }] = useRequestItemsPageCreateQuoteMutation({
 *   variables: {
 *      callbackRequest: // value for 'callbackRequest'
 *      addToCarts: // value for 'addToCarts'
 *   },
 * });
 */
export function useRequestItemsPageCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RequestItemsPageCreateQuoteMutation, RequestItemsPageCreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestItemsPageCreateQuoteMutation, RequestItemsPageCreateQuoteMutationVariables>(RequestItemsPageCreateQuoteDocument, options);
      }
export type RequestItemsPageCreateQuoteMutationHookResult = ReturnType<typeof useRequestItemsPageCreateQuoteMutation>;
export type RequestItemsPageCreateQuoteMutationResult = Apollo.MutationResult<RequestItemsPageCreateQuoteMutation>;
export type RequestItemsPageCreateQuoteMutationOptions = Apollo.BaseMutationOptions<RequestItemsPageCreateQuoteMutation, RequestItemsPageCreateQuoteMutationVariables>;
export const GetSerializedPdpPagesStoneRebateStatusDocument = gql`
    query GetSerializedPdpPagesStoneRebateStatus($type: StoneRebateType!) {
  stoneRebateStatus(type: $type) {
    stonesPurchased
    tiers {
      minimumQuantity
      maximumQuantity
      rebatePercent
    }
  }
}
    `;

/**
 * __useGetSerializedPdpPagesStoneRebateStatusQuery__
 *
 * To run a query within a React component, call `useGetSerializedPdpPagesStoneRebateStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerializedPdpPagesStoneRebateStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerializedPdpPagesStoneRebateStatusQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSerializedPdpPagesStoneRebateStatusQuery(baseOptions: Apollo.QueryHookOptions<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables> & ({ variables: GetSerializedPdpPagesStoneRebateStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables>(GetSerializedPdpPagesStoneRebateStatusDocument, options);
      }
export function useGetSerializedPdpPagesStoneRebateStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables>(GetSerializedPdpPagesStoneRebateStatusDocument, options);
        }
export function useGetSerializedPdpPagesStoneRebateStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables>(GetSerializedPdpPagesStoneRebateStatusDocument, options);
        }
export type GetSerializedPdpPagesStoneRebateStatusQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesStoneRebateStatusQuery>;
export type GetSerializedPdpPagesStoneRebateStatusLazyQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesStoneRebateStatusLazyQuery>;
export type GetSerializedPdpPagesStoneRebateStatusSuspenseQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesStoneRebateStatusSuspenseQuery>;
export type GetSerializedPdpPagesStoneRebateStatusQueryResult = Apollo.QueryResult<GetSerializedPdpPagesStoneRebateStatusQuery, GetSerializedPdpPagesStoneRebateStatusQueryVariables>;
export const GetSerializedPdpPagesDiamondDetailsDocument = gql`
    query GetSerializedPdpPagesDiamondDetails($serialNumber: ID!, $options: ItemLineOptionsInput, $nonConsignmentOptions: ItemLineOptionsInput = {isForConsignment: false}) {
  serializedProductBySerialNumber(serialNumber: $serialNumber, options: $options) {
    ...AddToCartSectionInfo
    ...PdpImageCarouselInfo
    id
    itemId {
      id
      type
    }
    image
    agtaDescription
    calibratedSize
    color
    clarity
    culet
    depthPercent
    isDiamond
    fluorescence
    girdle
    girdle2
    isCanadaMark
    isGCal8x
    length
    lengthToWidthRatio
    makeLookup
    maxDiameter
    minDiameter
    notes
    polishLookup
    serialNumber
    shape
    stoneFamily
    stoneOrigin
    symmetryLookup
    tablePercent
    weight
    width
    report {
      provider
      url
    }
  }
}
    ${AddToCartSectionInfoFragmentDoc}
${PdpImageCarouselInfoFragmentDoc}`;

/**
 * __useGetSerializedPdpPagesDiamondDetailsQuery__
 *
 * To run a query within a React component, call `useGetSerializedPdpPagesDiamondDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerializedPdpPagesDiamondDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerializedPdpPagesDiamondDetailsQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *      options: // value for 'options'
 *      nonConsignmentOptions: // value for 'nonConsignmentOptions'
 *   },
 * });
 */
export function useGetSerializedPdpPagesDiamondDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables> & ({ variables: GetSerializedPdpPagesDiamondDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables>(GetSerializedPdpPagesDiamondDetailsDocument, options);
      }
export function useGetSerializedPdpPagesDiamondDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables>(GetSerializedPdpPagesDiamondDetailsDocument, options);
        }
export function useGetSerializedPdpPagesDiamondDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables>(GetSerializedPdpPagesDiamondDetailsDocument, options);
        }
export type GetSerializedPdpPagesDiamondDetailsQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesDiamondDetailsQuery>;
export type GetSerializedPdpPagesDiamondDetailsLazyQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesDiamondDetailsLazyQuery>;
export type GetSerializedPdpPagesDiamondDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesDiamondDetailsSuspenseQuery>;
export type GetSerializedPdpPagesDiamondDetailsQueryResult = Apollo.QueryResult<GetSerializedPdpPagesDiamondDetailsQuery, GetSerializedPdpPagesDiamondDetailsQueryVariables>;
export const GetSerializedPdpPagesDiamondPermissionsDocument = gql`
    query GetSerializedPdpPagesDiamondPermissions {
  viewerPermissions {
    id
    canViewDiamondRebates
  }
}
    `;

/**
 * __useGetSerializedPdpPagesDiamondPermissionsQuery__
 *
 * To run a query within a React component, call `useGetSerializedPdpPagesDiamondPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerializedPdpPagesDiamondPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerializedPdpPagesDiamondPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSerializedPdpPagesDiamondPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>(GetSerializedPdpPagesDiamondPermissionsDocument, options);
      }
export function useGetSerializedPdpPagesDiamondPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>(GetSerializedPdpPagesDiamondPermissionsDocument, options);
        }
export function useGetSerializedPdpPagesDiamondPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>(GetSerializedPdpPagesDiamondPermissionsDocument, options);
        }
export type GetSerializedPdpPagesDiamondPermissionsQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesDiamondPermissionsQuery>;
export type GetSerializedPdpPagesDiamondPermissionsLazyQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesDiamondPermissionsLazyQuery>;
export type GetSerializedPdpPagesDiamondPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesDiamondPermissionsSuspenseQuery>;
export type GetSerializedPdpPagesDiamondPermissionsQueryResult = Apollo.QueryResult<GetSerializedPdpPagesDiamondPermissionsQuery, GetSerializedPdpPagesDiamondPermissionsQueryVariables>;
export const GetSerializedPdpPagesGemstoneDetailsDocument = gql`
    query GetSerializedPdpPagesGemstoneDetails($serialNumber: ID!, $options: ItemLineOptionsInput, $nonConsignmentOptions: ItemLineOptionsInput = {isForConsignment: false}) {
  serializedProductBySerialNumber(serialNumber: $serialNumber, options: $options) {
    ...AddToCartSectionInfo
    ...PdpImageCarouselInfo
    id
    itemId {
      id
      type
    }
    defaultProductGroup {
      id
      code
    }
    image
    serialNumber
    stoneFamily
    stoneOrigin
    isDiamond
    geographicalOrigin
  }
}
    ${AddToCartSectionInfoFragmentDoc}
${PdpImageCarouselInfoFragmentDoc}`;

/**
 * __useGetSerializedPdpPagesGemstoneDetailsQuery__
 *
 * To run a query within a React component, call `useGetSerializedPdpPagesGemstoneDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerializedPdpPagesGemstoneDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerializedPdpPagesGemstoneDetailsQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *      options: // value for 'options'
 *      nonConsignmentOptions: // value for 'nonConsignmentOptions'
 *   },
 * });
 */
export function useGetSerializedPdpPagesGemstoneDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables> & ({ variables: GetSerializedPdpPagesGemstoneDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables>(GetSerializedPdpPagesGemstoneDetailsDocument, options);
      }
export function useGetSerializedPdpPagesGemstoneDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables>(GetSerializedPdpPagesGemstoneDetailsDocument, options);
        }
export function useGetSerializedPdpPagesGemstoneDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables>(GetSerializedPdpPagesGemstoneDetailsDocument, options);
        }
export type GetSerializedPdpPagesGemstoneDetailsQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesGemstoneDetailsQuery>;
export type GetSerializedPdpPagesGemstoneDetailsLazyQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesGemstoneDetailsLazyQuery>;
export type GetSerializedPdpPagesGemstoneDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesGemstoneDetailsSuspenseQuery>;
export type GetSerializedPdpPagesGemstoneDetailsQueryResult = Apollo.QueryResult<GetSerializedPdpPagesGemstoneDetailsQuery, GetSerializedPdpPagesGemstoneDetailsQueryVariables>;
export const GetSerializedPdpPagesGemstonePermissionsDocument = gql`
    query GetSerializedPdpPagesGemstonePermissions {
  viewerPermissions {
    id
    canViewGemstoneRebates
  }
}
    `;

/**
 * __useGetSerializedPdpPagesGemstonePermissionsQuery__
 *
 * To run a query within a React component, call `useGetSerializedPdpPagesGemstonePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerializedPdpPagesGemstonePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerializedPdpPagesGemstonePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSerializedPdpPagesGemstonePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>(GetSerializedPdpPagesGemstonePermissionsDocument, options);
      }
export function useGetSerializedPdpPagesGemstonePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>(GetSerializedPdpPagesGemstonePermissionsDocument, options);
        }
export function useGetSerializedPdpPagesGemstonePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>(GetSerializedPdpPagesGemstonePermissionsDocument, options);
        }
export type GetSerializedPdpPagesGemstonePermissionsQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesGemstonePermissionsQuery>;
export type GetSerializedPdpPagesGemstonePermissionsLazyQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesGemstonePermissionsLazyQuery>;
export type GetSerializedPdpPagesGemstonePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesGemstonePermissionsSuspenseQuery>;
export type GetSerializedPdpPagesGemstonePermissionsQueryResult = Apollo.QueryResult<GetSerializedPdpPagesGemstonePermissionsQuery, GetSerializedPdpPagesGemstonePermissionsQueryVariables>;
export const GetSerializedPdpPagesRedirectSerialNumberOr404Document = gql`
    query GetSerializedPdpPagesRedirectSerialNumberOr404($serialNumber: ID!) {
  serializedProductBySerialNumber(serialNumber: $serialNumber) {
    id
    isDiamond
    serialNumber
  }
}
    `;

/**
 * __useGetSerializedPdpPagesRedirectSerialNumberOr404Query__
 *
 * To run a query within a React component, call `useGetSerializedPdpPagesRedirectSerialNumberOr404Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSerializedPdpPagesRedirectSerialNumberOr404Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerializedPdpPagesRedirectSerialNumberOr404Query({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *   },
 * });
 */
export function useGetSerializedPdpPagesRedirectSerialNumberOr404Query(baseOptions: Apollo.QueryHookOptions<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables> & ({ variables: GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables>(GetSerializedPdpPagesRedirectSerialNumberOr404Document, options);
      }
export function useGetSerializedPdpPagesRedirectSerialNumberOr404LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables>(GetSerializedPdpPagesRedirectSerialNumberOr404Document, options);
        }
export function useGetSerializedPdpPagesRedirectSerialNumberOr404SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables>(GetSerializedPdpPagesRedirectSerialNumberOr404Document, options);
        }
export type GetSerializedPdpPagesRedirectSerialNumberOr404QueryHookResult = ReturnType<typeof useGetSerializedPdpPagesRedirectSerialNumberOr404Query>;
export type GetSerializedPdpPagesRedirectSerialNumberOr404LazyQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesRedirectSerialNumberOr404LazyQuery>;
export type GetSerializedPdpPagesRedirectSerialNumberOr404SuspenseQueryHookResult = ReturnType<typeof useGetSerializedPdpPagesRedirectSerialNumberOr404SuspenseQuery>;
export type GetSerializedPdpPagesRedirectSerialNumberOr404QueryResult = Apollo.QueryResult<GetSerializedPdpPagesRedirectSerialNumberOr404Query, GetSerializedPdpPagesRedirectSerialNumberOr404QueryVariables>;
export const SerializedPdpPagesSendProductShareEmailDocument = gql`
    mutation SerializedPdpPagesSendProductShareEmail($input: ProductShareEmailInput!) {
  sendProductShareEmail(input: $input) {
    success
  }
}
    `;
export type SerializedPdpPagesSendProductShareEmailMutationFn = Apollo.MutationFunction<SerializedPdpPagesSendProductShareEmailMutation, SerializedPdpPagesSendProductShareEmailMutationVariables>;

/**
 * __useSerializedPdpPagesSendProductShareEmailMutation__
 *
 * To run a mutation, you first call `useSerializedPdpPagesSendProductShareEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSerializedPdpPagesSendProductShareEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serializedPdpPagesSendProductShareEmailMutation, { data, loading, error }] = useSerializedPdpPagesSendProductShareEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSerializedPdpPagesSendProductShareEmailMutation(baseOptions?: Apollo.MutationHookOptions<SerializedPdpPagesSendProductShareEmailMutation, SerializedPdpPagesSendProductShareEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SerializedPdpPagesSendProductShareEmailMutation, SerializedPdpPagesSendProductShareEmailMutationVariables>(SerializedPdpPagesSendProductShareEmailDocument, options);
      }
export type SerializedPdpPagesSendProductShareEmailMutationHookResult = ReturnType<typeof useSerializedPdpPagesSendProductShareEmailMutation>;
export type SerializedPdpPagesSendProductShareEmailMutationResult = Apollo.MutationResult<SerializedPdpPagesSendProductShareEmailMutation>;
export type SerializedPdpPagesSendProductShareEmailMutationOptions = Apollo.BaseMutationOptions<SerializedPdpPagesSendProductShareEmailMutation, SerializedPdpPagesSendProductShareEmailMutationVariables>;
export const GetServerAdminTaskDefinitionsByDomainDocument = gql`
    query GetServerAdminTaskDefinitionsByDomain($domain: String!) {
  taskDefinitionsByDomain(domain: $domain) {
    currentRun {
      beginTime
      completeTime
      duration
      runId
      status
      traceId
    }
    domain
    nextRunTime
    previousRun {
      beginTime
      completeTime
      duration
      runId
      status
      traceId
    }
    status
    taskName
  }
}
    `;

/**
 * __useGetServerAdminTaskDefinitionsByDomainQuery__
 *
 * To run a query within a React component, call `useGetServerAdminTaskDefinitionsByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerAdminTaskDefinitionsByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerAdminTaskDefinitionsByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetServerAdminTaskDefinitionsByDomainQuery(baseOptions: Apollo.QueryHookOptions<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables> & ({ variables: GetServerAdminTaskDefinitionsByDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables>(GetServerAdminTaskDefinitionsByDomainDocument, options);
      }
export function useGetServerAdminTaskDefinitionsByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables>(GetServerAdminTaskDefinitionsByDomainDocument, options);
        }
export function useGetServerAdminTaskDefinitionsByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables>(GetServerAdminTaskDefinitionsByDomainDocument, options);
        }
export type GetServerAdminTaskDefinitionsByDomainQueryHookResult = ReturnType<typeof useGetServerAdminTaskDefinitionsByDomainQuery>;
export type GetServerAdminTaskDefinitionsByDomainLazyQueryHookResult = ReturnType<typeof useGetServerAdminTaskDefinitionsByDomainLazyQuery>;
export type GetServerAdminTaskDefinitionsByDomainSuspenseQueryHookResult = ReturnType<typeof useGetServerAdminTaskDefinitionsByDomainSuspenseQuery>;
export type GetServerAdminTaskDefinitionsByDomainQueryResult = Apollo.QueryResult<GetServerAdminTaskDefinitionsByDomainQuery, GetServerAdminTaskDefinitionsByDomainQueryVariables>;
export const GetServerAdminTaskRunsDocument = gql`
    query GetServerAdminTaskRuns($domain: String!, $taskKey: String!, $paging: CursorPagingInput) {
  taskRuns(domain: $domain, taskKey: $taskKey, paging: $paging) {
    nextToken
    taskRuns {
      beginTime
      completeTime
      duration
      runId
      status
      traceId
      details {
        errorMessages
        messages
        operations {
          deletes {
            count
            values
          }
          reads {
            count
            values
          }
          writes {
            count
            values
          }
        }
      }
      taskSource
    }
  }
}
    `;

/**
 * __useGetServerAdminTaskRunsQuery__
 *
 * To run a query within a React component, call `useGetServerAdminTaskRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerAdminTaskRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerAdminTaskRunsQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      taskKey: // value for 'taskKey'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetServerAdminTaskRunsQuery(baseOptions: Apollo.QueryHookOptions<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables> & ({ variables: GetServerAdminTaskRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables>(GetServerAdminTaskRunsDocument, options);
      }
export function useGetServerAdminTaskRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables>(GetServerAdminTaskRunsDocument, options);
        }
export function useGetServerAdminTaskRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables>(GetServerAdminTaskRunsDocument, options);
        }
export type GetServerAdminTaskRunsQueryHookResult = ReturnType<typeof useGetServerAdminTaskRunsQuery>;
export type GetServerAdminTaskRunsLazyQueryHookResult = ReturnType<typeof useGetServerAdminTaskRunsLazyQuery>;
export type GetServerAdminTaskRunsSuspenseQueryHookResult = ReturnType<typeof useGetServerAdminTaskRunsSuspenseQuery>;
export type GetServerAdminTaskRunsQueryResult = Apollo.QueryResult<GetServerAdminTaskRunsQuery, GetServerAdminTaskRunsQueryVariables>;
export const ServerAdminAbortTaskDocument = gql`
    mutation ServerAdminAbortTask($input: TaskIdentifierInput!) {
  abortTask(input: $input)
}
    `;
export type ServerAdminAbortTaskMutationFn = Apollo.MutationFunction<ServerAdminAbortTaskMutation, ServerAdminAbortTaskMutationVariables>;

/**
 * __useServerAdminAbortTaskMutation__
 *
 * To run a mutation, you first call `useServerAdminAbortTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerAdminAbortTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverAdminAbortTaskMutation, { data, loading, error }] = useServerAdminAbortTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServerAdminAbortTaskMutation(baseOptions?: Apollo.MutationHookOptions<ServerAdminAbortTaskMutation, ServerAdminAbortTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ServerAdminAbortTaskMutation, ServerAdminAbortTaskMutationVariables>(ServerAdminAbortTaskDocument, options);
      }
export type ServerAdminAbortTaskMutationHookResult = ReturnType<typeof useServerAdminAbortTaskMutation>;
export type ServerAdminAbortTaskMutationResult = Apollo.MutationResult<ServerAdminAbortTaskMutation>;
export type ServerAdminAbortTaskMutationOptions = Apollo.BaseMutationOptions<ServerAdminAbortTaskMutation, ServerAdminAbortTaskMutationVariables>;
export const ServerAdminRunTaskDocument = gql`
    mutation ServerAdminRunTask($input: TaskIdentifierInput!) {
  runTask(input: $input)
}
    `;
export type ServerAdminRunTaskMutationFn = Apollo.MutationFunction<ServerAdminRunTaskMutation, ServerAdminRunTaskMutationVariables>;

/**
 * __useServerAdminRunTaskMutation__
 *
 * To run a mutation, you first call `useServerAdminRunTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServerAdminRunTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serverAdminRunTaskMutation, { data, loading, error }] = useServerAdminRunTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServerAdminRunTaskMutation(baseOptions?: Apollo.MutationHookOptions<ServerAdminRunTaskMutation, ServerAdminRunTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ServerAdminRunTaskMutation, ServerAdminRunTaskMutationVariables>(ServerAdminRunTaskDocument, options);
      }
export type ServerAdminRunTaskMutationHookResult = ReturnType<typeof useServerAdminRunTaskMutation>;
export type ServerAdminRunTaskMutationResult = Apollo.MutationResult<ServerAdminRunTaskMutation>;
export type ServerAdminRunTaskMutationOptions = Apollo.BaseMutationOptions<ServerAdminRunTaskMutation, ServerAdminRunTaskMutationVariables>;
export const GetAvailableStatementsDocument = gql`
    query GetAvailableStatements($custAccountId: Int!) {
  availableStatements(custAccountId: $custAccountId) {
    currentStatementDates
    historicalStatementDates
    showPaperlessEnrollment
  }
}
    `;

/**
 * __useGetAvailableStatementsQuery__
 *
 * To run a query within a React component, call `useGetAvailableStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableStatementsQuery({
 *   variables: {
 *      custAccountId: // value for 'custAccountId'
 *   },
 * });
 */
export function useGetAvailableStatementsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables> & ({ variables: GetAvailableStatementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables>(GetAvailableStatementsDocument, options);
      }
export function useGetAvailableStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables>(GetAvailableStatementsDocument, options);
        }
export function useGetAvailableStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables>(GetAvailableStatementsDocument, options);
        }
export type GetAvailableStatementsQueryHookResult = ReturnType<typeof useGetAvailableStatementsQuery>;
export type GetAvailableStatementsLazyQueryHookResult = ReturnType<typeof useGetAvailableStatementsLazyQuery>;
export type GetAvailableStatementsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableStatementsSuspenseQuery>;
export type GetAvailableStatementsQueryResult = Apollo.QueryResult<GetAvailableStatementsQuery, GetAvailableStatementsQueryVariables>;
export const GetTrainingDetailPageEventSessionsDocument = gql`
    query GetTrainingDetailPageEventSessions($eventId: String!) {
  eventSessions(eventId: $eventId) {
    id
    title
    startDate
    endDate
    timeZone
    location
  }
}
    `;

/**
 * __useGetTrainingDetailPageEventSessionsQuery__
 *
 * To run a query within a React component, call `useGetTrainingDetailPageEventSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingDetailPageEventSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrainingDetailPageEventSessionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTrainingDetailPageEventSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables> & ({ variables: GetTrainingDetailPageEventSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables>(GetTrainingDetailPageEventSessionsDocument, options);
      }
export function useGetTrainingDetailPageEventSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables>(GetTrainingDetailPageEventSessionsDocument, options);
        }
export function useGetTrainingDetailPageEventSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables>(GetTrainingDetailPageEventSessionsDocument, options);
        }
export type GetTrainingDetailPageEventSessionsQueryHookResult = ReturnType<typeof useGetTrainingDetailPageEventSessionsQuery>;
export type GetTrainingDetailPageEventSessionsLazyQueryHookResult = ReturnType<typeof useGetTrainingDetailPageEventSessionsLazyQuery>;
export type GetTrainingDetailPageEventSessionsSuspenseQueryHookResult = ReturnType<typeof useGetTrainingDetailPageEventSessionsSuspenseQuery>;
export type GetTrainingDetailPageEventSessionsQueryResult = Apollo.QueryResult<GetTrainingDetailPageEventSessionsQuery, GetTrainingDetailPageEventSessionsQueryVariables>;
export const UnsubscribeAllPageGlobalUnsubscribeEmailDocument = gql`
    mutation UnsubscribeAllPageGlobalUnsubscribeEmail($input: GlobalUnsubscribeEmailInput!) {
  globalUnsubscribeEmail(input: $input) {
    salesforceContactId
  }
}
    `;
export type UnsubscribeAllPageGlobalUnsubscribeEmailMutationFn = Apollo.MutationFunction<UnsubscribeAllPageGlobalUnsubscribeEmailMutation, UnsubscribeAllPageGlobalUnsubscribeEmailMutationVariables>;

/**
 * __useUnsubscribeAllPageGlobalUnsubscribeEmailMutation__
 *
 * To run a mutation, you first call `useUnsubscribeAllPageGlobalUnsubscribeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeAllPageGlobalUnsubscribeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeAllPageGlobalUnsubscribeEmailMutation, { data, loading, error }] = useUnsubscribeAllPageGlobalUnsubscribeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeAllPageGlobalUnsubscribeEmailMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeAllPageGlobalUnsubscribeEmailMutation, UnsubscribeAllPageGlobalUnsubscribeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeAllPageGlobalUnsubscribeEmailMutation, UnsubscribeAllPageGlobalUnsubscribeEmailMutationVariables>(UnsubscribeAllPageGlobalUnsubscribeEmailDocument, options);
      }
export type UnsubscribeAllPageGlobalUnsubscribeEmailMutationHookResult = ReturnType<typeof useUnsubscribeAllPageGlobalUnsubscribeEmailMutation>;
export type UnsubscribeAllPageGlobalUnsubscribeEmailMutationResult = Apollo.MutationResult<UnsubscribeAllPageGlobalUnsubscribeEmailMutation>;
export type UnsubscribeAllPageGlobalUnsubscribeEmailMutationOptions = Apollo.BaseMutationOptions<UnsubscribeAllPageGlobalUnsubscribeEmailMutation, UnsubscribeAllPageGlobalUnsubscribeEmailMutationVariables>;
export const GetUnsupportedBannerMinimumSupportedBrowsersDocument = gql`
    query GetUnsupportedBannerMinimumSupportedBrowsers {
  cmsLookupsByType(type: "Minimum-Supported-Browsers") {
    id
    name: code
    majorVersion: value
    minorVersion: value2
    message: value6
  }
}
    `;

/**
 * __useGetUnsupportedBannerMinimumSupportedBrowsersQuery__
 *
 * To run a query within a React component, call `useGetUnsupportedBannerMinimumSupportedBrowsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnsupportedBannerMinimumSupportedBrowsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnsupportedBannerMinimumSupportedBrowsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnsupportedBannerMinimumSupportedBrowsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>(GetUnsupportedBannerMinimumSupportedBrowsersDocument, options);
      }
export function useGetUnsupportedBannerMinimumSupportedBrowsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>(GetUnsupportedBannerMinimumSupportedBrowsersDocument, options);
        }
export function useGetUnsupportedBannerMinimumSupportedBrowsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>(GetUnsupportedBannerMinimumSupportedBrowsersDocument, options);
        }
export type GetUnsupportedBannerMinimumSupportedBrowsersQueryHookResult = ReturnType<typeof useGetUnsupportedBannerMinimumSupportedBrowsersQuery>;
export type GetUnsupportedBannerMinimumSupportedBrowsersLazyQueryHookResult = ReturnType<typeof useGetUnsupportedBannerMinimumSupportedBrowsersLazyQuery>;
export type GetUnsupportedBannerMinimumSupportedBrowsersSuspenseQueryHookResult = ReturnType<typeof useGetUnsupportedBannerMinimumSupportedBrowsersSuspenseQuery>;
export type GetUnsupportedBannerMinimumSupportedBrowsersQueryResult = Apollo.QueryResult<GetUnsupportedBannerMinimumSupportedBrowsersQuery, GetUnsupportedBannerMinimumSupportedBrowsersQueryVariables>;
export type AcceptConsignmentTermsPayloadKeySpecifier = ('user' | AcceptConsignmentTermsPayloadKeySpecifier)[];
export type AcceptConsignmentTermsPayloadFieldPolicy = {
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddToCartPayloadKeySpecifier = ('addedCartLineIds' | 'cart' | AddToCartPayloadKeySpecifier)[];
export type AddToCartPayloadFieldPolicy = {
	addedCartLineIds?: FieldPolicy<any> | FieldReadFunction<any>,
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddToFavoritesPayloadKeySpecifier = ('favorite' | AddToFavoritesPayloadKeySpecifier)[];
export type AddToFavoritesPayloadFieldPolicy = {
	favorite?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddToSignetCartPayloadKeySpecifier = ('message' | 'redirectUrl' | AddToSignetCartPayloadKeySpecifier)[];
export type AddToSignetCartPayloadFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('addressLines' | 'allowPickup' | 'city' | 'country' | 'county' | 'isInternational' | 'isLowerFortyEight' | 'isPoBox' | 'isResidential' | 'province' | 'state' | 'type' | 'zip' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	addressLines?: FieldPolicy<any> | FieldReadFunction<any>,
	allowPickup?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	county?: FieldPolicy<any> | FieldReadFunction<any>,
	isInternational?: FieldPolicy<any> | FieldReadFunction<any>,
	isLowerFortyEight?: FieldPolicy<any> | FieldReadFunction<any>,
	isPoBox?: FieldPolicy<any> | FieldReadFunction<any>,
	isResidential?: FieldPolicy<any> | FieldReadFunction<any>,
	province?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthUserKeySpecifier = ('consultantInfo' | 'consultantLogin' | 'email' | 'firstName' | 'id' | 'impersonatedBy' | 'lastName' | 'lastRefreshDate' | 'roles' | 'signature' | 'user' | 'username' | AuthUserKeySpecifier)[];
export type AuthUserFieldPolicy = {
	consultantInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	consultantLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	impersonatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRefreshDate?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	signature?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvailableStatementsKeySpecifier = ('currentStatementDates' | 'historicalStatementDates' | 'showPaperlessEnrollment' | AvailableStatementsKeySpecifier)[];
export type AvailableStatementsFieldPolicy = {
	currentStatementDates?: FieldPolicy<any> | FieldReadFunction<any>,
	historicalStatementDates?: FieldPolicy<any> | FieldReadFunction<any>,
	showPaperlessEnrollment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BackOrderInfoKeySpecifier = ('canBackOrder' | 'quantityOnHand' | BackOrderInfoKeySpecifier)[];
export type BackOrderInfoFieldPolicy = {
	canBackOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityOnHand?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillToAccountKeySpecifier = ('accountNumber' | 'accountSource' | 'accountType' | 'active' | 'address' | 'allowDropShip' | 'balanceDue' | 'canSeeStatements' | 'canShareLogins' | 'canUseCreditCard' | 'companyName' | 'compositeStarRank' | 'creationDate' | 'creditChecking' | 'creditHold' | 'creditRating' | 'currency' | 'customerAccountId' | 'excludeFromDiamondRebate' | 'excludeFromGemstoneRebate' | 'excludeFromPreferences' | 'id' | 'internalNotes' | 'isBuyingGroup' | 'isInMetalsClub' | 'isPaperlessStatements' | 'isToolsOnly' | 'isWebEnabled' | 'lastShipDateTime' | 'lastStatementBalance' | 'lastStatementDate' | 'memoAllowed' | 'parentNumber' | 'pastDueAmount' | 'pdfInvoiceEmailAddress' | 'phoneNumber' | 'poRequired' | 'priceListName' | 'requiresCreditCardAuthorizationPriorToShipping' | 'taxId' | 'terms' | BillToAccountKeySpecifier)[];
export type BillToAccountFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accountSource?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	allowDropShip?: FieldPolicy<any> | FieldReadFunction<any>,
	balanceDue?: FieldPolicy<any> | FieldReadFunction<any>,
	canSeeStatements?: FieldPolicy<any> | FieldReadFunction<any>,
	canShareLogins?: FieldPolicy<any> | FieldReadFunction<any>,
	canUseCreditCard?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	compositeStarRank?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creditChecking?: FieldPolicy<any> | FieldReadFunction<any>,
	creditHold?: FieldPolicy<any> | FieldReadFunction<any>,
	creditRating?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeFromDiamondRebate?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeFromGemstoneRebate?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeFromPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	isBuyingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	isInMetalsClub?: FieldPolicy<any> | FieldReadFunction<any>,
	isPaperlessStatements?: FieldPolicy<any> | FieldReadFunction<any>,
	isToolsOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	isWebEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	lastShipDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatementBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	lastStatementDate?: FieldPolicy<any> | FieldReadFunction<any>,
	memoAllowed?: FieldPolicy<any> | FieldReadFunction<any>,
	parentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pastDueAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	pdfInvoiceEmailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	poRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	priceListName?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresCreditCardAuthorizationPriorToShipping?: FieldPolicy<any> | FieldReadFunction<any>,
	taxId?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CODKeySpecifier = ('id' | CODKeySpecifier)[];
export type CODFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CadCamRequestKeySpecifier = ('brand' | 'canAddToSignetCart' | 'canReactivate' | 'canReorder' | 'cancelledReason' | 'customerName' | 'customerReference' | 'estimatedShipDate' | 'id' | 'image' | 'isCancelled' | 'requestDate' | 'requestStatuses' | 'showcasePrice' | 'source' | 'storeName' | 'storeReference' | CadCamRequestKeySpecifier)[];
export type CadCamRequestFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToSignetCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canReactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	canReorder?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelledReason?: FieldPolicy<any> | FieldReadFunction<any>,
	customerName?: FieldPolicy<any> | FieldReadFunction<any>,
	customerReference?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedShipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	isCancelled?: FieldPolicy<any> | FieldReadFunction<any>,
	requestDate?: FieldPolicy<any> | FieldReadFunction<any>,
	requestStatuses?: FieldPolicy<any> | FieldReadFunction<any>,
	showcasePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	storeName?: FieldPolicy<any> | FieldReadFunction<any>,
	storeReference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CadCamRequestStatusKeySpecifier = ('completedDate' | 'description' | 'isCustomerActionRequired' | 'name' | 'startedDate' | CadCamRequestStatusKeySpecifier)[];
export type CadCamRequestStatusFieldPolicy = {
	completedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustomerActionRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	startedDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CadCamRequestsSearchByCustomerReferenceResultKeySpecifier = ('count' | 'results' | CadCamRequestsSearchByCustomerReferenceResultKeySpecifier)[];
export type CadCamRequestsSearchByCustomerReferenceResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CadCamRequestsSearchByDateRangeResultKeySpecifier = ('count' | 'results' | CadCamRequestsSearchByDateRangeResultKeySpecifier)[];
export type CadCamRequestsSearchByDateRangeResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CancelScheduledOrderPayloadKeySpecifier = ('id' | 'isCanceled' | CancelScheduledOrderPayloadKeySpecifier)[];
export type CancelScheduledOrderPayloadFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCanceled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartKeySpecifier = ('cartHeader' | 'createdOn' | 'errors' | 'id' | 'itemCount' | 'items' | 'lastModifiedByEmployee' | 'lastModifiedDate' | 'notes' | 'price' | 'quotedPrice' | 'shipments' | 'shippingCountdown' | 'user' | CartKeySpecifier)[];
export type CartFieldPolicy = {
	cartHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedByEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	quotedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shipments?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCountdown?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartHeaderKeySpecifier = ('cartId' | 'createdOn' | 'id' | 'itemCount' | 'lastModifiedByEmployee' | 'lastModifiedDate' | 'topImages' | 'user' | CartHeaderKeySpecifier)[];
export type CartHeaderFieldPolicy = {
	cartId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedByEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	topImages?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartItemPriceKeySpecifier = ('discount' | 'total' | CartItemPriceKeySpecifier)[];
export type CartItemPriceFieldPolicy = {
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartLineKeySpecifier = ('canEditItem' | 'consultantDescription' | 'creationDate' | 'errors' | 'id' | 'inStockStatus' | 'item' | 'notes' | 'options' | 'price' | 'pricePerUnit' | 'productGroup' | 'quotedPrice' | 'shipDate' | 'trackingSource' | CartLineKeySpecifier)[];
export type CartLineFieldPolicy = {
	canEditItem?: FieldPolicy<any> | FieldReadFunction<any>,
	consultantDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	quotedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartLineInStockStatusKeySpecifier = ('quantityOnHand' | 'status' | 'statusCode' | CartLineInStockStatusKeySpecifier)[];
export type CartLineInStockStatusFieldPolicy = {
	quantityOnHand?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartMessageKeySpecifier = ('code' | 'message' | CartMessageKeySpecifier)[];
export type CartMessageFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartPriceKeySpecifier = ('salesTax' | 'salesTaxV2' | 'serviceCharges' | 'serviceChargesTotal' | 'shippingTotal' | 'subtotal' | 'total' | CartPriceKeySpecifier)[];
export type CartPriceFieldPolicy = {
	salesTax?: FieldPolicy<any> | FieldReadFunction<any>,
	salesTaxV2?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceChargesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartServiceChargeKeySpecifier = ('price' | 'quantity' | 'title' | 'type' | CartServiceChargeKeySpecifier)[];
export type CartServiceChargeFieldPolicy = {
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CartServiceChargePriceKeySpecifier = ('perUnit' | 'total' | 'type' | CartServiceChargePriceKeySpecifier)[];
export type CartServiceChargePriceFieldPolicy = {
	perUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryKeySpecifier = ('ancestors' | 'contentId' | 'displayTemplate' | 'hideSideNav' | 'id' | 'isActive' | 'mainNavCarouselContentContainerId' | 'mainNavContentContainerId' | 'mainNavDisplayName' | 'mainNavIsFeatured' | 'mainNavSortOrder' | 'name' | 'overrideUrl' | 'pageHeader' | 'pageMetaDescription' | 'pageTitle' | 'parentId' | 'sanitizedPath' | 'showProducts' | 'url' | CategoryKeySpecifier)[];
export type CategoryFieldPolicy = {
	ancestors?: FieldPolicy<any> | FieldReadFunction<any>,
	contentId?: FieldPolicy<any> | FieldReadFunction<any>,
	displayTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	hideSideNav?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	mainNavCarouselContentContainerId?: FieldPolicy<any> | FieldReadFunction<any>,
	mainNavContentContainerId?: FieldPolicy<any> | FieldReadFunction<any>,
	mainNavDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	mainNavIsFeatured?: FieldPolicy<any> | FieldReadFunction<any>,
	mainNavSortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	overrideUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	pageHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	pageMetaDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	parentId?: FieldPolicy<any> | FieldReadFunction<any>,
	sanitizedPath?: FieldPolicy<any> | FieldReadFunction<any>,
	showProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChainConfigurationDetailKeySpecifier = ('clasp' | 'length' | 'title' | ChainConfigurationDetailKeySpecifier)[];
export type ChainConfigurationDetailFieldPolicy = {
	clasp?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsContentKeySpecifier = ('content' | 'splitTestVersionsKey' | CmsContentKeySpecifier)[];
export type CmsContentFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	splitTestVersionsKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsLookupKeySpecifier = ('code' | 'id' | 'order' | 'publicAccess' | 'type' | 'value' | 'value2' | 'value3' | 'value4' | 'value5' | 'value6' | 'value7' | 'value8' | 'value9' | 'value10' | CmsLookupKeySpecifier)[];
export type CmsLookupFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	publicAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	value2?: FieldPolicy<any> | FieldReadFunction<any>,
	value3?: FieldPolicy<any> | FieldReadFunction<any>,
	value4?: FieldPolicy<any> | FieldReadFunction<any>,
	value5?: FieldPolicy<any> | FieldReadFunction<any>,
	value6?: FieldPolicy<any> | FieldReadFunction<any>,
	value7?: FieldPolicy<any> | FieldReadFunction<any>,
	value8?: FieldPolicy<any> | FieldReadFunction<any>,
	value9?: FieldPolicy<any> | FieldReadFunction<any>,
	value10?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommunicationChannelGlobalSubscriptionKeySpecifier = ('engagementChannelType' | 'optedOut' | 'sfdcContactId' | 'status' | CommunicationChannelGlobalSubscriptionKeySpecifier)[];
export type CommunicationChannelGlobalSubscriptionFieldPolicy = {
	engagementChannelType?: FieldPolicy<any> | FieldReadFunction<any>,
	optedOut?: FieldPolicy<any> | FieldReadFunction<any>,
	sfdcContactId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommunicationPreferenceKeySpecifier = ('channel' | 'description' | 'groupName' | 'id' | 'isSubscribed' | 'name' | 'optInRequired' | 'preferenceCreationToken' | CommunicationPreferenceKeySpecifier)[];
export type CommunicationPreferenceFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSubscribed?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	optInRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	preferenceCreationToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommunicationPreferencesResponseKeySpecifier = ('communicationChannelGlobalSubscriptions' | 'communicationPreferences' | 'optedOutEngagementChannels' | CommunicationPreferencesResponseKeySpecifier)[];
export type CommunicationPreferencesResponseFieldPolicy = {
	communicationChannelGlobalSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	communicationPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	optedOutEngagementChannels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentPriceKeySpecifier = ('caratPrice' | 'discount' | 'key' | 'parentKey' | 'quantity' | 'stullerFirstDiscount' | 'title' | 'total' | ComponentPriceKeySpecifier)[];
export type ComponentPriceFieldPolicy = {
	caratPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	parentKey?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	stullerFirstDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationKeySpecifier = ('addToCartDisabledReasons' | 'allowLineLevelDiscounting' | 'brand' | 'canAddCustomerNotes' | 'canAddSpecialInstructions' | 'canAddToCart' | 'canAnneal' | 'canBagAndTag' | 'canMatch' | 'canOrderOnConsignment' | 'canShipTo' | 'canUpdateOrderLine' | 'catalogValuesDescription' | 'customerSpecificPrice' | 'defaultProductGroup' | 'details' | 'dimensionalWeightInGrams' | 'hasCadFile' | 'id' | 'image' | 'inStockStatus' | 'inactiveReasons' | 'isActive' | 'isDimensionalBulkMetal' | 'isInStock' | 'isLimitedAvailability' | 'isMustConfigure' | 'isOnPriceList' | 'isPreorder' | 'isReturnable' | 'isTool' | 'isTwoDimensionalBulkMetal' | 'isValid' | 'itemId' | 'itemNumber' | 'itemStatus' | 'matchedSet' | 'maximumQuantity' | 'merchandiseHierarchy' | 'minimumQuantity' | 'optionErrors' | 'optionNotes' | 'options' | 'planningCode' | 'planningGroup' | 'prerequisiteProducts' | 'price' | 'product' | 'products' | 'serializedProducts' | 'series' | 'shipDate' | 'shippingCountdown' | 'shippingRestrictions' | 'showcasePriceSummary' | 'soldByDescription' | 'title' | 'weightInGrams' | ConfigurationKeySpecifier)[];
export type ConfigurationFieldPolicy = {
	addToCartDisabledReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	allowLineLevelDiscounting?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddCustomerNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddSpecialInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canAnneal?: FieldPolicy<any> | FieldReadFunction<any>,
	canBagAndTag?: FieldPolicy<any> | FieldReadFunction<any>,
	canMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	canOrderOnConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	canShipTo?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateOrderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogValuesDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSpecificPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionalWeightInGrams?: FieldPolicy<any> | FieldReadFunction<any>,
	hasCadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	isInStock?: FieldPolicy<any> | FieldReadFunction<any>,
	isLimitedAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	isMustConfigure?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnPriceList?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreorder?: FieldPolicy<any> | FieldReadFunction<any>,
	isReturnable?: FieldPolicy<any> | FieldReadFunction<any>,
	isTool?: FieldPolicy<any> | FieldReadFunction<any>,
	isTwoDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	itemStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedSet?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	merchandiseHierarchy?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	optionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	optionNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	planningCode?: FieldPolicy<any> | FieldReadFunction<any>,
	planningGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	prerequisiteProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	serializedProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	series?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCountdown?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	showcasePriceSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	soldByDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	weightInGrams?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationDetailKeySpecifier = ('title' | ConfigurationDetailKeySpecifier)[];
export type ConfigurationDetailFieldPolicy = {
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationProductKeySpecifier = ('product' | ConfigurationProductKeySpecifier)[];
export type ConfigurationProductFieldPolicy = {
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationSerializedProductKeySpecifier = ('serializedProduct' | ConfigurationSerializedProductKeySpecifier)[];
export type ConfigurationSerializedProductFieldPolicy = {
	serializedProduct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationServiceChargeKeySpecifier = ('configurationIds' | 'price' | 'quantity' | 'title' | 'type' | ConfigurationServiceChargeKeySpecifier)[];
export type ConfigurationServiceChargeFieldPolicy = {
	configurationIds?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationServiceChargePriceKeySpecifier = ('perUnit' | 'total' | 'type' | ConfigurationServiceChargePriceKeySpecifier)[];
export type ConfigurationServiceChargePriceFieldPolicy = {
	perUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConsultantCartsResultKeySpecifier = ('cartHeaders' | 'cartLineCount' | 'cartsCount' | ConsultantCartsResultKeySpecifier)[];
export type ConsultantCartsResultFieldPolicy = {
	cartHeaders?: FieldPolicy<any> | FieldReadFunction<any>,
	cartLineCount?: FieldPolicy<any> | FieldReadFunction<any>,
	cartsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConsultantInfoKeySpecifier = ('employee' | 'orderType' | 'salesPerson' | 'tradeShow' | ConsultantInfoKeySpecifier)[];
export type ConsultantInfoFieldPolicy = {
	employee?: FieldPolicy<any> | FieldReadFunction<any>,
	orderType?: FieldPolicy<any> | FieldReadFunction<any>,
	salesPerson?: FieldPolicy<any> | FieldReadFunction<any>,
	tradeShow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactKeySpecifier = ('active' | 'cadCamAcceptAllModFees' | 'cadCamHasLogoOnFile' | 'cadCamSendEmailStatusUpdates' | 'cadCamSendSmsStatusUpdates' | 'communicationPreferences' | 'creationDate' | 'directPhoneNumber' | 'displayName' | 'emailAddress' | 'excludeFromPreferences' | 'firstName' | 'fullName' | 'hasLocateAJeweler' | 'id' | 'inactiveReason' | 'isBenchMember' | 'jobTitle' | 'lastName' | 'mobilePhoneNumber' | 'modificationDate' | 'optIn302SMSNotifications' | 'optInEverAndEverSMSNotifications' | 'oraclePartyId' | 'preferredMethodOfContact' | 'preferredName' | 'salesforceContactId' | 'salutation' | 'suffix' | ContactKeySpecifier)[];
export type ContactFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamAcceptAllModFees?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamHasLogoOnFile?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamSendEmailStatusUpdates?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamSendSmsStatusUpdates?: FieldPolicy<any> | FieldReadFunction<any>,
	communicationPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	directPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	emailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeFromPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasLocateAJeweler?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveReason?: FieldPolicy<any> | FieldReadFunction<any>,
	isBenchMember?: FieldPolicy<any> | FieldReadFunction<any>,
	jobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	mobilePhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	modificationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	optIn302SMSNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	optInEverAndEverSMSNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	oraclePartyId?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredMethodOfContact?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredName?: FieldPolicy<any> | FieldReadFunction<any>,
	salesforceContactId?: FieldPolicy<any> | FieldReadFunction<any>,
	salutation?: FieldPolicy<any> | FieldReadFunction<any>,
	suffix?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactPreferencesResponseByContactIdResultKeySpecifier = ('communicationChannelGlobalSubscriptions' | 'communicationPreferences' | 'optedOutEngagementChannels' | ContactPreferencesResponseByContactIdResultKeySpecifier)[];
export type ContactPreferencesResponseByContactIdResultFieldPolicy = {
	communicationChannelGlobalSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	communicationPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	optedOutEngagementChannels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactSearchResultKeySpecifier = ('count' | 'results' | ContactSearchResultKeySpecifier)[];
export type ContactSearchResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactsByEmailResultKeySpecifier = ('count' | 'results' | ContactsByEmailResultKeySpecifier)[];
export type ContactsByEmailResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactsByPhoneNumberResultKeySpecifier = ('count' | 'results' | ContactsByPhoneNumberResultKeySpecifier)[];
export type ContactsByPhoneNumberResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopyConfigurationPayloadKeySpecifier = ('newConfiguration' | 'sourceConfigurationId' | CopyConfigurationPayloadKeySpecifier)[];
export type CopyConfigurationPayloadFieldPolicy = {
	newConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceConfigurationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryKeySpecifier = ('code' | 'name' | CountryKeySpecifier)[];
export type CountryFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateContactPayloadKeySpecifier = ('contact' | CreateContactPayloadKeySpecifier)[];
export type CreateContactPayloadFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateCreditCardPayloadKeySpecifier = ('creditCard' | CreateCreditCardPayloadKeySpecifier)[];
export type CreateCreditCardPayloadFieldPolicy = {
	creditCard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateFavoriteListPayloadKeySpecifier = ('favoriteList' | CreateFavoriteListPayloadKeySpecifier)[];
export type CreateFavoriteListPayloadFieldPolicy = {
	favoriteList?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateLocateAJewelerListingPayloadKeySpecifier = ('locateAJewelerListing' | CreateLocateAJewelerListingPayloadKeySpecifier)[];
export type CreateLocateAJewelerListingPayloadFieldPolicy = {
	locateAJewelerListing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateNotificationPayloadKeySpecifier = ('notification' | CreateNotificationPayloadKeySpecifier)[];
export type CreateNotificationPayloadFieldPolicy = {
	notification?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateQuotePayloadKeySpecifier = ('cart' | 'publicQuoteLines' | 'request' | CreateQuotePayloadKeySpecifier)[];
export type CreateQuotePayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>,
	publicQuoteLines?: FieldPolicy<any> | FieldReadFunction<any>,
	request?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreditCardKeySpecifier = ('activeAutorenewals' | 'cardholderName' | 'expirationMonth' | 'expirationYear' | 'id' | 'isDebitCard' | 'isExpired' | 'lastFourDigits' | 'tokenizedCardNumber' | 'type' | 'zip' | CreditCardKeySpecifier)[];
export type CreditCardFieldPolicy = {
	activeAutorenewals?: FieldPolicy<any> | FieldReadFunction<any>,
	cardholderName?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationYear?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDebitCard?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	lastFourDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenizedCardNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyValueKeySpecifier = ('currencyCode' | 'exchangeRate' | 'value' | 'valueInUsd' | CurrencyValueKeySpecifier)[];
export type CurrencyValueFieldPolicy = {
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeRate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueInUsd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomShowcaseSettingDetailKeySpecifier = ('id' | 'type' | 'value' | 'value2' | 'value3' | 'values' | CustomShowcaseSettingDetailKeySpecifier)[];
export type CustomShowcaseSettingDetailFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	value2?: FieldPolicy<any> | FieldReadFunction<any>,
	value3?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomShowcaseSettingsKeySpecifier = ('description' | 'details' | 'id' | 'navigationDisplayExclusions' | CustomShowcaseSettingsKeySpecifier)[];
export type CustomShowcaseSettingsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	navigationDisplayExclusions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerLogoEngravingLocationConfigurationKeySpecifier = ('logo' | CustomerLogoEngravingLocationConfigurationKeySpecifier)[];
export type CustomerLogoEngravingLocationConfigurationFieldPolicy = {
	logo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerLogoHotStampingLocationConfigurationKeySpecifier = ('colors' | 'locationDescription' | 'locationImage' | 'logo' | 'product' | CustomerLogoHotStampingLocationConfigurationKeySpecifier)[];
export type CustomerLogoHotStampingLocationConfigurationFieldPolicy = {
	colors?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	locationImage?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerLogoImprintingLocationConfigurationKeySpecifier = ('colors' | 'locationDescription' | 'locationImage' | 'logo' | 'product' | CustomerLogoImprintingLocationConfigurationKeySpecifier)[];
export type CustomerLogoImprintingLocationConfigurationFieldPolicy = {
	colors?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	locationImage?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerStoneKeySpecifier = ('stoneValue' | CustomerStoneKeySpecifier)[];
export type CustomerStoneFieldPolicy = {
	stoneValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerStoreInformationKeySpecifier = ('ags' | 'agta' | 'businessEstablishedYear' | 'businessLocationCommunity' | 'buyersInternationalGroup' | 'canadianBuyingGroup' | 'continentalBuyingGroup' | 'creationDate' | 'diGem' | 'employeeCount' | 'gemaltaCooperative' | 'id' | 'independentJewelersOrganization' | 'ja' | 'jic' | 'jvc' | 'leadingJewelers' | 'locationOfSales' | 'mjsa' | 'modificationDate' | 'nationalPawnbrokersAssociation' | 'numberOfEmployees' | 'otherOrganizations' | 'primaryLocationDescription' | 'retailJewelersOrganization' | 'shipToAccount' | 'siteHasShoppingCart' | 'user' | CustomerStoreInformationKeySpecifier)[];
export type CustomerStoreInformationFieldPolicy = {
	ags?: FieldPolicy<any> | FieldReadFunction<any>,
	agta?: FieldPolicy<any> | FieldReadFunction<any>,
	businessEstablishedYear?: FieldPolicy<any> | FieldReadFunction<any>,
	businessLocationCommunity?: FieldPolicy<any> | FieldReadFunction<any>,
	buyersInternationalGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	canadianBuyingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	continentalBuyingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	diGem?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	gemaltaCooperative?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	independentJewelersOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	ja?: FieldPolicy<any> | FieldReadFunction<any>,
	jic?: FieldPolicy<any> | FieldReadFunction<any>,
	jvc?: FieldPolicy<any> | FieldReadFunction<any>,
	leadingJewelers?: FieldPolicy<any> | FieldReadFunction<any>,
	locationOfSales?: FieldPolicy<any> | FieldReadFunction<any>,
	mjsa?: FieldPolicy<any> | FieldReadFunction<any>,
	modificationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	nationalPawnbrokersAssociation?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	otherOrganizations?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryLocationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	retailJewelersOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	siteHasShoppingCart?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeactivateContactPayloadKeySpecifier = ('contact' | DeactivateContactPayloadKeySpecifier)[];
export type DeactivateContactPayloadFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteAllCartLinesPayloadKeySpecifier = ('cart' | DeleteAllCartLinesPayloadKeySpecifier)[];
export type DeleteAllCartLinesPayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCartLinePayloadKeySpecifier = ('cart' | DeleteCartLinePayloadKeySpecifier)[];
export type DeleteCartLinePayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCreditCardPayloadKeySpecifier = ('creditCardId' | DeleteCreditCardPayloadKeySpecifier)[];
export type DeleteCreditCardPayloadFieldPolicy = {
	creditCardId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFavoriteListPayloadKeySpecifier = ('favoriteList' | DeleteFavoriteListPayloadKeySpecifier)[];
export type DeleteFavoriteListPayloadFieldPolicy = {
	favoriteList?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFavoritesPayloadKeySpecifier = ('favoriteIds' | DeleteFavoritesPayloadKeySpecifier)[];
export type DeleteFavoritesPayloadFieldPolicy = {
	favoriteIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLocateAJewelerListingPayloadKeySpecifier = ('locateAJewelerListingId' | DeleteLocateAJewelerListingPayloadKeySpecifier)[];
export type DeleteLocateAJewelerListingPayloadFieldPolicy = {
	locateAJewelerListingId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteNotificationPayloadKeySpecifier = ('deleted' | DeleteNotificationPayloadKeySpecifier)[];
export type DeleteNotificationPayloadFieldPolicy = {
	deleted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteSavedCartLinePayloadKeySpecifier = ('savedCartLineId' | DeleteSavedCartLinePayloadKeySpecifier)[];
export type DeleteSavedCartLinePayloadFieldPolicy = {
	savedCartLineId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EarringConfigurationDetailKeySpecifier = ('back' | 'post' | 'quantity' | 'title' | EarringConfigurationDetailKeySpecifier)[];
export type EarringConfigurationDetailFieldPolicy = {
	back?: FieldPolicy<any> | FieldReadFunction<any>,
	post?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmbeddedChatSettingKeySpecifier = ('chatEnabled' | 'experienceSiteUrl' | 'messagingChannel' | 'orgId' | 'orgName' | 'srcAttribute' | 'telephonyUrl' | EmbeddedChatSettingKeySpecifier)[];
export type EmbeddedChatSettingFieldPolicy = {
	chatEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	experienceSiteUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	messagingChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	orgName?: FieldPolicy<any> | FieldReadFunction<any>,
	srcAttribute?: FieldPolicy<any> | FieldReadFunction<any>,
	telephonyUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmbeddedChatSettingsResultKeySpecifier = ('embeddedChatSettings' | 'primaryEmbeddedChatSettings' | 'salesforceSettingName' | EmbeddedChatSettingsResultKeySpecifier)[];
export type EmbeddedChatSettingsResultFieldPolicy = {
	embeddedChatSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryEmbeddedChatSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	salesforceSettingName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmployeeKeySpecifier = ('displayName' | 'id' | EmployeeKeySpecifier)[];
export type EmployeeFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EngravingColorConfigurationKeySpecifier = ('hex' | 'name' | EngravingColorConfigurationKeySpecifier)[];
export type EngravingColorConfigurationFieldPolicy = {
	hex?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EngravingConfigurationDetailKeySpecifier = ('engravings' | 'title' | EngravingConfigurationDetailKeySpecifier)[];
export type EngravingConfigurationDetailFieldPolicy = {
	engravings?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EngravingLocationConfigurationKeySpecifier = ('engraving' | 'locationDescription' | EngravingLocationConfigurationKeySpecifier)[];
export type EngravingLocationConfigurationFieldPolicy = {
	engraving?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EngravingTextKeySpecifier = ('text' | 'thumbnailPreviewImage' | EngravingTextKeySpecifier)[];
export type EngravingTextFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailPreviewImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EstimatedShipDateKeySpecifier = ('date' | 'logId' | EstimatedShipDateKeySpecifier)[];
export type EstimatedShipDateFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	logId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventSessionKeySpecifier = ('endDate' | 'id' | 'location' | 'startDate' | 'timeZone' | 'title' | EventSessionKeySpecifier)[];
export type EventSessionFieldPolicy = {
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExactFitConfigurationKeySpecifier = ('depth' | 'length' | 'width' | ExactFitConfigurationKeySpecifier)[];
export type ExactFitConfigurationFieldPolicy = {
	depth?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExchangeRateKeySpecifier = ('code' | 'culture' | 'exchangeRateToUsd' | 'name' | ExchangeRateKeySpecifier)[];
export type ExchangeRateFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	culture?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeRateToUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FavoriteKeySpecifier = ('createdOn' | 'favoriteList' | 'id' | 'item' | 'modifiedOn' | 'notes' | 'options' | 'sortOrder' | FavoriteKeySpecifier)[];
export type FavoriteFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	favoriteList?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FavoriteListKeySpecifier = ('createdOn' | 'description' | 'favorites' | 'favoritesCount' | 'id' | 'isDefault' | 'isPinned' | 'modifiedOn' | 'name' | 'shareKey' | 'viewerCanEdit' | FavoriteListKeySpecifier)[];
export type FavoriteListFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	favorites?: FieldPolicy<any> | FieldReadFunction<any>,
	favoritesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isPinned?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	shareKey?: FieldPolicy<any> | FieldReadFunction<any>,
	viewerCanEdit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateFavoriteListShareKeyPayloadKeySpecifier = ('favoriteList' | GenerateFavoriteListShareKeyPayloadKeySpecifier)[];
export type GenerateFavoriteListShareKeyPayloadFieldPolicy = {
	favoriteList?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalUnsubscribeContactPayloadKeySpecifier = ('communicationPreferences' | 'communicationPreferencesResponse' | GlobalUnsubscribeContactPayloadKeySpecifier)[];
export type GlobalUnsubscribeContactPayloadFieldPolicy = {
	communicationPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	communicationPreferencesResponse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalUnsubscribeEmailPayloadKeySpecifier = ('salesforceContactId' | GlobalUnsubscribeEmailPayloadKeySpecifier)[];
export type GlobalUnsubscribeEmailPayloadFieldPolicy = {
	salesforceContactId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HandwrittenEngravingLocationConfigurationKeySpecifier = ('color' | HandwrittenEngravingLocationConfigurationKeySpecifier)[];
export type HandwrittenEngravingLocationConfigurationFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeadConfigurationDetailKeySpecifier = ('head' | 'title' | HeadConfigurationDetailKeySpecifier)[];
export type HeadConfigurationDetailFieldPolicy = {
	head?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ICartLineKeySpecifier = ('canEditItem' | 'consultantDescription' | 'creationDate' | 'errors' | 'id' | 'inStockStatus' | 'item' | 'notes' | 'options' | 'price' | 'pricePerUnit' | 'productGroup' | 'quotedPrice' | 'shipDate' | 'trackingSource' | ICartLineKeySpecifier)[];
export type ICartLineFieldPolicy = {
	canEditItem?: FieldPolicy<any> | FieldReadFunction<any>,
	consultantDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	quotedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IPriceKeySpecifier = ('caratPrice' | 'discount' | 'key' | 'quantity' | 'stullerFirstDiscount' | 'title' | 'total' | IPriceKeySpecifier)[];
export type IPriceFieldPolicy = {
	caratPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	stullerFirstDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('fullSize' | 'thumb225' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	fullSize?: FieldPolicy<any> | FieldReadFunction<any>,
	thumb225?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImprintingConfigurationDetailKeySpecifier = ('imprintings' | 'title' | ImprintingConfigurationDetailKeySpecifier)[];
export type ImprintingConfigurationDetailFieldPolicy = {
	imprintings?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImprintingLocationColorConfigurationKeySpecifier = ('hex' | 'instructions' | 'name' | ImprintingLocationColorConfigurationKeySpecifier)[];
export type ImprintingLocationColorConfigurationFieldPolicy = {
	hex?: FieldPolicy<any> | FieldReadFunction<any>,
	instructions?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImprintingLocationConfigurationKeySpecifier = ('colors' | 'locationDescription' | 'locationImage' | 'logo' | 'product' | ImprintingLocationConfigurationKeySpecifier)[];
export type ImprintingLocationConfigurationFieldPolicy = {
	colors?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	locationImage?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemKeySpecifier = ('addToCartDisabledReasons' | 'allowLineLevelDiscounting' | 'brand' | 'canAddCustomerNotes' | 'canAddSpecialInstructions' | 'canAddToCart' | 'canAnneal' | 'canBagAndTag' | 'canMatch' | 'canOrderOnConsignment' | 'canShipTo' | 'canUpdateOrderLine' | 'catalogValuesDescription' | 'customerSpecificPrice' | 'defaultProductGroup' | 'dimensionalWeightInGrams' | 'hasCadFile' | 'id' | 'image' | 'inStockStatus' | 'inactiveReasons' | 'isActive' | 'isDimensionalBulkMetal' | 'isInStock' | 'isLimitedAvailability' | 'isMustConfigure' | 'isOnPriceList' | 'isPreorder' | 'isReturnable' | 'isTool' | 'isTwoDimensionalBulkMetal' | 'itemId' | 'itemNumber' | 'itemStatus' | 'matchedSet' | 'maximumQuantity' | 'merchandiseHierarchy' | 'minimumQuantity' | 'optionErrors' | 'optionNotes' | 'options' | 'planningCode' | 'planningGroup' | 'prerequisiteProducts' | 'price' | 'product' | 'series' | 'shipDate' | 'shippingCountdown' | 'shippingRestrictions' | 'showcasePriceSummary' | 'soldByDescription' | 'title' | 'weightInGrams' | ItemKeySpecifier)[];
export type ItemFieldPolicy = {
	addToCartDisabledReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	allowLineLevelDiscounting?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddCustomerNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddSpecialInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canAnneal?: FieldPolicy<any> | FieldReadFunction<any>,
	canBagAndTag?: FieldPolicy<any> | FieldReadFunction<any>,
	canMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	canOrderOnConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	canShipTo?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateOrderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogValuesDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSpecificPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionalWeightInGrams?: FieldPolicy<any> | FieldReadFunction<any>,
	hasCadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	isInStock?: FieldPolicy<any> | FieldReadFunction<any>,
	isLimitedAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	isMustConfigure?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnPriceList?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreorder?: FieldPolicy<any> | FieldReadFunction<any>,
	isReturnable?: FieldPolicy<any> | FieldReadFunction<any>,
	isTool?: FieldPolicy<any> | FieldReadFunction<any>,
	isTwoDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	itemStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedSet?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	merchandiseHierarchy?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	optionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	optionNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	planningCode?: FieldPolicy<any> | FieldReadFunction<any>,
	planningGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	prerequisiteProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	series?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCountdown?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	showcasePriceSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	soldByDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	weightInGrams?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemIdKeySpecifier = ('id' | 'type' | ItemIdKeySpecifier)[];
export type ItemIdFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemInactiveReasonKeySpecifier = ('code' | 'message' | ItemInactiveReasonKeySpecifier)[];
export type ItemInactiveReasonFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemLineOptionMessageKeySpecifier = ('code' | 'message' | ItemLineOptionMessageKeySpecifier)[];
export type ItemLineOptionMessageFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemLineOptionsKeySpecifier = ('isAnnealed' | 'isForConsignment' | 'isMatched' | 'length' | 'quantity' | 'specialInstructions' | 'width' | ItemLineOptionsKeySpecifier)[];
export type ItemLineOptionsFieldPolicy = {
	isAnnealed?: FieldPolicy<any> | FieldReadFunction<any>,
	isForConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	isMatched?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	specialInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemMessageKeySpecifier = ('code' | 'message' | ItemMessageKeySpecifier)[];
export type ItemMessageFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemPriceKeySpecifier = ('extended' | 'priceBreaks' | 'rounded' | 'roundedPerUnit' | 'roundedPricePerPackUnit' | ItemPriceKeySpecifier)[];
export type ItemPriceFieldPolicy = {
	extended?: FieldPolicy<any> | FieldReadFunction<any>,
	priceBreaks?: FieldPolicy<any> | FieldReadFunction<any>,
	rounded?: FieldPolicy<any> | FieldReadFunction<any>,
	roundedPerUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	roundedPricePerPackUnit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JewelerShowcaseCallbackRequestKeySpecifier = ('cartHeader' | 'creationDate' | 'emailAddress' | 'firstName' | 'id' | 'lastName' | 'messageToJeweler' | 'phoneNumber' | JewelerShowcaseCallbackRequestKeySpecifier)[];
export type JewelerShowcaseCallbackRequestFieldPolicy = {
	cartHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	messageToJeweler?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JewelerShowcaseCallbackRequestsResultKeySpecifier = ('count' | 'results' | JewelerShowcaseCallbackRequestsResultKeySpecifier)[];
export type JewelerShowcaseCallbackRequestsResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KitConfigurationDetailKeySpecifier = ('products' | 'title' | KitConfigurationDetailKeySpecifier)[];
export type KitConfigurationDetailFieldPolicy = {
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LengthValueKeySpecifier = ('uom' | 'value' | LengthValueKeySpecifier)[];
export type LengthValueFieldPolicy = {
	uom?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerAddressKeySpecifier = ('addressLine1' | 'addressLine2' | 'city' | 'country' | 'stateOrProvince' | 'zip' | LocateAJewelerAddressKeySpecifier)[];
export type LocateAJewelerAddressFieldPolicy = {
	addressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	stateOrProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerHoursKeySpecifier = ('friday' | 'monday' | 'saturday' | 'sunday' | 'thursday' | 'tuesday' | 'wednesday' | LocateAJewelerHoursKeySpecifier)[];
export type LocateAJewelerHoursFieldPolicy = {
	friday?: FieldPolicy<any> | FieldReadFunction<any>,
	monday?: FieldPolicy<any> | FieldReadFunction<any>,
	saturday?: FieldPolicy<any> | FieldReadFunction<any>,
	sunday?: FieldPolicy<any> | FieldReadFunction<any>,
	thursday?: FieldPolicy<any> | FieldReadFunction<any>,
	tuesday?: FieldPolicy<any> | FieldReadFunction<any>,
	wednesday?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerHoursSettingsKeySpecifier = ('closeTime' | 'openTime' | 'type' | LocateAJewelerHoursSettingsKeySpecifier)[];
export type LocateAJewelerHoursSettingsFieldPolicy = {
	closeTime?: FieldPolicy<any> | FieldReadFunction<any>,
	openTime?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerListingKeySpecifier = ('address' | 'doingBusinessAs' | 'email' | 'hours' | 'id' | 'jewelerShowcase' | 'keywords' | 'latitude' | 'locationDescription' | 'longitude' | 'owner' | 'phoneNumber' | 'products' | 'salesFeatures' | 'services' | 'shipToAccount' | 'shopFeatures' | 'socials' | 'website' | LocateAJewelerListingKeySpecifier)[];
export type LocateAJewelerListingFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	doingBusinessAs?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	hours?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jewelerShowcase?: FieldPolicy<any> | FieldReadFunction<any>,
	keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	salesFeatures?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	shopFeatures?: FieldPolicy<any> | FieldReadFunction<any>,
	socials?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerListingSearchResultKeySpecifier = ('count' | 'results' | LocateAJewelerListingSearchResultKeySpecifier)[];
export type LocateAJewelerListingSearchResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerListingsSearchResultKeySpecifier = ('count' | 'results' | LocateAJewelerListingsSearchResultKeySpecifier)[];
export type LocateAJewelerListingsSearchResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerListingsSearchResultItemKeySpecifier = ('distanceInMiles' | 'id' | 'locateAJewelerListing' | LocateAJewelerListingsSearchResultItemKeySpecifier)[];
export type LocateAJewelerListingsSearchResultItemFieldPolicy = {
	distanceInMiles?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locateAJewelerListing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerOwnerKeySpecifier = ('firstName' | 'lastName' | 'salutation' | 'suffix' | LocateAJewelerOwnerKeySpecifier)[];
export type LocateAJewelerOwnerFieldPolicy = {
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	salutation?: FieldPolicy<any> | FieldReadFunction<any>,
	suffix?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocateAJewelerSocialsKeySpecifier = ('facebook' | 'instagram' | 'pinterest' | 'twitter' | 'youtube' | LocateAJewelerSocialsKeySpecifier)[];
export type LocateAJewelerSocialsFieldPolicy = {
	facebook?: FieldPolicy<any> | FieldReadFunction<any>,
	instagram?: FieldPolicy<any> | FieldReadFunction<any>,
	pinterest?: FieldPolicy<any> | FieldReadFunction<any>,
	twitter?: FieldPolicy<any> | FieldReadFunction<any>,
	youtube?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoyaltyProgramKeySpecifier = ('displayName' | 'id' | 'isStullerFirst' | LoyaltyProgramKeySpecifier)[];
export type LoyaltyProgramFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isStullerFirst?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoyaltyProgramAutorenewalKeySpecifier = ('autorenewalDate' | 'id' | 'loyaltyProgram' | 'shipToAccount' | LoyaltyProgramAutorenewalKeySpecifier)[];
export type LoyaltyProgramAutorenewalFieldPolicy = {
	autorenewalDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	loyaltyProgram?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarketRateKeySpecifier = ('date' | 'gold' | 'id' | 'palladium' | 'platinum' | 'silver' | 'url' | MarketRateKeySpecifier)[];
export type MarketRateFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	gold?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	palladium?: FieldPolicy<any> | FieldReadFunction<any>,
	platinum?: FieldPolicy<any> | FieldReadFunction<any>,
	silver?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchingChainConfigurationDetailKeySpecifier = ('product' | 'title' | MatchingChainConfigurationDetailKeySpecifier)[];
export type MatchingChainConfigurationDetailFieldPolicy = {
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaKeySpecifier = ('id' | MediaKeySpecifier)[];
export type MediaFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MerchandiseHierarchyKeySpecifier = ('segment1' | 'segment2' | 'segment3' | 'segment4' | 'segment5' | 'segment6' | 'segment7' | MerchandiseHierarchyKeySpecifier)[];
export type MerchandiseHierarchyFieldPolicy = {
	segment1?: FieldPolicy<any> | FieldReadFunction<any>,
	segment2?: FieldPolicy<any> | FieldReadFunction<any>,
	segment3?: FieldPolicy<any> | FieldReadFunction<any>,
	segment4?: FieldPolicy<any> | FieldReadFunction<any>,
	segment5?: FieldPolicy<any> | FieldReadFunction<any>,
	segment6?: FieldPolicy<any> | FieldReadFunction<any>,
	segment7?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MeteorImageKeySpecifier = ('id' | 'url' | MeteorImageKeySpecifier)[];
export type MeteorImageFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MonogramConfigurationDetailKeySpecifier = ('locations' | 'title' | MonogramConfigurationDetailKeySpecifier)[];
export type MonogramConfigurationDetailFieldPolicy = {
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MonogramLocationConfigurationKeySpecifier = ('locationDescription' | 'value' | MonogramLocationConfigurationKeySpecifier)[];
export type MonogramLocationConfigurationFieldPolicy = {
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveAllLinesToCartPayloadKeySpecifier = ('sourceCart' | 'targetCart' | MoveAllLinesToCartPayloadKeySpecifier)[];
export type MoveAllLinesToCartPayloadFieldPolicy = {
	sourceCart?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveCartLineToCartPayloadKeySpecifier = ('sourceCart' | 'targetCart' | MoveCartLineToCartPayloadKeySpecifier)[];
export type MoveCartLineToCartPayloadFieldPolicy = {
	sourceCart?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveFavoritesPayloadKeySpecifier = ('favorites' | MoveFavoritesPayloadKeySpecifier)[];
export type MoveFavoritesPayloadFieldPolicy = {
	favorites?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveSavedCartLineToCartPayloadKeySpecifier = ('cart' | MoveSavedCartLineToCartPayloadKeySpecifier)[];
export type MoveSavedCartLineToCartPayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('abortTask' | 'acceptConsignmentTerms' | 'addToCart' | 'addToFavorites' | 'addToSignetCart' | 'cancelScheduledOrder' | 'copyConfiguration' | 'createContact' | 'createCreditCard' | 'createFavoriteList' | 'createLocateAJewelerListing' | 'createNotification' | 'createQuote' | 'deactivateContact' | 'deleteAllCartLines' | 'deleteCartLine' | 'deleteCreditCard' | 'deleteFavoriteList' | 'deleteFavorites' | 'deleteLocateAJewelerListing' | 'deleteNotification' | 'deleteSavedCartLine' | 'generateFavoriteListShareKey' | 'globalUnsubscribeContact' | 'globalUnsubscribeEmail' | 'moveAllLinesToCart' | 'moveCartLineToCart' | 'moveFavorites' | 'moveSavedCartLineToCart' | 'reactivateCadCamRequestById' | 'runTask' | 'saveCartLineForLater' | 'sendProductShareEmail' | 'setPrimaryContact' | 'updateCartLine' | 'updateCartLineQuantity' | 'updateContact' | 'updateCreditCard' | 'updateCurrency' | 'updateDefaultPaymentMethod' | 'updateFavoriteList' | 'updateFavorites' | 'updateHideUsdPrice' | 'updateHoldShipmentsDate' | 'updateLocateAJewelerListing' | 'updateNotificationStatus' | 'updateNotificationsFeedRead' | 'updateSavedCartLine' | 'updateScheduledCartShippingMethod' | 'updateScheduledOrder' | 'upsertCommunicationPreference' | 'upsertCustomerStoreInformation' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	abortTask?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptConsignmentTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	addToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	addToFavorites?: FieldPolicy<any> | FieldReadFunction<any>,
	addToSignetCart?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelScheduledOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	copyConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	createContact?: FieldPolicy<any> | FieldReadFunction<any>,
	createCreditCard?: FieldPolicy<any> | FieldReadFunction<any>,
	createFavoriteList?: FieldPolicy<any> | FieldReadFunction<any>,
	createLocateAJewelerListing?: FieldPolicy<any> | FieldReadFunction<any>,
	createNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	createQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAllCartLines?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCartLine?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCreditCard?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFavoriteList?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFavorites?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLocateAJewelerListing?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSavedCartLine?: FieldPolicy<any> | FieldReadFunction<any>,
	generateFavoriteListShareKey?: FieldPolicy<any> | FieldReadFunction<any>,
	globalUnsubscribeContact?: FieldPolicy<any> | FieldReadFunction<any>,
	globalUnsubscribeEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	moveAllLinesToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	moveCartLineToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	moveFavorites?: FieldPolicy<any> | FieldReadFunction<any>,
	moveSavedCartLineToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	reactivateCadCamRequestById?: FieldPolicy<any> | FieldReadFunction<any>,
	runTask?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCartLineForLater?: FieldPolicy<any> | FieldReadFunction<any>,
	sendProductShareEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setPrimaryContact?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCartLine?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCartLineQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCreditCard?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDefaultPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFavoriteList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFavorites?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHideUsdPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHoldShipmentsDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLocateAJewelerListing?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNotificationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNotificationsFeedRead?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSavedCartLine?: FieldPolicy<any> | FieldReadFunction<any>,
	updateScheduledCartShippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	updateScheduledOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertCommunicationPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertCustomerStoreInformation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NormalTermsKeySpecifier = ('id' | NormalTermsKeySpecifier)[];
export type NormalTermsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('app' | 'createdDate' | 'expiresDate' | 'id' | 'important' | 'metadata' | 'status' | 'type' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	important?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationMetadataKeySpecifier = ('body' | 'title' | 'url' | NotificationMetadataKeySpecifier)[];
export type NotificationMetadataFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationsFeedKeySpecifier = ('cursor' | 'notifications' | NotificationsFeedKeySpecifier)[];
export type NotificationsFeedFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationsUnreadCountKeySpecifier = ('important' | 'total' | NotificationsUnreadCountKeySpecifier)[];
export type NotificationsUnreadCountFieldPolicy = {
	important?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineBagAndTagOptionsKeySpecifier = ('quantityPerBag' | 'tagBags' | OrderLineBagAndTagOptionsKeySpecifier)[];
export type OrderLineBagAndTagOptionsFieldPolicy = {
	quantityPerBag?: FieldPolicy<any> | FieldReadFunction<any>,
	tagBags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineOptionsKeySpecifier = ('bagAndTagOptions' | 'consultantDiscount' | 'customerNotes' | 'isAnnealed' | 'isForConsignment' | 'isMatched' | 'length' | 'matchingCode' | 'quantity' | 'salesType' | 'specialInstructions' | 'width' | OrderLineOptionsKeySpecifier)[];
export type OrderLineOptionsFieldPolicy = {
	bagAndTagOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	consultantDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	isAnnealed?: FieldPolicy<any> | FieldReadFunction<any>,
	isForConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	isMatched?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	matchingCode?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	salesType?: FieldPolicy<any> | FieldReadFunction<any>,
	specialInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderTypeKeySpecifier = ('id' | OrderTypeKeySpecifier)[];
export type OrderTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatternEngravingLocationConfigurationKeySpecifier = ('patternName' | PatternEngravingLocationConfigurationKeySpecifier)[];
export type PatternEngravingLocationConfigurationFieldPolicy = {
	patternName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhoneKeySpecifier = ('extension' | 'phoneNumber' | 'sanitizedPhoneNumber' | PhoneKeySpecifier)[];
export type PhoneFieldPolicy = {
	extension?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	sanitizedPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrerequisiteProductListKeySpecifier = ('id' | 'products' | PrerequisiteProductListKeySpecifier)[];
export type PrerequisiteProductListFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceKeySpecifier = ('caratPrice' | 'components' | 'discount' | 'key' | 'quantity' | 'stullerFirstDiscount' | 'title' | 'total' | PriceKeySpecifier)[];
export type PriceFieldPolicy = {
	caratPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	stullerFirstDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceBreakKeySpecifier = ('caratPrice' | 'discount' | 'maxQuantity' | 'minQuantity' | 'price' | PriceBreakKeySpecifier)[];
export type PriceBreakFieldPolicy = {
	caratPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	maxQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	minQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceDiscountKeySpecifier = ('originalPrice' | 'percent' | 'source' | 'value' | PriceDiscountKeySpecifier)[];
export type PriceDiscountFieldPolicy = {
	originalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	percent?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceListKeySpecifier = ('id' | 'name' | 'type' | PriceListKeySpecifier)[];
export type PriceListFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('addToCartDisabledReasons' | 'allowLineLevelDiscounting' | 'brand' | 'canAddCustomerNotes' | 'canAddSpecialInstructions' | 'canAddToCart' | 'canAnneal' | 'canBagAndTag' | 'canMatch' | 'canOrderOnConsignment' | 'canShipTo' | 'canUpdateOrderLine' | 'catalogValuesDescription' | 'customerSpecificPrice' | 'defaultProductGroup' | 'dimensionalWeightInGrams' | 'hasCadFile' | 'id' | 'image' | 'inStockStatus' | 'inactiveReasons' | 'isActive' | 'isDimensionalBulkMetal' | 'isInStock' | 'isLimitedAvailability' | 'isMustConfigure' | 'isOnPriceList' | 'isPreorder' | 'isReturnable' | 'isTool' | 'isTwoDimensionalBulkMetal' | 'isWebActive' | 'itemId' | 'itemNumber' | 'itemStatus' | 'matchedSet' | 'maximumQuantity' | 'merchandiseHierarchy' | 'minimumQuantity' | 'optionErrors' | 'optionNotes' | 'options' | 'planningCode' | 'planningGroup' | 'prerequisiteProducts' | 'price' | 'product' | 'quantityOnHand' | 'series' | 'shipDate' | 'shippingCountdown' | 'shippingRestrictions' | 'showcasePriceSummary' | 'soldByDescription' | 'substituteProducts' | 'title' | 'type' | 'webAdditionalDetails' | 'webDescription' | 'weightInGrams' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	addToCartDisabledReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	allowLineLevelDiscounting?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddCustomerNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddSpecialInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canAnneal?: FieldPolicy<any> | FieldReadFunction<any>,
	canBagAndTag?: FieldPolicy<any> | FieldReadFunction<any>,
	canMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	canOrderOnConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	canShipTo?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateOrderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogValuesDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSpecificPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionalWeightInGrams?: FieldPolicy<any> | FieldReadFunction<any>,
	hasCadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	isInStock?: FieldPolicy<any> | FieldReadFunction<any>,
	isLimitedAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	isMustConfigure?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnPriceList?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreorder?: FieldPolicy<any> | FieldReadFunction<any>,
	isReturnable?: FieldPolicy<any> | FieldReadFunction<any>,
	isTool?: FieldPolicy<any> | FieldReadFunction<any>,
	isTwoDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	isWebActive?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	itemStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedSet?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	merchandiseHierarchy?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	optionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	optionNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	planningCode?: FieldPolicy<any> | FieldReadFunction<any>,
	planningGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	prerequisiteProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityOnHand?: FieldPolicy<any> | FieldReadFunction<any>,
	series?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCountdown?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	showcasePriceSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	soldByDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	substituteProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	webAdditionalDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	webDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	weightInGrams?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupKeySpecifier = ('active' | 'code' | 'description' | 'discontinued' | 'id' | 'image' | 'maxDiscountProduct' | 'maxPriceProduct' | 'minDiscountProduct' | 'minPriceProduct' | 'replacementGroups' | 'title' | ProductGroupKeySpecifier)[];
export type ProductGroupFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	discontinued?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDiscountProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPriceProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	minDiscountProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	minPriceProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	replacementGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductInStockStatusKeySpecifier = ('backOrderInfo' | 'status' | 'statusCode' | ProductInStockStatusKeySpecifier)[];
export type ProductInStockStatusFieldPolicy = {
	backOrderInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductShareEmailPayloadKeySpecifier = ('success' | ProductShareEmailPayloadKeySpecifier)[];
export type ProductShareEmailPayloadFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicQuoteLineKeySpecifier = ('date' | 'id' | 'item' | 'options' | 'quote' | PublicQuoteLineKeySpecifier)[];
export type PublicQuoteLineFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	quote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicQuoteLineOptionsKeySpecifier = ('isAnnealed' | 'isForConsignment' | 'isMatched' | 'length' | 'quantity' | 'width' | PublicQuoteLineOptionsKeySpecifier)[];
export type PublicQuoteLineOptionsFieldPolicy = {
	isAnnealed?: FieldPolicy<any> | FieldReadFunction<any>,
	isForConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	isMatched?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('activeCategoriesByIds' | 'activeCategoryBySanitizedPath' | 'activeItems' | 'activeProductGroupsByIds' | 'authUser' | 'availableStatements' | 'billToAccountByAccountNumber' | 'cadCamRequestSearchByCustomerReference' | 'cadCamRequestSearchByDateRange' | 'cadCamRequestSearchById' | 'cadCamRequestSearchByWipJobNumber' | 'canCreateContact' | 'canDeactivateContact' | 'canSetPrimaryContact' | 'cart' | 'cartById' | 'cartByUserId' | 'cartItemCount' | 'categoryById' | 'cmsContentById' | 'cmsContentByName' | 'cmsLookupByTypeAndCode' | 'cmsLookupsByType' | 'cmsLookupsByTypes' | 'configurationById' | 'configurationServiceCharges' | 'consultantCarts' | 'contactPreferencesByContactId' | 'contactPreferencesResponseByContactId' | 'contactSearch' | 'contactsByEmail' | 'contactsByPhoneNumber' | 'countries' | 'customerStoreInformationByShipTo' | 'customersWithCart' | 'dummy' | 'embeddedChatSettings' | 'eventSessions' | 'exchangeRateByCode' | 'exchangeRates' | 'favoriteListById' | 'favoriteListByShareKey' | 'favoriteLists' | 'items' | 'jewelerShowcasesList' | 'locateAJewelerListingById' | 'locateAJewelerListingSearch' | 'locateAJewelerListingsDistanceSearch' | 'mainNavCategories' | 'marketRates' | 'pendingJewelerShowcaseCallbackRequests' | 'productById' | 'productGroupById' | 'productGroupSuggestions' | 'productGroupsByIds' | 'productSuggestions' | 'publicQuoteLineById' | 'queues' | 'savedCartLines' | 'searchSuggestions' | 'serializedProductBySerialNumber' | 'serializedProductsByMatchedSetIds' | 'shipToAccountByAccountNumber' | 'shipToAccountSearch' | 'showcaseOnlyCarts' | 'showcaseSettings' | 'showcaseSettingsByMemberId' | 'showcaseSettingsBySubdomain' | 'showcaseSettingsByUserId' | 'stateOrProvinces' | 'stoneRebateStatus' | 'taskDefinitionsByDomain' | 'taskRuns' | 'timeZoneById' | 'userById' | 'userByMemberId' | 'userByShowcaseSettingsId' | 'viewer' | 'viewerPermissions' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	activeCategoriesByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	activeCategoryBySanitizedPath?: FieldPolicy<any> | FieldReadFunction<any>,
	activeItems?: FieldPolicy<any> | FieldReadFunction<any>,
	activeProductGroupsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	authUser?: FieldPolicy<any> | FieldReadFunction<any>,
	availableStatements?: FieldPolicy<any> | FieldReadFunction<any>,
	billToAccountByAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamRequestSearchByCustomerReference?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamRequestSearchByDateRange?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamRequestSearchById?: FieldPolicy<any> | FieldReadFunction<any>,
	cadCamRequestSearchByWipJobNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	canDeactivateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetPrimaryContact?: FieldPolicy<any> | FieldReadFunction<any>,
	cart?: FieldPolicy<any> | FieldReadFunction<any>,
	cartById?: FieldPolicy<any> | FieldReadFunction<any>,
	cartByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	cartItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryById?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsContentById?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsContentByName?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsLookupByTypeAndCode?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsLookupsByType?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsLookupsByTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	configurationById?: FieldPolicy<any> | FieldReadFunction<any>,
	configurationServiceCharges?: FieldPolicy<any> | FieldReadFunction<any>,
	consultantCarts?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPreferencesByContactId?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPreferencesResponseByContactId?: FieldPolicy<any> | FieldReadFunction<any>,
	contactSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	contactsByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	contactsByPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	customerStoreInformationByShipTo?: FieldPolicy<any> | FieldReadFunction<any>,
	customersWithCart?: FieldPolicy<any> | FieldReadFunction<any>,
	dummy?: FieldPolicy<any> | FieldReadFunction<any>,
	embeddedChatSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	eventSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeRateByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeRates?: FieldPolicy<any> | FieldReadFunction<any>,
	favoriteListById?: FieldPolicy<any> | FieldReadFunction<any>,
	favoriteListByShareKey?: FieldPolicy<any> | FieldReadFunction<any>,
	favoriteLists?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	jewelerShowcasesList?: FieldPolicy<any> | FieldReadFunction<any>,
	locateAJewelerListingById?: FieldPolicy<any> | FieldReadFunction<any>,
	locateAJewelerListingSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	locateAJewelerListingsDistanceSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	mainNavCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	marketRates?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingJewelerShowcaseCallbackRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	productById?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupById?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	productSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	publicQuoteLineById?: FieldPolicy<any> | FieldReadFunction<any>,
	queues?: FieldPolicy<any> | FieldReadFunction<any>,
	savedCartLines?: FieldPolicy<any> | FieldReadFunction<any>,
	searchSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	serializedProductBySerialNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	serializedProductsByMatchedSetIds?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccountByAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccountSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseOnlyCarts?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseSettingsByMemberId?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseSettingsBySubdomain?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseSettingsByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	stateOrProvinces?: FieldPolicy<any> | FieldReadFunction<any>,
	stoneRebateStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	taskDefinitionsByDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	taskRuns?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZoneById?: FieldPolicy<any> | FieldReadFunction<any>,
	userById?: FieldPolicy<any> | FieldReadFunction<any>,
	userByMemberId?: FieldPolicy<any> | FieldReadFunction<any>,
	userByShowcaseSettingsId?: FieldPolicy<any> | FieldReadFunction<any>,
	viewer?: FieldPolicy<any> | FieldReadFunction<any>,
	viewerPermissions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueueKeySpecifier = ('deadLetterCount' | 'hasDeadLetter' | 'messagesInFlightCount' | 'name' | 'queueUrl' | 's3Count' | 'totalMessageCount' | QueueKeySpecifier)[];
export type QueueFieldPolicy = {
	deadLetterCount?: FieldPolicy<any> | FieldReadFunction<any>,
	hasDeadLetter?: FieldPolicy<any> | FieldReadFunction<any>,
	messagesInFlightCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	queueUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Count?: FieldPolicy<any> | FieldReadFunction<any>,
	totalMessageCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueueResultKeySpecifier = ('nextToken' | 'queues' | QueueResultKeySpecifier)[];
export type QueueResultFieldPolicy = {
	nextToken?: FieldPolicy<any> | FieldReadFunction<any>,
	queues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReactivateCadCamRequestByIdPayloadKeySpecifier = ('cadCamRequest' | ReactivateCadCamRequestByIdPayloadKeySpecifier)[];
export type ReactivateCadCamRequestByIdPayloadFieldPolicy = {
	cadCamRequest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RingSizeConfigurationDetailKeySpecifier = ('ringSize' | 'title' | RingSizeConfigurationDetailKeySpecifier)[];
export type RingSizeConfigurationDetailFieldPolicy = {
	ringSize?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SalesPersonKeySpecifier = ('id' | SalesPersonKeySpecifier)[];
export type SalesPersonFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaveCartLineForLaterPayloadKeySpecifier = ('cart' | 'savedCartLine' | SaveCartLineForLaterPayloadKeySpecifier)[];
export type SaveCartLineForLaterPayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>,
	savedCartLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SavedCartLineKeySpecifier = ('canEditItem' | 'consultantDescription' | 'creationDate' | 'errors' | 'id' | 'inStockStatus' | 'item' | 'notes' | 'options' | 'price' | 'pricePerUnit' | 'productGroup' | 'quotedPrice' | 'shipDate' | 'trackingSource' | SavedCartLineKeySpecifier)[];
export type SavedCartLineFieldPolicy = {
	canEditItem?: FieldPolicy<any> | FieldReadFunction<any>,
	consultantDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePerUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	quotedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SavedCartLinesResultKeySpecifier = ('count' | 'results' | SavedCartLinesResultKeySpecifier)[];
export type SavedCartLinesResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledOrderKeySpecifier = ('address' | 'id' | 'paymentMethod' | 'shipCompleteMethod' | 'shipToAccount' | 'timeZone' | ScheduledOrderKeySpecifier)[];
export type ScheduledOrderFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shipCompleteMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledOrderCODKeySpecifier = ('id' | ScheduledOrderCODKeySpecifier)[];
export type ScheduledOrderCODFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledOrderCreditCardKeySpecifier = ('cardholderName' | 'expirationMonth' | 'expirationYear' | 'id' | 'lastFourDigits' | 'tokenizedCardNumber' | 'type' | ScheduledOrderCreditCardKeySpecifier)[];
export type ScheduledOrderCreditCardFieldPolicy = {
	cardholderName?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationYear?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastFourDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenizedCardNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledOrderNormalTermsKeySpecifier = ('id' | ScheduledOrderNormalTermsKeySpecifier)[];
export type ScheduledOrderNormalTermsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchSuggestionKeySpecifier = ('clickLoggingUrl' | 'description' | 'groupId' | 'id' | 'imageUrl' | SearchSuggestionKeySpecifier)[];
export type SearchSuggestionFieldPolicy = {
	clickLoggingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SerializedProductKeySpecifier = ('addToCartDisabledReasons' | 'agtaCode' | 'agtaDescription' | 'allowLineLevelDiscounting' | 'brand' | 'calibratedSize' | 'canAddCustomerNotes' | 'canAddSpecialInstructions' | 'canAddToCart' | 'canAnneal' | 'canBagAndTag' | 'canMatch' | 'canOrderOnConsignment' | 'canShipTo' | 'canUpdateOrderLine' | 'canadaMarkNumber' | 'catalogValuesDescription' | 'clarity' | 'color' | 'colorDescription' | 'countryOfOrigin' | 'culet' | 'customerSpecificPrice' | 'cut' | 'defaultProductGroup' | 'depthPercent' | 'dimensionalWeightInGrams' | 'fluorescence' | 'geographicalOrigin' | 'girdle' | 'girdle2' | 'hasCadFile' | 'id' | 'image' | 'inStockStatus' | 'inactiveReasons' | 'inventoryActive' | 'isActive' | 'isCanadaMark' | 'isDiamond' | 'isDimensionalBulkMetal' | 'isGCal8x' | 'isGemstone' | 'isInStock' | 'isKnownOrigin' | 'isLabGrown' | 'isLabGrownDiamond' | 'isLimitedAvailability' | 'isMustConfigure' | 'isOnConsignment' | 'isOnPriceList' | 'isPreorder' | 'isReturnable' | 'isTool' | 'isTwoDimensionalBulkMetal' | 'itemId' | 'itemNumber' | 'itemStatus' | 'length' | 'lengthToWidthRatio' | 'make' | 'makeLookup' | 'matchedSet' | 'matchedSetId' | 'maxDiameter' | 'maximumQuantity' | 'media' | 'merchandiseHierarchy' | 'minDiameter' | 'minimumQuantity' | 'notes' | 'optionErrors' | 'optionNotes' | 'options' | 'percentOffRapaport' | 'planningCode' | 'planningGroup' | 'polish' | 'polishLookup' | 'prerequisiteProducts' | 'price' | 'product' | 'quality' | 'rapaport' | 'report' | 'serialNumber' | 'series' | 'shape' | 'shipDate' | 'shippingCountdown' | 'shippingRestrictions' | 'showcasePriceSummary' | 'soldByDescription' | 'stoneFamily' | 'stoneOrigin' | 'symmetry' | 'symmetryLookup' | 'tablePercent' | 'title' | 'weight' | 'weightInGrams' | 'width' | SerializedProductKeySpecifier)[];
export type SerializedProductFieldPolicy = {
	addToCartDisabledReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	agtaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	agtaDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	allowLineLevelDiscounting?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	calibratedSize?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddCustomerNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddSpecialInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canAnneal?: FieldPolicy<any> | FieldReadFunction<any>,
	canBagAndTag?: FieldPolicy<any> | FieldReadFunction<any>,
	canMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	canOrderOnConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	canShipTo?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateOrderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	canadaMarkNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogValuesDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	clarity?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	colorDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	countryOfOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	culet?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSpecificPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	cut?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	depthPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionalWeightInGrams?: FieldPolicy<any> | FieldReadFunction<any>,
	fluorescence?: FieldPolicy<any> | FieldReadFunction<any>,
	geographicalOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	girdle?: FieldPolicy<any> | FieldReadFunction<any>,
	girdle2?: FieldPolicy<any> | FieldReadFunction<any>,
	hasCadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	inStockStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	inventoryActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isCanadaMark?: FieldPolicy<any> | FieldReadFunction<any>,
	isDiamond?: FieldPolicy<any> | FieldReadFunction<any>,
	isDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	isGCal8x?: FieldPolicy<any> | FieldReadFunction<any>,
	isGemstone?: FieldPolicy<any> | FieldReadFunction<any>,
	isInStock?: FieldPolicy<any> | FieldReadFunction<any>,
	isKnownOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	isLabGrown?: FieldPolicy<any> | FieldReadFunction<any>,
	isLabGrownDiamond?: FieldPolicy<any> | FieldReadFunction<any>,
	isLimitedAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	isMustConfigure?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnConsignment?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnPriceList?: FieldPolicy<any> | FieldReadFunction<any>,
	isPreorder?: FieldPolicy<any> | FieldReadFunction<any>,
	isReturnable?: FieldPolicy<any> | FieldReadFunction<any>,
	isTool?: FieldPolicy<any> | FieldReadFunction<any>,
	isTwoDimensionalBulkMetal?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	itemStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	lengthToWidthRatio?: FieldPolicy<any> | FieldReadFunction<any>,
	make?: FieldPolicy<any> | FieldReadFunction<any>,
	makeLookup?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedSet?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedSetId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDiameter?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	merchandiseHierarchy?: FieldPolicy<any> | FieldReadFunction<any>,
	minDiameter?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	optionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	optionNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	percentOffRapaport?: FieldPolicy<any> | FieldReadFunction<any>,
	planningCode?: FieldPolicy<any> | FieldReadFunction<any>,
	planningGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	polish?: FieldPolicy<any> | FieldReadFunction<any>,
	polishLookup?: FieldPolicy<any> | FieldReadFunction<any>,
	prerequisiteProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quality?: FieldPolicy<any> | FieldReadFunction<any>,
	rapaport?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	series?: FieldPolicy<any> | FieldReadFunction<any>,
	shape?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCountdown?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	showcasePriceSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	soldByDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	stoneFamily?: FieldPolicy<any> | FieldReadFunction<any>,
	stoneOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	symmetry?: FieldPolicy<any> | FieldReadFunction<any>,
	symmetryLookup?: FieldPolicy<any> | FieldReadFunction<any>,
	tablePercent?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>,
	weightInGrams?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SerializedProductReportKeySpecifier = ('isDigitalOnly' | 'provider' | 'reportNumber' | 'url' | SerializedProductReportKeySpecifier)[];
export type SerializedProductReportFieldPolicy = {
	isDigitalOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	reportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetPrimaryContactPayloadKeySpecifier = ('user' | SetPrimaryContactPayloadKeySpecifier)[];
export type SetPrimaryContactPayloadFieldPolicy = {
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShipToAccountKeySpecifier = ('accountName' | 'accountNumber' | 'accountPassword' | 'accountSource' | 'accountType' | 'active' | 'address' | 'allowDropShip' | 'amazonMwsAuthToken' | 'amazonSellerId' | 'billToAccount' | 'businessLine' | 'canPlaceOrders' | 'compositeScore' | 'compositeStarRank' | 'creationDate' | 'creditHold' | 'creditNotes' | 'creditRating' | 'currency' | 'customerAccountId' | 'customerCategory' | 'customerClass' | 'customerSegment' | 'customerValueScore' | 'defaultShippingMethod' | 'documentsFolder' | 'ecommerceWebsite' | 'eoriNumber' | 'hiywBookFlag' | 'holdShipmentsDate' | 'id' | 'is3PL' | 'isAdminOfBuyingGroup' | 'isRelatedToGemvisionAccount' | 'isSignatureRequired' | 'isSpecialHandling' | 'isWebEnabled' | 'lastShipDateTime' | 'legalStatus' | 'loyaltyPrograms' | 'onboarding' | 'onboardingRepName' | 'owns302' | 'phoneNumber' | 'poRequired' | 'previousCompositeScore' | 'previousCompositeStarRank' | 'previousRecencyRank' | 'previousRecencyScore' | 'priceList' | 'programBookFlag' | 'recencyRank' | 'recencyScore' | 'requestedLeadTimeInWorkingDays' | 'salesChannel' | 'salesNotes' | 'salesforceAccountId' | 'salespersonId' | 'shippingDiscountProgramId' | 'showRetailPriceListDiscountInCart' | 'stullerYears' | 'taxId' | 'taxRate' | 'timeZone' | 'usedRetentionPromo' | 'vatNumber' | ShipToAccountKeySpecifier)[];
export type ShipToAccountFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	accountPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	accountSource?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	allowDropShip?: FieldPolicy<any> | FieldReadFunction<any>,
	amazonMwsAuthToken?: FieldPolicy<any> | FieldReadFunction<any>,
	amazonSellerId?: FieldPolicy<any> | FieldReadFunction<any>,
	billToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	businessLine?: FieldPolicy<any> | FieldReadFunction<any>,
	canPlaceOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	compositeScore?: FieldPolicy<any> | FieldReadFunction<any>,
	compositeStarRank?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creditHold?: FieldPolicy<any> | FieldReadFunction<any>,
	creditNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	creditRating?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	customerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	customerClass?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSegment?: FieldPolicy<any> | FieldReadFunction<any>,
	customerValueScore?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultShippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	documentsFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	ecommerceWebsite?: FieldPolicy<any> | FieldReadFunction<any>,
	eoriNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	hiywBookFlag?: FieldPolicy<any> | FieldReadFunction<any>,
	holdShipmentsDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is3PL?: FieldPolicy<any> | FieldReadFunction<any>,
	isAdminOfBuyingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	isRelatedToGemvisionAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	isSignatureRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	isSpecialHandling?: FieldPolicy<any> | FieldReadFunction<any>,
	isWebEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	lastShipDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	legalStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	loyaltyPrograms?: FieldPolicy<any> | FieldReadFunction<any>,
	onboarding?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingRepName?: FieldPolicy<any> | FieldReadFunction<any>,
	owns302?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	poRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	previousCompositeScore?: FieldPolicy<any> | FieldReadFunction<any>,
	previousCompositeStarRank?: FieldPolicy<any> | FieldReadFunction<any>,
	previousRecencyRank?: FieldPolicy<any> | FieldReadFunction<any>,
	previousRecencyScore?: FieldPolicy<any> | FieldReadFunction<any>,
	priceList?: FieldPolicy<any> | FieldReadFunction<any>,
	programBookFlag?: FieldPolicy<any> | FieldReadFunction<any>,
	recencyRank?: FieldPolicy<any> | FieldReadFunction<any>,
	recencyScore?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedLeadTimeInWorkingDays?: FieldPolicy<any> | FieldReadFunction<any>,
	salesChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	salesNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	salesforceAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	salespersonId?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingDiscountProgramId?: FieldPolicy<any> | FieldReadFunction<any>,
	showRetailPriceListDiscountInCart?: FieldPolicy<any> | FieldReadFunction<any>,
	stullerYears?: FieldPolicy<any> | FieldReadFunction<any>,
	taxId?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	usedRetentionPromo?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShipToAccountSearchResultKeySpecifier = ('count' | 'results' | ShipToAccountSearchResultKeySpecifier)[];
export type ShipToAccountSearchResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShipmentKeySpecifier = ('dimensionalWeightInGrams' | 'estimates' | 'isValid' | 'lines' | 'restrictions' | 'shipDate' | 'shipSetCode' | 'shippingMethodSelection' | 'validationErrors' | ShipmentKeySpecifier)[];
export type ShipmentFieldPolicy = {
	dimensionalWeightInGrams?: FieldPolicy<any> | FieldReadFunction<any>,
	estimates?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	restrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	shipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	shipSetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethodSelection?: FieldPolicy<any> | FieldReadFunction<any>,
	validationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingCountdownKeySpecifier = ('countdownKind' | 'cutoffDate' | ShippingCountdownKeySpecifier)[];
export type ShippingCountdownFieldPolicy = {
	countdownKind?: FieldPolicy<any> | FieldReadFunction<any>,
	cutoffDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingEstimateKeySpecifier = ('delivery' | 'freight' | 'isSaturdayDelivery' | 'method' | ShippingEstimateKeySpecifier)[];
export type ShippingEstimateFieldPolicy = {
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	freight?: FieldPolicy<any> | FieldReadFunction<any>,
	isSaturdayDelivery?: FieldPolicy<any> | FieldReadFunction<any>,
	method?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodKeySpecifier = ('carrier' | 'description' | 'id' | 'name' | ShippingMethodKeySpecifier)[];
export type ShippingMethodFieldPolicy = {
	carrier?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseMarkupKeySpecifier = ('description' | 'id' | 'methodId' | 'ticketedValues' | 'type' | 'values' | ShowcaseMarkupKeySpecifier)[];
export type ShowcaseMarkupFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	methodId?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketedValues?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseMarkupTicketedValuesKeySpecifier = ('costs' | 'flatPrice' | 'minimumPrice' | 'values' | 'weights' | ShowcaseMarkupTicketedValuesKeySpecifier)[];
export type ShowcaseMarkupTicketedValuesFieldPolicy = {
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	flatPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	weights?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseMarkupValuesKeySpecifier = ('costs' | 'flatPrice' | 'minimumPrice' | 'values' | 'weights' | ShowcaseMarkupValuesKeySpecifier)[];
export type ShowcaseMarkupValuesFieldPolicy = {
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	flatPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	weights?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseNavigationDisplayExclusionKeySpecifier = ('categoryId' | 'groupId' | 'id' | 'type' | ShowcaseNavigationDisplayExclusionKeySpecifier)[];
export type ShowcaseNavigationDisplayExclusionFieldPolicy = {
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseOnlyCartsResultKeySpecifier = ('cartHeaders' | 'count' | ShowcaseOnlyCartsResultKeySpecifier)[];
export type ShowcaseOnlyCartsResultFieldPolicy = {
	cartHeaders?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcasePriceSummaryKeySpecifier = ('baseTotal' | 'markedUpTotal' | 'sections' | ShowcasePriceSummaryKeySpecifier)[];
export type ShowcasePriceSummaryFieldPolicy = {
	baseTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcasePriceSummaryComponentKeySpecifier = ('basePrice' | 'baseStoneSettingCharge' | 'baseTotal' | 'flatPrice' | 'item' | 'markedUpStoneSettingCharge' | 'markedUpTotal' | 'markupDescription' | 'markupMultiplier' | 'markupPrice' | 'minimumPrice' | 'quantity' | 'title' | ShowcasePriceSummaryComponentKeySpecifier)[];
export type ShowcasePriceSummaryComponentFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	baseStoneSettingCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	baseTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	flatPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpStoneSettingCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	markupDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	markupMultiplier?: FieldPolicy<any> | FieldReadFunction<any>,
	markupPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcasePriceSummarySectionKeySpecifier = ('additionalCharge' | 'baseTotal' | 'centsOverride' | 'components' | 'item' | 'markedUpTotal' | 'title' | ShowcasePriceSummarySectionKeySpecifier)[];
export type ShowcasePriceSummarySectionFieldPolicy = {
	additionalCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	baseTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	centsOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseSettingsKeySpecifier = ('aboutUs' | 'aboutUsIsChecked' | 'additionalCharge' | 'backgroundColorClass' | 'backgroundPatternClass' | 'contactUs' | 'contactUsIsChecked' | 'customShowcaseSettings' | 'defaultActiveUser' | 'emailAddress' | 'hidePrices' | 'hideUSDPrices' | 'homepageTemplateCode' | 'iFrameShowNavigationBar' | 'id' | 'jewelerShowcaseSubdomain' | 'jewelerShowcaseUrl' | 'logo' | 'markups' | 'phoneNumber' | 'priceCents' | 'requiresAuthentication' | 'salesTax' | 'setup' | 'showCalculateShipDate' | 'showMetalMarkets' | 'ticketedAdditionalCharge' | 'title' | ShowcaseSettingsKeySpecifier)[];
export type ShowcaseSettingsFieldPolicy = {
	aboutUs?: FieldPolicy<any> | FieldReadFunction<any>,
	aboutUsIsChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColorClass?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundPatternClass?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUs?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUsIsChecked?: FieldPolicy<any> | FieldReadFunction<any>,
	customShowcaseSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultActiveUser?: FieldPolicy<any> | FieldReadFunction<any>,
	emailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	hidePrices?: FieldPolicy<any> | FieldReadFunction<any>,
	hideUSDPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	homepageTemplateCode?: FieldPolicy<any> | FieldReadFunction<any>,
	iFrameShowNavigationBar?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jewelerShowcaseSubdomain?: FieldPolicy<any> | FieldReadFunction<any>,
	jewelerShowcaseUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	markups?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	priceCents?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresAuthentication?: FieldPolicy<any> | FieldReadFunction<any>,
	salesTax?: FieldPolicy<any> | FieldReadFunction<any>,
	setup?: FieldPolicy<any> | FieldReadFunction<any>,
	showCalculateShipDate?: FieldPolicy<any> | FieldReadFunction<any>,
	showMetalMarkets?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketedAdditionalCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowcaseSettingsSetupKeySpecifier = ('displayComplete' | 'markupsComplete' | ShowcaseSettingsSetupKeySpecifier)[];
export type ShowcaseSettingsSetupFieldPolicy = {
	displayComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	markupsComplete?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpecialFinishConfigurationDetailKeySpecifier = ('finishes' | 'title' | SpecialFinishConfigurationDetailKeySpecifier)[];
export type SpecialFinishConfigurationDetailFieldPolicy = {
	finishes?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpecialFinishLocationConfigurationKeySpecifier = ('locationDescription' | 'previewImage' | 'specialFinishName' | SpecialFinishLocationConfigurationKeySpecifier)[];
export type SpecialFinishLocationConfigurationFieldPolicy = {
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	previewImage?: FieldPolicy<any> | FieldReadFunction<any>,
	specialFinishName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardEngravingLocationConfigurationKeySpecifier = ('color' | 'fontName' | 'lines' | StandardEngravingLocationConfigurationKeySpecifier)[];
export type StandardEngravingLocationConfigurationFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	fontName?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StateOrProvinceKeySpecifier = ('code' | 'name' | StateOrProvinceKeySpecifier)[];
export type StateOrProvinceFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoneRebateByBillToAccountResultKeySpecifier = ('stonesPurchased' | 'tiers' | StoneRebateByBillToAccountResultKeySpecifier)[];
export type StoneRebateByBillToAccountResultFieldPolicy = {
	stonesPurchased?: FieldPolicy<any> | FieldReadFunction<any>,
	tiers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoneRebateRangeKeySpecifier = ('id' | 'maximumQuantity' | 'minimumQuantity' | 'rebatePercent' | 'stoneType' | StoneRebateRangeKeySpecifier)[];
export type StoneRebateRangeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	rebatePercent?: FieldPolicy<any> | FieldReadFunction<any>,
	stoneType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoneSettingConfigurationDetailKeySpecifier = ('stoneSettings' | 'title' | StoneSettingConfigurationDetailKeySpecifier)[];
export type StoneSettingConfigurationDetailFieldPolicy = {
	stoneSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoneSettingLocationConfigurationKeySpecifier = ('exactFit' | 'locationDescription' | 'quantity' | 'stone' | StoneSettingLocationConfigurationKeySpecifier)[];
export type StoneSettingLocationConfigurationFieldPolicy = {
	exactFit?: FieldPolicy<any> | FieldReadFunction<any>,
	locationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	stone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrategicPurchaseListKeySpecifier = ('id' | StrategicPurchaseListKeySpecifier)[];
export type StrategicPurchaseListFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskDefinitionKeySpecifier = ('currentRun' | 'domain' | 'nextRunTime' | 'previousRun' | 'status' | 'taskName' | TaskDefinitionKeySpecifier)[];
export type TaskDefinitionFieldPolicy = {
	currentRun?: FieldPolicy<any> | FieldReadFunction<any>,
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	nextRunTime?: FieldPolicy<any> | FieldReadFunction<any>,
	previousRun?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	taskName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskOperationDetailKeySpecifier = ('count' | 'values' | TaskOperationDetailKeySpecifier)[];
export type TaskOperationDetailFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskResultSummaryKeySpecifier = ('errorMessages' | 'messages' | 'operations' | TaskResultSummaryKeySpecifier)[];
export type TaskResultSummaryFieldPolicy = {
	errorMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	operations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskRunKeySpecifier = ('beginTime' | 'completeTime' | 'details' | 'duration' | 'runId' | 'status' | 'taskSource' | 'traceId' | TaskRunKeySpecifier)[];
export type TaskRunFieldPolicy = {
	beginTime?: FieldPolicy<any> | FieldReadFunction<any>,
	completeTime?: FieldPolicy<any> | FieldReadFunction<any>,
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	runId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	taskSource?: FieldPolicy<any> | FieldReadFunction<any>,
	traceId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskRunOperationsKeySpecifier = ('deletes' | 'reads' | 'writes' | TaskRunOperationsKeySpecifier)[];
export type TaskRunOperationsFieldPolicy = {
	deletes?: FieldPolicy<any> | FieldReadFunction<any>,
	reads?: FieldPolicy<any> | FieldReadFunction<any>,
	writes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskRunsSearchResultKeySpecifier = ('nextToken' | 'taskRuns' | TaskRunsSearchResultKeySpecifier)[];
export type TaskRunsSearchResultFieldPolicy = {
	nextToken?: FieldPolicy<any> | FieldReadFunction<any>,
	taskRuns?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TermsKeySpecifier = ('creditCardOnly' | 'description' | 'id' | 'webPaymentMethod' | TermsKeySpecifier)[];
export type TermsFieldPolicy = {
	creditCardOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	webPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimeZoneKeySpecifier = ('cutoff' | 'id' | TimeZoneKeySpecifier)[];
export type TimeZoneFieldPolicy = {
	cutoff?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TrackingSourceKeySpecifier = ('index' | 'source' | 'sourceId' | 'type' | TrackingSourceKeySpecifier)[];
export type TrackingSourceFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TradeShowKeySpecifier = ('id' | TradeShowKeySpecifier)[];
export type TradeShowFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TrademarkKeySpecifier = ('id' | 'imagePreview' | 'name' | TrademarkKeySpecifier)[];
export type TrademarkFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imagePreview?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCartLinePayloadKeySpecifier = ('cart' | UpdateCartLinePayloadKeySpecifier)[];
export type UpdateCartLinePayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCartLineQuantityPayloadKeySpecifier = ('cart' | UpdateCartLineQuantityPayloadKeySpecifier)[];
export type UpdateCartLineQuantityPayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateContactPayloadKeySpecifier = ('contact' | UpdateContactPayloadKeySpecifier)[];
export type UpdateContactPayloadFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCreditCardPayloadKeySpecifier = ('creditCard' | UpdateCreditCardPayloadKeySpecifier)[];
export type UpdateCreditCardPayloadFieldPolicy = {
	creditCard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateCurrencyDisplayPayloadKeySpecifier = ('user' | UpdateCurrencyDisplayPayloadKeySpecifier)[];
export type UpdateCurrencyDisplayPayloadFieldPolicy = {
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDefaultPaymentMethodPayloadKeySpecifier = ('defaultPaymentMethod' | UpdateDefaultPaymentMethodPayloadKeySpecifier)[];
export type UpdateDefaultPaymentMethodPayloadFieldPolicy = {
	defaultPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateFavoriteListPayloadKeySpecifier = ('favoriteList' | UpdateFavoriteListPayloadKeySpecifier)[];
export type UpdateFavoriteListPayloadFieldPolicy = {
	favoriteList?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateHideUsdPricePayloadKeySpecifier = ('showcaseSettings' | UpdateHideUsdPricePayloadKeySpecifier)[];
export type UpdateHideUsdPricePayloadFieldPolicy = {
	showcaseSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateHoldShipmentsDatePayloadKeySpecifier = ('shipToAccount' | UpdateHoldShipmentsDatePayloadKeySpecifier)[];
export type UpdateHoldShipmentsDatePayloadFieldPolicy = {
	shipToAccount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLocateAJewelerListingPayloadKeySpecifier = ('locateAJewelerListing' | UpdateLocateAJewelerListingPayloadKeySpecifier)[];
export type UpdateLocateAJewelerListingPayloadFieldPolicy = {
	locateAJewelerListing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateNotificationStatusPayloadKeySpecifier = ('notification' | UpdateNotificationStatusPayloadKeySpecifier)[];
export type UpdateNotificationStatusPayloadFieldPolicy = {
	notification?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateNotificationsFeedReadPayloadKeySpecifier = ('count' | UpdateNotificationsFeedReadPayloadKeySpecifier)[];
export type UpdateNotificationsFeedReadPayloadFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateSavedCartLinePayloadKeySpecifier = ('savedCartLine' | UpdateSavedCartLinePayloadKeySpecifier)[];
export type UpdateSavedCartLinePayloadFieldPolicy = {
	savedCartLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateScheduledCartShippingMethodPayloadKeySpecifier = ('cart' | UpdateScheduledCartShippingMethodPayloadKeySpecifier)[];
export type UpdateScheduledCartShippingMethodPayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateScheduledOrderPayloadKeySpecifier = ('cart' | 'scheduledOrder' | UpdateScheduledOrderPayloadKeySpecifier)[];
export type UpdateScheduledOrderPayloadFieldPolicy = {
	cart?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpsertCommunicationPreferencePayloadKeySpecifier = ('communicationPreference' | 'optedOutEngagementChannels' | UpsertCommunicationPreferencePayloadKeySpecifier)[];
export type UpsertCommunicationPreferencePayloadFieldPolicy = {
	communicationPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	optedOutEngagementChannels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpsertCustomerStoreInformationPayloadKeySpecifier = ('customerStoreInformation' | UpsertCustomerStoreInformationPayloadKeySpecifier)[];
export type UpsertCustomerStoreInformationPayloadFieldPolicy = {
	customerStoreInformation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('active' | 'cartItemCount' | 'contact' | 'contactMode' | 'currencyDisplay' | 'defaultActiveShipToAccount' | 'defaultPaymentMethod' | 'ecommerceMerchandisingMode' | 'firstName' | 'fullName' | 'hasGemvisionAccount' | 'hasUnreadSpecialOrderMessages' | 'id' | 'is302Member' | 'isCadCamServicesMember' | 'isEverAndEverMember' | 'isStullerFirstEligible' | 'isStullerFirstEnrolled' | 'lastName' | 'memberId' | 'needsToAgreeToConsignmentTerms' | 'notification' | 'notificationsFeed' | 'notificationsUnreadCount' | 'paymentMethods' | 'preferredShipToAccountId' | 'priceList' | 'resetPassword' | 'scheduledOrder' | 'shipToAccount' | 'showcaseSettings' | 'strategicPurchasesByListIds' | 'username' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	cartItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactMode?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultActiveShipToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	ecommerceMerchandisingMode?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasGemvisionAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnreadSpecialOrderMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is302Member?: FieldPolicy<any> | FieldReadFunction<any>,
	isCadCamServicesMember?: FieldPolicy<any> | FieldReadFunction<any>,
	isEverAndEverMember?: FieldPolicy<any> | FieldReadFunction<any>,
	isStullerFirstEligible?: FieldPolicy<any> | FieldReadFunction<any>,
	isStullerFirstEnrolled?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	memberId?: FieldPolicy<any> | FieldReadFunction<any>,
	needsToAgreeToConsignmentTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationsFeed?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationsUnreadCount?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	preferredShipToAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	priceList?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	shipToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	showcaseSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	strategicPurchasesByListIds?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserStrategicPurchaseKeySpecifier = ('id' | 'strategicPurchaseList' | UserStrategicPurchaseKeySpecifier)[];
export type UserStrategicPurchaseFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	strategicPurchaseList?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VideoKeySpecifier = ('height' | 'type' | 'url' | 'width' | VideoKeySpecifier)[];
export type VideoFieldPolicy = {
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Video360KeySpecifier = ('id' | 'imageUrl' | 'sources' | Video360KeySpecifier)[];
export type Video360FieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewerPermissionsKeySpecifier = ('addToCartType' | 'canAddToFavorites' | 'canAdminContacts' | 'canApproveOrders' | 'canAutoReorder' | 'canCheckout' | 'canCreateLocateAJewelerListings' | 'canCreateLocateAJewelerListingsWithoutShipToAccount' | 'canCreateUniqueRequest' | 'canCreateUsers' | 'canManageLogos' | 'canManageMarketplaceSolutions' | 'canManagePaymentMethods' | 'canManagePreferences' | 'canManageProductDataFeeds' | 'canManageStullerFirstEnrollments' | 'canPayBill' | 'canSaveCartItems' | 'canSetOrderLineConsultantDiscounts' | 'canSetOrderLineMatching' | 'canSetOrderLineSalesType' | 'canSetup302Showcase' | 'canSetupEverAndEverShowcase' | 'canSetupShowcase' | 'canSignupForProductDataFeeds' | 'canSubmitOrderForApprovalBypassCheckout' | 'canSubmitQuote' | 'canUpdateCurrency' | 'canUpdateHoldShipments' | 'canUpgradeAccount' | 'canUseCreditCards' | 'canViewCadCamRequests' | 'canViewCart' | 'canViewConsultantCarts' | 'canViewDiamondRebates' | 'canViewGemstoneRebates' | 'canViewInvoices' | 'canViewJewelerShowcaseRequests' | 'canViewMarketingAssets' | 'canViewOrders' | 'canViewQuantityOnHand' | 'canViewShowcaseOnlyUsers' | 'canViewSignetCustomDesignHub' | 'canViewStatements' | 'id' | ViewerPermissionsKeySpecifier)[];
export type ViewerPermissionsFieldPolicy = {
	addToCartType?: FieldPolicy<any> | FieldReadFunction<any>,
	canAddToFavorites?: FieldPolicy<any> | FieldReadFunction<any>,
	canAdminContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	canApproveOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	canAutoReorder?: FieldPolicy<any> | FieldReadFunction<any>,
	canCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateLocateAJewelerListings?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateLocateAJewelerListingsWithoutShipToAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateUniqueRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	canManageLogos?: FieldPolicy<any> | FieldReadFunction<any>,
	canManageMarketplaceSolutions?: FieldPolicy<any> | FieldReadFunction<any>,
	canManagePaymentMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	canManagePreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	canManageProductDataFeeds?: FieldPolicy<any> | FieldReadFunction<any>,
	canManageStullerFirstEnrollments?: FieldPolicy<any> | FieldReadFunction<any>,
	canPayBill?: FieldPolicy<any> | FieldReadFunction<any>,
	canSaveCartItems?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetOrderLineConsultantDiscounts?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetOrderLineMatching?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetOrderLineSalesType?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetup302Showcase?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetupEverAndEverShowcase?: FieldPolicy<any> | FieldReadFunction<any>,
	canSetupShowcase?: FieldPolicy<any> | FieldReadFunction<any>,
	canSignupForProductDataFeeds?: FieldPolicy<any> | FieldReadFunction<any>,
	canSubmitOrderForApprovalBypassCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	canSubmitQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateHoldShipments?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpgradeAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	canUseCreditCards?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewCadCamRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewCart?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewConsultantCarts?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewDiamondRebates?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewGemstoneRebates?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewJewelerShowcaseRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewMarketingAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewQuantityOnHand?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewShowcaseOnlyUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewSignetCustomDesignHub?: FieldPolicy<any> | FieldReadFunction<any>,
	canViewStatements?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AcceptConsignmentTermsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AcceptConsignmentTermsPayloadKeySpecifier | (() => undefined | AcceptConsignmentTermsPayloadKeySpecifier),
		fields?: AcceptConsignmentTermsPayloadFieldPolicy,
	},
	AddToCartPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddToCartPayloadKeySpecifier | (() => undefined | AddToCartPayloadKeySpecifier),
		fields?: AddToCartPayloadFieldPolicy,
	},
	AddToFavoritesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddToFavoritesPayloadKeySpecifier | (() => undefined | AddToFavoritesPayloadKeySpecifier),
		fields?: AddToFavoritesPayloadFieldPolicy,
	},
	AddToSignetCartPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddToSignetCartPayloadKeySpecifier | (() => undefined | AddToSignetCartPayloadKeySpecifier),
		fields?: AddToSignetCartPayloadFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AuthUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthUserKeySpecifier | (() => undefined | AuthUserKeySpecifier),
		fields?: AuthUserFieldPolicy,
	},
	AvailableStatements?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvailableStatementsKeySpecifier | (() => undefined | AvailableStatementsKeySpecifier),
		fields?: AvailableStatementsFieldPolicy,
	},
	BackOrderInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BackOrderInfoKeySpecifier | (() => undefined | BackOrderInfoKeySpecifier),
		fields?: BackOrderInfoFieldPolicy,
	},
	BillToAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillToAccountKeySpecifier | (() => undefined | BillToAccountKeySpecifier),
		fields?: BillToAccountFieldPolicy,
	},
	COD?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CODKeySpecifier | (() => undefined | CODKeySpecifier),
		fields?: CODFieldPolicy,
	},
	CadCamRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CadCamRequestKeySpecifier | (() => undefined | CadCamRequestKeySpecifier),
		fields?: CadCamRequestFieldPolicy,
	},
	CadCamRequestStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CadCamRequestStatusKeySpecifier | (() => undefined | CadCamRequestStatusKeySpecifier),
		fields?: CadCamRequestStatusFieldPolicy,
	},
	CadCamRequestsSearchByCustomerReferenceResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CadCamRequestsSearchByCustomerReferenceResultKeySpecifier | (() => undefined | CadCamRequestsSearchByCustomerReferenceResultKeySpecifier),
		fields?: CadCamRequestsSearchByCustomerReferenceResultFieldPolicy,
	},
	CadCamRequestsSearchByDateRangeResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CadCamRequestsSearchByDateRangeResultKeySpecifier | (() => undefined | CadCamRequestsSearchByDateRangeResultKeySpecifier),
		fields?: CadCamRequestsSearchByDateRangeResultFieldPolicy,
	},
	CancelScheduledOrderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CancelScheduledOrderPayloadKeySpecifier | (() => undefined | CancelScheduledOrderPayloadKeySpecifier),
		fields?: CancelScheduledOrderPayloadFieldPolicy,
	},
	Cart?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartKeySpecifier | (() => undefined | CartKeySpecifier),
		fields?: CartFieldPolicy,
	},
	CartHeader?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartHeaderKeySpecifier | (() => undefined | CartHeaderKeySpecifier),
		fields?: CartHeaderFieldPolicy,
	},
	CartItemPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartItemPriceKeySpecifier | (() => undefined | CartItemPriceKeySpecifier),
		fields?: CartItemPriceFieldPolicy,
	},
	CartLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartLineKeySpecifier | (() => undefined | CartLineKeySpecifier),
		fields?: CartLineFieldPolicy,
	},
	CartLineInStockStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartLineInStockStatusKeySpecifier | (() => undefined | CartLineInStockStatusKeySpecifier),
		fields?: CartLineInStockStatusFieldPolicy,
	},
	CartMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartMessageKeySpecifier | (() => undefined | CartMessageKeySpecifier),
		fields?: CartMessageFieldPolicy,
	},
	CartPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartPriceKeySpecifier | (() => undefined | CartPriceKeySpecifier),
		fields?: CartPriceFieldPolicy,
	},
	CartServiceCharge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartServiceChargeKeySpecifier | (() => undefined | CartServiceChargeKeySpecifier),
		fields?: CartServiceChargeFieldPolicy,
	},
	CartServiceChargePrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CartServiceChargePriceKeySpecifier | (() => undefined | CartServiceChargePriceKeySpecifier),
		fields?: CartServiceChargePriceFieldPolicy,
	},
	Category?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryKeySpecifier | (() => undefined | CategoryKeySpecifier),
		fields?: CategoryFieldPolicy,
	},
	ChainConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChainConfigurationDetailKeySpecifier | (() => undefined | ChainConfigurationDetailKeySpecifier),
		fields?: ChainConfigurationDetailFieldPolicy,
	},
	CmsContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsContentKeySpecifier | (() => undefined | CmsContentKeySpecifier),
		fields?: CmsContentFieldPolicy,
	},
	CmsLookup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsLookupKeySpecifier | (() => undefined | CmsLookupKeySpecifier),
		fields?: CmsLookupFieldPolicy,
	},
	CommunicationChannelGlobalSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommunicationChannelGlobalSubscriptionKeySpecifier | (() => undefined | CommunicationChannelGlobalSubscriptionKeySpecifier),
		fields?: CommunicationChannelGlobalSubscriptionFieldPolicy,
	},
	CommunicationPreference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommunicationPreferenceKeySpecifier | (() => undefined | CommunicationPreferenceKeySpecifier),
		fields?: CommunicationPreferenceFieldPolicy,
	},
	CommunicationPreferencesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommunicationPreferencesResponseKeySpecifier | (() => undefined | CommunicationPreferencesResponseKeySpecifier),
		fields?: CommunicationPreferencesResponseFieldPolicy,
	},
	ComponentPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentPriceKeySpecifier | (() => undefined | ComponentPriceKeySpecifier),
		fields?: ComponentPriceFieldPolicy,
	},
	Configuration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationKeySpecifier | (() => undefined | ConfigurationKeySpecifier),
		fields?: ConfigurationFieldPolicy,
	},
	ConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationDetailKeySpecifier | (() => undefined | ConfigurationDetailKeySpecifier),
		fields?: ConfigurationDetailFieldPolicy,
	},
	ConfigurationProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationProductKeySpecifier | (() => undefined | ConfigurationProductKeySpecifier),
		fields?: ConfigurationProductFieldPolicy,
	},
	ConfigurationSerializedProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationSerializedProductKeySpecifier | (() => undefined | ConfigurationSerializedProductKeySpecifier),
		fields?: ConfigurationSerializedProductFieldPolicy,
	},
	ConfigurationServiceCharge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationServiceChargeKeySpecifier | (() => undefined | ConfigurationServiceChargeKeySpecifier),
		fields?: ConfigurationServiceChargeFieldPolicy,
	},
	ConfigurationServiceChargePrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationServiceChargePriceKeySpecifier | (() => undefined | ConfigurationServiceChargePriceKeySpecifier),
		fields?: ConfigurationServiceChargePriceFieldPolicy,
	},
	ConsultantCartsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConsultantCartsResultKeySpecifier | (() => undefined | ConsultantCartsResultKeySpecifier),
		fields?: ConsultantCartsResultFieldPolicy,
	},
	ConsultantInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConsultantInfoKeySpecifier | (() => undefined | ConsultantInfoKeySpecifier),
		fields?: ConsultantInfoFieldPolicy,
	},
	Contact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactKeySpecifier | (() => undefined | ContactKeySpecifier),
		fields?: ContactFieldPolicy,
	},
	ContactPreferencesResponseByContactIdResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactPreferencesResponseByContactIdResultKeySpecifier | (() => undefined | ContactPreferencesResponseByContactIdResultKeySpecifier),
		fields?: ContactPreferencesResponseByContactIdResultFieldPolicy,
	},
	ContactSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactSearchResultKeySpecifier | (() => undefined | ContactSearchResultKeySpecifier),
		fields?: ContactSearchResultFieldPolicy,
	},
	ContactsByEmailResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactsByEmailResultKeySpecifier | (() => undefined | ContactsByEmailResultKeySpecifier),
		fields?: ContactsByEmailResultFieldPolicy,
	},
	ContactsByPhoneNumberResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactsByPhoneNumberResultKeySpecifier | (() => undefined | ContactsByPhoneNumberResultKeySpecifier),
		fields?: ContactsByPhoneNumberResultFieldPolicy,
	},
	CopyConfigurationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopyConfigurationPayloadKeySpecifier | (() => undefined | CopyConfigurationPayloadKeySpecifier),
		fields?: CopyConfigurationPayloadFieldPolicy,
	},
	Country?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryKeySpecifier | (() => undefined | CountryKeySpecifier),
		fields?: CountryFieldPolicy,
	},
	CreateContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateContactPayloadKeySpecifier | (() => undefined | CreateContactPayloadKeySpecifier),
		fields?: CreateContactPayloadFieldPolicy,
	},
	CreateCreditCardPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateCreditCardPayloadKeySpecifier | (() => undefined | CreateCreditCardPayloadKeySpecifier),
		fields?: CreateCreditCardPayloadFieldPolicy,
	},
	CreateFavoriteListPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateFavoriteListPayloadKeySpecifier | (() => undefined | CreateFavoriteListPayloadKeySpecifier),
		fields?: CreateFavoriteListPayloadFieldPolicy,
	},
	CreateLocateAJewelerListingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateLocateAJewelerListingPayloadKeySpecifier | (() => undefined | CreateLocateAJewelerListingPayloadKeySpecifier),
		fields?: CreateLocateAJewelerListingPayloadFieldPolicy,
	},
	CreateNotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateNotificationPayloadKeySpecifier | (() => undefined | CreateNotificationPayloadKeySpecifier),
		fields?: CreateNotificationPayloadFieldPolicy,
	},
	CreateQuotePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateQuotePayloadKeySpecifier | (() => undefined | CreateQuotePayloadKeySpecifier),
		fields?: CreateQuotePayloadFieldPolicy,
	},
	CreditCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreditCardKeySpecifier | (() => undefined | CreditCardKeySpecifier),
		fields?: CreditCardFieldPolicy,
	},
	CurrencyValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyValueKeySpecifier | (() => undefined | CurrencyValueKeySpecifier),
		fields?: CurrencyValueFieldPolicy,
	},
	CustomShowcaseSettingDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomShowcaseSettingDetailKeySpecifier | (() => undefined | CustomShowcaseSettingDetailKeySpecifier),
		fields?: CustomShowcaseSettingDetailFieldPolicy,
	},
	CustomShowcaseSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomShowcaseSettingsKeySpecifier | (() => undefined | CustomShowcaseSettingsKeySpecifier),
		fields?: CustomShowcaseSettingsFieldPolicy,
	},
	CustomerLogoEngravingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerLogoEngravingLocationConfigurationKeySpecifier | (() => undefined | CustomerLogoEngravingLocationConfigurationKeySpecifier),
		fields?: CustomerLogoEngravingLocationConfigurationFieldPolicy,
	},
	CustomerLogoHotStampingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerLogoHotStampingLocationConfigurationKeySpecifier | (() => undefined | CustomerLogoHotStampingLocationConfigurationKeySpecifier),
		fields?: CustomerLogoHotStampingLocationConfigurationFieldPolicy,
	},
	CustomerLogoImprintingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerLogoImprintingLocationConfigurationKeySpecifier | (() => undefined | CustomerLogoImprintingLocationConfigurationKeySpecifier),
		fields?: CustomerLogoImprintingLocationConfigurationFieldPolicy,
	},
	CustomerStone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerStoneKeySpecifier | (() => undefined | CustomerStoneKeySpecifier),
		fields?: CustomerStoneFieldPolicy,
	},
	CustomerStoreInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerStoreInformationKeySpecifier | (() => undefined | CustomerStoreInformationKeySpecifier),
		fields?: CustomerStoreInformationFieldPolicy,
	},
	DeactivateContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeactivateContactPayloadKeySpecifier | (() => undefined | DeactivateContactPayloadKeySpecifier),
		fields?: DeactivateContactPayloadFieldPolicy,
	},
	DeleteAllCartLinesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteAllCartLinesPayloadKeySpecifier | (() => undefined | DeleteAllCartLinesPayloadKeySpecifier),
		fields?: DeleteAllCartLinesPayloadFieldPolicy,
	},
	DeleteCartLinePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCartLinePayloadKeySpecifier | (() => undefined | DeleteCartLinePayloadKeySpecifier),
		fields?: DeleteCartLinePayloadFieldPolicy,
	},
	DeleteCreditCardPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCreditCardPayloadKeySpecifier | (() => undefined | DeleteCreditCardPayloadKeySpecifier),
		fields?: DeleteCreditCardPayloadFieldPolicy,
	},
	DeleteFavoriteListPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFavoriteListPayloadKeySpecifier | (() => undefined | DeleteFavoriteListPayloadKeySpecifier),
		fields?: DeleteFavoriteListPayloadFieldPolicy,
	},
	DeleteFavoritesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFavoritesPayloadKeySpecifier | (() => undefined | DeleteFavoritesPayloadKeySpecifier),
		fields?: DeleteFavoritesPayloadFieldPolicy,
	},
	DeleteLocateAJewelerListingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLocateAJewelerListingPayloadKeySpecifier | (() => undefined | DeleteLocateAJewelerListingPayloadKeySpecifier),
		fields?: DeleteLocateAJewelerListingPayloadFieldPolicy,
	},
	DeleteNotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteNotificationPayloadKeySpecifier | (() => undefined | DeleteNotificationPayloadKeySpecifier),
		fields?: DeleteNotificationPayloadFieldPolicy,
	},
	DeleteSavedCartLinePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteSavedCartLinePayloadKeySpecifier | (() => undefined | DeleteSavedCartLinePayloadKeySpecifier),
		fields?: DeleteSavedCartLinePayloadFieldPolicy,
	},
	EarringConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EarringConfigurationDetailKeySpecifier | (() => undefined | EarringConfigurationDetailKeySpecifier),
		fields?: EarringConfigurationDetailFieldPolicy,
	},
	EmbeddedChatSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmbeddedChatSettingKeySpecifier | (() => undefined | EmbeddedChatSettingKeySpecifier),
		fields?: EmbeddedChatSettingFieldPolicy,
	},
	EmbeddedChatSettingsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmbeddedChatSettingsResultKeySpecifier | (() => undefined | EmbeddedChatSettingsResultKeySpecifier),
		fields?: EmbeddedChatSettingsResultFieldPolicy,
	},
	Employee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmployeeKeySpecifier | (() => undefined | EmployeeKeySpecifier),
		fields?: EmployeeFieldPolicy,
	},
	EngravingColorConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EngravingColorConfigurationKeySpecifier | (() => undefined | EngravingColorConfigurationKeySpecifier),
		fields?: EngravingColorConfigurationFieldPolicy,
	},
	EngravingConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EngravingConfigurationDetailKeySpecifier | (() => undefined | EngravingConfigurationDetailKeySpecifier),
		fields?: EngravingConfigurationDetailFieldPolicy,
	},
	EngravingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EngravingLocationConfigurationKeySpecifier | (() => undefined | EngravingLocationConfigurationKeySpecifier),
		fields?: EngravingLocationConfigurationFieldPolicy,
	},
	EngravingText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EngravingTextKeySpecifier | (() => undefined | EngravingTextKeySpecifier),
		fields?: EngravingTextFieldPolicy,
	},
	EstimatedShipDate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EstimatedShipDateKeySpecifier | (() => undefined | EstimatedShipDateKeySpecifier),
		fields?: EstimatedShipDateFieldPolicy,
	},
	EventSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventSessionKeySpecifier | (() => undefined | EventSessionKeySpecifier),
		fields?: EventSessionFieldPolicy,
	},
	ExactFitConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExactFitConfigurationKeySpecifier | (() => undefined | ExactFitConfigurationKeySpecifier),
		fields?: ExactFitConfigurationFieldPolicy,
	},
	ExchangeRate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExchangeRateKeySpecifier | (() => undefined | ExchangeRateKeySpecifier),
		fields?: ExchangeRateFieldPolicy,
	},
	Favorite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FavoriteKeySpecifier | (() => undefined | FavoriteKeySpecifier),
		fields?: FavoriteFieldPolicy,
	},
	FavoriteList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FavoriteListKeySpecifier | (() => undefined | FavoriteListKeySpecifier),
		fields?: FavoriteListFieldPolicy,
	},
	GenerateFavoriteListShareKeyPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateFavoriteListShareKeyPayloadKeySpecifier | (() => undefined | GenerateFavoriteListShareKeyPayloadKeySpecifier),
		fields?: GenerateFavoriteListShareKeyPayloadFieldPolicy,
	},
	GlobalUnsubscribeContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalUnsubscribeContactPayloadKeySpecifier | (() => undefined | GlobalUnsubscribeContactPayloadKeySpecifier),
		fields?: GlobalUnsubscribeContactPayloadFieldPolicy,
	},
	GlobalUnsubscribeEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalUnsubscribeEmailPayloadKeySpecifier | (() => undefined | GlobalUnsubscribeEmailPayloadKeySpecifier),
		fields?: GlobalUnsubscribeEmailPayloadFieldPolicy,
	},
	HandwrittenEngravingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HandwrittenEngravingLocationConfigurationKeySpecifier | (() => undefined | HandwrittenEngravingLocationConfigurationKeySpecifier),
		fields?: HandwrittenEngravingLocationConfigurationFieldPolicy,
	},
	HeadConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeadConfigurationDetailKeySpecifier | (() => undefined | HeadConfigurationDetailKeySpecifier),
		fields?: HeadConfigurationDetailFieldPolicy,
	},
	ICartLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ICartLineKeySpecifier | (() => undefined | ICartLineKeySpecifier),
		fields?: ICartLineFieldPolicy,
	},
	IPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IPriceKeySpecifier | (() => undefined | IPriceKeySpecifier),
		fields?: IPriceFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	ImprintingConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImprintingConfigurationDetailKeySpecifier | (() => undefined | ImprintingConfigurationDetailKeySpecifier),
		fields?: ImprintingConfigurationDetailFieldPolicy,
	},
	ImprintingLocationColorConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImprintingLocationColorConfigurationKeySpecifier | (() => undefined | ImprintingLocationColorConfigurationKeySpecifier),
		fields?: ImprintingLocationColorConfigurationFieldPolicy,
	},
	ImprintingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImprintingLocationConfigurationKeySpecifier | (() => undefined | ImprintingLocationConfigurationKeySpecifier),
		fields?: ImprintingLocationConfigurationFieldPolicy,
	},
	Item?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemKeySpecifier | (() => undefined | ItemKeySpecifier),
		fields?: ItemFieldPolicy,
	},
	ItemId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemIdKeySpecifier | (() => undefined | ItemIdKeySpecifier),
		fields?: ItemIdFieldPolicy,
	},
	ItemInactiveReason?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemInactiveReasonKeySpecifier | (() => undefined | ItemInactiveReasonKeySpecifier),
		fields?: ItemInactiveReasonFieldPolicy,
	},
	ItemLineOptionMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemLineOptionMessageKeySpecifier | (() => undefined | ItemLineOptionMessageKeySpecifier),
		fields?: ItemLineOptionMessageFieldPolicy,
	},
	ItemLineOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemLineOptionsKeySpecifier | (() => undefined | ItemLineOptionsKeySpecifier),
		fields?: ItemLineOptionsFieldPolicy,
	},
	ItemMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemMessageKeySpecifier | (() => undefined | ItemMessageKeySpecifier),
		fields?: ItemMessageFieldPolicy,
	},
	ItemPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemPriceKeySpecifier | (() => undefined | ItemPriceKeySpecifier),
		fields?: ItemPriceFieldPolicy,
	},
	JewelerShowcaseCallbackRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JewelerShowcaseCallbackRequestKeySpecifier | (() => undefined | JewelerShowcaseCallbackRequestKeySpecifier),
		fields?: JewelerShowcaseCallbackRequestFieldPolicy,
	},
	JewelerShowcaseCallbackRequestsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JewelerShowcaseCallbackRequestsResultKeySpecifier | (() => undefined | JewelerShowcaseCallbackRequestsResultKeySpecifier),
		fields?: JewelerShowcaseCallbackRequestsResultFieldPolicy,
	},
	KitConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KitConfigurationDetailKeySpecifier | (() => undefined | KitConfigurationDetailKeySpecifier),
		fields?: KitConfigurationDetailFieldPolicy,
	},
	LengthValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LengthValueKeySpecifier | (() => undefined | LengthValueKeySpecifier),
		fields?: LengthValueFieldPolicy,
	},
	LocateAJewelerAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerAddressKeySpecifier | (() => undefined | LocateAJewelerAddressKeySpecifier),
		fields?: LocateAJewelerAddressFieldPolicy,
	},
	LocateAJewelerHours?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerHoursKeySpecifier | (() => undefined | LocateAJewelerHoursKeySpecifier),
		fields?: LocateAJewelerHoursFieldPolicy,
	},
	LocateAJewelerHoursSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerHoursSettingsKeySpecifier | (() => undefined | LocateAJewelerHoursSettingsKeySpecifier),
		fields?: LocateAJewelerHoursSettingsFieldPolicy,
	},
	LocateAJewelerListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerListingKeySpecifier | (() => undefined | LocateAJewelerListingKeySpecifier),
		fields?: LocateAJewelerListingFieldPolicy,
	},
	LocateAJewelerListingSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerListingSearchResultKeySpecifier | (() => undefined | LocateAJewelerListingSearchResultKeySpecifier),
		fields?: LocateAJewelerListingSearchResultFieldPolicy,
	},
	LocateAJewelerListingsSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerListingsSearchResultKeySpecifier | (() => undefined | LocateAJewelerListingsSearchResultKeySpecifier),
		fields?: LocateAJewelerListingsSearchResultFieldPolicy,
	},
	LocateAJewelerListingsSearchResultItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerListingsSearchResultItemKeySpecifier | (() => undefined | LocateAJewelerListingsSearchResultItemKeySpecifier),
		fields?: LocateAJewelerListingsSearchResultItemFieldPolicy,
	},
	LocateAJewelerOwner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerOwnerKeySpecifier | (() => undefined | LocateAJewelerOwnerKeySpecifier),
		fields?: LocateAJewelerOwnerFieldPolicy,
	},
	LocateAJewelerSocials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocateAJewelerSocialsKeySpecifier | (() => undefined | LocateAJewelerSocialsKeySpecifier),
		fields?: LocateAJewelerSocialsFieldPolicy,
	},
	LoyaltyProgram?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoyaltyProgramKeySpecifier | (() => undefined | LoyaltyProgramKeySpecifier),
		fields?: LoyaltyProgramFieldPolicy,
	},
	LoyaltyProgramAutorenewal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoyaltyProgramAutorenewalKeySpecifier | (() => undefined | LoyaltyProgramAutorenewalKeySpecifier),
		fields?: LoyaltyProgramAutorenewalFieldPolicy,
	},
	MarketRate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarketRateKeySpecifier | (() => undefined | MarketRateKeySpecifier),
		fields?: MarketRateFieldPolicy,
	},
	MatchingChainConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchingChainConfigurationDetailKeySpecifier | (() => undefined | MatchingChainConfigurationDetailKeySpecifier),
		fields?: MatchingChainConfigurationDetailFieldPolicy,
	},
	Media?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaKeySpecifier | (() => undefined | MediaKeySpecifier),
		fields?: MediaFieldPolicy,
	},
	MerchandiseHierarchy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MerchandiseHierarchyKeySpecifier | (() => undefined | MerchandiseHierarchyKeySpecifier),
		fields?: MerchandiseHierarchyFieldPolicy,
	},
	MeteorImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MeteorImageKeySpecifier | (() => undefined | MeteorImageKeySpecifier),
		fields?: MeteorImageFieldPolicy,
	},
	MonogramConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MonogramConfigurationDetailKeySpecifier | (() => undefined | MonogramConfigurationDetailKeySpecifier),
		fields?: MonogramConfigurationDetailFieldPolicy,
	},
	MonogramLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MonogramLocationConfigurationKeySpecifier | (() => undefined | MonogramLocationConfigurationKeySpecifier),
		fields?: MonogramLocationConfigurationFieldPolicy,
	},
	MoveAllLinesToCartPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveAllLinesToCartPayloadKeySpecifier | (() => undefined | MoveAllLinesToCartPayloadKeySpecifier),
		fields?: MoveAllLinesToCartPayloadFieldPolicy,
	},
	MoveCartLineToCartPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveCartLineToCartPayloadKeySpecifier | (() => undefined | MoveCartLineToCartPayloadKeySpecifier),
		fields?: MoveCartLineToCartPayloadFieldPolicy,
	},
	MoveFavoritesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveFavoritesPayloadKeySpecifier | (() => undefined | MoveFavoritesPayloadKeySpecifier),
		fields?: MoveFavoritesPayloadFieldPolicy,
	},
	MoveSavedCartLineToCartPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveSavedCartLineToCartPayloadKeySpecifier | (() => undefined | MoveSavedCartLineToCartPayloadKeySpecifier),
		fields?: MoveSavedCartLineToCartPayloadFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NormalTerms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NormalTermsKeySpecifier | (() => undefined | NormalTermsKeySpecifier),
		fields?: NormalTermsFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationMetadataKeySpecifier | (() => undefined | NotificationMetadataKeySpecifier),
		fields?: NotificationMetadataFieldPolicy,
	},
	NotificationsFeed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationsFeedKeySpecifier | (() => undefined | NotificationsFeedKeySpecifier),
		fields?: NotificationsFeedFieldPolicy,
	},
	NotificationsUnreadCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationsUnreadCountKeySpecifier | (() => undefined | NotificationsUnreadCountKeySpecifier),
		fields?: NotificationsUnreadCountFieldPolicy,
	},
	OrderLineBagAndTagOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineBagAndTagOptionsKeySpecifier | (() => undefined | OrderLineBagAndTagOptionsKeySpecifier),
		fields?: OrderLineBagAndTagOptionsFieldPolicy,
	},
	OrderLineOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineOptionsKeySpecifier | (() => undefined | OrderLineOptionsKeySpecifier),
		fields?: OrderLineOptionsFieldPolicy,
	},
	OrderType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderTypeKeySpecifier | (() => undefined | OrderTypeKeySpecifier),
		fields?: OrderTypeFieldPolicy,
	},
	PatternEngravingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatternEngravingLocationConfigurationKeySpecifier | (() => undefined | PatternEngravingLocationConfigurationKeySpecifier),
		fields?: PatternEngravingLocationConfigurationFieldPolicy,
	},
	Phone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhoneKeySpecifier | (() => undefined | PhoneKeySpecifier),
		fields?: PhoneFieldPolicy,
	},
	PrerequisiteProductList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrerequisiteProductListKeySpecifier | (() => undefined | PrerequisiteProductListKeySpecifier),
		fields?: PrerequisiteProductListFieldPolicy,
	},
	Price?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceKeySpecifier | (() => undefined | PriceKeySpecifier),
		fields?: PriceFieldPolicy,
	},
	PriceBreak?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceBreakKeySpecifier | (() => undefined | PriceBreakKeySpecifier),
		fields?: PriceBreakFieldPolicy,
	},
	PriceDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceDiscountKeySpecifier | (() => undefined | PriceDiscountKeySpecifier),
		fields?: PriceDiscountFieldPolicy,
	},
	PriceList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceListKeySpecifier | (() => undefined | PriceListKeySpecifier),
		fields?: PriceListFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupKeySpecifier | (() => undefined | ProductGroupKeySpecifier),
		fields?: ProductGroupFieldPolicy,
	},
	ProductInStockStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductInStockStatusKeySpecifier | (() => undefined | ProductInStockStatusKeySpecifier),
		fields?: ProductInStockStatusFieldPolicy,
	},
	ProductShareEmailPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductShareEmailPayloadKeySpecifier | (() => undefined | ProductShareEmailPayloadKeySpecifier),
		fields?: ProductShareEmailPayloadFieldPolicy,
	},
	PublicQuoteLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicQuoteLineKeySpecifier | (() => undefined | PublicQuoteLineKeySpecifier),
		fields?: PublicQuoteLineFieldPolicy,
	},
	PublicQuoteLineOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicQuoteLineOptionsKeySpecifier | (() => undefined | PublicQuoteLineOptionsKeySpecifier),
		fields?: PublicQuoteLineOptionsFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	Queue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueueKeySpecifier | (() => undefined | QueueKeySpecifier),
		fields?: QueueFieldPolicy,
	},
	QueueResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueueResultKeySpecifier | (() => undefined | QueueResultKeySpecifier),
		fields?: QueueResultFieldPolicy,
	},
	ReactivateCadCamRequestByIdPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReactivateCadCamRequestByIdPayloadKeySpecifier | (() => undefined | ReactivateCadCamRequestByIdPayloadKeySpecifier),
		fields?: ReactivateCadCamRequestByIdPayloadFieldPolicy,
	},
	RingSizeConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RingSizeConfigurationDetailKeySpecifier | (() => undefined | RingSizeConfigurationDetailKeySpecifier),
		fields?: RingSizeConfigurationDetailFieldPolicy,
	},
	SalesPerson?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SalesPersonKeySpecifier | (() => undefined | SalesPersonKeySpecifier),
		fields?: SalesPersonFieldPolicy,
	},
	SaveCartLineForLaterPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaveCartLineForLaterPayloadKeySpecifier | (() => undefined | SaveCartLineForLaterPayloadKeySpecifier),
		fields?: SaveCartLineForLaterPayloadFieldPolicy,
	},
	SavedCartLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SavedCartLineKeySpecifier | (() => undefined | SavedCartLineKeySpecifier),
		fields?: SavedCartLineFieldPolicy,
	},
	SavedCartLinesResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SavedCartLinesResultKeySpecifier | (() => undefined | SavedCartLinesResultKeySpecifier),
		fields?: SavedCartLinesResultFieldPolicy,
	},
	ScheduledOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledOrderKeySpecifier | (() => undefined | ScheduledOrderKeySpecifier),
		fields?: ScheduledOrderFieldPolicy,
	},
	ScheduledOrderCOD?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledOrderCODKeySpecifier | (() => undefined | ScheduledOrderCODKeySpecifier),
		fields?: ScheduledOrderCODFieldPolicy,
	},
	ScheduledOrderCreditCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledOrderCreditCardKeySpecifier | (() => undefined | ScheduledOrderCreditCardKeySpecifier),
		fields?: ScheduledOrderCreditCardFieldPolicy,
	},
	ScheduledOrderNormalTerms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledOrderNormalTermsKeySpecifier | (() => undefined | ScheduledOrderNormalTermsKeySpecifier),
		fields?: ScheduledOrderNormalTermsFieldPolicy,
	},
	SearchSuggestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchSuggestionKeySpecifier | (() => undefined | SearchSuggestionKeySpecifier),
		fields?: SearchSuggestionFieldPolicy,
	},
	SerializedProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SerializedProductKeySpecifier | (() => undefined | SerializedProductKeySpecifier),
		fields?: SerializedProductFieldPolicy,
	},
	SerializedProductReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SerializedProductReportKeySpecifier | (() => undefined | SerializedProductReportKeySpecifier),
		fields?: SerializedProductReportFieldPolicy,
	},
	SetPrimaryContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetPrimaryContactPayloadKeySpecifier | (() => undefined | SetPrimaryContactPayloadKeySpecifier),
		fields?: SetPrimaryContactPayloadFieldPolicy,
	},
	ShipToAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShipToAccountKeySpecifier | (() => undefined | ShipToAccountKeySpecifier),
		fields?: ShipToAccountFieldPolicy,
	},
	ShipToAccountSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShipToAccountSearchResultKeySpecifier | (() => undefined | ShipToAccountSearchResultKeySpecifier),
		fields?: ShipToAccountSearchResultFieldPolicy,
	},
	Shipment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShipmentKeySpecifier | (() => undefined | ShipmentKeySpecifier),
		fields?: ShipmentFieldPolicy,
	},
	ShippingCountdown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingCountdownKeySpecifier | (() => undefined | ShippingCountdownKeySpecifier),
		fields?: ShippingCountdownFieldPolicy,
	},
	ShippingEstimate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingEstimateKeySpecifier | (() => undefined | ShippingEstimateKeySpecifier),
		fields?: ShippingEstimateFieldPolicy,
	},
	ShippingMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodKeySpecifier | (() => undefined | ShippingMethodKeySpecifier),
		fields?: ShippingMethodFieldPolicy,
	},
	ShowcaseMarkup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseMarkupKeySpecifier | (() => undefined | ShowcaseMarkupKeySpecifier),
		fields?: ShowcaseMarkupFieldPolicy,
	},
	ShowcaseMarkupTicketedValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseMarkupTicketedValuesKeySpecifier | (() => undefined | ShowcaseMarkupTicketedValuesKeySpecifier),
		fields?: ShowcaseMarkupTicketedValuesFieldPolicy,
	},
	ShowcaseMarkupValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseMarkupValuesKeySpecifier | (() => undefined | ShowcaseMarkupValuesKeySpecifier),
		fields?: ShowcaseMarkupValuesFieldPolicy,
	},
	ShowcaseNavigationDisplayExclusion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseNavigationDisplayExclusionKeySpecifier | (() => undefined | ShowcaseNavigationDisplayExclusionKeySpecifier),
		fields?: ShowcaseNavigationDisplayExclusionFieldPolicy,
	},
	ShowcaseOnlyCartsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseOnlyCartsResultKeySpecifier | (() => undefined | ShowcaseOnlyCartsResultKeySpecifier),
		fields?: ShowcaseOnlyCartsResultFieldPolicy,
	},
	ShowcasePriceSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcasePriceSummaryKeySpecifier | (() => undefined | ShowcasePriceSummaryKeySpecifier),
		fields?: ShowcasePriceSummaryFieldPolicy,
	},
	ShowcasePriceSummaryComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcasePriceSummaryComponentKeySpecifier | (() => undefined | ShowcasePriceSummaryComponentKeySpecifier),
		fields?: ShowcasePriceSummaryComponentFieldPolicy,
	},
	ShowcasePriceSummarySection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcasePriceSummarySectionKeySpecifier | (() => undefined | ShowcasePriceSummarySectionKeySpecifier),
		fields?: ShowcasePriceSummarySectionFieldPolicy,
	},
	ShowcaseSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseSettingsKeySpecifier | (() => undefined | ShowcaseSettingsKeySpecifier),
		fields?: ShowcaseSettingsFieldPolicy,
	},
	ShowcaseSettingsSetup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowcaseSettingsSetupKeySpecifier | (() => undefined | ShowcaseSettingsSetupKeySpecifier),
		fields?: ShowcaseSettingsSetupFieldPolicy,
	},
	SpecialFinishConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpecialFinishConfigurationDetailKeySpecifier | (() => undefined | SpecialFinishConfigurationDetailKeySpecifier),
		fields?: SpecialFinishConfigurationDetailFieldPolicy,
	},
	SpecialFinishLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpecialFinishLocationConfigurationKeySpecifier | (() => undefined | SpecialFinishLocationConfigurationKeySpecifier),
		fields?: SpecialFinishLocationConfigurationFieldPolicy,
	},
	StandardEngravingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardEngravingLocationConfigurationKeySpecifier | (() => undefined | StandardEngravingLocationConfigurationKeySpecifier),
		fields?: StandardEngravingLocationConfigurationFieldPolicy,
	},
	StateOrProvince?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StateOrProvinceKeySpecifier | (() => undefined | StateOrProvinceKeySpecifier),
		fields?: StateOrProvinceFieldPolicy,
	},
	StoneRebateByBillToAccountResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoneRebateByBillToAccountResultKeySpecifier | (() => undefined | StoneRebateByBillToAccountResultKeySpecifier),
		fields?: StoneRebateByBillToAccountResultFieldPolicy,
	},
	StoneRebateRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoneRebateRangeKeySpecifier | (() => undefined | StoneRebateRangeKeySpecifier),
		fields?: StoneRebateRangeFieldPolicy,
	},
	StoneSettingConfigurationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoneSettingConfigurationDetailKeySpecifier | (() => undefined | StoneSettingConfigurationDetailKeySpecifier),
		fields?: StoneSettingConfigurationDetailFieldPolicy,
	},
	StoneSettingLocationConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoneSettingLocationConfigurationKeySpecifier | (() => undefined | StoneSettingLocationConfigurationKeySpecifier),
		fields?: StoneSettingLocationConfigurationFieldPolicy,
	},
	StrategicPurchaseList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StrategicPurchaseListKeySpecifier | (() => undefined | StrategicPurchaseListKeySpecifier),
		fields?: StrategicPurchaseListFieldPolicy,
	},
	TaskDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskDefinitionKeySpecifier | (() => undefined | TaskDefinitionKeySpecifier),
		fields?: TaskDefinitionFieldPolicy,
	},
	TaskOperationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskOperationDetailKeySpecifier | (() => undefined | TaskOperationDetailKeySpecifier),
		fields?: TaskOperationDetailFieldPolicy,
	},
	TaskResultSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskResultSummaryKeySpecifier | (() => undefined | TaskResultSummaryKeySpecifier),
		fields?: TaskResultSummaryFieldPolicy,
	},
	TaskRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskRunKeySpecifier | (() => undefined | TaskRunKeySpecifier),
		fields?: TaskRunFieldPolicy,
	},
	TaskRunOperations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskRunOperationsKeySpecifier | (() => undefined | TaskRunOperationsKeySpecifier),
		fields?: TaskRunOperationsFieldPolicy,
	},
	TaskRunsSearchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskRunsSearchResultKeySpecifier | (() => undefined | TaskRunsSearchResultKeySpecifier),
		fields?: TaskRunsSearchResultFieldPolicy,
	},
	Terms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TermsKeySpecifier | (() => undefined | TermsKeySpecifier),
		fields?: TermsFieldPolicy,
	},
	TimeZone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimeZoneKeySpecifier | (() => undefined | TimeZoneKeySpecifier),
		fields?: TimeZoneFieldPolicy,
	},
	TrackingSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TrackingSourceKeySpecifier | (() => undefined | TrackingSourceKeySpecifier),
		fields?: TrackingSourceFieldPolicy,
	},
	TradeShow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TradeShowKeySpecifier | (() => undefined | TradeShowKeySpecifier),
		fields?: TradeShowFieldPolicy,
	},
	Trademark?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TrademarkKeySpecifier | (() => undefined | TrademarkKeySpecifier),
		fields?: TrademarkFieldPolicy,
	},
	UpdateCartLinePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCartLinePayloadKeySpecifier | (() => undefined | UpdateCartLinePayloadKeySpecifier),
		fields?: UpdateCartLinePayloadFieldPolicy,
	},
	UpdateCartLineQuantityPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCartLineQuantityPayloadKeySpecifier | (() => undefined | UpdateCartLineQuantityPayloadKeySpecifier),
		fields?: UpdateCartLineQuantityPayloadFieldPolicy,
	},
	UpdateContactPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateContactPayloadKeySpecifier | (() => undefined | UpdateContactPayloadKeySpecifier),
		fields?: UpdateContactPayloadFieldPolicy,
	},
	UpdateCreditCardPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCreditCardPayloadKeySpecifier | (() => undefined | UpdateCreditCardPayloadKeySpecifier),
		fields?: UpdateCreditCardPayloadFieldPolicy,
	},
	UpdateCurrencyDisplayPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateCurrencyDisplayPayloadKeySpecifier | (() => undefined | UpdateCurrencyDisplayPayloadKeySpecifier),
		fields?: UpdateCurrencyDisplayPayloadFieldPolicy,
	},
	UpdateDefaultPaymentMethodPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDefaultPaymentMethodPayloadKeySpecifier | (() => undefined | UpdateDefaultPaymentMethodPayloadKeySpecifier),
		fields?: UpdateDefaultPaymentMethodPayloadFieldPolicy,
	},
	UpdateFavoriteListPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateFavoriteListPayloadKeySpecifier | (() => undefined | UpdateFavoriteListPayloadKeySpecifier),
		fields?: UpdateFavoriteListPayloadFieldPolicy,
	},
	UpdateHideUsdPricePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateHideUsdPricePayloadKeySpecifier | (() => undefined | UpdateHideUsdPricePayloadKeySpecifier),
		fields?: UpdateHideUsdPricePayloadFieldPolicy,
	},
	UpdateHoldShipmentsDatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateHoldShipmentsDatePayloadKeySpecifier | (() => undefined | UpdateHoldShipmentsDatePayloadKeySpecifier),
		fields?: UpdateHoldShipmentsDatePayloadFieldPolicy,
	},
	UpdateLocateAJewelerListingPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLocateAJewelerListingPayloadKeySpecifier | (() => undefined | UpdateLocateAJewelerListingPayloadKeySpecifier),
		fields?: UpdateLocateAJewelerListingPayloadFieldPolicy,
	},
	UpdateNotificationStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateNotificationStatusPayloadKeySpecifier | (() => undefined | UpdateNotificationStatusPayloadKeySpecifier),
		fields?: UpdateNotificationStatusPayloadFieldPolicy,
	},
	UpdateNotificationsFeedReadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateNotificationsFeedReadPayloadKeySpecifier | (() => undefined | UpdateNotificationsFeedReadPayloadKeySpecifier),
		fields?: UpdateNotificationsFeedReadPayloadFieldPolicy,
	},
	UpdateSavedCartLinePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateSavedCartLinePayloadKeySpecifier | (() => undefined | UpdateSavedCartLinePayloadKeySpecifier),
		fields?: UpdateSavedCartLinePayloadFieldPolicy,
	},
	UpdateScheduledCartShippingMethodPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateScheduledCartShippingMethodPayloadKeySpecifier | (() => undefined | UpdateScheduledCartShippingMethodPayloadKeySpecifier),
		fields?: UpdateScheduledCartShippingMethodPayloadFieldPolicy,
	},
	UpdateScheduledOrderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateScheduledOrderPayloadKeySpecifier | (() => undefined | UpdateScheduledOrderPayloadKeySpecifier),
		fields?: UpdateScheduledOrderPayloadFieldPolicy,
	},
	UpsertCommunicationPreferencePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpsertCommunicationPreferencePayloadKeySpecifier | (() => undefined | UpsertCommunicationPreferencePayloadKeySpecifier),
		fields?: UpsertCommunicationPreferencePayloadFieldPolicy,
	},
	UpsertCustomerStoreInformationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpsertCustomerStoreInformationPayloadKeySpecifier | (() => undefined | UpsertCustomerStoreInformationPayloadKeySpecifier),
		fields?: UpsertCustomerStoreInformationPayloadFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserStrategicPurchase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserStrategicPurchaseKeySpecifier | (() => undefined | UserStrategicPurchaseKeySpecifier),
		fields?: UserStrategicPurchaseFieldPolicy,
	},
	Video?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VideoKeySpecifier | (() => undefined | VideoKeySpecifier),
		fields?: VideoFieldPolicy,
	},
	Video360?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Video360KeySpecifier | (() => undefined | Video360KeySpecifier),
		fields?: Video360FieldPolicy,
	},
	ViewerPermissions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewerPermissionsKeySpecifier | (() => undefined | ViewerPermissionsKeySpecifier),
		fields?: ViewerPermissionsFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;